import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { TextField, Button, Box, Paper, LinearProgress } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from './index.styles';
import Boxlayout from './box-layout';
import LabelTemplate from './labelTemplate';
import randomized from 'randomatic';
import assignmentstatus from './assignment-status';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Tooltip from '@mui/material/Tooltip';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import DialogContentText from '@mui/material/DialogContentText';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchableSelect from '../common/SearchableSelect';
import PaymentGatewayTypes from '../common/payment-gateways';
import { toast } from 'react-toastify';
import FormHelperText from '@mui/material/FormHelperText';
import PlayArrow from '@mui/icons-material/PlayArrow';
import Pause from '@mui/icons-material/Pause';
import PrintTemplate from 'react-print';
import EVENT_TYPES from '../common/event-type';
import EVENT_CRUD_TYPES from '../common/event-crud-types';
import EventLogHandler from '../common/event-log-handler';
import DemoData from '../common/demo-data';
import { getFlagsForA33Item } from '../shared/dummyPrescriptionFlags';
import { fetchAccountSignatureFlagCodes } from './counter/services/SignatureFlagsService';
import CONNECTION_TYPE from '../common/connection-type';
import {
  resolveEpicScanRegexp,
  parseEpicScanRegex,
} from '../../utils/epicRxParsing';
import { navigate } from '@reach/router';
import spinner from './images/spinner.gif';
import checked from './images/checked.png';
import cl from './images/cl.gif';
import HomeIcon from '@mui/icons-material/Home';
import WorkIcon from '@mui/icons-material/Work';
import OtherIcon from '@mui/icons-material/DevicesOther';
import LOCATION_TYPE from '../enum/location_type';
import DEVICE_TYPE from '../enum/device_type';
import Manualconsultation from './Manual-consultation';
import InputAdornment from '@mui/material/InputAdornment';
import MagnifyIcon from '@mui/icons-material/Search';
import curbsideIcon from '../iLocal-Delivery-Icons/Curbside.svg';
import inpatientIcon from '../iLocal-Delivery-Icons/Bedside.svg';
import courierIcon from '../iLocal-Delivery-Icons/Courier.svg';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import NumberFormat from 'react-number-format';
import BOX_TYPE from '../enum/box_type';
import io from 'socket.io-client';
import TablePagination from '@mui/material/TablePagination';
import PatientManulOverride from '../common/patient_manual_override';
import CounterAssignUI from './counter';
import DeliveryTypeTabs from './DeliveryTypeTabs';
import KioskDeliveryInfoPanel from './KioskDeliveryInfoPanel';
import NonRxCart from './NonRxCart';
import MarketplaceUpcScan from './MarketplaceUpcScan';
import OtcDeliveryCallout, { FeatureUnavailableCallout } from '../features/OtcDeliveryCallout';
import {
  fetchEntitlements,
  isFeatureUsable,
  isLocationTypeUsable,
  decorateLocationTypesWithLicense,
  getFirstUsableLocationTypeId,
  findEntitlement,
  featureKeyForLocationType,
  getInitialAssignLocationTypeId,
  getLocationTypeIdFromSearch,
  getSelectedBoxId,
  LOCKED_OTC_DELIVERY_ENTITLEMENT,
  resolveOtcDeliveryEntitlement,
} from '../../utils/productLicensing';
import CustomNotePicker from '../message-control-center/CustomNotePicker';
import {
  getDeliverTabLoading,
  stopDeliverTabLoading,
} from '../../utils/deliverTabLoading';
import { computeNonRxUnitTax } from '../../utils/nonRxTax';
import {
  getNonRxAuthToken,
  saveNonRxProductWithImage,
  validateNonRxProductForCatalogSave,
} from '../../utils/nonRxProductApi';
import {
  addOrIncrementNonRxCartItem,
  findMatchingNonRxCartIndex,
  incrementNonRxCartQty,
  isEmptyCatalogPickerRow,
  isSellableCatalogProduct,
  normalizeNonRxUpc,
} from '../../utils/nonRxCart';
import './index.css';
import AssignPrescriptionActionFooter from './AssignPrescriptionActionFooter';
import {
  getAssignActionButtonSx,
  formatAssignActionTooltip,
  assignActionIconButtonSize,
} from './assignActionButtonStyles';
import { withTranslation } from 'react-i18next';
import {
  resolveSizeBasedAssignUIFromBox,
  isPreAssignmentAccountFromSession,
  parseAvailableBinCounts,
  SIZE_BASED_ASSIGN_BIN_SIZES,
  parseSizeBasedBinCounts,
  getBinSizeTranslationMap,
} from '../../utils/preAssignment';
import SizeBasedBinAvailabilitySummary from '../SizeBasedBinAvailabilitySummary';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import CloseIcon from '@mui/icons-material/Close';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PhoneInput from '../common/PhoneInput';
import BinStatusLegend, { BIN_STATUS_LEGEND_WITH_LOCKED } from './BinStatusLegend';
import userroles from '../common/userroles';
import { writeAuditLog } from '../common/apis';
import {
  handleIntegrationAssignRxOnChange,
  handleIntegrationAssignRxKeyDown,
} from './integration-assign/integrationAssignHandlers';
import {
  usesOrderStagingAssignFlow,
  usesIntegrationAssignLookup,
  PARTNER_INTEGRATION_ASSIGN_PHI_TYPE,
} from './integration-assign/orderStagingAssignHelpers';
import { AddCircleOutlineRounded, RemoveCircleOutlineRounded, Info as InfoIcon, Accessible as AccessibleIcon, ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { getColumnMappingNotice } from './columnRestriction';

const rxData = require('./assets/rxData').default;

const localeTheme = createTheme(
  {},
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR
);

let searchedRxItems = [];
let searchedRxNumbers = [];
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

const isQs1MissingValue = (value) =>
  [undefined, 'undefined', null, 'null', ''].includes(value);

const normalizeQs1RxNumber = (rxNumber) =>
  String(rxNumber || '').replace(/^0+/, '');

const PAYMENT_DEVICE_SELECTION_STORAGE_PREFIX = 'selectedPaymentDevice';

const getPaymentDeviceUiId = (device) =>
  device && (device.id || device.client_device_id || device.payment_device_id || device.device_id);

const normalizePaymentGatewayId = (value) => {
  const normalized = String(value || '').trim();
  return normalized && !['undefined', 'null'].includes(normalized)
    ? normalized
    : PaymentGatewayTypes.GLOBAL_PAYMENTS;
};

/**
 * QS1 Orders API PatientAmount is the amount due shown in the PMS response.
 * Do not substitute TransactionQuery CopayAmount or PrimaryPriceAmount.
 */
const extractQs1PatientAmount = (orderStatus, rxNumber) => {
  if (isQs1MissingValue(orderStatus) || typeof orderStatus === 'number') {
    return null;
  }
  const orders = Array.isArray(orderStatus) ? orderStatus : [orderStatus];
  const target = normalizeQs1RxNumber(rxNumber);
  const match = target
    ? orders.find(
        (order) => normalizeQs1RxNumber(order && order.RxNumber) === target
      )
    : null;
  const order = match || (orders.length === 1 ? orders[0] : null);
  if (!order || isQs1MissingValue(order.PatientAmount)) {
    return null;
  }
  const parsed = parseFloat(order.PatientAmount);
  return Number.isFinite(parsed) ? parsed : null;
};

let rxMaxLength = null;
const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix='$'
      decimalScale={2}
      allowNegative={false}
      decimalSeparator={'.'}
      fixedDecimalScale={true}
    />
  );
});

NumberFormatCustom.propTypes = {
  onChange: PropTypes.func.isRequired,
};

class EnhancedTableHead extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props &&
      this.props.onRequestSort &&
      this.props.onRequestSort(event, property);
  };

  render() {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      isVisibleForPause,
      className,
      t,
    } = this.props;
    const rows = [
      {
        id: 'rxNo',
        numeric: false,
        disablePadding: true,
        label: t('Assign.PrescriptionID'),
      },
      {
        id: 'fillNumber',
        numeric: false,
        disablePadding: true,
        label: t('Assign.FillID'),
      },
      {
        id: 'PrescriptionNumber',
        numeric: false,
        disablePadding: true,
        label: t('Assign.PrescriptionNumber'),
      },
      {
        id: 'OrderId',
        numeric: false,
        disablePadding: true,
        label: t('Assign.OrderID'),
      },
      {
        id: 'TranactionId',
        numeric: false,
        disablePadding: true,
        label: sessionStorage.getItem('accountConnectionId') === CONNECTION_TYPE.QS1 ? t('Assign.SequnceNo') : t('Assign.TransactionID'),
      },
      {
        id: 'name',
        numeric: false,
        disablePadding: true,
        label: t('Assign.DrugName'),
      },
      {
        id: 'ndcCode',
        numeric: false,
        disablePadding: true,
        label: t('Assign.NDCCode'),
      },
      {
        id: 'qty',
        numeric: false,
        disablePadding: true,
        label: t('Assign.Qty'),
      },
      {
        id: 'iscontrolledsubstance',
        numeric: false,
        disablePadding: true,
        label: t('Assign.IsControlled'),
      },
      {
        id: 'consultrequire',
        numeric: false,
        disablePadding: true,
        label: t('Assign.ConsultRequired'),
      },
      {
        id: 'isreturnable',
        numeric: false,
        disablePadding: true,
        label: t('Assign.IsReturnable'),
      },
      {
        id: 'AmountDue',
        numeric: false,
        disablePadding: true,
        label: t('Assign.AmountDue'),
      },
    ];

    return (
      <TableHead>
        <TableRow style={{ height: 'auto' }}>
          {!isVisibleForPause && (
            <TableCell padding={'none'} style={{ width: 36, maxWidth: 36 }}>
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={numSelected === rowCount}
                onChange={onSelectAllClick}
                style={{ color: '#4fc3f7' }}
              />
            </TableCell>
          )}
          {rows.map((row, index) => {
            const isFirst = index === 0;
            const countLabel = rowCount != null ? ` (${rowCount})` : '';
            const labelWithCount = rowCount != null ? `${row.label}${countLabel}` : row.label;
            return (
              <TableCell
                key={row.id}
                align={row.numeric ? 'right' : 'left'}
                padding={row.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === row.id ? order : false}
                className={className}
                style={{
                    fontSize: '0.68rem',
                    fontWeight: 600,
                    whiteSpace: 'normal',
                    lineHeight: 1.2,
                    verticalAlign: 'bottom',
                    padding: '6px 4px',
                    wordBreak: 'normal',
                    overflowWrap: 'normal',
                    hyphens: 'none',
                }}
              >
                <Tooltip
                  title={t('Global.Label.Filter.Sort')}
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                    sx={{
                      whiteSpace: 'normal',
                      height: 'auto',
                      alignItems: 'flex-start',
                      wordBreak: 'normal',
                      overflowWrap: 'normal',
                      hyphens: 'none',
                      '& .MuiTableSortLabel-icon': { flexShrink: 0, mt: '2px' },
                    }}
                  >
                    {(isFirst) ? labelWithCount : row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  className: PropTypes.string,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  add: {
    backgroundColor: theme.palette.secondary.main,
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#bae6fd',
    },
  },
  gridActions: {
    display: 'inline-block',
    width: '144px',
  },
  deletePrimaryButton: {
    background: 'none',
    color: 'rgba(0, 0, 0, 0.54)',
    '&:hover': {
      background: '#0284c7',
      color: '#fff',
    },
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    /* add,  deleteUsers, editUser, viewUser, */ confirmDelete,
    t,
  } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 && (
          <Typography color='inherit' variant='subheading'>
            {numSelected} {t('Assign.SelectedRow')}
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected === 1 && (
          <div>
            <Tooltip key='single-delete' title={t('Assign.DeleteTooltip')}>
              <IconButton
                aria-label='Delete'
                onClick={confirmDelete}
                className={classes.deletePrimaryButton}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        )}
        {numSelected > 1 && (
          <Tooltip key='multi-delete' title={t('Assign.DeleteTooltip')}>
            <IconButton
              aria-label='Delete'
              onClick={confirmDelete}
              className={classes.deletePrimaryButton}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(
  withTranslation()(EnhancedTableToolbar)
);

const getLocationTypeName = (locationTypeId) => {
  const locationTypeMap = {
    [LOCATION_TYPE.Kiosk]: 'Kiosk',
    [LOCATION_TYPE.Home]: 'Home',
    [LOCATION_TYPE.Work]: 'Work',
    [LOCATION_TYPE.Courier]: 'Courier',
    [LOCATION_TYPE.Curbside]: 'Curbside',
    [LOCATION_TYPE.Bedside]: 'Bedside',
    [LOCATION_TYPE.Counter]: 'Counter',
    [LOCATION_TYPE.Other]: 'Other',
    [LOCATION_TYPE.Mail_Order]: 'Mail Order'
  };
  return locationTypeMap[locationTypeId] || 'Unknown';
};

/** Existing Counter + Bedside assign (no locker bin). Do not broaden this set casually. */
const isCounterOrBedside = (locationtype_id) =>
  [LOCATION_TYPE.Counter, LOCATION_TYPE.Bedside].includes(locationtype_id);

const isCurbsideLocation = (locationtype_id) =>
  locationtype_id === LOCATION_TYPE.Curbside;

/** Bedside + Curbside: mapped shelves with allow_multiple / default check-in. */
const isReusableStorageLocationType = (locationtype_id) =>
  [LOCATION_TYPE.Bedside, LOCATION_TYPE.Curbside].includes(locationtype_id);

/**
 * Counter / Bedside / Curbside share CounterAssignUI (storage scan + orders list).
 * Kiosk stays on locker-bin paths.
 */
const usesCounterAssignShell = (locationtype_id) =>
  isCounterOrBedside(locationtype_id) || isCurbsideLocation(locationtype_id);

/**
 * Curbside mirrors Counter/Bedside for bin-optional assign/print only.
 * Kiosk / Courier / etc. stay on locker-bin paths.
 */
const isBinOptionalAssignLocation = (locationtype_id) =>
  usesCounterAssignShell(locationtype_id);

const isBypassConsultEnabled = (accountDetails) =>
  !!(
    accountDetails &&
    (accountDetails.bypass_consult === true ||
      accountDetails.bypass_consult === 'true')
  );

const determineConsultRequire = (
  apiConsultValue,
  isControlledSubstance,
  locationTypeId,
  bypassConsult = false,
  isManualConsult = false
) => {
  const bypassOn = bypassConsult === true || bypassConsult === 'true';
  const consultTrue =
    apiConsultValue === true || apiConsultValue === 'true';

  // Bypass + explicit manual check: preserve staff intent (DI-5532).
  if (bypassOn && consultTrue && isManualConsult) {
    return true;
  }

  // Bypass: do not auto-set / strip non-manual true (DI-6213 / A55 demo).
  if (bypassOn) {
    return false;
  }

  // No bypass: preserve explicit/API consult=true.
  if (consultTrue) {
    return true;
  }

  // Counter location + controlled substance = true -> set consult to true
  if (
    locationTypeId === LOCATION_TYPE.Counter &&
    (isControlledSubstance === true || isControlledSubstance === 'true')
  ) {
    return true;
  }

  return false;
};

const isAssignFlagTrue = (value) => value === true || value === 'true';

/** DEA schedules II–V (string or number) used across PMS integrations. */
const CONTROLLED_DEA_SCHEDULE_VALUES = ['2', '3', '4', '5', 2, 3, 4, 5];

const isDeaScheduleControlled = (schedule) =>
  ![undefined, 'undefined', null, 'null', ''].includes(schedule) &&
  CONTROLLED_DEA_SCHEDULE_VALUES.includes(schedule);

const getItemDeaSchedule = (item) => {
  if (!item) {
    return undefined;
  }
  const candidates = [
    item.schedule,
    item.DrugSchedule,
    item.drugSchedule,
    item.DEAClass,
    item.DEACodeNumber,
    item.dea_schedule,
    item.drug_class,
  ];
  for (let i = 0; i < candidates.length; i++) {
    if (candidates[i] != null && candidates[i] !== '') {
      return candidates[i];
    }
  }
  return undefined;
};

const isItemControlledSubstance = (item) =>
  isAssignFlagTrue(item && item.is_controlled_substance) ||
  isAssignFlagTrue(item && item.is_controlledsubstances) ||
  isAssignFlagTrue(item && item.isControlledSubstance) ||
  isAssignFlagTrue(item && item.isControlledSubstances) ||
  isDeaScheduleControlled(getItemDeaSchedule(item));

/**
 * QS1 / Liberty schedule sanitization:
 * - Accept numeric ("2", "02", "5") and alphanumeric ("3C", "C2N", "2N")
 * - Fallback: extract the dominant DEA digit (1–5) when alpha prefixes/suffixes are present
 * - Never drop the original schedule string when storing (audit display)
 * Used only for QS1 and Liberty Software connection paths.
 */
const extractQs1DeaScheduleDigit = (schedule) => {
  if ([undefined, 'undefined', null, 'null', ''].includes(schedule)) {
    return null;
  }
  const s = String(schedule).trim();
  if (!s) return null;
  // Strictly numeric, including leading zeros ("02" → 2)
  if (/^\d+$/.test(s)) {
    const n = parseInt(s, 10);
    if (n >= 1 && n <= 5) return String(n);
    return null;
  }
  // Mixed alphanumeric ("3C", "C2N", "2N") — first DEA digit 1–5
  const match = s.match(/[1-5]/);
  return match ? match[0] : null;
};

const isQs1DrugScheduleControlled = (schedule) => {
  const digit = extractQs1DeaScheduleDigit(schedule);
  return digit != null && ['2', '3', '4', '5'].includes(digit);
};

/** Persist original QS1/Liberty schedule text when a DEA digit is present. */
const sanitizeQs1DrugScheduleForStorage = (schedule) => {
  if ([undefined, 'undefined', null, 'null', ''].includes(schedule)) {
    return null;
  }
  const normalized = String(schedule).trim();
  if (!normalized) return null;
  if (extractQs1DeaScheduleDigit(normalized) != null) {
    return normalized;
  }
  return null;
};

/** Liberty uses `schedule` (same digit rules as QS1 DrugSchedule). */
const isLibertyDrugScheduleControlled = isQs1DrugScheduleControlled;
const sanitizeLibertyDrugScheduleForStorage = sanitizeQs1DrugScheduleForStorage;

const getOrderControlledSubstanceFromCart = (cartItems) =>
  (cartItems || searchedRxItems).some(isItemControlledSubstance);

const normalizeCartItemControlledSubstance = (item) => {
  if (!item) {
    return item;
  }
  return {
    ...item,
    is_controlled_substance: isItemControlledSubstance(item),
  };
};

const isUuidLikeValue = (value) =>
  typeof value === 'string' &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    value.trim()
  );

const hasMeaningfulValue = (value) =>
  ![undefined, null, '', 'undefined', 'null'].includes(value);

/** Never surface prescription_detail UUIDs as Prescription ID. */
const getDisplayRxNo = (item) => {
  if (!item) return '';
  const rxNo = item.rxNo != null ? item.rxNo : item.rx_no;
  if (!hasMeaningfulValue(rxNo)) return '';
  if (isUuidLikeValue(String(rxNo))) return '';
  if (item.id != null && String(rxNo) === String(item.id)) return '';
  return rxNo;
};

/**
 * Rx identifier printed on the label. Order-staging integrations (MScripts/Solis)
 * store the PMS prescription number in `prescriptionnumber` and leave `rx_no`
 * blank/UUID, so mirror getCartRxNumbers() and fall back to that field.
 */
const getLabelRxNo = (item, connectionId = null) => {
  if (!item) return '';
  const prescriptionNumber =
    item.prescriptionnumber != null ? item.prescriptionnumber : item.prescriptionNumber;
  const hasPrescriptionNumber =
    hasMeaningfulValue(prescriptionNumber) && String(prescriptionNumber).trim() !== '';
  if (connectionId && usesOrderStagingAssignFlow(connectionId) && hasPrescriptionNumber) {
    return String(prescriptionNumber).trim();
  }
  const displayRxNo = getDisplayRxNo(item);
  if (hasMeaningfulValue(displayRxNo)) return displayRxNo;
  return hasPrescriptionNumber ? String(prescriptionNumber).trim() : '';
};

const isNonRxOrderItem = (item) => {
  if (!item) return false;
  if (
    item.is_non_rx === true ||
    item.is_non_rx === 'true' ||
    item.is_non_rx === 1 ||
    item.is_non_rx === '1'
  ) {
    return true;
  }
  const rxNo = item.rx_no != null ? item.rx_no : item.rxNo;
  const hasRealRxNo =
    hasMeaningfulValue(rxNo) &&
    !isUuidLikeValue(String(rxNo)) &&
    !(item.id != null && String(rxNo) === String(item.id));
  if (hasRealRxNo) return false;

  if (hasMeaningfulValue(item.item_number)) return true;

  const hasNdc = hasMeaningfulValue(item.ndc_code) || hasMeaningfulValue(item.ndcCode);
  const hasPrescriptionNumber =
    hasMeaningfulValue(item.prescriptionnumber) ||
    hasMeaningfulValue(item.prescriptionNumber);
  // Assigned Non-Rx lines have description/drug name and no Rx/NDC identifiers.
  if (hasNdc || hasPrescriptionNumber) return false;
  return hasMeaningfulValue(item.drug_name) || hasMeaningfulValue(item.description);
};

const mapRxItemsForCart = (rxItems) =>
  (rxItems || [])
    .filter((item) => !isNonRxOrderItem(item))
    .map((item) => normalizeCartItemControlledSubstance(item));

const splitOrderItemsForCarts = (orderItems) => {
  const items = Array.isArray(orderItems) ? orderItems : [];
  const rxItems = [];
  const nonRxItems = [];
  items.forEach((item) => {
    if (isNonRxOrderItem(item)) {
      nonRxItems.push({
        id: item.id || `nonrx-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        item_number: item.item_number || '',
        description: item.drug_name || item.description || '',
        price: item.price != null && item.price !== '' ? item.price : 0,
        qty: item.qty != null && item.qty !== '' ? item.qty : 1,
        upc: item.upc || '',
        uom: item.uom || '',
        tax_amount: item.tax_amount != null ? item.tax_amount : 0,
        image_url: item.image_url || '',
        non_rx_product_id: item.non_rx_product_id || null,
      });
    } else {
      rxItems.push(item);
    }
  });
  return { rxItems, nonRxItems };
};

/** Cart table source: integration flows may set assignCartItems; demo/legacy scans use searchedRxItems. */
const resolveAssignCartRxList = (assignCartItems, cartFromModule) => {
  const source =
    Array.isArray(assignCartItems) && assignCartItems.length > 0
      ? assignCartItems
      : cartFromModule || [];
  return (source || []).filter((item) => !isNonRxOrderItem(item));
};

export class AssignPrescriptions extends Component {
  getSearchedRxItems() {
    return searchedRxItems;
  }
  triggerPreAssignmentRefresh = () => {
    // PreAssignmentLayout reloads on a prop change (makeAPICall). Ensure it toggles.
    this.setState({ makePreAssignmentAPICall: false }, () => {
      // Force the prop transition to be observable (avoid React batching false->true)
      setTimeout(() => {
        this.setState({ makePreAssignmentAPICall: true });
      }, 0);
    });
  };
  refreshAfterHoldResume = () => {
    const { isSizeBasedPreAssignment, box_id } = this.state;
    if (isSizeBasedPreAssignment) {
      this.triggerPreAssignmentRefresh();
    } else if (box_id) {
      this.setState(
        (prev) => ({ binLayoutRefreshKey: prev.binLayoutRefreshKey + 1 }),
        () => this.getAssignedBins(box_id)
      );
    }
  };
  triggerOrderListsRefresh = () => {
    // Both right-side list variants listen for prop changes; always force false -> true transition.
    this.setState(
      { makeFastlaneAPICall: false, makePreAssignmentAPICall: false },
      () => {
        setTimeout(() => {
          this.setState({ makeFastlaneAPICall: true, makePreAssignmentAPICall: true });
        }, 0);
      }
    );
  };
  normalizeBinKey = (binId) => String(binId || '').replace(/\s/g, '');
  binHasActiveOrder = (binId) => {
    const normalized = this.normalizeBinKey(binId);
    if (!normalized) {
      return false;
    }
    const { BinStatus, orderId, selectedBinId } = this.state;
    const hasOccupiedBin =
      Array.isArray(BinStatus) &&
      BinStatus.some(
        (entry) => this.normalizeBinKey(entry.bin_id) === normalized
      );
    const hasLoadedOrder =
      Boolean(orderId) &&
      this.normalizeBinKey(selectedBinId) === normalized;
    return hasOccupiedBin || hasLoadedOrder;
  };
  clearHoldResumeOrderState = () => ({
    isVisibleForPause: false,
    is_stocked: false,
    isAlreadyOnHold: false,
    isAlreadyAssigned: false,
  });
  hasHoldResumePermission = () => {
    try {
      const checkUserRole = JSON.parse(sessionStorage.getItem('permissionUser'));
      if (checkUserRole === userroles.SUPERADMIN) {
        return true;
      }
      const permissions = JSON.parse(sessionStorage.getItem('permissions')) || [];
      const assignPrescriptions = permissions.filter(
        (item) => item.permission_entity_type === 'Assign Prescription'
      );
      return assignPrescriptions.some(
        (x) => x.name.trim() === 'Hold/Resume' && x.is_allowed === 1
      );
    } catch (error) {
      return false;
    }
  };
  refreshCurrentBoxAfterClear = (onComplete) => {
    const currentBoxId = this.state.box_id || localStorage.getItem('selectedLocation');
    const locationTypeId = this.state.locationtype_id || localStorage.getItem('selectedLocationTypeId') || '';

    this.ClearFields(() => {
      this.setState(
        {
          locationtype_id: locationTypeId,
          box_id: currentBoxId,
        },
        () => {
          this.triggerOrderListsRefresh();
          if (currentBoxId && !['null', 'undefined', '', null, undefined].includes(currentBoxId)) {
            this.syncAssignUIFromBoxRegion(currentBoxId);
            this.getBoxesByID(currentBoxId);
          }
          if (typeof onComplete === 'function') {
            onComplete();
          }
        }
      );
    });
  };
  constructor(props) {
    super(props);
    this._rxByBinRequestId = 0;
    this._upcLookupInFlight = false;
    this._orderCodeGeneration = 0;
    this._lastAssignedStockCode = '';
    this._labelPrintQueue = [];
    this._labelPrintRunning = false;
    // Initialize module-level variables (ClearFields cannot be called here as state is not yet initialized)
    searchedRxItems = [];
    searchedRxNumbers = [];
    this.state = {
      rxDetails: rxData,
      selectedBinId: '',
      openMessage: false,
      disableFeild: false,
      stockCode: '',
      pickupCode: '',
      searchedRxNo: [],
      prescriptionMasterData: {},
      rxNumber: '',
      selected: [],
      nonRxCartItems: [],
      otcDeliveryEntitlement: null,
      otcDeliveryEntitlementLoading: true,
      featureEntitlements: null,
      upcScan: '',
      upcScanBusy: false,
      nonRxPriceEditIndex: null,
      printNonRxItems: [],
      box: [],
      hasError: false,
      box_id: localStorage.getItem('selectedLocation'),
      currentBoxData: null,
      pharmacyDetails: {},
      accountDetails: {},
      accountSignatureFlagCodes: [],
      BinStatus: [],
      binLayoutRefreshKey: 0,
      deactivatedBins: [],
      assignedPrescription: {},
      isVisibleForPause: false,
      isBoxSelected: false,
      selectedUnitName: '',
      loader: false,
      expansionUnits: [],
      box_expansions_id: '',
      isLoadingTrans: false,
      isADACompatible: false,
      ConsultRequire: false,
      is_returnable: false,
      isAmountPaid: false,
      isPartiallyPaid: false,
      paymentPaidAmount: 0,
      paymentDueAmount: 0,
      locationtype_id: getInitialAssignLocationTypeId(
        typeof window !== 'undefined' ? window.location.search : ''
      ),
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: '',
      nonReadyRxBlockDialogOpen: false,
      nonReadyRxBlockMessage: '',
      epicStatusBannerMessage: '',
      EmailID: '',
      phone: '',
      notifyChannel: 'sms',
      basicEmailError: false,
      is_stocked: false,
      order: 'desc',
      orderBy: 'created_on',
      PrintFirstName: '',
      PrintLastName: '',
      ADAData: [],
      SearchResultDialogOpen: false,
      reminderData: [],
      AccountConnections: [],
      location: '',
      isUnplugged: false,
      accountConnectionsLoginId: sessionStorage.getItem('accountConnectionId') || '',
      boxDetails: [],
      boxItems: [],
      allBoxes: [],
      globalAccountConnection: {},
      source_location: '',
      delivery_notes: '',
      order_notes: '',
      patient_notes: '',
      storage_location: '',
      defaultCheckInLocation: null,
      defaultCheckInLocationBoxId: null,
      bedsideLocationOptions: [],
      isLoadingCheckInDefault: false,
      room_number: '',
      location_notes: '',
      searchedItems: [],
      assignCartItems: null,
      courier_type: [],
      courier_tracking: '',
      default_courier_selected: '',
      orderIds: [],
      prescriptionIds: [],
      isEdit: false,
      indexNo: null,
      binid: null,
      pmid: null,
      page: 0,
      rowsPerPage: 10,
      isManualOverrideOpen: false,
      printDialogOpen: false,
      printLoading: false,
      selectedObject: [],
      searchObj: {
        searchTxt: '',
        pageNo: 0,
        pageSize: 10,
        sortOrder: 'desc',
      },
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      selectedAccountIdForPrescriptionCheck: null,
      doesPrescriptionScanned: false,
      selectedPMSType: "",
      confirmPMSDialogOpen: false,
      scannedRxScript: "",
      originalScannedScript: "",
      boxTypeId: '',
      allow_multi_bins_pickup: false,
      FutureRelease: false,
      showDatePopup: false,
      FutureReleaseDate: null,
      selectedBox: '',
      address: null,
      patientNotes: '',
      readOnly: true,
      isBinDeactivated: false,
      alternateAgents: [],
      selectedBinSize: '',
      isBinSizeRequired: false,
      isSizeBasedPreAssignment: false,
      largeBinsCount: 0,
      mediumBinsCount: 0,
      smallBinsCount: 0,
      coolBinsCount: 0,
      binCountsBySize: {},
      makePreAssignmentAPICall: false,
      makeFastlaneAPICall: false,
      is_controlled_substance: false,
      servePresFetchCount: 0,
      servePresRetryCount: 3, // Max 3 times retrieval
      isRetrying: false,
      doesBinClicked: false,
      confirmPhantomRemoval: false,
      isPhantomStockCodePrompt: false,
      isManualOverridePermissionEnabled: true,
      prescriptionUnAssign: true,
      prescriptionAssign: true,
      prescriptionView: true,
      prescriptionDirectPickup: true,
      prescriptionRemind: true,
      prescriptionConsult: true,
      prescriptionHoldResume: true,
      prescriptionAcDc: true,
      assign_order_notes: '',
      customNote: { id: null, text: '', source: '' },
      show_order_notes_dialog: false,
      selectionType: 0,
      consultWaiveDialogOpen: false,
      consultWaiveIndex: null,
      consultWaiveReason: '',
      consultCheckBoxFlagForRxByBin: false,
      rxEntries: [
        { rxNumber: '', isConsultRequired: false }
      ],
      isRxView: false,
      phoneError: false,
      dobError: false,
      printTicketPermissionAllowed: false,
      htmlBodyToPrint: '',
      openPrintDialog: false,
      fastlaneBinRetryCount: 0,
      fastlaneBinMaxRetries: 3,
      isFastlaneRetrying: false,
      fastlaneRetryMessage: '',
      fastlaneBinFetchError: false,
      fastlaneBinValidationError: false,
      pendingSaveMode: null,
      fastlaneBinId: '',
      isFastlaneCollisionResolving: false,
      fastlaneCollisionDialogOpen: false,
      fastlaneCollisionNextBinId: '',
      selectedAssignmentLocation: null,
      selectedAssignmentBoxId: null,
      selectedAssignmentBinId: null,
      selectedAssignmentBoxTypeId: null,
      isBinLocked: false,
      isOpenPath: false,
      selectedPaymentDeviceId: '',
      selectedPaymentDeviceName: '',
      paymentDeviceDialogOpen: false,
    };
    this.textInput = React.createRef();
    this.BinSizes = [];

    this.phoneInputRef = React.createRef();
  }

  findBoxById = (boxId) => {
    if (!boxId) return null;
    const { boxDetails, allBoxes, selectedBox, currentBoxData } = this.state;
    return (
      this.findBoxInList(boxDetails, boxId) ||
      this.findBoxInList(allBoxes, boxId) ||
      (selectedBox && this.idsMatch(selectedBox.id, boxId) ? selectedBox : null) ||
      (currentBoxData && this.idsMatch(currentBoxData.id, boxId) ? currentBoxData : null)
    );
  };

  /** Assign UI variant is driven only by box.selected_regioin (en_CA / fr_CA vs other). */
  syncAssignUIFromBoxRegion = (boxId) => {
    if (!boxId) {
      this.setState({ isSizeBasedPreAssignment: false });
      this.BinSizes = [];
      return;
    }
    const box = this.findBoxById(boxId);
    const isSizeBased = resolveSizeBasedAssignUIFromBox(box);
    this.BinSizes = isSizeBased ? [...SIZE_BASED_ASSIGN_BIN_SIZES] : [];
    this.setState({ isSizeBasedPreAssignment: isSizeBased }, () => {
      if (
        isSizeBased &&
        this.state.locationtype_id === LOCATION_TYPE.Kiosk
      ) {
        this.getAvailableBinsCount(boxId);
      }
    });
  };

  handleBinSizeChange = (event) => {
    this.setState({
      selectedBinSize: event.target.value,
      isBinSizeRequired: false,
    });
  };

  getDeliveryTypeSelectItems = () =>
    (this.state.locationtype || []).map((type) => ({
      id: type.id,
      name: type.label,
    }));

  getBinSizeSelectItems = (t) => {
    const binSizeTranslationObj = getBinSizeTranslationMap(t);
    return [
      { id: '', name: t('Unplugged.SelectBinSize') },
      ...(this.BinSizes || []).map((size) => ({
        id: size,
        name: binSizeTranslationObj[size] || size,
      })),
    ];
  };

  getColumnMappingNoticeContent = () => {
    const columnMappings = this.state.currentBoxData && this.state.currentBoxData.column_mappings
      ? this.state.currentBoxData.column_mappings
      : [];
    const groupType = sessionStorage.getItem('groupType');
    const userGroupType = groupType && groupType !== 'null' && groupType !== 'undefined' && groupType !== ''
      ? groupType
      : null;
    return getColumnMappingNotice(columnMappings, userGroupType);
  };

  isAdaCompatiblePatient = () => {
    const { ADAData, searchedItems } = this.state;
    const patientId = searchedItems && searchedItems.PatientID;
    return Array.isArray(ADAData) && ADAData.some(
      (item) => item && item.patient_id === patientId && item.ada_compitible === true
    );
  };

  shouldShowScanRowNotices = () => this.isAdaCompatiblePatient();

  renderColumnMappingNotice = () => {
    const columnMappingNotice = this.getColumnMappingNoticeContent();
    if (!columnMappingNotice) {
      return null;
    }
    return (
      <div className="assign-column-mapping-notice assign-header-column-mapping" role="status">
        <InfoIcon className="assign-column-mapping-notice__icon" />
        <div>
          <div className="assign-column-mapping-notice__title">{columnMappingNotice.title}</div>
          <div className="assign-column-mapping-notice__text">{columnMappingNotice.text}</div>
        </div>
      </div>
    );
  };

  renderScanRowNotices = () => {
    if (!this.isAdaCompatiblePatient()) {
      return null;
    }
    return (
      <div className="assign-scan-notices">
        <div className="assign-ada-chip">
          <AccessibleIcon className="assign-ada-chip__icon" />
          <span>ADA Compatible Patient</span>
        </div>
      </div>
    );
  };

  renderLocationSelect = (id, { menuPlacement } = {}) => {
    const { t, classes } = this.props;
    const { hasError } = this.state;
    return (
      <React.Fragment>
        <SearchableSelect
          label={t('Assign.Location')}
          items={this.state.boxItems || []}
          value={this.state.box_id || ''}
          onChange={this.handleChange}
          placeholder="Search locations..."
          id={id}
          fullWidth={true}
          variant="standard"
          menuPlacement={menuPlacement || 'bottom'}
        />
        {hasError && (
          <FormHelperText className={classes.selectLable}>
            Please select any box
          </FormHelperText>
        )}
      </React.Fragment>
    );
  };

  renderBinSizeSelect = (id, { menuPlacement } = {}) => {
    const { t, classes } = this.props;
    return (
      <React.Fragment>
        <SearchableSelect
          label={t('Unplugged.BinSize')}
          items={this.getBinSizeSelectItems(t)}
          value={this.state.selectedBinSize || ''}
          onChange={this.handleBinSizeChange}
          placeholder={t('Unplugged.SelectBinSize')}
          id={id}
          fullWidth={true}
          variant="standard"
          menuPlacement={menuPlacement || 'bottom'}
        />
        {this.state.isBinSizeRequired ? (
          <FormHelperText className={classes.selectLable}>
            {t('Validation.Required')}
          </FormHelperText>
        ) : null}
      </React.Fragment>
    );
  };

  getAvailableBinsCount = async (box_id) => {
    fetch(
      process.env.REACT_APP_BASEURL +
        'pre-assignment/getAvailableBinsCount/' +
        box_id,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((result) => {
        if (result && result.data) {
          const legacyCounts = parseAvailableBinCounts(result.data);
          this.setState({
            binCountsBySize: parseSizeBasedBinCounts(result.data),
            largeBinsCount: legacyCounts.largeCounts,
            mediumBinsCount: legacyCounts.mediumCounts,
            smallBinsCount: legacyCounts.smallCounts,
            coolBinsCount: legacyCounts.coolCounts,
          });
        }
      })
      .catch((error) => console.error(error));
  };

  renderKioskBinOrBinSizeField = (classes, t, selectedBinId, { asTableCell, gridXs = 6 } = {}) => {
    let content;
    if (
      this.state.locationtype_id === LOCATION_TYPE.Kiosk &&
      this.state.isSizeBasedPreAssignment
    ) {
      content = (
        <React.Fragment>
          <SearchableSelect
            label={t('Unplugged.BinSize')}
            items={this.getBinSizeSelectItems(t)}
            value={this.state.selectedBinSize || ''}
            onChange={this.handleBinSizeChange}
            placeholder={t('Unplugged.SelectBinSize')}
            id='bin_sizes'
            fullWidth={true}
            variant='standard'
          />
          {this.state.isBinSizeRequired ? (
            <FormHelperText className={classes.selectLable}>
              {t('Validation.Required')}
            </FormHelperText>
          ) : null}
        </React.Fragment>
      );
    } else {
      content = (
        <TextField
          id='bin'
          type='text'
          className={classes.textField}
          margin='normal'
          variant='standard'
          label={t('Assign.BIN')}
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={selectedBinId || ''}
          style={asTableCell ? { marginTop: '8.5%', marginLeft: '1%' } : undefined}
          inputProps={{
            autoComplete: 'off',
            form: {
              autoComplete: 'off',
            },
          }}
        />
      );
    }
    if (asTableCell) {
      return <TableCell style={{ border: 'none' }}>{content}</TableCell>;
    }
    return <Grid item xs={gridXs}>{content}</Grid>;
  };

  shouldShowBasicUI = () => {
    const { selectedBox, currentBoxData, locationtype_id, accountDetails, accountConnectionsLoginId } = this.state;
    
    if (accountConnectionsLoginId === CONNECTION_TYPE.BASIC) {
      if (!locationtype_id) {
        return true;
      }
      return locationtype_id === LOCATION_TYPE.Kiosk;
    }
    
    const boxData = currentBoxData || selectedBox;
    
    if (!boxData) {
      return false;
    }
    
    if (locationtype_id !== LOCATION_TYPE.Kiosk) {
      return false;
    }
    
    if (boxData.parent_account_id && accountDetails && accountDetails.id === boxData.parent_account_id) {
      if (accountDetails.connection && accountDetails.connection.id === CONNECTION_TYPE.BASIC) {
        return true;
      }
    }
    
    return false;
  }

  isBasicConnection = () => {
    const { accountDetails, accountConnectionsLoginId } = this.state;
    if (accountConnectionsLoginId === CONNECTION_TYPE.BASIC) {
      return true;
    }
    const connectionId =
      accountDetails && accountDetails.connection && accountDetails.connection.id;
    return connectionId === CONNECTION_TYPE.BASIC;
  }

  isBasicDobOptional = () => {
    const flag = this.state.accountDetails && this.state.accountDetails.is_dob_optional;
    return [true, 'true', 1, '1'].includes(flag);
  }

  validateEmail = (value = "") => {
    const trimmed = (value || "").trim();
    if (!trimmed) {
      return true;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(trimmed);
  };

  getEmailError = (value = "") => {
    const trimmed = (value || "").trim();
    if (!trimmed) {
      return "";
    }
    return this.validateEmail(trimmed) ? "" : "Enter a valid email address.";
  };

  formatUSPhoneNumber = (value = "") => {
    const digits = (value || "").replace(/\D/g, "").slice(0, 10);
    if (digits.length === 0) {
      return "";
    }
    if (digits.length < 4) {
      return digits;
    }
    if (digits.length < 7) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    }
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  getPhoneError = (value = "") => {
    const digits = (value || "").replace(/\D/g, "");
    if (!digits) {
      return "";
    }
    return digits.length === 10 ? "" : "Enter a valid 10-digit phone number.";
  };

  handlePatientEmailChange = (value = "") => {
    const sanitizedValue = (value || "").replace(/\s/g, "");
    this.setState({ EmailID: sanitizedValue });
  };

  handlePatientPhoneChange = (value = "") => {
    const formatted = this.formatUSPhoneNumber(value);
    this.setState({ phone: formatted });
  };

  getAssignSelectedLocationsByType = () => {
    try {
      const raw = localStorage.getItem('assignSelectedLocationsByType');
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  };

  getStoredLocationForType = (locationTypeId) => {
    if (!locationTypeId) {
      return null;
    }

    const locationsByType = this.getAssignSelectedLocationsByType();
    return locationsByType[locationTypeId] || null;
  };

  setStoredLocationForType = (locationTypeId, location) => {
    if (!locationTypeId || !location || !location.id) {
      return;
    }

    const locationsByType = this.getAssignSelectedLocationsByType();
    locationsByType[locationTypeId] = {
      id: location.id,
      name: location.name || location.value || '',
    };
    localStorage.setItem('assignSelectedLocationsByType', JSON.stringify(locationsByType));
  };

  idsMatch = (a, b) => a != null && b != null && String(a) === String(b);

  getPreferredLocationId = () => getSelectedBoxId() || null;

  findBoxInList = (boxes, boxId) => {
    if (!Array.isArray(boxes) || boxId == null || boxId === '') {
      return null;
    }
    return boxes.find((box) => box && this.idsMatch(box.id, boxId)) || null;
  };

  getAssignableBoxes = (allBoxes = this.state.allBoxes) => {
    if (!Array.isArray(allBoxes)) {
      return [];
    }

    return allBoxes.filter(
      (box) => box && box.is_deleted === false && [true, 'true'].includes(box.IsActive)
    );
  };

  buildAssignableLocationTypesFromBoxes = (allBoxes = this.state.allBoxes) => {
    const assignableBoxes = this.getAssignableBoxes(allBoxes);
    const excludedLocationTypes = new Set([
      LOCATION_TYPE.Work,
      LOCATION_TYPE.Home,
      LOCATION_TYPE.Mail_Order,
    ]);
    const seenLocationTypeIds = new Set();

    return assignableBoxes.reduce((types, box) => {
      const locationTypeId = box.location_type_id || box.locationtype_id;
      if (
        !locationTypeId ||
        excludedLocationTypes.has(locationTypeId) ||
        seenLocationTypeIds.has(locationTypeId)
      ) {
        return types;
      }

      seenLocationTypeIds.add(locationTypeId);
      types.push({
        id: locationTypeId,
        label: getLocationTypeName(locationTypeId),
      });

      return types;
    }, []);
  };

  syncAssignableLocationTypes = (allBoxes = this.state.allBoxes) => {
    const filteredLocationTypes = this.buildAssignableLocationTypesFromBoxes(allBoxes);
    const previousLocationTypeId = this.state.locationtype_id;
    const search =
      (this.props.location && this.props.location.search) ||
      (typeof window !== 'undefined' && window.location.search) ||
      '';
    const urlTypeId = getLocationTypeIdFromSearch(search);
    const preferredBox = this.findBoxInList(
      this.getAssignableBoxes(allBoxes),
      this.getPreferredLocationId()
    );
    const preferredTypeId = preferredBox
      ? (preferredBox.location_type_id || preferredBox.locationtype_id)
      : null;
    const candidateTypeId = urlTypeId || preferredTypeId || this.state.locationtype_id;
    const matchedType = filteredLocationTypes.find((type) =>
      this.idsMatch(type.id, candidateTypeId)
    );
    const nextLocationTypeId =
      (matchedType && matchedType.id) ||
      (filteredLocationTypes[0] && filteredLocationTypes[0].id) ||
      '';
    const shouldSelectPreferred =
      !!preferredBox && this.idsMatch(preferredTypeId, nextLocationTypeId);

    this.setState(
      {
        locationtype: filteredLocationTypes,
        locationtype_id: nextLocationTypeId,
        ...(shouldSelectPreferred
          ? {
              box_id: preferredBox.id,
              selectedBox: preferredBox,
            }
          : {}),
      },
      () => {
        if (nextLocationTypeId) {
          localStorage.setItem('selectedLocationTypeId', nextLocationTypeId);
        }

        if (
          nextLocationTypeId &&
          (!this.idsMatch(nextLocationTypeId, previousLocationTypeId) ||
            this.state.boxDetails.length === 0 ||
            shouldSelectPreferred)
        ) {
          this.getAllBoxes(nextLocationTypeId);
        }
        this.bounceUnlicensedLocationType();
      }
    );
  };

  initSocket = async (authToken) => {
    if (!this.socket && this.user) {
      /**
       ** Socket Initialization **
       */

      this.socket = io(
        `${process.env.REACT_APP_VIDEO_SOCKET_BASEURL}/console-socket`,
        {
          transports: ['websocket'],
          auth: {
            token: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`,
          },
          secure: true,
        }
      );

      /**
       ** Internal Socket Event **
       */

      this.socket &&
        this.socket.on('connect', () => {
          console.log('Socket connection established from PORTAL(ReConnect)');
        });
      this.socket &&
        this.socket.on('connect_error', (error) => {
          console.log('Connect Error: ', error);
          if (
            error.message === 'TokenExpiredError' ||
            error.message === 'JsonWebTokenError' ||
            error.message === 'NoTokenFound'
          ) {
            console.log('Token issue!');
          }
        });
      this.socket &&
        this.socket.on('connect_failed', (error) => {
          console.log('Connect Failed: ', error);
        });
      this.socket &&
        this.socket.on('error', (error) => {
          console.log('Error: ', error);
        });
      this.socket &&
        this.socket.on('disconnect', (reason) => {
          console.log(
            `Socket Disconnected From Portal and Reason is: ${reason}`
          );
        });
    }
  };

  dismissEpicStatusBanner = () => {
    this.setState({ epicStatusBannerMessage: '' });
  };

  renderEpicStatusBanner = () => {
    const message = this.state.epicStatusBannerMessage;
    if (!message) {
      return null;
    }
    return (
      <div className="assign-epic-status-banner" role="status">
        <ErrorOutlineIcon className="assign-epic-status-banner__icon" />
        <span className="assign-epic-status-banner__text">{message}</span>
        <IconButton
          aria-label="Close"
          size="small"
          className="assign-epic-status-banner__close"
          onClick={this.dismissEpicStatusBanner}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    );
  };

  componentWillUnmount() {
    this.socket && this.socket.disconnect();
    this.socket = false;
  }

  async componentDidMount() {
    this.user = JSON.parse(sessionStorage.getItem('user'));
    !this.socket && (await this.initSocket());
    this.handleFocus();
    this.setPermission();
    if (this.phoneInputRef.current) {
      this.phoneInputRef.current.focus();
    }
    // Log initial location type from localStorage
    const initialLocationType = localStorage.getItem('selectedLocationTypeId');
    const initialLocationName = localStorage.getItem('selected_location_name') || 'Not Set';
    const initialLocationTypeName = getLocationTypeName(initialLocationType);
    console.log('📍 [ASSIGN PRESCRIPTION] Initial Location Loaded:', {
      locationTypeId: initialLocationType,
      locationTypeName: initialLocationTypeName,
      locationName: initialLocationName,
      source: 'localStorage'
    });
    
    // Initialize SearchableMultiSelect state with saved location
    const savedBoxId = localStorage.getItem('selectedLocation');
    if (savedBoxId && savedBoxId !== 'null' && savedBoxId !== 'undefined') {
      // Set initial state - the name will be updated when boxes are loaded
      this.setState({
        selectedBoxItems: [{ id: savedBoxId, name: 'Loading...' }],
        selectedBoxChips: [{ id: savedBoxId, name: 'Loading...' }]
      });
    }
    // Account-wide licenses must load even when no box is selected yet.
    // Otherwise Marketplace locks while Counter/Curbside stay usable.
    this.fetchOtcDeliveryEntitlement(savedBoxId);

    if (initialLocationType && savedBoxId) {
      this.setStoredLocationForType(initialLocationType, {
        id: savedBoxId,
        name: initialLocationName === 'Not Set' ? '' : initialLocationName,
      });
      if (initialLocationType === LOCATION_TYPE.Bedside || initialLocationType === LOCATION_TYPE.Curbside) {
        this.loadDefaultCheckInLocation(savedBoxId);
      }
    }
    
    this.is_pre_assignment = isPreAssignmentAccountFromSession();

    this.fetchAllBoxesForTabs();
    this.GetAcccountConnectionId();
    this.maybeStopDeliverTabLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevSearch = prevProps.location && prevProps.location.search;
    const nextSearch = this.props.location && this.props.location.search;
    if (prevSearch !== nextSearch) {
      this.applyDeliveryTypeFromUrl();
    }
    this.maybeStopDeliverTabLoading();

    const usesReusableStorage = isReusableStorageLocationType(this.state.locationtype_id);
    const boxChanged = prevState.box_id !== this.state.box_id;
    const typeChanged = prevState.locationtype_id !== this.state.locationtype_id;

    if (usesReusableStorage && this.state.box_id && (boxChanged || typeChanged)) {
      this.loadDefaultCheckInLocation(this.state.box_id);
    }

    if (!usesReusableStorage && typeChanged) {
      this.setState({
        defaultCheckInLocation: null,
        defaultCheckInLocationBoxId: null,
        bedsideLocationOptions: [],
        storage_location: "",
        locationData: null,
        isLoadingCheckInDefault: false,
      });
    }

    // Safety: if isRetrying flipped false without clearAssignInFlight, unlock.
    if (prevState.isRetrying && !this.state.isRetrying && this._assignInFlight) {
      this._assignInFlight = false;
    }

    if (this.state.loader && !prevState.loader && this._loaderCover) {
      this._loaderCover.focus();
    }

    const message = this.state.isEpicHasValidRxMessage;
    const showBanner =
      this.state.isEpicHasValidRx === false &&
      Boolean(message) &&
      (
        prevState.isEpicHasValidRx !== false ||
        prevState.isEpicHasValidRxMessage !== message ||
        (prevState.loader === true && this.state.loader === false)
      );
    if (showBanner && this.state.epicStatusBannerMessage !== message) {
      this.setState({ epicStatusBannerMessage: message });
    }
  }

  /** Sync assign lock — clear on every saveCustomerMaster exit (do not rely on setState). */
  clearAssignInFlight = () => {
    this._assignInFlight = false;
  };

  renderLoaderCover = () => {
    if (!this.state.loader) {
      return null;
    }
    const { classes } = this.props;
    return (
      <div
        className={classes.spinner}
        role="alertdialog"
        aria-modal="true"
        aria-busy="true"
        aria-label="Please wait"
        tabIndex={-1}
        ref={(node) => {
          this._loaderCover = node;
        }}
        onKeyDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        <img className={classes.spinnerImage} src={spinner} alt="" />
      </div>
    );
  };

  maybeStopDeliverTabLoading = () => {
    const loadingType = getDeliverTabLoading();
    if (!loadingType) {
      return;
    }
    const activeKey = featureKeyForLocationType(this.getActiveLocationTypeId());
    if (activeKey === loadingType) {
      stopDeliverTabLoading();
    }
  };

  applyDeliveryTypeFromUrl = () => {
    const search =
      (this.props.location && this.props.location.search) ||
      (typeof window !== 'undefined' && window.location.search) ||
      '';
    const typeId = getLocationTypeIdFromSearch(search);
    if (!typeId || typeId === this.state.locationtype_id) {
      return;
    }
    if (!Array.isArray(this.state.featureEntitlements)) {
      try {
        localStorage.setItem('selectedLocationTypeId', typeId);
      } catch (_err) {
        // ignore
      }
      this.setState({ locationtype_id: typeId });
      return;
    }
    this.handleLocationTypeChange(typeId);
  };

  syncDeliveryTypeInUrl = (locationTypeId) => {
    const featureKey = featureKeyForLocationType(locationTypeId);
    const path =
      (this.props.location && this.props.location.pathname) ||
      (typeof window !== 'undefined' && window.location.pathname) ||
      '';
    if (!path) {
      return;
    }
    const nextHref = featureKey ? path + '?type=' + featureKey : path;
    const currentSearch =
      (this.props.location && this.props.location.search) ||
      (typeof window !== 'undefined' && window.location.search) ||
      '';
    const currentHref = path + currentSearch;
    if (currentHref === nextHref) {
      return;
    }
    navigate(nextHref, { replace: true });
  };

  loadDefaultCheckInLocation = async (boxId) => {
    if (!boxId || (this.state.isLoadingCheckInDefault && String(this.state.defaultCheckInLocationBoxId) === String(boxId))) {
      return;
    }

    const previousDefault = this.state.defaultCheckInLocation;
    const requestId = `${boxId}-${Date.now()}`;
    this._checkInDefaultRequestId = requestId;
    this.setState({
      isLoadingCheckInDefault: true,
      defaultCheckInLocationBoxId: boxId,
    });

    try {
      const token = JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken.jwtToken;
      const response = await fetch(process.env.REACT_APP_BASEURL + "deliver/locations", {
        method: "POST",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          box_id: boxId,
          page: 1,
          pageSize: 500,
        }),
      });
      const result = await response.json();
      const data = (result && result.data) || {};
      const locations = Array.isArray(data.locations) ? data.locations : [];
      const locationOptions = locations.map((location) => ({
        id: location.id,
        location: location.location,
        location_code: location.location_code,
        color_code: location.color_code,
        box_id: location.box_id || boxId,
        matched_field: "location",
        allow_multiple_orders: location.allow_multiple_orders,
        is_checkin_default: location.is_checkin_default,
      }));
      const defaultLocation = locationOptions.find((location) =>
        location && [true, "true"].includes(location.is_checkin_default)
      );
      const defaultLocationData = defaultLocation ? { ...defaultLocation } : null;

      if (this._checkInDefaultRequestId !== requestId) {
        return;
      }

      const isStillReusableStorage = isReusableStorageLocationType(this.state.locationtype_id);
      const isStillSameBox = String(this.state.box_id) === String(boxId);
      if (!isStillReusableStorage || !isStillSameBox) {
        return;
      }

      const shouldPrefill =
        defaultLocationData &&
        (!this.state.storage_location ||
          (previousDefault && this.state.storage_location === previousDefault.location));
      const shouldClearPreviousDefault =
        !defaultLocationData &&
        previousDefault &&
        this.state.storage_location === previousDefault.location;

      this.setState({
        defaultCheckInLocation: defaultLocationData,
        bedsideLocationOptions: locationOptions,
        isLoadingCheckInDefault: false,
        ...(shouldPrefill
          ? {
              storage_location: defaultLocationData.location || "",
              locationData: defaultLocationData,
            }
          : shouldClearPreviousDefault
            ? {
                storage_location: "",
                locationData: null,
              }
            : {}),
      });
    } catch (error) {
      console.error("Error loading default check-in location:", error);
      if (this._checkInDefaultRequestId === requestId) {
        this.setState({
          defaultCheckInLocation: null,
          bedsideLocationOptions: [],
          isLoadingCheckInDefault: false,
        });
      }
    }
  };

  getAllBoxes = (id) => {
    const data = this.getAssignableBoxes(this.state.allBoxes).filter((box) => {
      const boxLocationTypeId = box.location_type_id || box.locationtype_id;
      return this.idsMatch(boxLocationTypeId, id);
    });

    if (data && data.length > 0) {
      let tmp = data.map((val) => {
        return {
          id: val.id,
          value: val.name,
          brandName: val.brandName,
          brandPhone: val.brandPhone,
          ...val,
        };
      });
      let AddressLine1 = "",
        AddressLine2 = "",
        City = "",
        State = "",
        Zip = "",
        Country = "";
      const storedLocationForType = this.getStoredLocationForType(id);
      const preferredForThisType = this.findBoxInList(data, this.getPreferredLocationId());
      const storedForThisType = storedLocationForType && storedLocationForType.id
        ? this.findBoxInList(data, storedLocationForType.id)
        : null;
      const currentInList = this.findBoxInList(data, this.state.box_id);
      const currentSelectedLocation =
        preferredForThisType || storedForThisType || currentInList || data[0];
      if (currentSelectedLocation && currentSelectedLocation.id) {
        this.setStoredLocationForType(id, currentSelectedLocation);
        const preferredId = this.getPreferredLocationId();
        if (!preferredId || this.idsMatch(preferredId, currentSelectedLocation.id)) {
          localStorage.setItem('selectedLocation', currentSelectedLocation.id);
          localStorage.setItem('selected_location_name', currentSelectedLocation.name || currentSelectedLocation.value || '');
        }
      }
      if (currentSelectedLocation) {
        const addr = currentSelectedLocation.address || currentSelectedLocation;
        AddressLine1 = addr.address_line_1 || currentSelectedLocation.address_line_1 || "";
        AddressLine2 = addr.address_line_2 || currentSelectedLocation.address_line_2 || "";
        City = addr.city || currentSelectedLocation.city || "";
        State = addr.state || currentSelectedLocation.state || "";
        Zip = addr.zip || currentSelectedLocation.zip || "";
        Country = addr.country || currentSelectedLocation.country || "";
      }

      const boxItems = tmp.map(box => ({
        id: box.id,
        name: box.value
      }));

      this.setState((prevState) => ({
        boxDetails: tmp,
        boxItems: boxItems,
        boxTypeId: ![undefined, undefined, null, null, ''].includes(currentSelectedLocation) ? currentSelectedLocation.type_id : data && data[0].type_id,
        assignedPrescription:
          (data && data[0].location_type_id) === LOCATION_TYPE.Kiosk
            ? data[0]
            : [],
        box_id: currentSelectedLocation ? currentSelectedLocation.id : (this.state && this.state.box_id),
        selectedBox: currentSelectedLocation,
        searchedItems: {
          ...prevState.searchedItems,
          AddressLine1: AddressLine1,
          AddressLine2: AddressLine2,
          City: City,
          State: State,
          Zip: Zip,
          Country: Country,
        },
        address: {
          address1: AddressLine1,
          address2: AddressLine2,
          city: City,
          state: State,
          zip: Zip,
          country: Country
        },
      }), () => {
        const effectiveBoxId = this.state.box_id || (currentSelectedLocation && currentSelectedLocation.id);
        if (effectiveBoxId) {
          this.syncAssignUIFromBoxRegion(effectiveBoxId);
          this.getBoxesByID(effectiveBoxId);
        }
      });
      this.getBoxes();
    } else {
      this.setState({
        boxDetails: [],
        boxItems: [],
        selectedBox: null,
      });
    }
  };

  getBoxes(value) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'boxes', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          const boxesResponse = response.json();
          return boxesResponse;
        } catch (error) {
          return null;
        }
      })
      .then((boxtypes) => {
        if (boxtypes) {
          this.setState({ boxdata: boxtypes });
          const boxTypes = boxtypes.map((type) => {
            return {
              id: type.id,
              label: type.name,
              accountId: type.parent_account_id,
            };
          });
          if (boxtypes.length > 0) {
            if (value === 0) {
              const preferredBox = this.findBoxInList(boxTypes, this.getPreferredLocationId());
              const defaultSelectedBoxId =
                this.state.box_id ||
                (preferredBox && preferredBox.id) ||
                boxTypes[0].id;
              if (!this.state.box_id) {
                this.setState({ box_id: defaultSelectedBoxId });
              }
              this.getAssignedBins(defaultSelectedBoxId);
              this.getPharmacyDetails(defaultSelectedBoxId);
              this.getExpansionBins(defaultSelectedBoxId);
            } else {
              this.getAssignedBins(this.state && this.state.box_id);
              this.getPharmacyDetails(this.state && this.state.box_id);
              this.getExpansionBins(this.state && this.state.box_id);
            }
          }
          this.setState({ boxTypes, printDialogOpen: false, loader: false });
        } else {
          this.setState({ loader: false });
        }
      }).catch((error) => {
        this.setState({ loader: false });
        this.getBoxes(value);
      });
  }

  fetchAllBoxesForTabs = async () => {
    const parentAccountId = sessionStorage.getItem('parentAccountId');
    if (![undefined, 'undefined', null, 'null', ''].includes(parentAccountId)) {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASEURL}getBoxesByStoreId/${parentAccountId}`, {
          method: 'GET',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
          }
        });
        
        if (response.ok) {
          const allBoxes = await response.json();
          this.setState({ allBoxes: allBoxes || [] }, () => {
            this.syncAssignableLocationTypes(allBoxes || []);
            // Auto-select preferred location for Counter/Bedside if available
            this.selectPreferredCounterLocation(allBoxes);
            if (
              this.state.locationtype_id === LOCATION_TYPE.Kiosk &&
              this.state.box_id
            ) {
              this.syncAssignUIFromBoxRegion(this.state.box_id);
            }
          });
        }
      } catch (error) {
        console.error('Error fetching all boxes for Counter component:', error);
        this.setState({ allBoxes: [] });
      }
    }
  };

  componentWillMount() {
    searchedRxItems = [];
    this.setState({ assignCartItems: null });
  }

  GetAcccountConnectionId = () => {
    this.setState({ loader: true });
    fetch(`${process.env.REACT_APP_BASEURL}getConnection`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accountConnectionsId) => {
        this.setState({ loader: false });
        if (accountConnectionsId) {
          // Check if connection_details is missing for PioneerRx and fetch full account details
          if (!accountConnectionsId.connection_details && 
              accountConnectionsId.id && 
              accountConnectionsId.account_connections_id === CONNECTION_TYPE.PIONEERRX) {
            this.fetchFullAccountDetails(accountConnectionsId.id);
          }
          this.setState({ globalAccountConnection: accountConnectionsId });
          if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id ===
            CONNECTION_TYPE.UNPLUGGED
          ) {
            navigate('/home/prescription/unpluggedassign');
          }
          else if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id === CONNECTION_TYPE.QS1
          ) {
            rxMaxLength = 12;
          } else if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id ===
            CONNECTION_TYPE.ILOCALBOX_PHARMACY
          ) {
            rxMaxLength = 6 || 7;
          }
          if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id !==
            CONNECTION_TYPE.UNPLUGGED
          ) {
            setTimeout(() => {
              this.textInput &&
                this.textInput.current &&
                this.textInput.current.focus &&
                this.handleFocus();
            }, 3000);
          }
        } else {
          rxMaxLength = 6 || 7;
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  fetchFullAccountDetails = (accountId) => {
    fetch(`${process.env.REACT_APP_BASEURL}account/${accountId}`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((fullAccountData) => {
        // Update globalAccountConnection with the full data including connection_details
        if (fullAccountData && fullAccountData[0]) {
          this.setState({ globalAccountConnection: fullAccountData[0] });
        }
      })
      .catch((error) => {
        console.error('Error fetching full account details:', error);
      });
  };

  shouldUseNumericOrderCodes = () => {
    let isNumericCode = false;
    try {
      const raw = localStorage.getItem('isNumericCode');
      if (raw != null && raw !== '') {
        isNumericCode = JSON.parse(raw);
      }
    } catch (e) {
      isNumericCode = false;
    }
    return [true, 'true'].includes(this.state.isOpenPath) || !!isNumericCode;
  };

  generateCodes() {
    const generation = (this._orderCodeGeneration || 0) + 1;
    this._orderCodeGeneration = generation;
    const codes = this.buildRandomOrderCodes(this.shouldUseNumericOrderCodes());
    setTimeout(() => {
      if (generation !== this._orderCodeGeneration) {
        return;
      }
      this.checkIfCodesExists(codes, 0, generation);
    }, 100);
  }

  buildRandomOrderCodes = (useNumeric) => {
    if (useNumeric) {
      return {
        stockCode: randomized('0', 4),
        pickupCode: randomized('0', 4),
        useNumeric: true,
      };
    }
    return {
      stockCode: randomized('A0', 6, { exclude: '0oOiIlL1&zZ' }),
      pickupCode: randomized('A0', 6, { exclude: '0oOiIlL1&zZ' }),
      useNumeric: false,
    };
  };

  verifyOrderCodesExist = async (codes) => {
    const response = await fetch(process.env.REACT_APP_BASEURL + 'verify/codes', {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify({
        stockCode: codes.stockCode,
        pickupCode: codes.pickupCode,
      }),
    });
    const res = await response.json();
    return !!(res && res.isExist === true);
  };

  commitOrderCodes = (codes) => new Promise((resolve) => {
    this.setState(
      { stockCode: codes.stockCode, pickupCode: codes.pickupCode },
      resolve
    );
  });

  ensureUnusedOrderCodes = async () => {
    const currentStock = (this.state.stockCode || '').trim();
    const currentPickup = (this.state.pickupCode || '').trim();
    const reused =
      this._lastAssignedStockCode &&
      currentStock === this._lastAssignedStockCode;
    if (currentStock && currentPickup && !reused) {
      return;
    }
    const generation = (this._orderCodeGeneration || 0) + 1;
    this._orderCodeGeneration = generation;
    const useNumeric = this.shouldUseNumericOrderCodes();
    let codes = this.buildRandomOrderCodes(useNumeric);
    for (let attempt = 0; attempt < 8; attempt += 1) {
      if (generation !== this._orderCodeGeneration) {
        return;
      }
      let exists = false;
      try {
        exists = await this.verifyOrderCodesExist(codes);
      } catch (error) {
        exists = false;
      }
      const sameAsLast =
        this._lastAssignedStockCode &&
        codes.stockCode === this._lastAssignedStockCode;
      if (!exists && !sameAsLast) {
        await this.commitOrderCodes(codes);
        return;
      }
      codes = this.buildRandomOrderCodes(attempt >= 6 ? false : useNumeric);
    }
    if (generation !== this._orderCodeGeneration) {
      return;
    }
    await this.commitOrderCodes(codes);
  };

  isValidRx(rxno) {
    let customer = this.state.rxDetails.filter((element) =>
      element.orders.some((order) =>
        order.items.some((item) => {
          const trulyValue =
            item.rxNo.toString().toLowerCase() ===
            rxno.toString().toLowerCase();
          if (!trulyValue) {
            return false;
          }
          return trulyValue;
        })
      )
    );
    return customer.length;
  }

  fetchTransactions = (requestParams) => {
    this.setState({ isLoadingTrans: true });
    let tran = {};
    if (requestParams) {
      fetch(process.env.REACT_APP_BASEURL + 'qs/rxTransactions', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(requestParams),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          this.setState({ isLoadingTrans: false });
          tran = JSON.parse(res);
          let rxDetails = tran.rxdetails;
          searchedRxItems.map((i, index) => {
            /*-----Start Modification----- */
            /*
              Modified By: Belani Jaimin
              Modified Date: 01/22/2020
              Description: Check weather Zero is Exist or not as first character. If yes then do not add padded Zero as prefix else add Zero for QS1
            */
            // let _firstCharZero = this.state && this.state.rxNumber.charAt(0); //
            let RxNumber = rxDetails.RxNumber;
            
            // if (_firstCharZero === 0 || _firstCharZero === '0') {
            //   if (this.state && this.state.rxNumber.length === 12) {
            //     RxNumber =
            //       this.state &&
            //       this.state.rxNumber.slice(
            //         0,
            //         this.state && this.state.rxNumber.length - 4
            //       );
            //   } else {
            //     RxNumber = this.state.rxNumber;
            //   }
            // } else {
            //   RxNumber = '0' + this.state.rxNumber;
            // }

            /*-----End Modification----- */
            // Removed By : Belani Jaimin
            // Date: 01/22/2020
            // Description: Removed because It was appending 2 zeros before Rx Number.
            // let RxNumber = '0' + this.state.rxNumber
            if (RxNumber.length > 8) {
              RxNumber = RxNumber.substr(4, RxNumber.length - 8);
            }
            if (i.rxNo === RxNumber) {
              searchedRxItems[index].ndcCode =
                (rxDetails && rxDetails.NDC) || '';
              searchedRxItems[index].qty =
                (rxDetails && rxDetails.QuantityDispensed) || 0;
              searchedRxItems[index].isLoadingTrans = false;
              searchedRxItems[index].SeqNumber =
                (rxDetails && rxDetails.SeqNumber) || 0;
              searchedRxItems[index].fillNumber =
                (rxDetails && rxDetails.FillNumber) || 0;  
            }
            return true;
          });
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
          this.forceUpdate();
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };
  onChange = (event) => {
    const patientId =
      this.state &&
      this.state.searchedItems &&
      this.state.searchedItems.PatientID;
    const searchedString = event.target.value;
    this.setState({
      isEdit: false,
      doesPrescriptionScanned: true,
      rxNumber: searchedString && searchedString,
    });

    // Check connection type and route to appropriate handler for Counter Rx scanning
    const { globalAccountConnection } = this.state;
    const connectionTypeId = globalAccountConnection && globalAccountConnection.account_connections_id;

    // Handle Epic and Epic With MTLS Rx scanning
    if ((connectionTypeId === CONNECTION_TYPE.EPIC || connectionTypeId === CONNECTION_TYPE.EPIC_WITH_MTLS) &&
        searchedString && searchedString.trim().length > 0) {
      // Create synthetic event with Enter keyCode to trigger Epic Rx handler
      const syntheticEvent = {
        target: { value: searchedString },
        keyCode: 13,
        preventDefault: () => {},
      };
      const pmsType = connectionTypeId === CONNECTION_TYPE.EPIC ? 'EPIC' : 'Epic With MTLS';
      // Call handleRxCheck which will process Epic Rx scanning
      this.handleRxCheck(syntheticEvent, pmsType);
      return;
    }

    // Default flow for other connection types (BASIC, etc.)
    if (
      searchedString.toString().toUpperCase().length > 0 &&
      searchedString.toString().toUpperCase().length >= rxMaxLength
    ) {
      let isValid = this.isValidRx(searchedString);
      if (isValid > 0) {
        fetch(
          process.env.REACT_APP_BASEURL + 'checkrxexistornot/' + searchedString + '/false',
          {
            method: 'GET',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession
                  .idToken.jwtToken,
            },
          }
        )
          .then((response) => response.json())
          .then((boxes) => {
            if (boxes && !boxes.Rx_Is_Exist) {
              const data = this.state.rxDetails;
              if (this.state.searchedRxNo.length === 0) {
                this.state.rxDetails.filter((element) =>
                  element.orders.some((order) =>
                    order.items.some((items) => {
                      const trulyValue =
                        items.rxNo.toString().toUpperCase() ===
                        searchedString.toString().toUpperCase();
                      if (trulyValue) {
                        searchedRxItems.push(items);
                        this.setState({
                          searchedItems: element,
                          EmailID: element.EmailID,
                        });
                        this.checkADACompatible(
                          element.PatientID,
                          this.state && this.state.EmailID
                        );
                        if (searchedString.toString().length === rxMaxLength) {
                          this.setState({
                            searchedRxNo: [
                              ...this.state.searchedRxNo,
                              searchedString.toString().length ===
                              rxMaxLength && searchedString,
                            ],
                          });
                        }
                        this.setState({
                          rxNumber: '',
                        });
                        this.handleFocus();
                      }
                      return trulyValue;
                    })
                  )
                );
              } else {
                this.state.searchedRxNo.forEach((item) => {
                  // current rxNo
                  const rxno = this.state.rxNumber.toString().toUpperCase();
                  let currentRxObj = [];
                  data.filter((element) =>
                    element.orders.filter((order) =>
                      order.items.some((items) => {
                        if (items.rxNo.toString().toUpperCase() === rxno) {
                          currentRxObj = element;
                          this.setState({ EmailID: element.EmailID });
                          this.checkADACompatible(
                            element.PatientID,
                            this.state && this.state.EmailID
                          );
                        }
                        return true;
                      })
                    )
                  );

                  if (
                    this.state.searchedItems.PatientID !==
                    currentRxObj.PatientID &&
                    currentRxObj.PatientID !== undefined
                  ) {
                    toast.error(this.props.t('Toast.Error.WrongPatient'));
                    this.setState({
                      rxNumber: '',
                    });
                    this.handleFocus();
                  } else {
                    if (searchedString !== item) {
                      data.filter((element) =>
                        element.orders.some((order) =>
                          order.items.some((items) => {
                            const trulyValue =
                              items.rxNo.toString().toUpperCase() ===
                              searchedString.toString().toUpperCase() &&
                              patientId === element.PatientID;
                            if (trulyValue) {
                              var test = false;
                              for (var i = 0; i < searchedRxItems.length; i++) {
                                if (
                                  searchedRxItems[i].rxNo
                                    .toString()
                                    .toUpperCase() ===
                                  searchedString.toString().toUpperCase()
                                ) {
                                  test = true;
                                }
                              }
                              if (!test) {
                                searchedRxItems.push(items);
                                this.setState({ searchedItems: element });
                                this.setState({ EmailID: element.EmailID });
                                this.checkADACompatible(
                                  element.PatientID,
                                  this.state && this.state.EmailID
                                );
                                if (
                                  searchedString.toString().length ===
                                  rxMaxLength
                                ) {
                                  this.setState({
                                    searchedRxNo: [
                                      ...this.state.searchedRxNo,
                                      searchedString.toString().length ===
                                      rxMaxLength && searchedString,
                                    ],
                                  });
                                }
                              }
                              this.setState({
                                rxNumber: '',
                              });
                              this.handleFocus();
                            }
                            return trulyValue;
                          })
                        )
                      );
                    }
                  }
                });
              }
              this.setState({ readOnly: false });
            } else {
              this.setState({
                rxNumber: '',
              });
              this.handleFocus();
              toast.error(this.props.t('Toast.Error.RxAssigned'));
            }
          }).catch(() => {
            this.setState({ loader: false });
          });
      } else if (
        searchedString.substring(0, 3).toUpperCase() === 'A11' &&
        this.state.accountDetails.connection &&
        this.state.accountDetails.connection.id ===
        CONNECTION_TYPE.ILOCALBOX_PHARMACY
      ) {
        //Assign single Rx for Patient
        if (this.state.searchedRxNo.length === 0) {
          var patient = DemoData.randomPatient();
          patient.EmailID =
            (this.state.accountDetails &&
              this.state.accountDetails.demo_email) ||
            this.state.EmailID;
          patient.MobileNo =
            (this.state.accountDetails &&
              this.state.accountDetails.demo_phone) ||
            this.state.phone;
          var items = DemoData.randomRx();
          items.rxNo = searchedString;
          items.patientId = patient.PatientID;
          searchedRxItems.push(items);
          this.checkADACompatible(patient.PatientID, patient.EmailID);
          this.getcustomerLocation(patient, items, 'A11');
          this.setState({
            EmailID: patient.EmailID,
            phone: patient.MobileNo,
            alternateAgents: patient.alternateAgents,
            searchedRxNo: [
              ...this.state.searchedRxNo,
              searchedString.toString().length === rxMaxLength &&
              searchedString,
            ],
            rxNumber: '',
            readOnly: false,
          });
          this.handleFocus();
        } else if (this.state.searchedRxNo[0] === searchedString) {
          //Do nothing.
          this.setState({ readOnly: false })
        } else {
          toast.error(this.props.t('Toast.Error.WrongPatient'));
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        }
      } else if (
        searchedString.substring(0, 3).toUpperCase() === 'A22' &&
        this.state.accountDetails.connection &&
        this.state.accountDetails.connection.id ===
        CONNECTION_TYPE.ILOCALBOX_PHARMACY
      ) {
        //Assign multi Rx for Patient
        const res3 = searchedRxItems.some((elm) => {
          if (
            elm.rxNo &&
            elm.rxNo.toUpperCase() === searchedString.toUpperCase()
          ) {
            return true;
          } else {
            return false;
          }
        });

        if (res3) {
          if (this.state.accountDetails && this.state.accountDetails.demo_email) {
            this.setState({ EmailID: this.state.accountDetails.demo_email });
          } else if (this.state.searchedItems && this.state.searchedItems.EmailID) {
            this.setState({ EmailID: this.state.searchedItems.EmailID });
          }
          return;
        }
        if (this.state.searchedRxNo.length === 0) {
          var patient1 = DemoData.randomPatient();
          patient1.EmailID =
            this.state.accountDetails && this.state.accountDetails.demo_email;
          patient1.MobileNo =
            this.state.accountDetails && this.state.accountDetails.demo_phone;
          if (!patient1.orders || !patient1.orders[0]) {
            patient1.orders = [{
              items: []
            }];
          }
          var items1 = DemoData.randomRx();
          items1.rxNo = searchedString;
          items1.patientId = patient1.PatientID;
          items1.name =
            items1.name +
            ' ' +
            Math.floor(Math.random() * 100 + 1) +
            randomized(' ', 1, { exclude: '0oOiIlL1&zZ' });
          searchedRxItems.push(items1);
          if (patient1.orders[0] && patient1.orders[0].items) {
            patient1.orders[0].items.push(items1);
          }
          this.setState({
            searchedItems: patient1,
            EmailID: patient1.EmailID,
            phone: patient1.MobileNo,
            alternateAgents: patient1.alternateAgents,
          });
          this.checkADACompatible(patient1.PatientID, patient1.EmailID);
          this.getcustomerLocation(patient1, items1, 'A22');
          this.setState({
            searchedRxNo: [
              ...this.state.searchedRxNo,
              searchedString.toString().length === rxMaxLength &&
              searchedString,
            ],
            readOnly: false,
          });
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        } else {
          var patient2 = this.state.searchedItems;
          const res = this.state.rxDetails.some((element) => {
            if (element.PatientID === patient2.PatientID) {
              return true;
            } else {
              return false;
            }
          });

          const res2 = searchedRxItems.some((elm) => {
            const prefix = elm.rxNo && elm.rxNo.substring(0, 3).toUpperCase();
            return prefix === 'A11' || prefix === 'A33' || prefix === 'A55';
          });

          if (!res && !res2) {
            var orderItems = this.state.searchedItems.orders[0];
            var items2 = DemoData.randomRx();
            items2.patientId = patient2.PatientID;
            items2.rxNo = searchedString;
            items2.name =
              items2.name +
              ' ' +
              Math.floor(Math.random() * 100 + 1) +
              +randomized(' ', 1, { exclude: '0oOiIlL1&zZ' });
            items2.ndcCode =
              Math.floor(Math.random() * 100000 + 1) +
              '-' +
              Math.floor(Math.random() * 1000 + 1);
            searchedRxItems.push(items2);
            orderItems && orderItems.items && orderItems.items.push && orderItems.items.push(items2);
            patient2.orders[0] = orderItems;

            this.setState({ searchedItems: patient2 });
            const emailToSet = patient2.EmailID || 
                              this.state.EmailID || 
                              (this.state.accountDetails && this.state.accountDetails.demo_email) || 
                              '';
            this.setState({ 
              EmailID: emailToSet, 
              alternateAgents: (patient && patient.alternateAgents) || (patient2 && patient2.alternateAgents) 
            });
            this.checkADACompatible(
              patient2.PatientID,
              this.state && this.state.EmailID
            );
            if (searchedString.toString().length === rxMaxLength) {
              this.setState({
                searchedRxNo: [
                  ...this.state.searchedRxNo,
                  searchedString.toString().length === rxMaxLength &&
                  searchedString,
                ],
                readOnly: false,
              });
            }
          } else {
            toast.error(this.props.t('Toast.Error.WrongPatient'));
          }

          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        }
      } else if (
        searchedString.substring(0, 3).toUpperCase() === 'A33' &&
        this.state.accountDetails.connection &&
        this.state.accountDetails.connection.id ===
        CONNECTION_TYPE.ILOCALBOX_PHARMACY
      ) {
        // Assign multi Rx for Patient (A33 flow, same as A22)
        const res3 = searchedRxItems.some((elm) => {
          if (
            elm.rxNo &&
            elm.rxNo.toUpperCase() === searchedString.toUpperCase()
          ) {
            return true;
          } else {
            return false;
          }
        });

        if (res3) {
          if (this.state.accountDetails && this.state.accountDetails.demo_email) {
            this.setState({ EmailID: this.state.accountDetails.demo_email });
          } else if (this.state.searchedItems && this.state.searchedItems.EmailID) {
            this.setState({ EmailID: this.state.searchedItems.EmailID });
          }
          return;
        }
        if (this.state.searchedRxNo.length === 0) {
          const patient1A33 = DemoData.randomPatient();
          patient1A33.EmailID =
            this.state.accountDetails && this.state.accountDetails.demo_email;
          patient1A33.MobileNo =
            this.state.accountDetails && this.state.accountDetails.demo_phone;
          if (!patient1A33.orders || !patient1A33.orders[0]) {
            patient1A33.orders = [{
              items: []
            }];
          }
          const items1A33 = DemoData.randomRx();
          items1A33.rxNo = searchedString;
          items1A33.patientId = patient1A33.PatientID;
          items1A33.AllFlags = getFlagsForA33Item({
            apiFlagCodes: this.state.accountSignatureFlagCodes,
            dummyMin: 2,
            dummyMax: 5,
          });
          items1A33.PrescriptionFlags = items1A33.AllFlags || [];
          items1A33.Flags = items1A33.AllFlags || [];
          items1A33.name =
            items1A33.name +
            ' ' +
            Math.floor(Math.random() * 100 + 1) +
            randomized(' ', 1, { exclude: '0oOiIlL1&zZ' });
          searchedRxItems.push(items1A33);
          if (patient1A33.orders[0] && patient1A33.orders[0].items) {
            patient1A33.orders[0].items.push(items1A33);
          }
          this.setState({
            searchedItems: patient1A33,
            EmailID: patient1A33.EmailID,
            phone: patient1A33.MobileNo,
            alternateAgents: patient1A33.alternateAgents,
          });
          this.checkADACompatible(patient1A33.PatientID, patient1A33.EmailID);
          this.getcustomerLocation(patient1A33, items1A33, 'A33');
          this.setState({
            searchedRxNo: [
              ...this.state.searchedRxNo,
              searchedString.toString().length === rxMaxLength &&
              searchedString,
            ],
            readOnly: false,
          });
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        } else {
          const patient2A33 = this.state.searchedItems;
          const res = this.state.rxDetails.some((element) => {
            if (element.PatientID === patient2A33.PatientID) {
              return true;
            } else {
              return false;
            }
          });

          const res2 = searchedRxItems.some((elm) => {
            const prefix = elm.rxNo && elm.rxNo.substring(0, 3).toUpperCase();
            return prefix === 'A11' || prefix === 'A22' || prefix === 'A55';
          });

          if (!res && !res2) {
            const orderItemsA33 = this.state.searchedItems.orders[0];
            const items2A33 = DemoData.randomRx();
            items2A33.patientId = patient2A33.PatientID;
            items2A33.rxNo = searchedString;
            items2A33.AllFlags = getFlagsForA33Item({
              apiFlagCodes: this.state.accountSignatureFlagCodes,
              dummyMin: 2,
              dummyMax: 5,
            });
            items2A33.PrescriptionFlags = items2A33.AllFlags || [];
            items2A33.Flags = items2A33.AllFlags || [];
            items2A33.name =
              items2A33.name +
              ' ' +
              Math.floor(Math.random() * 100 + 1) +
              +randomized(' ', 1, { exclude: '0oOiIlL1&zZ' });
            items2A33.ndcCode =
              Math.floor(Math.random() * 100000 + 1) +
              '-' +
              Math.floor(Math.random() * 1000 + 1);
            searchedRxItems.push(items2A33);
            orderItemsA33 && orderItemsA33.items && orderItemsA33.items.push && orderItemsA33.items.push(items2A33);
            patient2A33.orders[0] = orderItemsA33;

            this.setState({ searchedItems: patient2A33 });
            const emailToSet = patient2A33.EmailID ||
                              this.state.EmailID ||
                              (this.state.accountDetails && this.state.accountDetails.demo_email) ||
                              '';
            this.setState({
              EmailID: emailToSet,
              alternateAgents: (patient && patient.alternateAgents) || (patient2A33 && patient2A33.alternateAgents)
            });
            this.checkADACompatible(
              patient2A33.PatientID,
              this.state && this.state.EmailID
            );
            if (searchedString.toString().length === rxMaxLength) {
              this.setState({
                searchedRxNo: [
                  ...this.state.searchedRxNo,
                  searchedString.toString().length === rxMaxLength &&
                  searchedString,
                ],
                readOnly: false,
              });
            }
          } else {
            toast.error(this.props.t('Toast.Error.WrongPatient'));
          }

          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        }
      } else if (
        searchedString.substring(0, 3).toUpperCase() === 'A55' &&
        this.state.accountDetails.connection &&
        this.state.accountDetails.connection.id ===
        CONNECTION_TYPE.ILOCALBOX_PHARMACY
      ) {
        if (process.env.NODE_ENV !== 'production') {
          console.log('[A55 Demo] A55 branch entered', {
            searchedString,
            rxMaxLength,
            searchedRxNoLength: this.state.searchedRxNo.length,
            bypass_consult: this.state.accountDetails && this.state.accountDetails.bypass_consult,
            locationtype_id: this.state.locationtype_id,
          });
        }
        // Assign single Rx – random controlled substance (ID capture + consult at pickup)
        if (this.state.searchedRxNo.length === 0) {
          const patientA55 = DemoData.randomPatient();
          patientA55.EmailID =
            (this.state.accountDetails &&
              this.state.accountDetails.demo_email) ||
            this.state.EmailID;
          patientA55.MobileNo =
            (this.state.accountDetails &&
              this.state.accountDetails.demo_phone) ||
            this.state.phone;
          const itemsA55 = DemoData.randomRx();
          const a55Flags = DemoData.getA55DemoRxFlags(searchedString);
          const a55BypassOn = isBypassConsultEnabled(this.state.accountDetails);
          // Demo consult rolls are auto-derived — respect bypass_consult like other PMS paths.
          const a55ConsultRequired = a55BypassOn
            ? false
            : a55Flags.ConsultRequire;
          itemsA55.rxNo = searchedString;
          itemsA55.patientId = patientA55.PatientID;
          itemsA55.is_controlled_substance = a55Flags.is_controlled_substance;
          itemsA55.ConsultRequire = a55ConsultRequired;
          itemsA55.is_consultrequire = a55ConsultRequired;
          itemsA55.consultRequireManual = false;
          searchedRxItems.push(itemsA55);
          if (process.env.NODE_ENV !== 'production') {
            const consultCheckboxChecked = !(
              itemsA55.ConsultRequire !== true && itemsA55.is_consultrequire !== true
            );
            console.log('[A55 Demo] item after flags applied', {
              rxNo: itemsA55.rxNo,
              drugName: itemsA55.name,
              ConsultRequire: itemsA55.ConsultRequire,
              is_consultrequire: itemsA55.is_consultrequire,
              is_controlled_substance: itemsA55.is_controlled_substance,
              bypass_consult: a55BypassOn,
              demo_consult_rolled: a55Flags.ConsultRequire,
              consultCheckboxChecked,
              searchedRxItemsCount: searchedRxItems.length,
            });
          }
          this.checkADACompatible(patientA55.PatientID, patientA55.EmailID);
          this.getcustomerLocation(patientA55, itemsA55, 'A55');
          this.setState({
            EmailID: patientA55.EmailID,
            phone: patientA55.MobileNo,
            alternateAgents: patientA55.alternateAgents,
            is_controlled_substance: a55Flags.is_controlled_substance,
            searchedRxNo: [
              ...this.state.searchedRxNo,
              searchedString.toString().length === rxMaxLength &&
              searchedString,
            ],
            rxNumber: '',
            readOnly: false,
          }, () => {
            if (process.env.NODE_ENV !== 'production') {
              const cartItem = searchedRxItems.find(
                (x) => String(x.rxNo || '').toUpperCase() === searchedString.toUpperCase()
              );
              console.log('[A55 Demo] setState complete (cart row)', {
                searchedRxNo: this.state.searchedRxNo,
                cartItem: cartItem
                  ? {
                      rxNo: cartItem.rxNo,
                      ConsultRequire: cartItem.ConsultRequire,
                      is_consultrequire: cartItem.is_consultrequire,
                      is_controlled_substance: cartItem.is_controlled_substance,
                    }
                  : null,
              });
            }
            this.forceUpdate();
          });
          this.handleFocus();
        } else if (this.state.searchedRxNo[0] === searchedString) {
          this.setState({ readOnly: false });
        } else {
          toast.error(this.props.t('Toast.Error.WrongPatient'));
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        }
      }
      let unique = [...new Set(searchedRxItems)];
      searchedRxItems = [];
      searchedRxItems = unique;
      if (searchedRxItems.length > 0) {
        this.forceUpdate();
      }
      if (
        process.env.NODE_ENV !== 'production' &&
        searchedString.substring(0, 3).toUpperCase() === 'A55'
      ) {
        console.log('[A55 Demo] cart after dedupe', {
          searchedString,
          cart: searchedRxItems.map((item) => ({
            rxNo: item.rxNo,
            ConsultRequire: item.ConsultRequire,
            is_consultrequire: item.is_consultrequire,
            is_controlled_substance: item.is_controlled_substance,
          })),
        });
      }
    }
  };

  checkADACompatible = (PatientID, EmailID) => {
    this.setState({ loader: true });
    let patientObj = {
      PatientID: PatientID,
      EmailID: EmailID,
    };
    fetch(process.env.REACT_APP_BASEURL + 'getADACompatiblePatients', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(patientObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((Pdata) => {
        if (Pdata && Pdata.ADAcustomers && Pdata.ADAcustomers.length > 0) {
          this.setState({
            ADAData: Pdata.ADAcustomers,
            isADACompatible: true,
            loader: false
          });
        } else {
          this.setState({ ADAData: [], isADACompatible: false, loader: false });
        }
      })
      .catch((error) => {
        toast.error(JSON.stringify(error));
        this.setState({ loader: false });
      });
  };
  getSelectedBin = (binId, position, flag) => {
    const { deactivatedBins } = this.state;
    const patch = {
      isBinDeactivated: deactivatedBins.includes(binId),
      selectedBinId: binId,
      box_position: position,
      isSelectedFlag: flag,
    };
    if (!this.binHasActiveOrder(binId)) {
      Object.assign(patch, this.clearHoldResumeOrderState());
    }
    this.setState(patch);
  };

  /*
      Added By : Belani Jaimin
      Added Date : 02/11/2019
      Description : Get Bin Status
    */
  getAssignedBins = (box_id) => {
    if (resolveSizeBasedAssignUIFromBox(this.findBoxById(box_id))) {
      const box = this.findBoxById(box_id) || this.state.selectedBox;
      let deactivatedBins = [];
      if (box && typeof box.disabled_bins === 'string' && box.disabled_bins.trim().length > 0) {
        deactivatedBins = box.disabled_bins.split(',').map((b) => b.trim()).filter(Boolean);
      }
      this.setState({ loader: false, BinStatus: [], deactivatedBins });
      return;
    }
    this.setState({ loader: true });
    let _binStatus = [];
    const { selectedBox } = this.state;
    if (!box_id) {
      this.setState({ loader: false });
      return;
    }
    if (box_id) {
      fetch(process.env.REACT_APP_BASEURL + 'api/v2/orders/occupied-bins/' + box_id, {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((bins) => {
          this.setState({ loader: false });
          let deactivatedBins;
          _binStatus = JSON.parse(bins);
          if (_binStatus && _binStatus[0] && _binStatus[0].disabled_bins) {
            deactivatedBins = _binStatus[0].disabled_bins.toString().split(',');
            this.setState({ deactivatedBins: deactivatedBins });
          } else {
            if (selectedBox && typeof selectedBox.disabled_bins === 'string') {
              let disabledBinsStr = selectedBox.disabled_bins.trim();
              if (disabledBinsStr.length > 0) {
                // Split by comma, trim each, filter out empty
                let binsArray = disabledBinsStr.split(',').map(b => b.trim()).filter(b => b.length > 0);
                this.setState({ deactivatedBins: binsArray });
              } else {
                this.setState({ deactivatedBins: [] });
              }
            } else {
              this.setState({ deactivatedBins: [] });
            }
          }
          this.setState({ BinStatus: _binStatus });
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  getBoxesByID = (id) => {
    fetch(`${process.env.REACT_APP_BASEURL}boxes/${id}`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((boxes) => {
        // Handle both array and single object responses
        const boxData = Array.isArray(boxes) && boxes.length > 0 ? boxes[0] : boxes;
        
        if (boxData) {
          this.setState(
            {
              courier_type:
                boxData.courier_type && boxData.courier_type.length > 0
                  ? boxData.courier_type.map((val) => {
                    return val.courier_type;
                  })
                  : [],
              boxTypeId: boxData.type_id || '',
              currentBoxData: boxData, // Store full box data in separate state
              selectedBox: boxData,
              isOpenPath: boxData.openpath
            },
            () => {
              if (this.state.courier_type.length > 0) {
                this.setState({
                  default_courier_selected:
                    boxData.courier_type[0].default_courier_type,
                });
              }
              // Always set address state when box data is available
              const addr = boxData.address || boxData;
              const address = {
                address1: addr.address_line_1 || boxData.address_line_1 || '',
                address2: addr.address_line_2 || boxData.address_line_2 || '',
                city: addr.city || boxData.city || '',
                state: addr.state || boxData.state || '',
                zip: addr.zip || boxData.zip || '',
                country: addr.country || boxData.country || ''
              };
              this.setState({ address });
              this.syncSelectedPaymentDeviceForBox(boxData);
              this.syncAssignUIFromBoxRegion(id);
            }
          );
          let search = this.state.searchedItems;
          if (search && boxData.location_notes) {
            search.location_notes = '';
            search.location_notes = boxData.location_notes;
            this.setState({ searchedItems: search });
          }
          this.getAssignedBins(id);
          this.getPharmacyDetails(id);
          this.getExpansionBins(id);
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleChange = async (event) => {
    const  { 
      boxDetails
    } = this.state;
    const newBoxId = event.target.value;
    if (newBoxId == null || newBoxId === '') {
      return;
    }
    const locationDetails = this.findBoxInList(boxDetails, newBoxId);
    if (!locationDetails) {
      return;
    }
    this.setState({ box_id: newBoxId })
    this.syncAssignUIFromBoxRegion(newBoxId);
    this.getExpansionBins(event.target.value);
    if (!resolveSizeBasedAssignUIFromBox(locationDetails)) {
      this.getAssignedBins(event.target.value);
    }
    // Fetch full box details for currentBoxData
    this.getBoxesByID(event.target.value);
    let AddressLine1 = '', 
    AddressLine2 = '', 
    City = '', 
    State = '', 
    Zip = '', 
    Country = '';
    if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
      const addr = locationDetails.address || locationDetails;
      AddressLine1 = addr.address_line_1 || locationDetails.address_line_1 || "";
      AddressLine2 = addr.address_line_2 || locationDetails.address_line_2 || "";
      City = addr.city || locationDetails.city || "";
      State = addr.state || locationDetails.state || "";
      Zip = addr.zip || locationDetails.zip || "";
      Country = addr.country || locationDetails.country || "";
    }
    this.setState(prevState => ({
      searchedItems: {
        ...prevState.searchedItems,
        AddressLine1: AddressLine1,
        AddressLine2: AddressLine2,
        City: City,
        State: State,
        Zip: Zip,
        Country: Country
      },
      boxTypeId: locationDetails.type_id,
      selectedBox: locationDetails
    }), () => {
      // Always set address state when box data is available
      const address = {
        address1: AddressLine1,
        address2: AddressLine2,
        city: City,
        state: State,
        zip: Zip,
        country: Country
      };
      this.setState({ address });
    });
  };

  handletypeChange = async (event) => {
    const newLocationType = event.target.value;
    this.handleLocationTypeChange(newLocationType);
  };

  handleLocationTypeChange = async (newLocationType) => {
    if (
      Array.isArray(this.state.featureEntitlements) &&
      !isLocationTypeUsable(newLocationType, this.state.featureEntitlements)
    ) {
      return;
    }
    const locationTypeName = (this.state.locationtype && this.state.locationtype.find(l => l.id === newLocationType)) ? this.state.locationtype.find(l => l.id === newLocationType).label : 'Unknown';
    console.log('📍 [ASSIGN PRESCRIPTION] Location Type Changed:', {
      oldLocationType: this.state.locationtype_id,
      newLocationType: newLocationType,
      locationTypeName: locationTypeName
    });
    // Save to localStorage to persist user's selection
    localStorage.setItem('selectedLocationTypeId', newLocationType);
    this.syncDeliveryTypeInUrl(newLocationType);
    const isReusableStorageLocationTypeSelected = isReusableStorageLocationType(newLocationType);
    this.setState({
      locationtype_id: newLocationType,
      ...(!isReusableStorageLocationTypeSelected
        ? {
            defaultCheckInLocation: null,
            defaultCheckInLocationBoxId: null,
            bedsideLocationOptions: [],
            storage_location: "",
            locationData: null,
            isLoadingCheckInDefault: false,
          }
        : {}),
    }, () => {
      this.getAllBoxes(newLocationType);
      if (this.state.allBoxes && this.state.allBoxes.length > 0) {
        this.selectPreferredCounterLocation(this.state.allBoxes);
      }
    });
  };

  selectPreferredCounterLocation = (allBoxes) => {
    const locationtype_id = this.state.locationtype_id;
    if (!locationtype_id || !allBoxes || allBoxes.length === 0) {
      return;
    }

    const boxesForType = this.getAssignableBoxes(allBoxes).filter(box => {
      const boxLocationTypeId = box.location_type_id || box.locationtype_id;
      return this.idsMatch(boxLocationTypeId, locationtype_id);
    });
    if (boxesForType.length === 0) {
      return;
    }

    const storedLocationForType = this.getStoredLocationForType(locationtype_id);
    const preferredBox = this.findBoxInList(boxesForType, this.getPreferredLocationId());
    const storedBox = storedLocationForType && storedLocationForType.id
      ? this.findBoxInList(boxesForType, storedLocationForType.id)
      : null;
    const boxToSelect = preferredBox || storedBox || boxesForType[0];

    if (boxToSelect && boxToSelect.id && !this.idsMatch(this.state.box_id, boxToSelect.id)) {
      this.setState({ box_id: boxToSelect.id, selectedBox: boxToSelect }, () => {
        this.getBoxesByID(boxToSelect.id);
        this.setStoredLocationForType(locationtype_id, boxToSelect);
        if (!this.getPreferredLocationId() || this.idsMatch(this.getPreferredLocationId(), boxToSelect.id)) {
          localStorage.setItem('selectedLocation', boxToSelect.id);
          localStorage.setItem('selected_location_name', boxToSelect.name || '');
        }
      });
    } else if (boxToSelect && !this.state.selectedBox) {
      this.setState({ selectedBox: boxToSelect });
    }
  };

  handleCounterLocationChange = (boxName) => {
    if (!boxName || !this.state.allBoxes || this.state.allBoxes.length === 0) {
      return;
    }
    
    const selectedBox = this.getAssignableBoxes(this.state.allBoxes).find(box => {
      const boxLocationTypeId = box.location_type_id || box.locationtype_id;
      const matchesLocationType = this.idsMatch(boxLocationTypeId, this.state.locationtype_id);
      const matchesName = box.name === boxName;
      return matchesLocationType && matchesName;
    });
    
    if (!selectedBox || !selectedBox.id) {
      return;
    }
    
    this.setState({ box_id: selectedBox.id, selectedBox }, () => {
      this.getBoxesByID(selectedBox.id);
      this.setStoredLocationForType(this.state.locationtype_id, selectedBox);
      localStorage.setItem('selectedLocation', selectedBox.id);
      localStorage.setItem('selected_location_name', selectedBox.name);
    });
  };
  handleFutureChange = async (event) => {
    if (event.preventDefault) event.preventDefault();
    this.setState({
      FutureRelease: event.target.value
    })
    if (event.target.value) {
      this.setState({
        showDatePopup: true
      })
    }
  }
  handleFutureDateChange = async (event) => {
    if (event.start > new Date()) {
      this.setState({ FutureReleaseDate: event.start, showDatePopup: false });
    }
  }

  getPharmacyDetails(boxId) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'boxes/' + boxId, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((phrmacydetail) => {
        const boxRow = Array.isArray(phrmacydetail) ? phrmacydetail[0] : phrmacydetail;
        if (!boxRow) {
          this.setState({ loader: false });
          return;
        }
        this.setState({
          loader: false,
          pharmacyDetails: boxRow,
          allow_multi_bins_pickup: boxRow.allow_multi_bins_pickup,
        });
        this.getAccountDetails(boxRow.parent_account_id);
        this.fetchOtcDeliveryEntitlement(boxId);
      })
      .catch((error) => {
        console.error(error);
        this.setState({ loader: false });
      });
  }
  //Added by Naresh | DI-329 | Date:27-05-2019
  getExpansionBins(boxId) {
    if (boxId == null || boxId === '' || boxId === 'undefined' || boxId === 'null') {
      return;
    }
    fetch(process.env.REACT_APP_BASEURL + 'box-expansions/' + boxId, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((expansionDetails) => {
        let order = 0;
        let UnitLayout = [];
        let UnitIndex = 0;
        if (expansionDetails && expansionDetails.length > 0) {
          //Add Left side Unit
          UnitLayout = [];
          if (expansionDetails.findIndex((x) => x.direction === 1) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 1) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = Math.abs(unit.box_position);
                  boxlist.pos = 'L';
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                return true;
              });
          }
          if (UnitLayout.length > 0) {
            UnitLayout.reverse();
          }
          order = order + 1;
          UnitIndex = UnitIndex + 1;
          const boxesExpansions =
            expansionDetails &&
            expansionDetails.find((x) => x.box.id === boxId);
          if (boxesExpansions && boxesExpansions !== undefined) {
            if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.Locker
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M22
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M22',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M24
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M24',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.FASTLANE
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'FASTLANE',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.FASTLANEGOLIATH
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'FASTLANEGOLIATH',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M41
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M41',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            }
          }
          //Add Right side Unit
          if (expansionDetails.findIndex((x) => x.direction === 2) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 2) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = unit.box_position;
                  boxlist.pos = 'R';
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                return true;
              });
          }
        } else {
          order = order + 1;
          const boxes =
            this.state &&
            this.state.boxdata &&
            this.state.boxdata.length &&
            this.state.boxdata.length > 0 &&
            this.state.boxdata.find((x) => x.id === boxId);
          if (boxes && boxes !== undefined) {
            if (
              boxes &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.Locker
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M22
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M22',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M24
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M24',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.FASTLANE
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'FASTLANE',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.FASTLANEGOLIATH
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'FASTLANEGOLIATH',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M41
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M41',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            }
          }
        }
        this.setState({ expansionUnits: UnitLayout });
        
        // Format expansion data for dialog use from UnitLayout (which has add-ons processed)
        const dialogExpansions = [];
        
        // Build dialog expansions from UnitLayout - filter out main units (M, M22, M24, FASTLANE, M41)
        // Keep only add-ons (L or R position)
        if (UnitLayout && UnitLayout.length > 0) {
          UnitLayout.forEach((unit, index) => {
            // Add-ons have pos === 'L' or pos === 'R'
            // Main units have pos === 'M', 'M22', 'M24', 'FASTLANE', 'M41', etc.
            const isAddOn = unit.pos === 'L' || unit.pos === 'R';
            
            if (isAddOn && unit.box && unit.box.id) {
              const directionLabel = unit.pos === 'L' ? 'Left' : 'Right';
              
              // For add-ons, use expansion_id or boxes_type.id as the box type (not box.type_id which is the main box)
              const addOnBoxTypeId = unit.expansion_id || (unit.boxes_type && unit.boxes_type.id) || unit.box.type_id;
              
              // Get box type name from expansion_id/boxes_type
              let boxName = 'Unit';
              if (unit.boxes_type && unit.boxes_type.name) {
                boxName = unit.boxes_type.name;
              } else if (addOnBoxTypeId) {
                // Map common box type IDs to names
                const boxTypeNames = {
                  [BOX_TYPE.Locker]: 'Locker',
                  [BOX_TYPE.L60]: 'L60',
                  [BOX_TYPE.Cool]: 'Cool',
                  [BOX_TYPE.HD36]: 'HD36',
                  [BOX_TYPE.M22]: 'M22',
                  [BOX_TYPE.M24]: 'M24',
                  [BOX_TYPE.C30]: 'C30',
                  [BOX_TYPE.A12]: 'A12',
                  [BOX_TYPE.V12]: 'V12',
                  [BOX_TYPE.COOL_12]: 'Cool12',
                  [BOX_TYPE.C28]: 'C28',
                  [BOX_TYPE.HD33]: 'HD33',
                };
                boxName = boxTypeNames[addOnBoxTypeId] || 'Unit';
              }
              
              // For add-ons, use the expansion ID as boxId, and expansion_id as boxTypeId
              // The expansion ID (unit.id) represents the add-on unit itself
              dialogExpansions.push({
                id: unit.id, // Expansion ID (the add-on unit ID)
                label: `Add-on ${directionLabel} - ${boxName}`,
                boxId: unit.id, // Use expansion ID as boxId for the add-on
                boxTypeId: addOnBoxTypeId, // Use expansion_id (add-on type) as boxTypeId
                expansionData: unit, // Full unit object with all properties
                isMainUnit: false
              });
            } else {
              console.log('⚠️ Skipped unit (main unit or invalid):', {
                pos: unit.pos,
                isAddOn: isAddOn,
                hasBox: !!unit.box,
                boxId: unit.box ? unit.box.id : 'NO BOX'
              });
            }
          });
        } else {
          console.log('⚠️ No units found in UnitLayout');
        }
        
        this.setState({ expansionUnitsForDialog: dialogExpansions });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ loader: false });
      })
  }
  //End DI-329

  getAccountDetails(accountId) {
    this.setState({ loader: true });
    fetch(
      process.env.REACT_APP_BASEURL + 'account/' + accountId,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      },
      accountId
    )
      .then((response) => response.json())
      .then((accountdetail) => {
        this.setState({ loader: false });
        const details = accountdetail && accountdetail[0];
        this.setState({ accountDetails: details });
        const accountId = details && details.id;
        if (accountId) {
          fetchAccountSignatureFlagCodes(accountId).then((codes) => {
            this.setState({ accountSignatureFlagCodes: codes || [] });
          }).catch(() => { this.setState({ accountSignatureFlagCodes: [] }); });
        } else {
          this.setState({ accountSignatureFlagCodes: [] });
        }
        this.setState({ accountDetails: accountdetail && accountdetail[0] }, () => {
          // Set address if not already set and we have box data
          if (!this.state.address) {
            const { selectedBox, searchedItems } = this.state;
            if (selectedBox || searchedItems) {
              const boxAddr = selectedBox && selectedBox.address;
              const address = {
                address1: (boxAddr && boxAddr.address_line_1) || (selectedBox && selectedBox.address_line_1) || (searchedItems && searchedItems.AddressLine1) || '',
                address2: (boxAddr && boxAddr.address_line_2) || (selectedBox && selectedBox.address_line_2) || (searchedItems && searchedItems.AddressLine2) || '',
                city: (boxAddr && boxAddr.city) || (selectedBox && selectedBox.city) || (searchedItems && searchedItems.City) || '',
                state: (boxAddr && boxAddr.state) || (selectedBox && selectedBox.state) || (searchedItems && searchedItems.State) || '',
                zip: (boxAddr && boxAddr.zip) || (selectedBox && selectedBox.zip) || (searchedItems && searchedItems.Zip) || '',
                country: (boxAddr && boxAddr.country) || (selectedBox && selectedBox.country) || (searchedItems && searchedItems.Country) || ''
              };
              this.setState({ address });
            }
          }
        });
      }).catch((error) => {
        console.error(error);
        this.setState({ loader: false });
      });
  }

  EventLogHanlder = (uData) => {
    let tofor_id = '';
    let descriptions = '';
    tofor_id =
      uData && uData.prescriptions_master && uData.prescriptions_master.id;
    descriptions =
      'Prescription is Assigned with stock code ' +
      this.state.stockCode +
      ' and pick up code ' +
      this.state.pickupCode +
      ' with Rx No ' +
      this.state.rxNumber;

    const event_params = {
      event_name: EVENT_CRUD_TYPES.INSERT,
      event_type_name: EVENT_TYPES.ASSIGNED,
      description: descriptions,
      object_id: assignmentstatus.ASSIGNED,
      tofor_id: tofor_id,
      box_id: this.state.box_id,
    };
    new EventLogHandler().handleEventLog(event_params);
  };

  courierTrackingHandler = (evt) => {
    this.setState({ courier_tracking: evt.target.value });
  };

  checkBoxHandler = (value) => {
    this.setState({ default_courier_selected: value });
  };

  getCartRxNumbers = () => {
    const { accountDetails } = this.state;
    searchedRxNumbers = [];
    searchedRxItems.map((item) => {
      if (item) {
        if (
          accountDetails &&
          usesOrderStagingAssignFlow(accountDetails.connection.id)
        ) {
          searchedRxNumbers.push(item.prescriptionnumber);
        } else {
          searchedRxNumbers.push(item.rxNo || item.rx_no);
        }
      }
      return true;
    });
  };

  sortArray(Ids) {
    var reA = /[^a-zA-Z]/g;
    var reN = /[^0-9]/g;

    function sortAlphaNum(a, b) {
      var aA = a.replace(reA, '');
      var bA = b.replace(reA, '');
      if (aA === bA) {
        var aN = parseInt(a.replace(reN, ''), 10);
        var bN = parseInt(b.replace(reN, ''), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    }
    return Ids.sort(sortAlphaNum);
  }

  handleClose = () => {
    this.setState({ openMessage: false });
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({
        selected: searchedRxItems.map((n) => n.rxNo),
      }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: searchedRxItems.filter(
          (x) => x.itemId === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: searchedRxItems.filter(
          (x) => this.state.selected.indexOf(x.rxNo) > -1
        ),
      });
    }
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    } else {
      this.deleteItems();
    }
    this.setState({ deleteDialogOpen: false });
  };

  resetAfterDeleteAllPrescriptions = () => {
    const boxId = this.state.box_id || localStorage.getItem('selectedLocation');
    this.ClearFields(() => {
      const locationTypeId = localStorage.getItem('selectedLocationTypeId');
      this.setState(
        {
          locationtype_id: locationTypeId,
          box_id: boxId,
        },
        () => {
          if (boxId && !['null', 'undefined', '', null, undefined].includes(boxId)) {
            this.getBoxesByID(boxId);
          }
          this.handleFocus();
        }
      );
    });
  };

  deleteItems = (event) => {
    const rowIdToDelete = this.state.forDeletion;
    if (rowIdToDelete.length === searchedRxItems.length) {
      this.resetAfterDeleteAllPrescriptions();
    } else {
      for (var i = 0; i < rowIdToDelete.length; i++) {
        searchedRxItems = searchedRxItems.filter(
          // eslint-disable-next-line no-loop-func
          (x) => x.rxNo !== rowIdToDelete[i].rxNo
        );
      }
      this.setState({
        rxNumber: '',
        selected: [],
      });
      this.handleFocus();
    }
  };

  resolveStockCodeForRxByBin = (binId, pmId, stockCodeOverride = null) => {
    const explicitOverride = (stockCodeOverride || '').trim();
    if (explicitOverride) {
      return explicitOverride;
    }
    const { BinStatus } = this.state;
    if (Array.isArray(BinStatus) && BinStatus.length > 0) {
      // Match the order first. A bin match alone can belong to a different patient.
      if (pmId) {
        const byOrder = BinStatus.find((entry) => entry && entry.id === pmId);
        if (byOrder && byOrder.stock_code) {
          return String(byOrder.stock_code).trim();
        }
      } else if (binId) {
        const byBin = BinStatus.find((entry) => entry && entry.bin_id === binId);
        if (byBin && byBin.stock_code) {
          return String(byBin.stock_code).trim();
        }
      }
    }
    const hasUsableBinId = ![undefined, 'undefined', null, 'null', ''].includes(binId);
    const hasPmId = ![undefined, 'undefined', null, 'null', ''].includes(pmId);
    if (!hasUsableBinId && !hasPmId) {
      return (this.state.stockCode || '').trim();
    }
    return '';
  };

  getPrescriptionDetails = (BinId, pm_id, stockCodeOverride = null) => {
    const isFastlaneGoliath =
      this.state.boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    const hasUsableBinId = ![undefined, 'undefined', null, 'null', ''].includes(BinId);
    const hasPmId = ![undefined, 'undefined', null, 'null', ''].includes(pm_id);
    const isSizeBasedPreAssignment =
      this.state.isSizeBasedPreAssignment ||
      resolveSizeBasedAssignUIFromBox(this.findBoxById(this.state.box_id));
    // Canada size-based: bin_id may be null until stock; load by pm_id (same as unplugged).
    const useSizeBasedRxLookup = isSizeBasedPreAssignment && hasPmId;
    const resolvedStockCode = this.resolveStockCodeForRxByBin(
      BinId,
      pm_id,
      stockCodeOverride
    );
    const hasUsableStockCode = resolvedStockCode.length > 0;
    const canResolveWithoutBinId =
      isFastlaneGoliath ||
      useSizeBasedRxLookup ||
      (hasUsableStockCode && pm_id);
    // Goliath, Counter, size-based pre-assignment, and search flows can resolve without bin_id.
    if (hasUsableBinId || canResolveWithoutBinId) {
      const { accountDetails, deactivatedBins } = this.state;
      const binPatch = {
        isEdit: true,
        binid: hasUsableBinId ? BinId : null,
        pmid: pm_id,
        indexNo: '',
        isBinDeactivated: hasUsableBinId && deactivatedBins.includes(BinId),
      };
      if (!hasUsableBinId) {
        binPatch.selectedBinId = '';
        binPatch.box_position = '';
        binPatch.isSelectedFlag = false;
      } else {
        binPatch.selectedBinId = String(BinId).trim();
      }
      this.setState(binPatch);
      if (
        searchedRxItems &&
        searchedRxItems.length > 0 &&
        this.state &&
        this.state.doesPrescriptionScanned
      ) {
        let obj = {
          bin_id: BinId,
          box_id: this.state && this.state.box_id,
          account_id: accountDetails && accountDetails.id,
        };
        this.setState({ loader: true });
        let statusCheckToken = '';
        try {
          statusCheckToken = JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken;
        } catch (tokenError) {
          this.setState({ loader: false });
          return;
        }
        fetch(process.env.REACT_APP_BASEURL + 'prescription/status/check', {
          crossDomain: true,
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + statusCheckToken,
          },
          body: JSON.stringify(obj),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then((res) => {
            if (res && res.statusCode === 409) {
              this.setState({
                isVerifyingBin: true,
                isVerifyingBinMessage:
                  'This bin is currently unavailable, please select another bin.',
                loader: false,
              });
              return;
            }
            this.setState({ loader: false });
          }).catch(() => {
            this.setState({ loader: false });
          });
      } else {
        let isMScript = false;
        if (
          accountDetails &&
          usesOrderStagingAssignFlow(accountDetails.connection.id)
        ) {
          isMScript = true;
        }
        if (BinId === null && !canResolveWithoutBinId) {
          searchedRxItems = [];
          this.setState({
            searchedRxNo: [],
            searchedItems: [],
            rxNumber: '',
            selected: [],
            nonRxCartItems: [],
            nonRxPriceEditIndex: null,
            assignCartItems: null,
          });
          this.handleFocus();
          searchedRxItems = [];
        } else {
          const boxId = this.state.box_id;
          const useRxByPmId = useSizeBasedRxLookup && !isFastlaneGoliath;
          const bin_info = useRxByPmId
            ? { id: boxId, pm_id: pm_id }
            : {
                id: boxId,
                bin_id: hasUsableBinId ? BinId : null,
                pm_id: pm_id,
                stock_code: resolvedStockCode || null,
              };
          this.setState({ loader: true, reminderData: [] });
          const rxByBinRequestId = ++this._rxByBinRequestId;
          let rxByBinToken = '';
          try {
            rxByBinToken = JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken;
          } catch (tokenError) {
            this.setState({ loader: false });
            return;
          }
          const RxByBinAbort = window.AbortController;
          const rxByBinController = typeof RxByBinAbort === 'function' ? new RxByBinAbort() : null;
          const rxByBinTimeoutId = rxByBinController
            ? setTimeout(() => rxByBinController.abort(), 20000)
            : null;
          fetch(
            process.env.REACT_APP_BASEURL +
              (useRxByPmId ? 'pre-assignment/rxbyPMID' : 'rxbybin'),
            {
            method: 'POST',
            withCredentials: true,
            ...(rxByBinController ? { signal: rxByBinController.signal } : {}),
            headers: {
              Authorization: 'Bearer ' + rxByBinToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(bin_info),
          })
            .then(async (response) => {
              let data = null;
              try {
                data = await response.json();
              } catch (error) {
                data = null;
              }
              return { ok: response.ok, data };
            })
            .then(({ ok, data }) => {
              clearTimeout(rxByBinTimeoutId);
              if (rxByBinRequestId !== this._rxByBinRequestId) {
                return;
              }
              const boxPayload = data && data.response && data.response.box;
              const isFastlaneGoliathBox =
                this.state.boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
              const hasCustomers =
                boxPayload &&
                Array.isArray(boxPayload.customers) &&
                boxPayload.customers.length > 0;

              if (isFastlaneGoliathBox && !hasCustomers) {
                this.setState({
                  loader: false,
                  doesBinClicked: true,
                  confirmPhantomRemoval: true,
                  isPhantomStockCodePrompt: true,
                  stockCode: '',
                });
                return;
              }
              if (!ok) {
                this.setState({ loader: false, doesBinClicked: true });
                toast.error(
                  (data && data.message) || 'Unable to load this bin. Please try again.'
                );
                return;
              }
              if (!boxPayload || !hasCustomers) {
                this.getCartRxNumbers();
                this.setState({
                  loader: false,
                  doesBinClicked: true,
                  reminderData: [],
                  ...this.clearHoldResumeOrderState(),
                  nonRxCartItems: [],
                  nonRxPriceEditIndex: null,
                  assignCartItems: null,
                  assignedPrescription: null,
                  disableFeild: false,
                  readOnly: false,
                  stockCode: '',
                  pickupCode: '',
                  orderId: '',
                  basicDetails: null,
                  searchedItems: [],
                  rxNumber: '',
                  patientNotes: '',
                  EmailID: '',
                  phone: '',
                });
                return;
              }

              searchedRxItems = [];
              const basicDetails = boxPayload.customers && boxPayload.customers[0];
              const orders = basicDetails && basicDetails.orders && basicDetails.orders[0];
              const nextState = {
                loader: false,
                doesBinClicked: true,
                reminderData: { bin_info: bin_info, data: data },
                // Occupied bin selected (assigned/stocked/hold) → show occupied actions.
                // Hold/Resume permission only gates the pause/resume buttons, not this mode.
                isVisibleForPause: true,
              };

              if (!basicDetails || !orders) {
                this.getCartRxNumbers();
                this.setState({
                  ...nextState,
                  ...this.clearHoldResumeOrderState(),
                  nonRxCartItems: [],
                  nonRxPriceEditIndex: null,
                  assignCartItems: null,
                  assignedPrescription: boxPayload,
                  disableFeild: true,
                });
                return;
              }

              const typeId = orders.type_id;
              const stockcode = orders.stock_code;
              const pickupcode = orders.pucode;
              const rxItems = orders.items;
              const orderId = orders.id;
              const { rxItems: rxOnlyItems, nonRxItems: loadedNonRxItems } =
                splitOrderItemsForCarts(rxItems);
              const rxNo =
                (rxOnlyItems[0] && rxOnlyItems[0].rx_no) ||
                (rxOnlyItems[0] && rxOnlyItems[0].rxNo) ||
                '';
              const bindId = orders.bin_id;
              const resolvedBinId =
                isFastlaneGoliathBox
                  ? (bindId && this.isAddOnBin(bindId) ? String(bindId).trim() : '')
                  : (bindId != null && bindId !== '' ? bindId : '');
              const binSize = orders && orders.bin_size;
              const contactDetails = (basicDetails.contacts && basicDetails.contacts[0]) || {};
              const locationDetails = Array.isArray(orders.customerLocations)
                ? orders.customerLocations
                : [];
              const emailValue = isMScript ? 'N/A' : (contactDetails.email || '');
              const phoneValue = isMScript ? 'N/A' : (contactDetails.phone || '');
              const rawFutureDate = orders.future_release_date;
              const parsedFutureDate = rawFutureDate ? new Date(rawFutureDate) : null;
              const futureReleaseDate =
                parsedFutureDate && !Number.isNaN(parsedFutureDate.getTime())
                  ? parsedFutureDate
                  : null;

              const readKioskAddress = () => {
                const boxData = this.state.boxdata;
                if (!Array.isArray(boxData)) {
                  return {};
                }
                const match = boxData.find((item) => this.state.box_id === item.id);
                const addr = (match && match.address) || {};
                return {
                  address1: addr.address_line_1,
                  address2: addr.address_line_2,
                  city: addr.city,
                  state: addr.state,
                  zip: addr.zip,
                  country: addr.country,
                };
              };

              if (this.shouldShowBasicUI()) {
                nextState.dateOfBirth = basicDetails.dob_str;
                nextState.rxEntries = (rxOnlyItems || []).map((item) => ({
                  rxNumber: item.rx_no,
                  isConsultRequired: item.is_consultrequire,
                }));
                nextState.isRxView = true;
                const kioskAddress = readKioskAddress();
                if (kioskAddress.address1 || kioskAddress.city) {
                  nextState.address = kioskAddress;
                }
              }

              let address1;
              let address2;
              let city;
              let state;
              let zip;
              let country;
              if (locationDetails.length > 0 && this.state.locationtype_id !== LOCATION_TYPE.Kiosk) {
                locationDetails.forEach((type) => {
                  if (this.state.locationtype_id === type.locationtype_id) {
                    address1 = type.addressline1;
                    address2 = type.addressline2;
                    city = type.city;
                    state = type.state;
                    zip = type.zip;
                    country = type.country;
                  }
                });
              } else if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                const kioskAddress = readKioskAddress();
                address1 = kioskAddress.address1;
                address2 = kioskAddress.address2;
                city = kioskAddress.city;
                state = kioskAddress.state;
                zip = kioskAddress.zip;
                country = kioskAddress.country;
              }

              searchedRxItems = mapRxItemsForCart(
                (rxOnlyItems || []).map((item) => ({
                  ...item,
                  // Preserve stored consult requirements through bypass save strip (DI-6213).
                  // DB items only carry snake_case is_consultrequire; mirror it so the
                  // save payload (which reads ConsultRequire) sees the stored value.
                  ConsultRequire:
                    item.ConsultRequire !== undefined
                      ? item.ConsultRequire
                      : item.is_consultrequire === true,
                  consultRequireManual: item.is_consultrequire === true,
                }))
              );
              const orderHasControlled = searchedRxItems.some((item) =>
                isItemControlledSubstance(item)
              );
              this.getCartRxNumbers();
              this.setState({
                ...nextState,
                stockCode: stockcode || resolvedStockCode || this.state.stockCode,
                pickupCode: pickupcode,
                locationDetails: locationDetails,
                basicDetails: basicDetails,
                contactDetails: contactDetails,
                PrintisCoolItem: orders.is_cool_item,
                FutureRelease: orders.is_future_release,
                FutureReleaseDate: futureReleaseDate,
                selectedBox: boxPayload,
                alternateAgents: basicDetails.alternetAgents,
                assign_order_notes: orders.assign_order_notes,
                isBinLocked: orders.is_locked,
                EmailID: emailValue,
                phone: phoneValue,
                isAlreadyOnHold: typeId === DEVICE_TYPE.Hold,
                isAlreadyAssigned: typeId === DEVICE_TYPE.Assigned,
                is_stocked: typeId === DEVICE_TYPE.Stocked,
                searchedItems: {
                  FirstName: basicDetails.first_name,
                  LastName: basicDetails.last_name,
                  DateOfBirth: basicDetails.dob_str,
                  MobileNo: phoneValue,
                  EmailID: emailValue,
                  AddressLine1: address1,
                  AddressLine2: address2,
                  City: city,
                  State: state,
                  Zip: zip,
                  Country: country,
                  isCoolItem: orders && orders.is_cool_item,
                  notes: basicDetails.notes,
                  customer_id: basicDetails.customer_id || basicDetails.customerId || basicDetails.id,
                  assignedDate: orders && (orders.created_on || orders.createdOn || orders.assigned_date),
                  assigned_date: orders && (orders.created_on || orders.createdOn || orders.assigned_date),
                  stockedDate: orders && (orders.stocked_date || orders.stockedDate),
                  stocked_date: orders && (orders.stocked_date || orders.stockedDate),
                  expiresDate: orders && (orders.rx_expiration_date || orders.rxExpirationDate || orders.expiresDate),
                  rx_expiration_date: orders && (orders.rx_expiration_date || orders.rxExpirationDate),
                },
                rxNumber: rxNo,
                selectedBinId: resolvedBinId,
                selectedBinSize: binSize || this.state.selectedBinSize || '',
                orderId: orderId,
                patientNotes: basicDetails.notes,
                readOnly: true,
                consultCheckBoxFlagForRxByBin: true,
                is_controlled_substance: orderHasControlled,
                nonRxCartItems: loadedNonRxItems,
                nonRxPriceEditIndex: null,
                assignCartItems: null,
                assignedPrescription: boxPayload,
                disableFeild: true,
              });
              this.getPaymentDetails(orderId, basicDetails.id);
            }).catch(() => {
              clearTimeout(rxByBinTimeoutId);
              if (rxByBinRequestId === this._rxByBinRequestId) {
                this.setState({ loader: false });
                toast.error('Unable to load this bin. Please try again.');
              }
            });
        }
      }
    }
  };

  GetFormattedDate(dob) {
    var tempDate = new Date(dob);
    var formattedDate = ('0' + tempDate.getUTCDate()).slice(-2);
    var formattedMonth = ('0' + (tempDate.getUTCMonth() + 1)).slice(-2);
    var formattedYears = tempDate.getUTCFullYear();
    var dateString =
      formattedMonth + '/' + formattedDate + '/' + formattedYears;
    return dateString;
  }
  sendOrederStatusEmail(reqDetails) {
    fetch(process.env.REACT_APP_BASEURL + 'emailHoldStatus', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqDetails),
    }).then((response) => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    })
    .then((data) => { console.log(JSON.stringify(data, null, 2)) })
    .catch(() => {
      this.setState({ loader: false });
    });
  }
  changeOrderStatus(status) {
    this.setState({ loader: true });
    let bin_info;
    let reqDetails = {};
    if (status === 'pause') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.Hold,
      };
      reqDetails = {
        box_id: this.state.box_id,
        pucode: this.state.pickupCode,
        onHold: true,
      };
    } else if (status === 'play') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.Stocked,
      };
      reqDetails = {
        box_id: this.state.box_id,
        pucode: this.state.pickupCode,
        onHold: false,
      };
    } else if (status === 'remove') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.RemoveRx,
      };
    }

    return fetch(process.env.REACT_APP_BASEURL + 'updateStatusOfRx', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...bin_info, audit_writer: 'web-gap-v1' }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Order status was not saved');
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (!data || (!data.prescriptions_master || !data.prescriptions_master.id) || data.status === false || data.success === false) throw new Error('Order status was not saved');
          if (
            bin_info.type_id === assignmentstatus.REMOVE_RX &&
            data.prescriptions_master.id
          ) {
            const event_params = {
              event_name: EVENT_CRUD_TYPES.UPDATE,
              event_type_name: EVENT_TYPES.REMOVE_RX,
              description:
                'Prescription is Remove with stock code ' +
                this.state.stockCode,
              object_id: assignmentstatus.REMOVE_RX,
              tofor_id: this.state.orderId,
              box_id: this.state.box_id,
            };
            new EventLogHandler().handleEventLog(event_params);
          }

        if (status === 'pause' || status === 'play') this.sendOrederStatusEmail(reqDetails);
        this.setState({ loader: false });
        const { t } = this.props;
        if (status === 'pause') {
          toast.success(t('Prescriptions.Messages.OnHold'));
          this.setState({
            isAlreadyOnHold: true,
            isAlreadyAssigned: false,
            is_stocked: false,
            isVisibleForPause: true,
          });
        } else if (status === 'play') {
          toast.success(t('Prescriptions.Messages.NotOnHold'));
          this.setState({
            isAlreadyOnHold: false,
            is_stocked: true,
            isVisibleForPause: true,
          });
        } else if (status === 'remove') {
          toast.success(t('Prescriptions.Messages.RemovedRx'));
          searchedRxItems = [];
          this.setState({
            selectedBinId: '',
            searchedItems: [],
            rxNumber: '',
            isVisibleForPause: false,
            EmailID: '',
            phone: '',
            makeFastlaneAPICall: true,
            stockCode: '',
            pickupCode: '',
            orderId: '',
            isAlreadyOnHold: false,
            isAlreadyAssigned: false,
            is_stocked: false,
          });
          searchedRxNumbers = [];
        }
        this.handleFocus();
        this.getBoxes();
        if (status === 'pause' || status === 'play') {
          this.refreshAfterHoldResume();
        }
        if (status === 'remove') {
          this.setState({ makeFastlaneAPICall: false });
        }
        return true;
      }).catch(() => {
        this.setState({ loader: false });
        toast.error('Order status could not be saved. Please try again.');
        return false;
      });
  }

  getSelectedUnitName = (index) => {
    if (index === 1) {
      this.setState({ selectedUnitName: 'L60 (Locker Addon with 60 bins)' });
    } else if (index === 2) {
      this.setState({ selectedUnitName: 'HD36 (Locker Addon with 36 bins)' });
    } else if (index === 3) {
      this.setState({ selectedUnitName: 'Cool (Temp Controlled with 8 bins)' });
    }  else if (index === 4) {
      this.setState({ selectedUnitName: 'C30 (C30 with 30 bins)' });
    } else {
      this.setState({ selectedUnitName: 'Locker (Main Unit with 46 bins)' });
    }
  };

  getFormattedExpiryDate(expirydate) {
    let parsedDate;
    if (
      expirydate !== '' &&
      expirydate !== 'null' &&
      expirydate !== null &&
      expirydate !== undefined &&
      expirydate !== 'undefined'
    ) {
      let ExpiryDateyear = expirydate.substr(0, 4);
      let ExpiryDatemonth = expirydate.substr(5, 2);
      let ExpiryDateday = expirydate.substr(8, 2);
      parsedDate = ExpiryDatemonth + '/' + ExpiryDateday + '/' + ExpiryDateyear;
    } else {
      parsedDate = '';
    }
    return parsedDate;
  }

  handleConsultrequire = (index) => {
    if (!searchedRxItems || !searchedRxItems.length || searchedRxItems[index] == null) return;
    const item = searchedRxItems[index];
    const isCurrentlyRequired = item.ConsultRequire || item.is_consultrequire;
    const bypassOn = isBypassConsultEnabled(this.state.accountDetails);
    if (isCurrentlyRequired) {
      // Bypass accounts: simple toggle, no waive dialog (DI-6213).
      if (bypassOn) {
        const reason = 'Bypass consult account - toggled off';
        const rxNo = item.rxNo || item.rx_no || '';
        const prescriptionNumber =
          item.prescriptionNumber || item.prescriptionnumber || '';
        writeAuditLog(
          `Consult requirement canceled. Rx: ${rxNo || '—'}, Prescription: ${prescriptionNumber || '—'}, Reason: ${reason}`,
          'Consult Cancel',
          {
            rx_no: rxNo,
            drug_name: item.name || item.drug_name || '',
            prescription_number: prescriptionNumber,
            reason,
          }
        ).catch((err) =>
          console.error('Consult cancel audit log failed:', err)
        );
        item.ConsultRequire = false;
        item.is_consultrequire = false;
        item.consultRequireManual = false;
        this.forceUpdate();
        return;
      }
      this.setState({
        consultWaiveDialogOpen: true,
        consultWaiveIndex: index,
        consultWaiveReason: '',
      });
      return;
    }
    item.ConsultRequire = true;
    item.is_consultrequire = true;
    item.consultRequireManual = true;
    this.forceUpdate();
  };

  handleConsultWaiveConfirm = async () => {
    const { consultWaiveIndex, consultWaiveReason } = this.state;
    const { t } = this.props;
    const reason = (consultWaiveReason || '').trim();
    if (reason === '') {
      toast.error(t('Assign.ConsultWaive.ReasonLabel') || 'Reason is required');
      return;
    }
    if (!searchedRxItems || consultWaiveIndex == null || !searchedRxItems[consultWaiveIndex]) {
      this.setState({ consultWaiveDialogOpen: false, consultWaiveIndex: null, consultWaiveReason: '' });
      return;
    }
    const item = searchedRxItems[consultWaiveIndex];
    const rxNo = item.rxNo || item.rx_no || '';
    const drugName = item.name || item.drug_name || '';
    const prescriptionNumber = item.prescriptionNumber || item.prescriptionnumber || '';
    try {
      const auditDescription = `${t('Assign.ConsultWaive.AuditMessage', { defaultValue: 'Consult requirement canceled' })}. Rx: ${rxNo || '—'}, Prescription: ${prescriptionNumber || '—'}, Reason: ${reason}`;
      await writeAuditLog(
        auditDescription,
        'Consult Cancel',
        {
          rx_no: rxNo,
          drug_name: drugName,
          prescription_number: prescriptionNumber,
          reason,
        }
      );
    } catch (err) {
      console.error('Consult cancel audit log failed:', err);
    }
    item.ConsultRequire = false;
    item.is_consultrequire = false;
    item.consultRequireManual = false;
    item.consult_waive_reason = reason;
    this.setState({ consultWaiveDialogOpen: false, consultWaiveIndex: null, consultWaiveReason: '' });
    this.forceUpdate();
  };

  handleConsultWaiveCancel = () => {
    this.setState({ consultWaiveDialogOpen: false, consultWaiveIndex: null, consultWaiveReason: '' }, () => this.forceUpdate());
  };

  handleIsReturnable = (index) => {
    if (searchedRxItems && searchedRxItems.length > 0) {
      searchedRxItems[index].IsReturnable = !searchedRxItems[index].IsReturnable;
      this.forceUpdate();
    }
  };

  handleControlledSubstanceChange = (index, checked) => {
    if (!searchedRxItems || !searchedRxItems[index]) {
      return;
    }
    searchedRxItems[index].is_controlled_substance = checked;
    const orderHasControlled = searchedRxItems.some((item) =>
      isItemControlledSubstance(item)
    );
    this.setState({ is_controlled_substance: orderHasControlled }, () =>
      this.forceUpdate()
    );
  };

  handleEpicChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  getActualRx = (rxNumber) => {
    if(rxNumber.startsWith("\\")) {
        rxNumber = rxNumber.substr(4, rxNumber.length - 1);
    } else if(rxNumber.startsWith("RX")){
        rxNumber = rxNumber.substr(3, rxNumber.length - 1);
    }
    return rxNumber;
  };

  parseCoreflexScript = (scannedQR) => {
    let parsedCoreFlexObject = {};
    let _removeIlb = scannedQR.split('?');
    let _findRxs = _removeIlb[1].split('&');
    let _s = _findRxs[3].split('=')[1];
    parsedCoreFlexObject.key = _findRxs[0].split('=')[1];
    parsedCoreFlexObject.v = _findRxs[1].split('=')[1];
    parsedCoreFlexObject.d = _findRxs[2].split('=')[1];
    parsedCoreFlexObject.s = _s.split('#').filter((el) => el);
    return parsedCoreFlexObject;
  };

  verifyScriptIsCoreflexOrNotAndSaveEntryForHistory = async (scannedQR) => {
    // LEON Medical Coreflex Sample Script
    // ilb://?key=client&v=1.0&d=04/04/2020&s=10-1217253#10-1217254#
    let _parsedResponse = {};
    let _parsedRx = this.parseCoreflexScript(scannedQR);
    _parsedResponse.pharmacyNCPDPId = '';
    _parsedResponse.fillId = '';
    _parsedResponse.prescriptionNumber = _parsedRx.s;
    return _parsedResponse;
  };

  parseScannedQrCode = async (scannedQR, account_id) => {
    let _scannedQRCode = scannedQR;
    let _parsedResponse = {};
    if (scannedQR.length > 40) {
      if (scannedQR.startsWith('ilb') || scannedQR.includes('key')) {
        _parsedResponse = await this.verifyScriptIsCoreflexOrNotAndSaveEntryForHistory(
          scannedQR
        );
      } else {
        let arrayOfRxNumber = [];
        let splitByCarrotSign = _scannedQRCode.split('^');
        let actualRxNumber = this.getActualRx(splitByCarrotSign[0]);
        arrayOfRxNumber.push(actualRxNumber);
        _parsedResponse.prescriptionNumber = arrayOfRxNumber;
        _parsedResponse.pharmacyNCPDPId = splitByCarrotSign[splitByCarrotSign.length - 8];
        _parsedResponse.fillId = splitByCarrotSign[5];
        _parsedResponse.is_coreFlex = false;      
      }
    } else {
      _parsedResponse = await this.verifyScriptIsCoreflexOrNotAndSaveEntryForHistory(
        scannedQR
      );
    }
    console.log(
      `Parsed Response for EPIC script : ${JSON.stringify(
        _parsedResponse,
        null,
        2
      )}`
    );
    return _parsedResponse;
  };

  checkIfRxExistOrNot = async (rxTransactionNumber) => {
    let response = {};
    return fetch(
      process.env.REACT_APP_BASEURL +
      'epic/checkpoint/epic/rxno-fillid/' +
      rxTransactionNumber,
      {
        method: 'get',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((checkResponse) => {
        if (checkResponse) {
          let parsedJsonResponse = JSON.parse(checkResponse);
          if (
            parsedJsonResponse &&
            parsedJsonResponse.res &&
            parsedJsonResponse.res.status === 200
          ) {
            response.error = parsedJsonResponse.res.message;
            response.result = true;
            return response;
          } else {
            response.error = '';
            response.result = false;
            return response;
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  checkIfRxExistorNotForEpicWithmTLS = async (rxTransactionNumber) => {
    let response = {};
    return fetch(
      process.env.REACT_APP_BASEURL +
      'kp/epic/mtls/checkpoint/epic/rxno-fillid/' +
      rxTransactionNumber,
      {
        method: 'get',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((checkresponse) => {
        if (checkresponse) {
          let parsedJsonResponse = JSON.parse(checkresponse);
          if (
            parsedJsonResponse &&
            parsedJsonResponse.res &&
            parsedJsonResponse.res.status === 200
          ) {
            response.error = parsedJsonResponse.res.message;
            response.result = true;
            return response;
          } else {
            response.error = '';
            response.result = false;
            return response;
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  isRxExistInCart = async (searchedString, patientDetails, items) => {
    const { globalAccountConnection } = this.state;
    let connectionType;
    switch (globalAccountConnection.account_connections_id) {
      case CONNECTION_TYPE.EPIC:
        connectionType = 'Epic';
        break;
      case CONNECTION_TYPE.EPIC_WITH_MTLS:
        connectionType = 'Epic With MTLS';
        break;
      default:
        break;
    }
    let _existingPrescriptionNumbers = [];
    let existingRxNo = await this.parseEpicLabel(searchedString);
    if (existingRxNo && existingRxNo.regexMiss) {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: this.props.t('Toast.Error.EpicRegexMiss'),
      });
      return true;
    }
    if (
      Array.isArray(
        existingRxNo &&
          existingRxNo.prescriptionNumber &&
          existingRxNo.prescriptionNumber
      )
    ) {
      if (
        existingRxNo &&
        existingRxNo.prescriptionNumber &&
        existingRxNo.prescriptionNumber.length > 0
      ) {
        const _existingRxItems = existingRxNo.prescriptionNumber;
        for (let exist = 0; exist < _existingRxItems.length; exist++) {
          for (let si = 0; si < searchedRxItems.length; si++) {
            if (
              _existingRxItems[exist].trim() ===
                searchedRxItems[si].prescriptionNumber &&
              existingRxNo.fillId === searchedRxItems[si].fillNumber
            ) {
              _existingPrescriptionNumbers.push(_existingRxItems[exist].trim());
            }
          }
        }
      }
    } else {
      const _existingRxItems = existingRxNo.prescriptionNumber;
      for (let si = 0; si < searchedRxItems.length; si++) {
        if (
          _existingRxItems.trim() ===
            searchedRxItems[si].prescriptionNumber &&
          existingRxNo.fillId === searchedRxItems[si].fillNumber
        ) {
          _existingPrescriptionNumbers.push(_existingRxItems.trim());
        }
      }
    }
    if (_existingPrescriptionNumbers.length > 0) {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers.join(
          ','
        )} are already exist in the cart!`,
      });
      return true;
    } else {
      let itemsdetail;
      let validRxScripts = this.validateRxFills(items);
      if (
        validRxScripts &&
        validRxScripts.validRxItems &&
        validRxScripts.validRxItems.length > 0
      ) {
        itemsdetail = validRxScripts.validRxItems;
      } else {
        itemsdetail = validRxScripts.inValidRxItems;
        if (
          this.isPreventNonReadyAssignmentEnabled() &&
          itemsdetail &&
          itemsdetail.length > 0
        ) {
          this.showNonReadyPrescriptionBlock(itemsdetail);
          return true;
        }
      }
      for (let i = 0; i < itemsdetail.length; i++) {
        searchedRxItems.push(itemsdetail[i]);
      }
      this.checkADACompatible(
        patientDetails.MedicalRecordNumber,
        patientDetails.EmailAddress
      );
      this.getcustomerLocation(patientDetails, itemsdetail, connectionType);
      this.forceUpdate();
      this.setState({
        rxNumber: '',
        loader: false,
      });
    }
  };

  isSamePatient = (patientDetails) => {
    const { searchedItems } = this.state;
    if (searchedItems.PatientID === patientDetails.MedicalRecordNumber) {
      this.setState({
        EmailID: patientDetails.EmailAddress,
        phone: patientDetails.MobilePhone,
      });
      return true;
    } else {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The scanned or entered prescription has different patient details. Please assign this prescription to any bin first then scan or enter another prescription!`,
      });
      return false;
    }
  };

  handleEpicKeyDown = (event) => {
    // if (event.keyCode === 13) {
      this.setState({
        loader: true,
        isEpicHasValidRx: true,
        isEpicHasValidRxMessage: '',
        isEdit: false,
      });
      const { originalScannedScript } = this.state;
      let searchedString = originalScannedScript;
      let validItems = [];
      let items = [];
      let obj = {
        PrescriptionId: searchedString,
        account_id: this.state.accountDetails.id,
      };
      fetch(process.env.REACT_APP_BASEURL + 'epic/GetPrescriptionInfoById', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then(async (res) => {
          let parsedJsonResponse = JSON.parse(res);
          let parsedJson;
          if (parsedJsonResponse && parsedJsonResponse.message) {
            this.setState({
              loader: false,
              rxNumber: '',
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
            });
            return;
          }
          parsedJson = parsedJsonResponse.response;
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.prescriptions;
          if (prescriptionDetails.length <= 0) {
            toast.error(this.props.t('Toast.Error.Prescription'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              let _existingPrescriptionNumbers = [];
              if (
                prescriptionDetails &&
                prescriptionDetails.length &&
                prescriptionDetails.length > 0
              ) {
                for (let i = 0; i < prescriptionDetails.length; i++) {
                  let preacriptionNumber = prescriptionDetails[i].PrescriptionNumber.trim();
                  for (let si = 0; si < searchedRxItems.length; si++) {
                    let fillNumber = prescriptionDetails[i].Fill[i].Id;
                    if (
                      preacriptionNumber ===
                      searchedRxItems[si].prescriptionNumber && fillNumber === searchedRxItems[si].fillNumber
                    ) {
                      _existingPrescriptionNumbers.push(preacriptionNumber);
                    }
                  }
                }
              }
              if (
                _existingPrescriptionNumbers &&
                _existingPrescriptionNumbers.length &&
                _existingPrescriptionNumbers.length > 0
              ) {
                this.setState({
                  loader: false,
                  rxNumber: '',
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers} are already exist in the cart!`,
                });
                return true;
              }
            }
          }
          for (let j = 0; j < prescriptionDetails.length; j++) {
            let isconsultrequired = false;
            let isreturnable = false;
            if([true, "true"].includes(this.state.accountDetails.bypass_consult)){
              isconsultrequired = false;
            } else if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsConsultRequired === true
            ) {
              isconsultrequired = prescriptionDetails[j].IsConsultRequired;
            } else {
              isconsultrequired = false;
            }
            console.log(isconsultrequired, "isconsultrequired");
            //check for isreturnable feild in fetched prescriptions
            if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsReturnable === true
            ) {
              isreturnable = prescriptionDetails[j].IsReturnable;
            } else {
              isreturnable = false;
            }
            for (let i = 0; i < prescriptionDetails[j].Fill.length; i++) {
              let item = {
                ndcCode: prescriptionDetails[j].Fill[i].Ndc,
                itemId: '',
                binId: '',
                rxNo: prescriptionDetails[j].Fill[i].PrescriptionId,
                name: prescriptionDetails[j].Medication,
                description: prescriptionDetails[j].Sig,
                image: '',
                potency: '',
                qty: prescriptionDetails[j].Fill[i].Quantity,
                schedule: prescriptionDetails[j].Frequency,
                dea_schedule: prescriptionDetails[j].DEACodeNumber,
                Amount: prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                taxPercentage: '',
                insuranceAmount: '',
                CoPayAmount:
                  prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                PaidAmount: '',
                DueAmount: '',
                paymentDueDate: '',
                stockedOn: '',
                stockedBy: '',
                deStockedOn: '',
                strength: '',
                route: '',
                doseage_form: '',
                non_proprietary_name: '',
                ExpirationDate: '',
                isLoadingTrans: false,
                fillNumber: prescriptionDetails[j].Fill[i].Id,
                prescriptionNumber:
                  prescriptionDetails[j].Fill[i].PrescriptionNumber,
                ConsultRequire: isconsultrequired,
                IsReturnable: isreturnable,
                status: prescriptionDetails[j].Fill[i].Status,
                is_controlled_substance: prescriptionDetails[j].isControlledSubstances,
                // Add flags and blocking reasons for informational display
                Flags: prescriptionDetails[j].Fill[i].Flags || [],
                CannotDispenseReasons: prescriptionDetails[j].Fill[i].CannotDispenseReasons || [],
                IsDispensable: prescriptionDetails[j].Fill[i].IsDispensable,
                // Prescription-level flags
                PrescriptionFlags: prescriptionDetails[j].AllFlags || prescriptionDetails[j].Flags || [],
                ReasonNotFillable: prescriptionDetails[j].ReasonNotFillable
              };
              let rxTransactionNumber = `${prescriptionDetails[j].Fill[i].PrescriptionId}-${prescriptionDetails[j].Fill[i].Id}`;
              if (
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'verified' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'readytodispense' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'intransit' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'received'
              ) {
                const isRxTrasactionNumberExist = await this.checkIfRxExistOrNot(
                  rxTransactionNumber
                );
                if (
                  isRxTrasactionNumberExist &&
                  isRxTrasactionNumberExist.result === true
                ) {
                  toast.error(isRxTrasactionNumberExist.error);
                  this.setState({
                    rxNumber: '',
                    loader: false,
                    EmailID: '',
                    phone: '',
                    isEpicHasValidRx: true,
                    isEpicHasValidRxMessage: '',
                  });
                  return;
                } else {
                  items.push(item);
                  if (
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'verified' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'readytodispense' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'intransit' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'received'
                  ) {
                    validItems.push(prescriptionDetails[j].Fill[i]);
                  }
                  if (validItems.length > 0) {
                    prescriptionDetails[j].Fill[i] = validItems;
                  }
                }
              } else {
                items.push(item);
              }
            }
          }
          if (items && items.length === 0) {
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              this.isRxExistInCart(searchedString, patientDetails, items);
            }
          } else {
            let RxItems = this.validateRxFills(items);
            if (
              RxItems &&
              RxItems.validRxItems &&
              RxItems.validRxItems.length > 0
            ) {
              searchedRxItems = RxItems.validRxItems;
            } else if (
              this.isPreventNonReadyAssignmentEnabled() &&
              RxItems &&
              RxItems.inValidRxItems &&
              RxItems.inValidRxItems.length > 0
            ) {
              this.showNonReadyPrescriptionBlock(RxItems.inValidRxItems);
              return;
            } else {
              searchedRxItems = RxItems.inValidRxItems;
              if (searchedRxItems && searchedRxItems.length > 0) {
                this.setState({
                  loader: false,
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: this.buildEpicNonReadyStatusMessage(
                    searchedRxItems
                  ),
                });
              }
            }
            this.setState({
              EmailID: patientDetails.EmailAddress,
              phone: patientDetails.MobilePhone,
            });
            this.checkADACompatible(
              patientDetails.MedicalRecordNumber,
              patientDetails.EmailAddress
            );
            this.getcustomerLocation(patientDetails, searchedRxItems, 'Epic');
            this.forceUpdate();
            this.setState({
              rxNumber: '',
              loader: false,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            loader: false,
            rxNumber: '',
            isEpicHasValidRx: false,
            isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
          });
          return;
        });
    // }
  };

  isPreventNonReadyAssignmentEnabled = () => {
    const connection = this.state.globalAccountConnection;
    if (
      !connection ||
      connection.account_connections_id !== CONNECTION_TYPE.EPIC
    ) {
      return false;
    }
    return [true, 'true'].includes(connection.prevent_assigning_non_ready);
  };

  buildEpicNonReadyStatusMessage = (invalidItems) => {
    const statuses = (invalidItems || [])
      .map((item) => item && item.status)
      .filter((status) => ![undefined, null, ''].includes(status));
    const statusLabel = statuses.join(', ');
    return statuses.length > 1
      ? `Statuses ${statusLabel} cannot be assigned. Use Verified, ReadyToDispense, Received, or InTransit.`
      : `Status ${statusLabel} cannot be assigned. Use Verified, ReadyToDispense, Received, or InTransit.`;
  };

  showNonReadyPrescriptionBlock = (invalidItems) => {
    this.setState({
      loader: false,
      rxNumber: '',
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: '',
      nonReadyRxBlockDialogOpen: true,
      nonReadyRxBlockMessage: this.buildEpicNonReadyStatusMessage(invalidItems),
    });
  };

  closeNonReadyPrescriptionBlock = () => {
    this.setState(
      {
        nonReadyRxBlockDialogOpen: false,
        nonReadyRxBlockMessage: '',
      },
      () => {
        this.handleFocus();
      }
    );
  };

  validateRxFills = (items) => {
    let _validRxItemArray = [];
    let _inValidRxItemArray = [];
    let validatedRxFills = {};
    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        if (
          items[i].status.toLowerCase() === 'verified' ||
          items[i].status.toLowerCase() === 'readytodispense' ||
          items[i].status.toLowerCase() === 'received' ||
          items[i].status.toLowerCase() === 'intransit'
        ) {
          _validRxItemArray.push(items[i]);
        } else {
          _inValidRxItemArray.push(items[i]);
        }
      }
    }
    validatedRxFills.validRxItems = _validRxItemArray;
    validatedRxFills.inValidRxItems = _inValidRxItemArray;
    return validatedRxFills;
  };

  getDueAmount = () => {
    let orderAmount = 0;
    for (let i = 0; i < searchedRxItems.length; i++) {
      if (
        !isNaN(
          parseFloat(searchedRxItems[i].CoPayAmount) ||
          parseFloat(searchedRxItems[i].price)
        )
      ) {
        let amount =
          parseFloat(searchedRxItems[i].CoPayAmount) ||
          parseFloat(searchedRxItems[i].price);
        orderAmount = orderAmount + amount;
      }
    }
    return `$${orderAmount.toFixed(2)}`;
  };

  isNonRxDeliverEnabled = () => {
    return isFeatureUsable(this.state.otcDeliveryEntitlement);
  };

  isOtcDeliveryEntitlementLoading = () =>
    this.state.otcDeliveryEntitlementLoading === true;

  getActiveLocationTypeId = () => {
    const current = this.state.locationtype_id;
    if (!Array.isArray(this.state.featureEntitlements)) {
      return current || LOCATION_TYPE.Kiosk;
    }
    if (isLocationTypeUsable(current, this.state.featureEntitlements)) {
      return current;
    }
    return (
      getFirstUsableLocationTypeId(
        this.state.locationtype,
        this.state.featureEntitlements,
        current
      ) || LOCATION_TYPE.Kiosk
    );
  };

  getLicensedLocationTypes = () =>
    decorateLocationTypesWithLicense(
      this.state.locationtype,
      this.state.featureEntitlements
    );

  getCurrentLocationTypeEntitlement = () => {
    const featureKey = featureKeyForLocationType(this.state.locationtype_id);
    if (!featureKey) {
      return null;
    }
    return findEntitlement(this.state.featureEntitlements, featureKey);
  };

  bounceUnlicensedLocationType = () => {
    if (!Array.isArray(this.state.featureEntitlements)) {
      return;
    }
    if (isLocationTypeUsable(this.state.locationtype_id, this.state.featureEntitlements)) {
      return;
    }
    const nextLocationTypeId = getFirstUsableLocationTypeId(
      this.state.locationtype,
      this.state.featureEntitlements,
      this.state.locationtype_id
    );
    if (nextLocationTypeId && nextLocationTypeId !== this.state.locationtype_id) {
      this.handleLocationTypeChange(nextLocationTypeId);
    }
  };

  renderLocationTypeLicenseCallout = () => {
    const entitlement = this.getCurrentLocationTypeEntitlement();
    if (
      !entitlement ||
      isLocationTypeUsable(this.state.locationtype_id, this.state.featureEntitlements)
    ) {
      return null;
    }
    return (
      <FeatureUnavailableCallout
        t={this.props.t}
        entitlement={entitlement}
        boxId={this.state.box_id}
      />
    );
  };

  fetchOtcDeliveryEntitlement = (boxId) => {
    const locationId = boxId || this.state.box_id;
    const hasLocation =
      !!locationId && !['null', 'undefined', ''].includes(locationId);
    const cacheKey = hasLocation ? locationId : '__account__';
    // Same location already in flight or resolved — avoid mount + pharmacy-details double fetch
    if (
      this._otcEntitlementInFlightBoxId === cacheKey ||
      (this._otcEntitlementResolvedBoxId === cacheKey &&
        this.state.otcDeliveryEntitlement != null &&
        Array.isArray(this.state.featureEntitlements) &&
        this.state.otcDeliveryEntitlementLoading !== true)
    ) {
      this.bounceUnlicensedLocationType();
      return;
    }
    const requestId = (this._otcEntitlementRequestId || 0) + 1;
    this._otcEntitlementRequestId = requestId;
    this._otcEntitlementInFlightBoxId = cacheKey;
    this.setState({
      otcDeliveryEntitlementLoading: true,
    });
    fetchEntitlements(hasLocation ? { boxId: locationId } : {})
      .then((data) => {
        if (requestId !== this._otcEntitlementRequestId) {
          return;
        }
        this._otcEntitlementInFlightBoxId = null;
        this._otcEntitlementResolvedBoxId = cacheKey;
        this.setState({
          otcDeliveryEntitlement: resolveOtcDeliveryEntitlement(
            data && data.entitlements
          ),
          otcDeliveryEntitlementLoading: false,
          featureEntitlements: (data && data.entitlements) || [],
        }, () => {
          this.bounceUnlicensedLocationType();
        });
      })
      .catch(() => {
        if (requestId !== this._otcEntitlementRequestId) {
          return;
        }
        this._otcEntitlementInFlightBoxId = null;
        this._otcEntitlementResolvedBoxId = cacheKey;
        this.setState({
          otcDeliveryEntitlement: LOCKED_OTC_DELIVERY_ENTITLEMENT,
          otcDeliveryEntitlementLoading: false,
          featureEntitlements: Array.isArray(this.state.featureEntitlements)
            ? this.state.featureEntitlements
            : null,
        });
      });
  };

  hasCartItems = () => {
    const nonRxCount = (this.state.nonRxCartItems || []).length;
    const hasSearchedRx = searchedRxItems && searchedRxItems.length > 0;
    const hasAssignCartRx =
      Array.isArray(this.state.assignCartItems) &&
      this.state.assignCartItems.length > 0;
    // BASIC / Build and Deploy kiosk UI stores typed Rx numbers in rxEntries,
    // not in searchedRxItems (PMS scan cart).
    const hasBasicRxEntries = (this.state.rxEntries || []).some(
      (entry) => entry && String(entry.rxNumber || '').trim() !== ''
    );
    return hasSearchedRx || hasAssignCartRx || hasBasicRxEntries || nonRxCount > 0;
  };

  validateNonRxCartItems = () => {
    const items = this.state.nonRxCartItems || [];
    for (let i = 0; i < items.length; i++) {
      const description = (items[i].description || '').toString().trim();
      if (!description) {
        return this.props.t('Assign.NonRxCart.DescriptionRequired', {
          defaultValue: 'Marketplace item description is required.',
        });
      }
      const price = parseFloat(items[i].price);
      if (isNaN(price) || price < 0) {
        return this.props.t('Assign.NonRxCart.PriceInvalid', {
          defaultValue: 'Marketplace item price must be 0 or greater.',
        });
      }
      const qty = parseFloat(items[i].qty);
      if (isNaN(qty) || qty < 1) {
        return this.props.t('Assign.NonRxCart.QtyInvalid', {
          defaultValue: 'Marketplace item quantity must be at least 1.',
        });
      }
    }
    return null;
  };

  createEmptyNonRxCartItem = (overrides = {}) => ({
    id: `nonrx-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    isDraft: true,
    is_custom: false,
    item_number: '',
    description: '',
    price: 0,
    qty: 1,
    upc: '',
    uom: 'EA',
    tax_amount: 0,
    tax_type: 'amount',
    image_url: '',
    non_rx_product_id: null,
    ...overrides,
  });

  handleAddNonRxItem = () => {
    if (!this.canAddNonRxItems()) {
      return;
    }
    const items = this.state.nonRxCartItems || [];
    if (items.some(isEmptyCatalogPickerRow)) {
      return;
    }
    this.setState({
      nonRxCartItems: [...items, this.createEmptyNonRxCartItem()],
    });
  };

  handleAddCustomNonRxItem = () => {
    if (!this.canAddNonRxItems()) {
      return;
    }
    this.setState({
      nonRxCartItems: [
        ...(this.state.nonRxCartItems || []),
        this.createEmptyNonRxCartItem({ is_custom: true }),
      ],
    });
  };

  getNonRxAccountId = () => {
    const parentAccountId = sessionStorage.getItem('parentAccountId');
    if (![undefined, 'undefined', null, 'null', ''].includes(parentAccountId)) {
      return parentAccountId;
    }
    return (this.state.accountDetails && this.state.accountDetails.id) || '';
  };

  mapCatalogProductToCartItem = (product, quantity = 1) => ({
    id: `nonrx-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    isDraft: true,
    item_number: product.item_number || '',
    description: product.description || '',
    price: product.sell_price != null ? product.sell_price : 0,
    qty: quantity,
    upc: product.upc || '',
    uom: product.uom || 'EA',
    tax_amount: computeNonRxUnitTax(product),
    tax_type: product.tax_type || 'amount',
    is_taxable: product.is_taxable,
    image_url: product.image_url || '',
    non_rx_product_id: product.id || null,
    is_custom: false,
  });

  searchNonRxCatalog = async (searchText) => {
    const search = String(searchText || '').trim();
    const accountId = this.getNonRxAccountId();
    let token = '';
    try {
      const user = JSON.parse(sessionStorage.getItem('user') || 'null');
      token =
        user &&
        user.signInUserSession &&
        user.signInUserSession.idToken &&
        user.signInUserSession.idToken.jwtToken
          ? user.signInUserSession.idToken.jwtToken
          : '';
    } catch (error) {
      token = '';
    }
    if (!token) {
      toast.error(
        this.props.t('Assign.NonRxCart.LookupFailed', {
          defaultValue: 'Could not load catalog.',
        })
      );
      return [];
    }
    try {
      const body = {
        search,
        page: 0,
        pageSize: 20,
        status: 'active',
      };
      if (accountId) {
        body.account_id = accountId;
      }
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}api/non-rx-products`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        }
      );
      const data = await response.json();
      if (!response.ok) {
        toast.error(
          (data && data.message) ||
            this.props.t('Assign.NonRxCart.LookupFailed', {
              defaultValue: 'Could not load catalog.',
            })
        );
        return [];
      }
      return (data.results || []).filter(isSellableCatalogProduct);
    } catch (error) {
      toast.error(
        this.props.t('Assign.NonRxCart.LookupFailed', {
          defaultValue: 'Could not load catalog.',
        })
      );
      return [];
    }
  };

  handleSelectNonRxCatalogProduct = (index, product) => {
    if (!product) return;
    if (!isSellableCatalogProduct(product)) {
      toast.error(
        this.props.t('Assign.NonRxCart.InactiveOrDeleted', {
          defaultValue:
            'This product is inactive or deleted and cannot be added.',
        })
      );
      return;
    }
    const items = [...(this.state.nonRxCartItems || [])];
    const current = items[index];
    if (!current) return;
    if (
      current.non_rx_product_id &&
      product.id &&
      String(current.non_rx_product_id) === String(product.id)
    ) {
      return;
    }
    const matchIndex = findMatchingNonRxCartIndex(items, {
      productId: product.id,
      upc: product.upc,
      skipIndex: index,
    });
    if (matchIndex >= 0) {
      const extraQty = parseFloat(current.qty) || 1;
      items[matchIndex] = incrementNonRxCartQty(items[matchIndex], extraQty);
      items.splice(index, 1);
      this.setState({ nonRxCartItems: items });
      toast.success(
        this.props.t('Assign.NonRxCart.CatalogItemQtyUpdated', {
          defaultValue: 'Item already in cart. Quantity updated.',
        })
      );
      return;
    }
    const mapped = this.mapCatalogProductToCartItem(product, current.qty || 1);
    items[index] = {
      ...mapped,
      id: current.id,
      isDraft: current.isDraft,
      qty: current.qty || 1,
    };
    this.setState({ nonRxCartItems: items });
    toast.success(
      this.props.t('Assign.NonRxCart.CatalogItemSelected', {
        defaultValue: 'Catalog item loaded.',
      })
    );
  };

  handleSaveNonRxProductImage = async (index, imageFile) => {
    const items = this.state.nonRxCartItems || [];
    const item = items[index];
    if (!item || !imageFile) {
      return false;
    }

    const isDraftItem =
      item.isDraft || String(item.id || '').startsWith('nonrx-');
    if (this.isAssignedOrderReadOnly() && !isDraftItem) {
      return false;
    }

    const accountId = this.getNonRxAccountId();
    const token = getNonRxAuthToken();
    const isEdit = !!item.non_rx_product_id;

    if (!isEdit) {
      const missing = validateNonRxProductForCatalogSave(item);
      if (missing.length > 0) {
        toast.error(
          this.props.t('Assign.NonRxCart.ImageSaveMissingFields', {
            defaultValue:
              'Enter Item #, Description, and UPC on this row before saving a catalog photo.',
          })
        );
        return false;
      }
    }

    if (!accountId) {
      toast.error(
        this.props.t('NonRxCatalog.AccountRequired', {
          defaultValue: 'Account is required.',
        })
      );
      return false;
    }

    try {
      const product = await saveNonRxProductWithImage({
        item,
        accountId,
        imageFile,
        token,
      });
      const nextItems = [...items];
      nextItems[index] = {
        ...item,
        image_url: product.image_url || item.image_url || '',
        non_rx_product_id: product.id || item.non_rx_product_id || null,
        is_custom: false,
        item_number: product.item_number || item.item_number || '',
        description: product.description || item.description || '',
        upc: product.upc || item.upc || '',
        uom: product.uom || item.uom || 'EA',
        price:
          product.sell_price != null ? product.sell_price : item.price,
        tax_amount: computeNonRxUnitTax(product, item.price),
        tax_type: product.tax_type || item.tax_type || 'amount',
        is_taxable: product.is_taxable,
      };
      this.setState({ nonRxCartItems: nextItems });
      toast.success(
        this.props.t(
          isEdit
            ? 'Assign.NonRxCart.ImageUpdated'
            : 'Assign.NonRxCart.ImageSavedToCatalog',
          {
            defaultValue: isEdit
              ? 'Product photo updated in Marketplace catalog.'
              : 'Product saved to Marketplace catalog with photo.',
          }
        )
      );
      return true;
    } catch (error) {
      if (error && error.message === 'MISSING_REQUIRED_FIELDS') {
        toast.error(
          this.props.t('Assign.NonRxCart.ImageSaveMissingFields', {
            defaultValue:
              'Enter Item #, Description, and UPC on this row before saving a catalog photo.',
          })
        );
        return false;
      }
      toast.error(
        (error && error.message) ||
          this.props.t('Assign.NonRxCart.ImageSaveFailed', {
            defaultValue: 'Failed to save product photo.',
          })
      );
      return false;
    }
  };

  lookupAndAddCatalogItem = async (rawUpc) => {
    const upc = normalizeNonRxUpc(rawUpc);
    if (!upc || !this.canAddNonRxItems() || this._upcLookupInFlight) {
      return;
    }
    const accountId = this.getNonRxAccountId();
    this._upcLookupInFlight = true;
    this.setState({ upcScanBusy: true });
    try {
      const query = `upc=${encodeURIComponent(upc)}${
        accountId ? `&account_id=${encodeURIComponent(accountId)}` : ''
      }`;
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}api/non-rx-products/lookup?${query}`,
        {
          method: 'GET',
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
        }
      );
      const payload = await response.json().catch(() => ({}));
      if (
        response.status === 409 ||
        payload.code === 'PRODUCT_INACTIVE' ||
        payload.code === 'PRODUCT_DELETED'
      ) {
        toast.error(
          payload.message ||
            this.props.t('Assign.NonRxCart.InactiveOrDeleted', {
              defaultValue:
                payload.code === 'PRODUCT_DELETED'
                  ? 'This product has been deleted and cannot be added.'
                  : 'This product is inactive and cannot be added.',
            })
        );
        this.setState({ upcScan: '', upcScanBusy: false });
        return;
      }
      if (response.status === 404) {
        const oneOffItem = this.createEmptyNonRxCartItem({
          is_custom: true,
          item_number: upc,
          upc,
        });
        let merged = false;
        this.setState(
          (prev) => {
            const result = addOrIncrementNonRxCartItem(
              prev.nonRxCartItems,
              oneOffItem,
              { upc }
            );
            merged = result.merged;
            return {
              nonRxCartItems: result.items,
              upcScan: '',
              upcScanBusy: false,
            };
          },
          () => {
            if (merged) {
              toast.success(
                this.props.t('Assign.NonRxCart.CatalogItemQtyUpdated', {
                  defaultValue: 'Item already in cart. Quantity updated.',
                })
              );
            } else {
              toast.info(
                this.props.t('Assign.NonRxCart.NotInCatalogAddOneOff', {
                  defaultValue:
                    'Item not in catalog. Added as a one-off — complete description and price.',
                })
              );
            }
          }
        );
        return;
      }
      const product = payload;
      if (!response.ok) {
        throw new Error(product.message || 'Lookup failed');
      }
      if (!isSellableCatalogProduct(product)) {
        toast.error(
          this.props.t('Assign.NonRxCart.InactiveOrDeleted', {
            defaultValue:
              'This product is inactive or deleted and cannot be added.',
          })
        );
        this.setState({ upcScan: '', upcScanBusy: false });
        return;
      }
      const mappedItem = this.mapCatalogProductToCartItem(product, 1);
      let merged = false;
      this.setState(
        (prev) => {
          const result = addOrIncrementNonRxCartItem(
            prev.nonRxCartItems,
            mappedItem,
            { productId: product.id, upc: product.upc || upc }
          );
          merged = result.merged;
          return {
            nonRxCartItems: result.items,
            upcScan: '',
            upcScanBusy: false,
          };
        },
        () => {
          toast.success(
            this.props.t(
              merged
                ? 'Assign.NonRxCart.CatalogItemQtyUpdated'
                : 'Assign.NonRxCart.CatalogItemAdded',
              {
                defaultValue: merged
                  ? 'Item already in cart. Quantity updated.'
                  : '{{name}} added',
                name: product.description || upc,
              }
            )
          );
        }
      );
    } catch (error) {
      this.setState({ upcScanBusy: false });
      toast.error(
        error.message ||
          this.props.t('Assign.NonRxCart.LookupFailed', {
            defaultValue: 'Could not look up that UPC.',
          })
      );
    } finally {
      this._upcLookupInFlight = false;
    }
  };

  handleUpcScanChange = (event) => {
    this.setState({ upcScan: event.target.value });
  };

  handleUpcScanFocus = () => {
    this._upcScanFocused = true;
  };

  handleUpcScanBlur = () => {
    this._upcScanFocused = false;
  };

  handleUpcScanKeyDown = (event) => {
    if (event.key !== 'Enter') {
      return;
    }
    event.preventDefault();
    if (!this.isUpcScanEnabled()) {
      return;
    }
    this.lookupAndAddCatalogItem(this.state.upcScan);
  };

  handleUpcScanSubmit = () => {
    if (!this.isUpcScanEnabled()) {
      return;
    }
    this.lookupAndAddCatalogItem(this.state.upcScan);
  };

  isUpcScanEnabled = () =>
    !this.isOtcDeliveryEntitlementLoading() &&
    this.canAddNonRxItems() &&
    this.state.upcScanBusy !== true;

  renderUpcScanField = (classes) => {
    const { t } = this.props;
    return (
      <MarketplaceUpcScan
        t={t}
        variant="standard"
        className={classNames(classes.scantextField, 'assign-upc-scan-field')}
        value={this.state.upcScan || ''}
        disabled={!this.isUpcScanEnabled()}
        busy={this.state.upcScanBusy}
        loading={this.isOtcDeliveryEntitlementLoading()}
        enabled={this.isNonRxDeliverEnabled()}
        onChange={this.handleUpcScanChange}
        onFocus={this.handleUpcScanFocus}
        onBlur={this.handleUpcScanBlur}
        onKeyDown={this.handleUpcScanKeyDown}
        onSubmit={this.handleUpcScanSubmit}
      />
    );
  };

  renderMarketplaceSection = (classes, t) => {
    const scanField = this.isNonRxDeliverEnabled() ? (
      <div className="assign-marketplace-scan">
        {this.renderUpcScanField(classes)}
      </div>
    ) : null;

    if (this.isOtcDeliveryEntitlementLoading()) {
      return (
        <div className="assign-marketplace-panel is-loading">
          <div className="assign-marketplace-panel-header">
            {t('Assign.Marketplace.SectionTitle', {
              defaultValue: 'Marketplace',
            })}
          </div>
          <div className="assign-non-rx-feature is-loading">
            <div className="assign-non-rx-loading-header">
              {t('Assign.NonRxCart.Title', {
                defaultValue: 'Marketplace Items',
              })}
            </div>
            <LinearProgress className="assign-non-rx-loading-bar" />
            <p className="assign-non-rx-loading-copy">
              {t('Assign.NonRxCart.CheckingAvailability', {
                defaultValue: 'Checking Marketplace availability…',
              })}
            </p>
          </div>
        </div>
      );
    }

    if (this.isNonRxDeliverEnabled()) {
      return (
        <div className="assign-marketplace-panel">
          <div className="assign-marketplace-panel-header">
            {t('Assign.Marketplace.SectionTitle', {
              defaultValue: 'Marketplace',
            })}
            <span className="assign-marketplace-panel-badge">
              {t('Assign.Marketplace.SectionBadge', {
                defaultValue: 'Non-pharmacy items',
              })}
            </span>
          </div>
          {scanField}
          <NonRxCart
            t={t}
            items={this.state.nonRxCartItems}
            disabled={this.isAssignedOrderReadOnly()}
            allowAdd={this.canAddNonRxItems()}
            priceEditable={this.canEditNonRxPriceOnAssignedBin()}
            editingPriceIndex={this.state.nonRxPriceEditIndex}
            onAddItem={this.handleAddNonRxItem}
            onAddCustomItem={this.handleAddCustomNonRxItem}
            onChangeItem={this.handleChangeNonRxItem}
            onRemoveItem={this.handleRemoveNonRxItem}
            onStartPriceEdit={this.handleStartNonRxPriceEdit}
            onSavePriceEdit={this.handleSaveNonRxPriceEdit}
            onSaveDraftItem={this.handleSaveDraftNonRxItem}
            onSearchCatalog={this.searchNonRxCatalog}
            onSelectCatalogProduct={this.handleSelectNonRxCatalogProduct}
            onSaveProductImage={this.handleSaveNonRxProductImage}
          />
        </div>
      );
    }

    return (
      <div className="assign-marketplace-panel is-unavailable">
        <div className="assign-marketplace-panel-header">
          {t('Assign.Marketplace.SectionTitle', {
            defaultValue: 'Marketplace',
          })}
        </div>
        <div className="assign-non-rx-feature is-unavailable">
          <OtcDeliveryCallout
            t={t}
            entitlement={
              this.state.otcDeliveryEntitlement ||
              LOCKED_OTC_DELIVERY_ENTITLEMENT
            }
            boxId={this.state.box_id}
          />
          <NonRxCart
            t={t}
            items={this.state.nonRxCartItems}
            disabled
            allowAdd={false}
            onAddItem={this.handleAddNonRxItem}
            onAddCustomItem={this.handleAddCustomNonRxItem}
            onChangeItem={this.handleChangeNonRxItem}
            onRemoveItem={this.handleRemoveNonRxItem}
          />
        </div>
      </div>
    );
  };

  handleChangeNonRxItem = (index, field, value) => {
    const nextItems = [...(this.state.nonRxCartItems || [])];
    if (!nextItems[index]) return;
    const item = nextItems[index];
    const isDraft =
      item.isDraft || String(item.id || '').startsWith('nonrx-');
    if (
      this.isAssignedOrderReadOnly() &&
      !isDraft &&
      field !== 'price'
    ) {
      return;
    }
    nextItems[index] = { ...item, [field]: value };
    this.setState({ nonRxCartItems: nextItems });
  };

  handleRemoveNonRxItem = (index) => {
    const items = this.state.nonRxCartItems || [];
    const item = items[index];
    if (!item) return;
    const isDraft =
      item.isDraft || String(item.id || '').startsWith('nonrx-');
    if (this.isAssignedOrderReadOnly() && !isDraft) {
      return;
    }
    const nextItems = [...items];
    nextItems.splice(index, 1);
    this.setState({
      nonRxCartItems: nextItems,
      nonRxPriceEditIndex:
        this.state.nonRxPriceEditIndex === index
          ? null
          : this.state.nonRxPriceEditIndex,
    });
  };

  handleStartNonRxPriceEdit = (index) => {
    this.setState({ nonRxPriceEditIndex: index });
  };

  isPersistedNonRxItemId = (id) => {
    if (!id) return false;
    const value = String(id);
    if (value.startsWith('nonrx-')) return false;
    return isUuidLikeValue(value);
  };

  handleSaveNonRxPriceEdit = (index) => {
    const items = this.state.nonRxCartItems || [];
    const item = items[index];
    if (!item) {
      this.setState({ nonRxPriceEditIndex: null });
      return;
    }
    const price = parseFloat(item.price);
    if (Number.isNaN(price) || price < 0) {
      toast.error(
        this.props.t('Assign.NonRxCart.PriceInvalid', {
          defaultValue: 'Marketplace item price must be 0 or greater.',
        })
      );
      return;
    }
    this.setState({ nonRxPriceEditIndex: null });
    if (this.isPersistedNonRxItemId(item.id)) {
      this.updateDueAmount(
        item.id,
        price,
        this.props.t('Assign.NonRxCart.PriceUpdated', {
          defaultValue: 'Marketplace item price updated successfully',
        })
      );
    }
  };

  canEditNonRxPriceOnAssignedBin = () =>
    this.state.isEdit === true &&
    this.state.isAmountPaid === false &&
    this.state.isPartiallyPaid === false;

  // Empty Deliver form defaults to readOnly:true; only lock Marketplace add when
  // an existing assigned order is loaded for viewing.
  isAssignedOrderReadOnly = () =>
    this.state.readOnly === true && Boolean(this.state.orderId);

  canAddNonRxItems = () =>
    this.isNonRxDeliverEnabled() &&
    !this.isAssignedOrderReadOnly() &&
    this.state.isAmountPaid === false &&
    this.state.isPartiallyPaid === false;

  handleSaveDraftNonRxItem = async (index) => {
    const items = this.state.nonRxCartItems || [];
    const item = items[index];
    const orderId = this.state.orderId;
    if (!item) return;

    const description = (item.description || '').toString().trim();
    if (!description) {
      toast.error(
        this.props.t('Assign.NonRxCart.DescriptionRequired', {
          defaultValue: 'Marketplace item description is required.',
        })
      );
      return;
    }
    const price = parseFloat(item.price);
    if (Number.isNaN(price) || price < 0) {
      toast.error(
        this.props.t('Assign.NonRxCart.PriceInvalid', {
          defaultValue: 'Marketplace item price must be 0 or greater.',
        })
      );
      return;
    }
    const qty = parseFloat(item.qty);
    if (Number.isNaN(qty) || qty < 1) {
      toast.error(
        this.props.t('Assign.NonRxCart.QtyInvalid', {
          defaultValue: 'Marketplace item quantity must be at least 1.',
        })
      );
      return;
    }

    // Assigned order: persist immediately via addItems.
    if (!orderId) {
      toast.error(
        this.props.t('Assign.NonRxCart.SaveFailed', {
          defaultValue: 'Failed to save Marketplace item to order.',
        })
      );
      return;
    }

    this.setState({ loader: true });
    try {
      const response = await fetch(
        process.env.REACT_APP_BASEURL + 'prescription/addItems',
        {
          method: 'POST',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            audit_writer: 'web-gap-v1',
            prescription_id: orderId,
            items: [
              {
                is_non_rx: true,
                item_number: (item.item_number || '').toString().trim(),
                drug_name: description,
                price,
                qty,
                tax_amount: parseFloat(item.tax_amount) || 0,
                upc: (item.upc || '').toString().trim() || null,
                uom: (item.uom || '').toString().trim() || null,
                non_rx_product_id: item.non_rx_product_id || null,
                image_url: (item.image_url || '').toString().trim() || null,
              },
            ],
          }),
        }
      );
      const data = await response.json().catch(() => null);
      if (!response.ok || (data && data.statusCode && data.statusCode >= 400)) {
        toast.error(
          (data && data.message) ||
            this.props.t('Assign.NonRxCart.SaveFailed', {
              defaultValue: 'Failed to save Marketplace item to order.',
            })
        );
        this.setState({ loader: false });
        return;
      }

      const saved =
        data &&
        Array.isArray(data.prescriptionItems) &&
        data.prescriptionItems[0]
          ? data.prescriptionItems[0]
          : null;
      const nextItems = [...items];
      nextItems[index] = {
        id: (saved && saved.id) || item.id,
        isDraft: false,
        item_number:
          (saved && saved.item_number) ||
          (item.item_number || '').toString().trim(),
        description:
          (saved && (saved.drug_name || saved.description)) || description,
        price: saved && saved.price != null ? saved.price : price,
        qty: saved && saved.qty != null ? saved.qty : qty,
      };
      this.setState({ nonRxCartItems: nextItems, loader: false });
      toast.success(
        this.props.t('Assign.NonRxCart.ItemAdded', {
          defaultValue: 'Marketplace item added to order successfully',
        })
      );
    } catch (error) {
      this.setState({ loader: false });
      toast.error(
        this.props.t('Assign.NonRxCart.SaveFailed', {
          defaultValue: 'Failed to save Marketplace item to order.',
        })
      );
    }
  };

  getPaidAmountDisplay = () => {
    const { isAmountPaid, isPartiallyPaid, paymentPaidAmount } = this.state;
    if (isAmountPaid) {
      return this.getDueAmount();
    }
    if (isPartiallyPaid) {
      return `$${Number(paymentPaidAmount || 0).toFixed(2)}`;
    }
    return `$${(0).toFixed(2)}`;
  };

  getDueAmountDisplay = () => {
    const { isAmountPaid, isPartiallyPaid, paymentDueAmount } = this.state;
    if (isAmountPaid) {
      return `$${(0).toFixed(2)}`;
    }
    if (isPartiallyPaid) {
      return `$${Number(paymentDueAmount || 0).toFixed(2)}`;
    }
    return this.getDueAmount();
  };
  getBinAssignments = () => {
    // Get bin assignments from BinStatus or searchedItems
    const { BinStatus, searchedItems, pickupCode } = this.state;
    const assignments = [];

    if (BinStatus && BinStatus.length > 0) {
      BinStatus.forEach((bin) => {
        if (bin.customer_name) {
          assignments.push({
            name: bin.customer_name,
            bin: bin.bin_id || bin.id,
            status: bin.status === 'assigned' || bin.status === 'stocked',
            puCode: bin.pucode || pickupCode,
          });
        }
      });
    } else if (searchedItems && searchedItems.first_name) {
      // If we have patient info but no bin status, show patient with selected bin
      assignments.push({
        name: `${searchedItems.first_name || ''} ${searchedItems.last_name || ''}`.trim(),
        bin: this.state.selectedBinId || this.state.binid || '',
        status: !!this.state.selectedBinId || !!this.state.binid,
        puCode: pickupCode,
      });
    }

    return assignments;
  };

  getPaymentDetails = (orderId, customerId) => {
    if (!orderId || !customerId) {
      this.setState({ loader: false });
      return;
    }
    let paymentToken = '';
    try {
      paymentToken = JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken;
    } catch (tokenError) {
      this.setState({ loader: false });
      return;
    }
    const PaymentAbort = window.AbortController;
    const paymentController = typeof PaymentAbort === 'function' ? new PaymentAbort() : null;
    const paymentTimeoutId = paymentController
      ? setTimeout(() => paymentController.abort(), 20000)
      : null;
    fetch(
      `${process.env.REACT_APP_BASEURL}payments/validate-payment?order_id=${orderId}&customer_id=${customerId}`,
      {
        method: 'GET',
        withCredentials: true,
        ...(paymentController ? { signal: paymentController.signal } : {}),
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + paymentToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        clearTimeout(paymentTimeoutId);
        if (data && (data.res !== undefined || data.is_paid !== undefined)) {
          const isPaid = data.res === true || data.is_paid === true;
          const isPartial =
            !isPaid &&
            (data.partial_payment === true || data.partial_payment === 'true') &&
            Number(data.remaining_amount || 0) > 0;
          this.setState({
            isAmountPaid: isPaid,
            isPartiallyPaid: isPartial,
            paymentPaidAmount: isPartial ? Number(data.paid_amount || 0) : 0,
            paymentDueAmount: isPartial ? Number(data.remaining_amount || 0) : 0,
            loader: false,
          });
        } else {
          // Always clear overlay — empty/invalid payment payloads used to leave the screen frozen
          this.setState({ loader: false });
        }
      }).catch(() => {
        clearTimeout(paymentTimeoutId);
        this.setState({ loader: false });
      });
  };
  getPaymentDeviceStorageKey = (boxId, gatewayId) => {
    const normalizedBoxId = String(boxId || '').trim();
    const normalizedGatewayId = normalizePaymentGatewayId(gatewayId);
    if (!normalizedBoxId) return null;
    return `${PAYMENT_DEVICE_SELECTION_STORAGE_PREFIX}:${normalizedBoxId}:${normalizedGatewayId}`;
  };

  parseBoxPaymentDevices = (box) => {
    if (!box) return [];
    const source = box.payment_devices || box.paymentDevices || [];
    if (Array.isArray(source)) return source.filter(Boolean);
    if (typeof source === 'string' && source.trim()) {
      try {
        const parsed = JSON.parse(source);
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
      } catch (_error) {
        return [];
      }
    }
    return [];
  };

  getBoxPaymentGatewayId = (box) =>
    normalizePaymentGatewayId(box && (box.selected_payment_gateway || box.selectedPaymentGateway));

  getAvailablePaymentDevicesForBox = (box) => {
    const gatewayId = this.getBoxPaymentGatewayId(box);
    return this.parseBoxPaymentDevices(box).filter((device) => {
      const deviceGateway = normalizePaymentGatewayId(device && (device.payment_gateway_id || device.paymentGatewayId));
      const isDeleted = device && (device.is_deleted === true || device.is_deleted === 'true');
      const isInactive = device && (device.is_active === false || device.is_active === 'false' || device.is_active === 0 || device.is_active === '0');
      return !isDeleted && !isInactive && deviceGateway === gatewayId && getPaymentDeviceUiId(device);
    });
  };

  getStoredPaymentDeviceSelection = (boxId, gatewayId) => {
    const key = this.getPaymentDeviceStorageKey(boxId, gatewayId);
    if (!key) return null;
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed && parsed.paymentDeviceId ? parsed : null;
    } catch (_error) {
      return null;
    }
  };

  setStoredPaymentDeviceSelection = (box, device) => {
    if (!box || !device) return;
    const deviceId = getPaymentDeviceUiId(device);
    const key = this.getPaymentDeviceStorageKey(box.id || this.state.box_id, this.getBoxPaymentGatewayId(box));
    if (!key || !deviceId) return;
    try {
      localStorage.setItem(key, JSON.stringify({
        paymentDeviceId: deviceId,
        deviceName: device.name || device.device_name || '',
        gatewayId: this.getBoxPaymentGatewayId(box),
        boxId: box.id || this.state.box_id,
        savedAt: new Date().toISOString(),
      }));
    } catch (_error) {
      // localStorage can fail in private browsing; payment can still continue with component state.
    }
  };

  syncSelectedPaymentDeviceForBox = (box = this.state.currentBoxData || this.state.selectedBox) => {
    const boxId = box && (box.id || this.state.box_id);
    const gatewayId = this.getBoxPaymentGatewayId(box);
    const devices = this.getAvailablePaymentDevicesForBox(box);
    if (!boxId || devices.length === 0) {
      if (this.state.selectedPaymentDeviceId || this.state.selectedPaymentDeviceName) {
        this.setState({ selectedPaymentDeviceId: '', selectedPaymentDeviceName: '' });
      }
      return;
    }

    const storedSelection = this.getStoredPaymentDeviceSelection(boxId, gatewayId);
    const currentDevice = this.state.selectedPaymentDeviceId
      ? devices.find((device) => String(getPaymentDeviceUiId(device)) === String(this.state.selectedPaymentDeviceId))
      : null;
    const storedDevice = storedSelection
      ? devices.find((device) => String(getPaymentDeviceUiId(device)) === String(storedSelection.paymentDeviceId))
      : null;
    const selectedDevice = currentDevice || storedDevice || devices[0];
    const selectedDeviceId = getPaymentDeviceUiId(selectedDevice);
    const selectedDeviceName = selectedDevice.name || selectedDevice.device_name || '';

    if (selectedDeviceId && selectedDeviceId !== (storedSelection && storedSelection.paymentDeviceId)) {
      this.setStoredPaymentDeviceSelection(box, selectedDevice);
    }

    if (
      String(this.state.selectedPaymentDeviceId || '') !== String(selectedDeviceId || '') ||
      String(this.state.selectedPaymentDeviceName || '') !== String(selectedDeviceName || '')
    ) {
      this.setState({
        selectedPaymentDeviceId: selectedDeviceId || '',
        selectedPaymentDeviceName: selectedDeviceName || '',
      });
    }
  };

  selectPaymentDevice = (selectedDevice, options = {}) => {
    if (!selectedDevice) return;
    const selectedPaymentDeviceId = getPaymentDeviceUiId(selectedDevice);
    if (!selectedPaymentDeviceId) return;

    const box = this.state.currentBoxData || this.state.selectedBox;
    this.setStoredPaymentDeviceSelection(box, selectedDevice);
    this.setState({
      selectedPaymentDeviceId,
      selectedPaymentDeviceName: selectedDevice.name || selectedDevice.device_name || '',
      paymentDeviceDialogOpen: options.closeDialog ? false : this.state.paymentDeviceDialogOpen,
    });
  };

  handlePaymentDeviceSelectionChange = (event) => {
    const selectedPaymentDeviceId = event.target.value;
    const box = this.state.currentBoxData || this.state.selectedBox;
    const devices = this.getAvailablePaymentDevicesForBox(box);
    const selectedDevice = devices.find(
      (device) => String(getPaymentDeviceUiId(device)) === String(selectedPaymentDeviceId)
    );
    this.selectPaymentDevice(selectedDevice);
  };

  getSelectedPaymentDeviceIdForPayment = () => {
    const box = this.state.currentBoxData || this.state.selectedBox;
    const devices = this.getAvailablePaymentDevicesForBox(box);
    if (devices.length === 0) return '';

    const selectedFromState = this.state.selectedPaymentDeviceId
      ? devices.find((device) => String(getPaymentDeviceUiId(device)) === String(this.state.selectedPaymentDeviceId))
      : null;
    if (selectedFromState) return getPaymentDeviceUiId(selectedFromState);

    const storedSelection = this.getStoredPaymentDeviceSelection(
      box && (box.id || this.state.box_id),
      this.getBoxPaymentGatewayId(box)
    );
    const selectedFromStorage = storedSelection
      ? devices.find((device) => String(getPaymentDeviceUiId(device)) === String(storedSelection.paymentDeviceId))
      : null;
    const selectedDevice = selectedFromStorage || devices[0];
    return getPaymentDeviceUiId(selectedDevice) || '';
  };

  shouldShowPaymentDeviceSelectorForPayment = () => {
    const locationTypeId = this.state.locationtype_id;
    return [LOCATION_TYPE.Counter, LOCATION_TYPE.Bedside, LOCATION_TYPE.Courier].some((allowedTypeId) =>
      this.idsMatch(locationTypeId, allowedTypeId)
    );
  };

  renderPaymentDeviceSelector = ({ paymentCard = false } = {}) => {
    if (paymentCard && !this.shouldShowPaymentDeviceSelectorForPayment()) return null;

    const box = this.state.currentBoxData || this.state.selectedBox;
    const devices = this.getAvailablePaymentDevicesForBox(box);
    if (!box || devices.length <= 1) return null;

    const selectedDeviceId = this.getSelectedPaymentDeviceIdForPayment();
    const selectedDevice = devices.find(
      (device) => String(getPaymentDeviceUiId(device)) === String(selectedDeviceId)
    ) || devices[0];
    const selectedDeviceName = (selectedDevice && (selectedDevice.name || selectedDevice.device_name || selectedDevice.pos_terminal_id)) || 'Payment Device';

    return (
      <React.Fragment>
        <Button
          type="button"
          variant="outlined"
          size="small"
          className={
            'assign-rx-payment-device-selector' +
            (paymentCard ? ' assign-rx-payment-device-selector--payment-card' : '')
          }
          id="react-no-print"
          onClick={() => this.setState({ paymentDeviceDialogOpen: true })}
        >
          <span className="assign-rx-payment-device-selector__label">Device</span>
          <span className="assign-rx-payment-device-selector__name">{selectedDeviceName}</span>
        </Button>

        <Dialog
          open={this.state.paymentDeviceDialogOpen}
          onClose={() => this.setState({ paymentDeviceDialogOpen: false })}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Select Payment Device</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
              Choose which terminal should light up for this screen.
            </DialogContentText>
            <div className="assign-rx-payment-device-dialog-list">
              {devices.map((device) => {
                const deviceId = getPaymentDeviceUiId(device);
                const isSelected = String(deviceId) === String(selectedDeviceId);
                const deviceName = device.name || device.device_name || device.pos_terminal_id || 'Payment Device';
                const terminalId = device.pos_terminal_id || device.xwebterminalid || device.terminal_id || device.terminalId || '';
                const merchantId = device.pos_merchant_site_id || device.xwebid || device.pos_merchant_key || '';
                return (
                  <button
                    key={deviceId}
                    type="button"
                    className={
                      'assign-rx-payment-device-dialog-row' +
                      (isSelected ? ' assign-rx-payment-device-dialog-row--selected' : '')
                    }
                    onClick={() => this.selectPaymentDevice(device, { closeDialog: true })}
                  >
                    <span className="assign-rx-payment-device-dialog-radio" aria-hidden="true" />
                    <span className="assign-rx-payment-device-dialog-copy">
                      <span className="assign-rx-payment-device-dialog-name">{deviceName}</span>
                      {terminalId ? (
                        <span className="assign-rx-payment-device-dialog-meta">Terminal: {terminalId}</span>
                      ) : null}
                      {merchantId ? (
                        <span className="assign-rx-payment-device-dialog-meta">Merchant / Store: {merchantId}</span>
                      ) : null}
                    </span>
                  </button>
                );
              })}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ paymentDeviceDialogOpen: false })}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  };

  getcustomerLocation = (patient, items, type, onComplete) => {
    const { 
      phone, 
      EmailID, 
      boxDetails 
    } = this.state;
    let parsedDob = '', 
    AddressLine1 = '', 
    AddressLine2 = '', 
    City = '', 
    State = '', 
    Zip = '', 
    Country = '', 
    phoneNumber = '', 
    emailAddress = '',
    boxId = this.state.box_id;
    this.generateCodes();
    let locationDetails = (boxDetails || []).filter((x) => x.id === boxId)[0];
    if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
      const addr = locationDetails.address || locationDetails;
      AddressLine1 = addr.address_line_1 || locationDetails.address_line_1 || "";
      AddressLine2 = addr.address_line_2 || locationDetails.address_line_2 || "";
      City = addr.city || locationDetails.city || "";
      State = addr.state || locationDetails.state || "";
      Zip = addr.zip || locationDetails.zip || "";
      Country = addr.country || locationDetails.country || "";
    }
    if (type === 'Epic' || type === 'Epic With MTLS') {
      parsedDob = patient.DateOfBirth.substr(5, 2) + '/' + patient.DateOfBirth.substr(8, 2) + '/' + patient.DateOfBirth.substr(0, 4);
      phoneNumber = phone;
      emailAddress = EmailID;
      if (patient.EmailAddress === '' || EmailID === '') {
        toast.error(this.props.t('Toast.Error.EnterEmail'));
        this.setState({ loader: false });
      }
      if (patient.MobilePhone === '' || phone === '') {
        toast.error(this.props.t('Toast.Error.EnterMobile'));
        this.setState({ loader: false });
      }
    } else if (type === 'Pioneer') {
      parsedDob = patient.dateOfBirth.substr(5, 2) + '/' + patient.dateOfBirth.substr(8, 2) + '/' + patient.dateOfBirth.substr(0, 4);
      phoneNumber = phone;
      emailAddress = EmailID;
    } else if (type === 'Medbank') {
      parsedDob = patient.dob_str || patient.dateOfBirth;
      phoneNumber = phone;
      emailAddress = EmailID;
    } else if (type === 'MScripts') {
      parsedDob = patient.dob_str || patient.dateOfBirth || patient.dob;
      phoneNumber = 'N/A';
      emailAddress = 'N/A';
    } else if (type === PARTNER_INTEGRATION_ASSIGN_PHI_TYPE) {
      parsedDob = patient.dob_str || patient.DateOfBirth || patient.dob;
      phoneNumber = patient.phone || patient.MobileNo || 'N/A';
      emailAddress = patient.EmailAddress || patient.email || 'N/A';
      if (patient.address_line_1) {
        AddressLine1 = patient.address_line_1 || '';
        AddressLine2 = patient.address_line_2 || '';
        City = patient.city || '';
        State = patient.state || '';
        Zip = patient.zip || '';
      }
    } else if (type === 'McKesson') {
      parsedDob = patient.DateOfBirth
      phoneNumber = patient.MobilePhoneWithoutAreaCode;
      emailAddress = patient.EmailAddress;
    } else if (type === 'LIBERTYSOFTWARE') {
      parsedDob = patient.dob_str;
      phoneNumber = patient.phone;
      emailAddress = patient.email;
    }  else if (type === 'HL7') {
      parsedDob = patient.dob_str || patient.dateOfBirth || patient.dob;
    } else if(type === 'DRX') {
      parsedDob = patient.dob.substr(5, 2) + '/' + patient.dob.substr(8, 2) + '/' + patient.dob.substr(0, 4);
      phoneNumber = patient.phone;
      emailAddress = patient.email;
    } else if (type === 'PrimeRx') {
      console.log(patient, 'patient');
      parsedDob = patient.dob_str || patient.dateOfBirth || patient.dob;
      phoneNumber = patient.phone;
      emailAddress = patient.email;
    } else {
      parsedDob = patient.DateOfBirth;
      phoneNumber = phone;
      emailAddress = EmailID;
    }
    const basicDetails = {
      first_name: patient.FirstName,
      last_name: patient.LastName,
      dob_str: patient.DateOfBirth,
    };
    const contactDetails = {
      phone: phoneNumber,
      email: emailAddress,
    };
    this.setState(
      {
        locationtype_id: localStorage.getItem('selectedLocationTypeId'),
        box_id: boxId,
        searchedItems: {
          PatientID:
            patient.PatientID ||
            patient.MedicalRecordNumber ||
            patient.patient_id ||
            patient.patientID ||
            patient.ExternalPatientID,
          customer_id: patient.customer_id || patient.customerId,
          FirstName: patient.FirstName || patient.first_name || patient.firstName,
          LastName: patient.LastName || patient.last_name || patient.lastName,
          MiddleName: patient.MiddleName || null,
          DateOfBirth: parsedDob,
          MobileNo: phoneNumber,
          EmailID: emailAddress,
          AddressLine1: AddressLine1,
          AddressLine2: AddressLine2,
          City: City,
          State: State,
          Zip: Zip,
          Country: Country,
          notes: (patient && patient.notes) || '',
          orders: [{ items: Array.isArray(items) ? items : [items] }],
        },
        patientNotes: (patient && patient.notes) || '',
        basicDetails: basicDetails,
        contactDetails: contactDetails,
      },
      () => {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      }
    );
  };

  reminderHandler = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'reminder/notification', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.state.reminderData),
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ searchedRxNo: [] });
          toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
        }
        try {
          return response.text();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((uData) => {
        this.setState({ loader: false });
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  textInputHandler = (type, value) => {
    this.setState({ [type]: value });
  };

  ManualPickupNotification = async (type) => {
    const rawEmail =
      this.state.searchedItems.EmailID || (this.state && this.state.EmailID);
    const emailID =
      rawEmail && String(rawEmail).trim() !== '@' ? String(rawEmail).trim() : '';
    const firstRx =
      this.state.searchedRxNo && this.state.searchedRxNo[0];
    const cartRx =
      searchedRxItems &&
      searchedRxItems[0] &&
      (searchedRxItems[0].rxNo || searchedRxItems[0].rx_no);
    const rxNo =
      this.state.rxNumber ||
      (typeof firstRx === 'string'
        ? firstRx
        : firstRx && (firstRx.rxNo || firstRx.rx_no)) ||
      cartRx ||
      '';
    let reqDetails = {
      box_id: this.state.box_id,
      pucode: this.state.pickupCode,
      rxNo,
      emailID,
      firstName: this.state.searchedItems.FirstName,
      lastName: this.state.searchedItems.LastName,
      AccountName: this.state.accountDetails && this.state.accountDetails.name,
      AccountAddress:
        this.state.accountDetails &&
        this.state.accountDetails.contact &&
        this.state.accountDetails.contact.address &&
        this.state.accountDetails.contact.address.address_line_1 +
        ' ' +
        this.state.accountDetails.contact.address.address_line_2 +
        ' ',
      AccountAddress2:
        this.state.accountDetails &&
        this.state.accountDetails.contact &&
        this.state.accountDetails.contact.address &&
        this.state.accountDetails.contact.address.city +
        ', ' +
        this.state.accountDetails.contact.address.state +
        ' ' +
        this.state.accountDetails.contact.address.zip,
      // assigned bin → counter pickup confirmation; scan/no-space → no locker space + hours
      scenario: type === 1 ? 'counter_pickup' : 'no_space',
    };
    if (type === 1) {
      // Clear assigned bin: record remove transaction (Direct Pickup + Remove)
      const removed = await this.changeOrderStatus('remove');
      if (!removed) return;
    }
    fetch(process.env.REACT_APP_BASEURL + 'emailPickupNotification', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqDetails),
    })
      .then(async (response) => {
        let emailSent = false;
        try {
          const text = await response.text();
          try {
            const parsed = JSON.parse(text);
            const result = (parsed && parsed.result) || parsed;
            if ((parsed && parsed.emailSent === true) || result === 'Email Sent') {
              emailSent = true;
              toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
            } else {
              toast.error(
                this.props.t('Prescriptions.Messages.NotificationNotSent') ||
                  (typeof result === 'string' ? result : 'Notification not sent')
              );
            }
          } catch (_parseErr) {
            // Legacy plain-text response
            if (response.status === 200 && text === 'Email Sent') {
              emailSent = true;
              toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
            } else {
              toast.error(
                this.props.t('Prescriptions.Messages.NotificationNotSent') ||
                  text ||
                  'Notification not sent'
              );
            }
          }
        } catch (_err) {
          toast.error(
            this.props.t('Prescriptions.Messages.NotificationNotSent') ||
              'Notification not sent'
          );
        }
        return emailSent;
      })
      .then((emailSent) => {
        // Full reset (not partial searchedItems: []) so the next scan is a new
        // patient. Leaving searchedItems as [] is truthy and triggers WrongPatient
        // on Liberty/Epic/HL7/demo multi-Rx checks.
        if (emailSent || type === 1) {
          this.refreshCurrentBoxAfterClear(() => this.handleFocus());
        } else {
          this.handleFocus();
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  ClearFields = (onComplete) => {
    searchedRxItems = [];
    searchedRxNumbers = [];
    this._upcScanFocused = false;
    this._upcLookupInFlight = false;
    // Drop in-flight stock-code checks so they cannot restore the previous order's code.
    this._orderCodeGeneration = (this._orderCodeGeneration || 0) + 1;
    this.setState({
      selectedBinId: '',
      openMessage: false,
      locationData: isReusableStorageLocationType(this.state.locationtype_id) ? this.state.defaultCheckInLocation : null,
      disableFeild: false,
      stockCode: '',
      pickupCode: '',
      searchedRxNo: [],
      prescriptionMasterData: {},
      rxNumber: '',
      selected: [],
      nonRxCartItems: [],
      upcScan: '',
      upcScanBusy: false,
      nonRxPriceEditIndex: null,
      printNonRxItems: [],
      box: [],
      hasError: false,
      // box_id: '',
      BinStatus: [],
      deactivatedBins: [],
      assignedPrescription: {},
      isVisibleForPause: false,
      isBoxSelected: false,
      selectedUnitName: '',
      loader: false,
      expansionUnits: [],
      box_expansions_id: '',
      isLoadingTrans: false,
      servePresRetryCount: 3,
      servePresFetchCount: 0,
      isRetrying: false,
      isADACompatible: false,
      ConsultRequire: false,
      is_returnable: false,
      isAmountPaid: false,
      isPartiallyPaid: false,
      paymentPaidAmount: 0,
      paymentDueAmount: 0,
      locationtype_id: localStorage.getItem('selectedLocationTypeId') || '',
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: '',
      EmailID: '',
      phone: '',
      is_stocked: false,
      order: 'desc',
      orderBy: 'created_on',
      PrintFirstName: '',
      PrintLastName: '',
      ADAData: [],
      SearchResultDialogOpen: false,
      reminderData: [],
      AccountConnections: [],
      location: '',
      isUnplugged: false,
      source_location: '',
      delivery_notes: '',
      order_notes: '',
      patient_notes: '',
      storage_location: isReusableStorageLocationType(this.state.locationtype_id) && this.state.defaultCheckInLocation
        ? this.state.defaultCheckInLocation.location || ''
        : '',
      room_number: '',
      location_notes: '',
      searchedItems: null,
      assignCartItems: null,
      courier_type: [],
      courier_tracking: '',
      default_courier_selected: '',
      basicDetails: undefined,
      isEdit: false,
      selectedObject: [],
      orderId: '',
      orderIds: [],
      prescriptionIds: [],
      indexNo: null,
      binid: null,
      pmid: null,
      isAlreadyOnHold: false,
      isAlreadyAssigned: false,
      searchObj: {
        searchTxt: '',
        pageNo: 0,
        pageSize: 10,
        sortOrder: 'desc',
      },
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      selectedAccountIdForPrescriptionCheck: null,
      doesPrescriptionScanned: false,
      selectedPMSType: "",
      confirmPMSDialogOpen: false,
      scannedRxScript: "",
      originalScannedScript: "",
      allow_multi_bins_pickup: false,
      FutureRelease: false,
      FutureReleaseDate: null,
      selectedBinSize: '',
      patientNotes: '',
      readOnly: true,
      isBinDeactivated: false,
      alternateAgents: [],
      doesBinClicked: false,
      confirmPhantomRemoval: false,
      isPhantomStockCodePrompt: false,
      isManualOverridePermissionEnabled: true,
      prescriptionUnAssign: true,
      prescriptionAssign: true,
      prescriptionView: true,
      prescriptionDirectPickup: true,
      prescriptionRemind: true,
      prescriptionConsult: true,
      prescriptionHoldResume: true,
      prescriptionAcDc: true,
      assign_order_notes: '',
      customNote: { id: null, text: '', source: '' },
      show_order_notes_dialog: false,
      is_controlled_substance: false,
      rxEntries: [
        { rxNumber: '', isConsultRequired: false }
      ],
      dateOfBirth: '',
      address: null,
      isRxView: false,
      dobError: false,
      phoneError: false,
      rxError: false,
      printTicketPermissionAllowed: false,
      htmlBodyToPrint: '',
      openPrintDialog: false,
      fastlaneBinId: '',
      fastlaneBinRetryCount: 0,
      isFastlaneRetrying: false,
      fastlaneRetryMessage: '',
      fastlaneBinFetchError: false,
      fastlaneBinValidationError: false,
      pendingSaveMode: null,
      makeFastlaneAPICall: false,
      makePreAssignmentAPICall: false,
      binLayoutRefreshKey: this.state.binLayoutRefreshKey + 1,
      consultCheckBoxFlagForRxByBin: false,
    }, () => {
      // Rehydrate right-side box/list UI immediately after reset.
      this.getBoxes();
      this.GetAcccountConnectionId();
      this.fetchAllBoxesForTabs();
      this.setPermission();
      if (this.phoneInputRef && this.phoneInputRef.current) {
        this.phoneInputRef.current.focus();
      }
      if (typeof onComplete === 'function') {
        onComplete();
      }
    });
  };

  onInputChange = (event) => {
    const { searchedItems } = this.state;
    searchedItems[event.target.name] = event.target.value;
    this.setState({ [event.target.name]: event.target.value, searchedItems });
  };
  handleConsultClick = () => {
    this.setState({ detailDialogOpen: true });
  };

  handleConsultClose = () => {
    this.setState({ detailDialogOpen: false });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  onSearchChange = (event) => {
    const searchString = event.target.value;
    this.setState({
      searchObj: { ...this.state.searchObj, searchTxt: searchString },
    });
    if (searchString.length > 2) {
      this.FetchSearchResult();
    } else {
      searchedRxItems = [];
      searchedRxNumbers = [];
      this.setState({
        selectedBinId: '',
        searchedItems: [],
        rxNumber: '',
        isVisibleForPause: false,
        EmailID: '',
        phone: '',
        isEpicHasValidRx: true,
        isEpicHasValidRxMessage: '',
      });
    }
  };

  FetchSearchResult = () => {
    let FilterObj = {
      searchtext: this.state.searchObj.searchTxt,
      pageNo: this.state.searchObj.pageNo,
      pageSize: this.state.searchObj.pageSize,
      sortOrder: this.state.searchObj.sortOrder,
    };
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'getPrescriptionSearchResult', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(FilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.setState({
          totalSearchRecords: uData && uData['total'],
          loader: false,
          innerSearchLoader: false,
        });
        if (
          uData &&
          Array.isArray(uData['results']) &&
          uData['results']['length'] > 0
        ) {
          if (uData['results']['length'] === 1) {
            let BinId = uData['results'][0].bin_id;
            let pm_id = uData['results'][0].pm_id;
            let stockCode = uData['results'][0].stock_code;
            this.getPrescriptionDetails(BinId, pm_id, stockCode);
          } else
            this.setState({
              selectedObject: uData['results'],
              SearchResultDialogOpen: true,
            });
        } else {
          searchedRxItems = [];
          searchedRxNumbers = [];
          this.setState({
            selectedBinId: '',
            searchedItems: [],
            rxNumber: '',
            isVisibleForPause: false,
            EmailID: '',
            phone: '',
            isEpicHasValidRx: true,
            isEpicHasValidRxMessage: '',
            SearchResultDialogOpen: false,
            innerSearchLoader: false,
            searchObj: { pageNo: 0, pageSize: 10, sortOrder: 'desc' },
          });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleSearchClose = (event) => {
    event.preventDefault();
    this.setState({
      SearchResultDialogOpen: false,
      selectedObject: [],
      innerSearchLoader: false,
      searchObj: { searchTxt: '', pageNo: 0, pageSize: 10, sortOrder: 'desc' },
    });
  };

  handlePUcodeClick = (event, BinId, pm_id, boxid, stockCode = null) => {
    event.preventDefault();
    this.getPharmacyDetails(boxid);
    this.getExpansionBins(boxid);
    this.getAssignedBins(boxid);
    this.setState({ box_id: boxid }, () => {
      this.syncAssignUIFromBoxRegion(boxid);
      setTimeout(() => {
        this.handleSearchClose(event);
        this.getPrescriptionDetails(BinId, pm_id, stockCode);
      }, 100);
    });
  };

  handleMedBankChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleMedBankKeyDown = (event) => {
    const { globalAccountConnection } = this.state;
    if (event.keyCode === 13) {
      let isRxExist = false;
      this.setState({ loader: true, isEdit: false });
      let searchedString = event.target.value;
      let obj = {
        rxNumber: searchedString,
      };
      fetch(`${process.env.REACT_APP_BASEURL}medbank/is-exist`, {
        method: 'post',
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          let parsedResponse = JSON.parse(res);
          isRxExist = parsedResponse.Rx_Is_Exist;
          if (isRxExist === false || isRxExist === 'false') {
            let obj = {
              lookupValue: searchedString,
              account_id: globalAccountConnection.id,
            };
            fetch(
              process.env.REACT_APP_BASEURL +
              'medbank/GetPrescriptionByPrescriptionNumber',
              {
                crossDomain: true,
                method: 'post',
                headers: {
                  Authorization:
                    'Bearer ' +
                    JSON.parse(sessionStorage.getItem('user')).signInUserSession
                      .idToken.jwtToken,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(obj),
              }
            )
              .then((response) => {
                try {
                  return response.text();
                } catch (error) {
                  return null;
                }
              })
              .then((res) => {
                let parsedJson = JSON.parse(res);
                let patientDetails = parsedJson.patient;
                let prescriptionDetails = parsedJson.Rxs;
                if (prescriptionDetails && prescriptionDetails.length === 0) {
                  toast.error(this.props.t('Toast.Error.RxFound'));
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                  return;
                }
                let isreturnable = false
                for (let i = 0; i < prescriptionDetails.length; i++) {
                  if (
                    prescriptionDetails[i] &&
                    prescriptionDetails[i].IsReturnable === true
                  ) {
                    isreturnable = prescriptionDetails[i].IsReturnable;
                  } else {
                    isreturnable = false;
                  }
                  let item = {
                    ndcCode: prescriptionDetails[i].dispensedNDC,
                    itemId: '',
                    binId: '',
                    rxNo: prescriptionDetails[i].PrescriptionNumber,
                    name: prescriptionDetails[i].dispensedDrugName,
                    description: prescriptionDetails[i].dispensedDrugName,
                    image: '',
                    potency: '',
                    qty: prescriptionDetails[i].prescribedQuantity,
                    schedule: '',
                    Amount: prescriptionDetails[i].dispensedAmount,
                    taxPercentage: '',
                    insuranceAmount: '',
                    CoPayAmount: prescriptionDetails[i].dispensedAmount,
                    PaidAmount: '',
                    DueAmount: '',
                    paymentDueDate: '',
                    stockedOn: '',
                    stockedBy: '',
                    deStockedOn: '',
                    strength: '',
                    route: '',
                    doseage_form: '',
                    non_proprietary_name: '',
                    ExpirationDate: '',
                    isLoadingTrans: false,
                    fillNumber: prescriptionDetails[i].fillNumber,
                    prescriptionNumber:
                      prescriptionDetails[i].PrescriptionNumber,
                    ConsultRequire: prescriptionDetails[i].promptForCounseling,
                    IsReturnable: isreturnable,
                    status: '',
                  };
                  const existingItem = this.state.searchedItems;
                  const EmailAddress =
                    (patientDetails && patientDetails.email) ||
                    (patientDetails &&
                      patientDetails.contacts &&
                      patientDetails.contacts[0] &&
                      patientDetails.contacts[0].email);
                  const CellPhone =
                    (patientDetails && patientDetails.sms_phone) ||
                    (patientDetails &&
                      patientDetails.contacts &&
                      patientDetails.contacts[0] &&
                      patientDetails.contacts[0].phone);
                  this.setState({ EmailID: EmailAddress, phone: CellPhone });
                  if (
                    existingItem &&
                    searchedRxItems &&
                    searchedRxItems.length > 0
                  ) {
                    let isexist = searchedRxItems.findIndex(
                      (x) => x.rxNo === searchedString
                    );
                    if (existingItem.PatientID === patientDetails.patientID) {
                      if (isexist < 0) {
                        searchedRxItems.push(item);
                        if (
                          patientDetails &&
                          patientDetails.patientID &&
                          EmailAddress
                        ) {
                          this.checkADACompatible(
                            patientDetails.patientID,
                            EmailAddress
                          );
                        }
                        this.getcustomerLocation(
                          patientDetails,
                          searchedRxItems,
                          'Medbank'
                        );
                        this.setState({
                          rxNumber: '',
                        });
                        this.forceUpdate();
                      } else {
                        toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                        this.setState({
                          rxNumber: '',
                          loader: false,
                        });
                      }
                    } else {
                      toast.error(this.props.t('Toast.Error.WrongPatient'));
                      this.setState({
                        rxNumber: '',
                        loader: false,
                      });
                    }
                  } else {
                    searchedRxItems.push(item);
                    if (
                      patientDetails &&
                      patientDetails.patientID &&
                      EmailAddress
                    ) {
                      this.checkADACompatible(
                        patientDetails.patientID,
                        EmailAddress
                      );
                    }
                    this.getcustomerLocation(
                      patientDetails,
                      searchedRxItems,
                      'Medbank'
                    );
                    this.forceUpdate();
                    this.setState({
                      rxNumber: '',
                      loader: false,
                    });
                  }
                }
              }).catch(() => {
                this.setState({ loader: false });
              });
          } else {
            toast.error(this.props.t('Toast.Error.RxExist'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
          }
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  handleMScriptsOnChange = (e) => {
    const scannedValue = e.target.value;
    const cleanedValue = String(scannedValue).replace(/^0+/, ""); 
    
    this.setState(
      {
        rxNumber: cleanedValue,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };
  handleMScriptsKeyDown = (event) => {
    const { globalAccountConnection } = this.state;
    if (event.keyCode === 13) {
      let isRxExist = false;
      this.setState({ loader: true, isEdit: false });
      let searchedString = event.target.value;
      let obj = {
        lookupValue: searchedString,
        account_id: globalAccountConnection.id,
      };
      fetch(process.env.REACT_APP_BASEURL + 'orders/lookup', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          let parsedJson = JSON.parse(res);
          if (
            parsedJson &&
            parsedJson.status &&
            parsedJson.status.toLowerCase() === 'failed'
          ) {
            toast.error(parsedJson.error_message);
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.order_details;
          if([false, 'false'].includes(patientDetails && patientDetails._isOrderFound)) {
            toast.error("This order may not be deliverable.", {
              autoClose: 5000,
              progress: undefined,
              hideProgressBar: false,
            });
          }
          let isreturnable = false
          if (
            prescriptionDetails &&
            prescriptionDetails.IsReturnable === true
          ) {
            isreturnable = prescriptionDetails.IsReturnable;
          } else {
            isreturnable = false;
          }
          if (!prescriptionDetails) {
            toast.error(this.props.t('Toast.Error.RxFound'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          } else {
            let item = {
              ndcCode: prescriptionDetails.ndc,
              itemId: '',
              binId: '',
              // rxNo: prescriptionDetails.rx_num,
              rxNo: '',
              name: prescriptionDetails.name,
              description: '',
              image: '',
              potency: '',
              qty: prescriptionDetails.dispensed_qty,
              schedule: '',
              Amount: prescriptionDetails.amount_due,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: prescriptionDetails.amount_due,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: prescriptionDetails.expiry_date,
              isLoadingTrans: false,
              fillNumber: prescriptionDetails.fill_number,
              prescriptionNumber: prescriptionDetails.rx_num,
              ConsultRequire:
                [true, "true"].includes(this.state.accountDetails.bypass_consult)
                  ? false
                  : ((prescriptionDetails && prescriptionDetails.fill_number === 0) ||
                     (prescriptionDetails && prescriptionDetails.fill_number === '0')),
              IsReturnable: isreturnable,
              status: '',
              order_id: parsedJson.order_id,
              prescription_txn_id: prescriptionDetails.prescription_txn_id,
            };
            let objIsExist = {
              rxNumber: item.prescription_txn_id,
              account_id: globalAccountConnection.id,
            };
            fetch(`${process.env.REACT_APP_BASEURL}is-rx-exists`, {
              method: 'post',
              withCredentials: true,
              headers: {
                'Content-Type': 'application/json',
                Authorization:
                  'Bearer ' +
                  JSON.parse(sessionStorage.getItem('user')).signInUserSession
                    .idToken.jwtToken,
              },
              body: JSON.stringify(objIsExist),
            })
              .then((response) => {
                try {
                  return response.text();
                } catch (error) {
                  return null;
                }
              })
              .then((res) => {
                let parsedResponse = JSON.parse(res);
                isRxExist = parsedResponse.Rx_Is_Exist;
                if (isRxExist === false || isRxExist === 'false') {
                  const existingItem = this.state.searchedItems;
                  // this.setState({ EmailID: patientDetails.EmailAddress, phone: patientDetails.phone });
                  this.setState({ EmailID: 'N/A', phone: 'N/A' });
                  if (
                    existingItem &&
                    searchedRxItems &&
                    searchedRxItems.length > 0
                  ) {
                    let isexist = searchedRxItems.findIndex(
                      (x) => x.prescription_txn_id === searchedString
                    );
                    if (existingItem.PatientID === patientDetails.patient_id) {
                      if (isexist < 0) {
                        searchedRxItems.push(item);
                        if (
                          patientDetails &&
                          patientDetails.patient_id &&
                          patientDetails.EmailAddress
                        ) {
                          this.checkADACompatible(
                            patientDetails.patient_id,
                            patientDetails.EmailAddress
                          );
                        }
                        this.getcustomerLocation(
                          patientDetails,
                          searchedRxItems,
                          'MScripts'
                        );
                        this.setState({
                          rxNumber: '',
                          loader: false,
                        });
                        this.forceUpdate();
                      } else {
                        toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                        this.setState({
                          rxNumber: '',
                          loader: false,
                        });
                      }
                    } else {
                      toast.error(this.props.t('Toast.Error.WrongPatient'));
                      this.setState({
                        rxNumber: '',
                        loader: false,
                      });
                    }
                  } else {
                    searchedRxItems.push(item);
                    // if(patientDetails && patientDetails.patientID && EmailAddress) {
                    //   this.checkADACompatible(patientDetails.patientID, EmailAddress)
                    // }
                    this.getcustomerLocation(
                      patientDetails,
                      searchedRxItems,
                      'MScripts'
                    );
                    this.forceUpdate();
                    this.setState({
                      rxNumber: '',
                      loader: false,
                    });
                  }
                } else {
                  toast.error(this.props.t('Toast.Error.RxExist'));
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                }
              });
          }
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  handlePioneerKeyDown = () => {
    const { originalScannedScript, scannedRxScript } = this.state;
    let searchedString = this.normalizePioneerRxNumber(
      originalScannedScript || scannedRxScript
    );
    this.setState({ loader: true, isEdit: false });
    let obj = {
      lookupValue: searchedString,
      vendor_key: this.state.accountDetails.connection_details
        .vendor_key,
      data_exchange_id: this.state.accountDetails.connection_details
        .data_exchange_id,
      contentType: 'application/json',
      returnType: 0,
      endPoint: this.state.accountDetails.connection_details.endpoint,
      account_id: this.state.accountDetails.id,
    };
    fetch(`${process.env.REACT_APP_BASEURL}pioneerRx/rxQuery`, {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession
            .idToken.jwtToken,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => {
        this.setState({ loader: false });
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        if (
          JSON.parse(res).status === 500 ||
          JSON.parse(res).status === '500'
        ) {
          toast.error(this.props.t("Assign.Pioneer.NoRxFound"));
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else if (
          (JSON.parse(res).status > 200 &&
            JSON.parse(res).status < 500) ||
          (JSON.parse(res).status > '200' &&
            JSON.parse(res).status < '500')
        ) {
          toast.error(this.props.t('Toast.Error.AdministratorContact')
          );
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else {
          if (res && res !== '') {
            let parsedResponse = JSON.parse(res);
            let patientDetails = parsedResponse.patient;
            let rxDetails = parsedResponse.rx;
            this.setState({ loader: false, confirmPMSDialogOpen: false });
            if (
              rxDetails !== undefined &&
              rxDetails !== 'undefined' &&
              rxDetails !== null &&
              rxDetails !== 'null' &&
              rxDetails !== ''
            ) {
              // if (rxDetails.readyToBeSold !== 1 && (rxDetails.statusTypeID !== 5 || rxDetails.statusTypeID !== 6)) {
              /*
              1 = Waiting for Data Entry
              2 = Waiting for Pre-check
              3 = Waiting for Fill
              4 = Waiting for Check
              10 = Completed
              16 = Cancelled
              17 = Waiting for Print
            */
              if (
                rxDetails.statusTypeID === 1 ||
                rxDetails.statusTypeID === 2 ||
                rxDetails.statusTypeID === 3 ||
                rxDetails.statusTypeID === 4 ||
                rxDetails.statusTypeID === 10 ||
                rxDetails.statusTypeID === 16 ||
                rxDetails.statusTypeID === 17
              ) {
                // toast.error(`The status of this Rx number is ${rxDetails.statusTypeText}`);
                this.setState({
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: this.props.t('Toast.Error.PioneerRx.Completed'),
                  rxNumber: '',
                });
                // return;
              }
            }
            if (rxDetails === undefined || rxDetails === 'undefined') {
              toast.error(this.props.t('Toast.Error.RxNotValid'));
              this.setState({
                rxNumber: '',
              });
              return;
            }
            let isConsultRequired = false;
            if (
              rxDetails.isControlled === 1 ||
              rxDetails.isControlled === '1' ||
              rxDetails.promptForCounseling === 1 ||
              rxDetails.promptForCounseling === '1'
            ) {
              isConsultRequired = true;
            }
            // Check if account has bypass_consult enabled
            if ([true, "true"].includes(this.state.accountDetails.bypass_consult)) {
              isConsultRequired = false;
            }
            let isreturnable = false
            if (
              rxDetails &&
              rxDetails.IsReturnable === true
            ) {
              isreturnable = rxDetails.IsReturnable;
            } else {
              isreturnable = false;
            }
            let _localIsControlledSubstance = false;
            if(![undefined, 'undefined', null, 'null', ''].includes(rxDetails.drugSchedule)) {
              if(["2", "3", "4", "5", 2, 3, 4, 5].includes(rxDetails.drugSchedule)) {
                this.setState({ is_controlled_substance: true });
                _localIsControlledSubstance = true;
              } else {
                this.setState({ is_controlled_substance: false });
                _localIsControlledSubstance = false;
              }
            } else {
              this.setState({ is_controlled_substance: false });
              _localIsControlledSubstance = false;
            }
            // User-friendly logs for calculation and values
            console.log("=== Account & Prescription Billing Calculation Start ===");
            if (this.state.globalAccountConnection) {
              console.log("Account Connection Details found.");
              if (this.state.globalAccountConnection.connection_details) {
                console.log("Connection Type:", (
                  this.state.globalAccountConnection && 
                  this.state.globalAccountConnection.connection && 
                  this.state.globalAccountConnection.connection.name) || 
                  "N/A"
                );
                console.log("Account has 'calculate_tax' enabled:",
                  !!this.state.globalAccountConnection.connection_details.calculate_tax
                );
              } else {
                console.log("No connection_details property found on account connection.");
              }
            } else {
              console.log("No account connection configuration available.");
            }

            const shouldCalculateTax =
              this.state.globalAccountConnection &&
              this.state.globalAccountConnection.connection_details &&
              this.state.globalAccountConnection.connection_details.calculate_tax;

            if (shouldCalculateTax) {
              console.log("Tax calculation by Connect is ENABLED for this account.");
            } else {
              console.log("Tax calculation by Connect is DISABLED or not configured for this account.");
            }

            // Parse patient amount
            const patientAmount = [undefined, 'undefined', null, 'null', '', '0', 0].includes(rxDetails.patientAmountOwed)
              ? 0
              : (typeof rxDetails.patientAmountOwed === 'string' ? parseFloat(rxDetails.patientAmountOwed) : rxDetails.patientAmountOwed);

            if (patientAmount > 0) {
              console.log(`Patient responsibility amount from Pioneer: $${patientAmount.toFixed(2)}`);
            } else {
              console.log("No patient responsibility amount provided in the rx details. Defaulting to zero.");
            }

            // Parse tax amount
            let taxAmount = [undefined, 'undefined', null, 'null', '', '0', 0].includes(rxDetails.taxAmountOwedByPatient)
              ? 0
              : (typeof rxDetails.taxAmountOwedByPatient === 'string' ? parseFloat(rxDetails.taxAmountOwedByPatient) : rxDetails.taxAmountOwedByPatient);

            if (taxAmount > 0) {
              console.log(`Tax amount from Pioneer: $${taxAmount.toFixed(2)}`);
            } else {
              console.log("No tax amount provided in the rx details. Will attempt to calculate if enabled...");
            }

            // If calculate_tax is enabled and Pioneer didn't provide tax, calculate it using account tax_rate
            if (shouldCalculateTax && (taxAmount === 0 || taxAmount === null || taxAmount === undefined)) {
              const taxData = this.state.globalAccountConnection && this.state.globalAccountConnection.tax_data;
              const taxRate = taxData && taxData.tax_rate;
              if (taxRate && taxRate > 0) {
                taxAmount = (patientAmount * parseFloat(taxRate)) / 100;
                console.log(`Calculated tax using tax_rate (${taxRate}%): $${taxAmount.toFixed(2)} (for patient amount $${patientAmount.toFixed(2)})`);
              } else {
                console.log("No valid tax_rate found in account settings; tax remains zero.");
              }
            }

            // Calculate total amount based on account setting
            const totalAmount = shouldCalculateTax ? (patientAmount + taxAmount) : patientAmount;
            console.log(`Total amount to be charged: $${totalAmount.toFixed(2)} (Patient: $${patientAmount.toFixed(2)} + Tax: $${taxAmount.toFixed(2)})`);
            console.log("=== Account & Prescription Billing Calculation Complete ===");
            
            let item = {
              ndcCode: rxDetails.prescribedNDC,
              itemId: '',
              binId: '',
              rxNo: rxDetails.rxNumber,
              name: rxDetails.prescribedDrugName,
              description: '',
              image: '',
              potency: '',
              qty: rxDetails.dispensedQuantity,
              schedule: rxDetails.drugSchedule,
              dea_schedule: rxDetails.drugSchedule,
              Amount: totalAmount,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: totalAmount,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: '',
              isLoadingTrans: false,
              fillNumber: rxDetails.fillNumber,
              ConsultRequire: isConsultRequired,
              IsReturnable: isreturnable,
              is_controlled_substance: [true, 'true'].includes(_localIsControlledSubstance) ? true : false,
              tax_amount: taxAmount,
            };
            this.setState({
              EmailID: patientDetails.emailAddress,
              phone: patientDetails.primaryPhone,
              is_controlled_substance: [true, 'true'].includes(_localIsControlledSubstance) ? true : false
            });
            const existingItem = this.state.searchedItems;
            if (
              existingItem &&
              searchedRxItems &&
              searchedRxItems.length > 0
            ) {
              let rxNumbers = searchedString;
              if (rxNumbers[0].toLowerCase() === 'x') {
                rxNumbers = rxNumbers.split('X')[1];
              } else {
                rxNumbers = searchedString.split('-')[0];
              }
              let isexist = searchedRxItems.findIndex(
                (x) => x.rxNo === rxNumbers
              );
              if (existingItem.PatientID === patientDetails.patientID) {
                if (isexist < 0) {
                  searchedRxItems.push(item);
                  if (
                    patientDetails.emailAddress !== '' &&
                    patientDetails.emailAddress !== undefined &&
                    patientDetails.emailAddress !== 'undefined' &&
                    patientDetails.emailAddress !== 'null' &&
                    patientDetails.emailAddress !== 'null'
                  ) {
                    this.checkADACompatible(
                      patientDetails.patientID,
                      patientDetails.emailAddress
                    );
                  }
                  this.getcustomerLocation(
                    patientDetails,
                    searchedRxItems,
                    'Pioneer'
                  );
                  this.forceUpdate();
                  this.setState({
                    rxNumber: '',
                  });
                } else {
                  toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                  this.setState({
                    rxNumber: '',
                  });
                }
              } else {
                toast.error(this.props.t('Toast.Error.WrongPatient'));
                this.setState({
                  rxNumber: '',
                });
              }
            } else {
              searchedRxItems.push(item);
              if (
                patientDetails.emailAddress !== null &&
                patientDetails.emailAddress !== 'null' &&
                patientDetails.emailAddress !== undefined &&
                patientDetails.emailAddress !== 'undefined' &&
                patientDetails.emailAddress !== ''
              ) {
                this.checkADACompatible(
                  patientDetails.patientID,
                  patientDetails.emailAddress
                );
              }
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'Pioneer'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
              });
            }
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });

  };

  handlePioneerChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleOpenDueAmountEditInput = (index) => {
    this.setState({ indexNo: index });
  };

  handleCloseDueAmountEditInput = (index, id) => {
    this.setState({ indexNo: Math.random() || index });
    const orderdueamount =
      searchedRxItems && searchedRxItems.find((item, i) => item.id === id);
    this.updateDueAmount(id, orderdueamount['price']);
  };

  updateDueAmount = (orderid, dueAmount, successMessage = null) => {
    this.setState({ loader: true });
    const updateParams = {
      orderid: orderid,
      dueamount: dueAmount,
    };
    try {
      fetch(process.env.REACT_APP_BASEURL + 'updateorderdueamout', {
        method: 'PUT',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateParams),
      })
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          if (res && res.UpdateDueAmount && res.UpdateDueAmount.success === true) {
            this.setState({ loader: false });
            toast.success(
              successMessage ||
                (res && res.UpdateDueAmount && res.UpdateDueAmount.message)
            );
            //this.getPrescriptionDetails(this.state.binid, this.state.pmid);
          } else {
            this.setState({ loader: false });
            toast.error((res && res.UpdateDueAmount && res.UpdateDueAmount.error) || (res && res.error) || 'Amount could not be saved');
          }
        }).catch(() => {
          this.setState({ loader: false });
          toast.error('Amount could not be saved');
        });
    } catch (error) {
      this.setState({ loader: false });
      console.log(error);
    }
  };

  onHandleChangeInputValue = (id, type, value, rxNumber) => {
    if (type === 'price') {
      const items =
        searchedRxItems &&
        searchedRxItems.map((item, i) => {
          if (((item.id || item.itemId) === id) && ((item.rxNo || item.rx_no) === rxNumber)) {
            return { ...item, price: parseFloat(value), CoPayAmount: parseFloat(value), Amount: parseFloat(value) };
          }
          return item;
        });
      searchedRxItems = items;
    } else if (type === 'seqNumber') {
      const items =
        searchedRxItems &&
        searchedRxItems.map((item, i) => {
          if (((item.id || item.itemId) === id) && ((item.rxNo || item.rx_no) === rxNumber)) {
            return { ...item, SeqNumber: value };
          }
          return item;
        });
      searchedRxItems = items;
    }
    this.forceUpdate();
  };

  handleMcKessonRxChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  parseRegexFromString = (regexString) => {
    const match = regexString.match(/^\/(.*)\/([gimsuy]*)$/); // Extract pattern & flags
    if (!match) throw new Error("Invalid regex format in DB");
  
    const [, pattern, flags] = match; // Destructure extracted values
    return new RegExp(pattern, flags);
  };

  normalizePioneerRxNumber = (value = "") => {
    const normalizedValue = String(value || "").trim();
    return normalizedValue.replace(/^\s*x\s*/i, "").trim();
  };

  parseMcKessonRxNumber = (prescriptionId, accountObject) => {
    // await McKessionParseRxService('40036000109000', /\d(?<storeNumber>\d{3})(?<rxNumber>\d{7})(?<fillNumber>\d{2})(?<partialFillNumber>\d{1})/)
    // await McKessionParseRxService('^4-11-6119625-01-2^', /\^\d{1}-(?<storeNumber>\d{2})-(?<rxNumber>\d{7})-(?<fillNumber>\d{2})-(?<partialFillNumber>\d{1})/)
    // await McKessionParseRxService('RX6385102000-0000930', /(?<rxNumber>\d{7})(?<fillNumber>\d{2})(?<partialFillNumber>\d{1})/)
    const regExp = this.parseRegexFromString(accountObject && accountObject.regexp);
    const parsedScript = regExp.exec(prescriptionId);
    let parsedRxNumber = null;
    if (parsedScript && parsedScript.length > 0) {
      const _groups = parsedScript && parsedScript.groups;
      if (![undefined, "undefined", null, "null", ""].includes(_groups)) {
        parsedRxNumber = {
          storeNumber: (_groups && _groups.storeNumber) || "",
          rxNumber:
            `${_groups && _groups.rxNumber}${_groups && _groups.fillNumber}` ||
            "",
          rxNumberWithoutFill: (_groups && _groups.rxNumber) || "",
          fillNumber: (_groups && _groups.fillNumber) || "",
          partialFillNumber: (_groups && _groups.partialFillNumber) || "",
        };
      }
    }
    return parsedRxNumber;
  };  
  handleMcKessonRxKeyDown = () => {
    const { globalAccountConnection, originalScannedScript } = this.state;
    this.setState({ loader: true, isEdit: false, confirmPMSDialogOpen: false });
    let searchedString = originalScannedScript;
    const rxToValidate = this.parseMcKessonRxNumber(searchedString, globalAccountConnection);
    let obj = {
      PrescriptionId: searchedString,
      account_id: this.state.accountDetails.id,
      isSafetyCheck: false,
    };
    fetch(
      process.env.REACT_APP_BASEURL +
      'api/mc-kession/GetPrescriptionDetailsById',
      {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession
              .idToken.jwtToken,
        },
        body: JSON.stringify(obj),
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        if (
          JSON.parse(res).status === 500 ||
          JSON.parse(res).status === '500'
        ) {
          toast.error(
            this.props.t('Toast.Error.AdministratorContact')
          );
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else if (
          (JSON.parse(res).status > 200 &&
            JSON.parse(res).status < 500) ||
          (JSON.parse(res).status > '200' &&
            JSON.parse(res).status < '500')
        ) {
          toast.error(
            this.props.t('Toast.Error.AdministratorContact')
          );
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else {
          let parsedResponse = JSON.parse(res) && JSON.parse(res).res;
          if (parsedResponse.patientInfo !== null) {
            let patientDetails = parsedResponse.patientInfo;
            let rxDetails = parsedResponse.prescriptionInfo;
            this.setState({ loader: false });
            if (rxDetails.WorkflowStatus !== 'Ready') {
              this.setState({
                isEpicHasValidRx: false,
                isEpicHasValidRxMessage: `The status of Rx: ${searchedString} is not ready. Please check your system and try again.`,
                rxNumber: '',
              });
            }
            if (
              (patientDetails && patientDetails.ExternalPatientID) ===
              undefined ||
              (patientDetails && patientDetails.ExternalPatientID) ===
              'undefined'
            ) {
              toast.error(this.props.t('Toast.Error.RxNotValid'));
              this.setState({
                rxNumber: '',
              });
              return;
            }
            let isConsultRequired = false;
            if (
              rxDetails.isControlledSubstance === true ||
              rxDetails.isControlledSubstance === 'true'
            ) {
              isConsultRequired = true;
            }
            // Check if account has bypass_consult enabled
            if ([true, "true"].includes(this.state.accountDetails.bypass_consult)) {
              isConsultRequired = false;
            }
            let isreturnable = false
            if (
              rxDetails &&
              rxDetails.IsReturnable === true
            ) {
              isreturnable = rxDetails.IsReturnable;
            } else {
              isreturnable = false;
            }
            let item = {
              ndcCode: rxDetails.DispensedNDC,
              itemId: '',
              binId: '',
              rxNo: rxDetails.RxNumber,
              name: rxDetails.DrugName || rxDetails.ProductName,
              description: rxDetails.SigText,
              image: '',
              potency: '',
              qty: rxDetails.Quantity,
              schedule: rxDetails.SigText,
              Amount: rxDetails.Price,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: rxDetails.Price,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: rxDetails.ExpirationDate,
              isLoadingTrans: false,
              fillNumber: rxDetails.FillNumber,
              ConsultRequire: isConsultRequired,
              IsReturnable: isreturnable,
              partialfillseqnum: rxDetails.partialfillseqnum,
              is_controlled_substance: rxDetails.isControlledSubstance,
              StoreNumber: rxDetails.StoreNumber,
            };
            this.setState({
              EmailID: patientDetails && patientDetails.EmailAddress,
              phone: patientDetails && patientDetails.MobilePhone,
            });
            const existingItem = this.state.searchedItems;
            if (
              existingItem &&
              searchedRxItems &&
              searchedRxItems.length > 0
            ) {
              let isexist = searchedRxItems.findIndex(
                (x) => x.rxNo === rxToValidate.rxNumber
              );
              if (
                existingItem.ExternalPatientID ===
                patientDetails.ExternalPatientID ||
                existingItem.PatientID === patientDetails.ExternalPatientID
              ) {
                if (isexist < 0) {
                  searchedRxItems.push(item);
                  if (
                    patientDetails.EmailAddress !== '' &&
                    patientDetails.EmailAddress !== undefined &&
                    patientDetails.EmailAddress !== 'undefined' &&
                    patientDetails.EmailAddress !== 'null' &&
                    patientDetails.EmailAddress !== 'null'
                  ) {
                    this.checkADACompatible(
                      patientDetails.ExternalPatientID,
                      patientDetails.EmailAddress
                    );
                  }
                  this.getcustomerLocation(
                    patientDetails,
                    searchedRxItems,
                    'McKesson'
                  );
                  this.forceUpdate();
                  this.setState({
                    rxNumber: '',
                  });
                } else {
                  toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                  this.setState({
                    rxNumber: '',
                  });
                }
              } else {
                toast.error(this.props.t('Toast.Error.WrongPatient'));
                this.setState({
                  rxNumber: '',
                });
              }
            } else {
              searchedRxItems.push(item);
              if (
                patientDetails &&
                patientDetails.EmailAddress !== null &&
                patientDetails &&
                patientDetails.EmailAddress !== 'null' &&
                patientDetails &&
                patientDetails.EmailAddress !== undefined &&
                patientDetails &&
                patientDetails.EmailAddress !== 'undefined' &&
                patientDetails &&
                patientDetails.EmailAddress !== ''
              ) {
                this.checkADACompatible(
                  patientDetails.ExternalPatientID,
                  patientDetails.EmailAddress
                );
              }
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'McKesson'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
              });
            }
          } else {
            this.setState({
              loader: false,
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: `Prescription found but no patient information is available for Rx: ${searchedString}. Please verify the prescription in your system.`,
              rxNumber: ''
            });
          }
        }
        this.setState({ loader: false });
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleEpicWithmTLSChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleEpicWithmTLSKeyDown = () => {
    // if (event.keyCode === 13) {
      this.setState({
        loader: true,
        isEpicHasValidRx: true,
        isEpicHasValidRxMessage: '',
        isEdit: false,
      });
      const { originalScannedScript } = this.state;
      let searchString = originalScannedScript;
      let validItems = [];
      let items = [];
      let obj = {
        PrescriptionId: searchString,
        account_id: this.state.accountDetails.id,
      };
      fetch(
        process.env.REACT_APP_BASEURL + 'kp/epic/mtls/GetPrescriptionInfoById',
        {
          crossDomain: true,
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
          body: JSON.stringify(obj),
        }
      )
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then(async (res) => {
          let parsedJsonResponse = JSON.parse(res);
          let parsedJson;
          if (parsedJsonResponse && parsedJsonResponse.message) {
            this.setState({
              loader: false,
              rxNumber: '',
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
            });
            return;
          }
          parsedJson = parsedJsonResponse.response;
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.prescriptions;
          if (prescriptionDetails && prescriptionDetails.length <= 0) {
            toast.error(this.props.t('Toast.Error.Prescription'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              let _existingPrescriptionNumbers = [];
              if (
                prescriptionDetails &&
                prescriptionDetails.length &&
                prescriptionDetails.length > 0
              ) {
                for (
                  let exist = 0;
                  exist < prescriptionDetails.length;
                  exist++
                ) {
                  let preacriptionNumber = prescriptionDetails[
                    exist
                  ].PrescriptionNumber.trim();
                  for (let si = 0; si < searchedRxItems.length; si++) {
                    if (
                      preacriptionNumber ===
                      searchedRxItems[si].prescriptionNumber
                    ) {
                      _existingPrescriptionNumbers.push(preacriptionNumber);
                    }
                  }
                }
              }
              if (
                _existingPrescriptionNumbers &&
                _existingPrescriptionNumbers.length &&
                _existingPrescriptionNumbers.length > 0
              ) {
                this.setState({
                  loader: false,
                  rxNumber: '',
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers} are already exist in the cart!`,
                });
                return true;
              }
            }
          }
          for (let j = 0; j < prescriptionDetails.length; j++) {
            let isconsultrequired = false;
            if ([true, "true"].includes(this.state.accountDetails.bypass_consult)) {
              isconsultrequired = false;
            } else if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsConsultRequired === true
            ) {
              isconsultrequired = prescriptionDetails[j].IsConsultRequired;
            } else {
              isconsultrequired = false;
            }
            let isreturnable = false
            if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsReturnable === true
            ) {
              isreturnable = prescriptionDetails[j].IsReturnable;
            } else {
              isreturnable = false;
            }
            for (let i = 0; i < prescriptionDetails[j].Fill.length; i++) {
              let item = {
                ndcCode: prescriptionDetails[j].Fill[i].Ndc,
                itemId: '',
                binId: '',
                rxNo: prescriptionDetails[j].Fill[i].PrescriptionId,
                name: prescriptionDetails[j].Medication,
                description: prescriptionDetails[j].Sig,
                image: '',
                potency: '',
                qty: prescriptionDetails[j].Fill[i].Quantity,
                schedule: prescriptionDetails[j].Frequency,
                dea_schedule: prescriptionDetails[j].DEACodeNumber,
                Amount: prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                taxPercentage: '',
                insuranceAmount: '',
                CoPayAmount:
                  prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                PaidAmount: '',
                DueAmount: '',
                paymentDueDate: '',
                stockedOn: '',
                stockedBy: '',
                deStockedOn: '',
                strength: '',
                route: '',
                doseage_form: '',
                non_proprietary_name: '',
                ExpirationDate: '',
                isLoadingTrans: false,
                fillNumber: prescriptionDetails[j].Fill[i].Id,
                prescriptionNumber:
                  prescriptionDetails[j].Fill[i].PrescriptionNumber,
                ConsultRequire: isconsultrequired,
                IsReturnable: isreturnable,
                status: prescriptionDetails[j].Fill[i].Status,
                is_controlled_substance: prescriptionDetails[j].isControlledSubstances,
                // Add flags and blocking reasons for informational display
                Flags: prescriptionDetails[j].Fill[i].Flags || [],
                CannotDispenseReasons: prescriptionDetails[j].Fill[i].CannotDispenseReasons || [],
                IsDispensable: prescriptionDetails[j].Fill[i].IsDispensable,
                // Prescription-level flags
                PrescriptionFlags: prescriptionDetails[j].AllFlags || prescriptionDetails[j].Flags || [],
                ReasonNotFillable: prescriptionDetails[j].ReasonNotFillable
              };
              let rxTransactionNumber = `${prescriptionDetails[j].Fill[i].PrescriptionId}-${prescriptionDetails[j].Fill[i].Id}`;
              if (
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'verified' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'readytodispense' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'intransit' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'received'
              ) {
                const isRxTrasactionNumberExist = await this.checkIfRxExistorNotForEpicWithmTLS(
                  rxTransactionNumber
                );
                if (
                  isRxTrasactionNumberExist &&
                  isRxTrasactionNumberExist.result === true
                ) {
                  toast.error(isRxTrasactionNumberExist.error);
                  this.setState({
                    rxNumber: '',
                    loader: false,
                    EmailID: '',
                    phone: '',
                    isEpicHasValidRx: true,
                    isEpicHasValidRxMessage: '',
                  });
                  return;
                } else {
                  items.push(item);
                  if (
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'verified' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'readytodispense' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'intransit' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'received'
                  ) {
                    validItems.push(prescriptionDetails[j].Fill[i]);
                  }
                  if (validItems.length > 0) {
                    prescriptionDetails[j].Fill[i] = validItems;
                  }
                }
              } else {
                items.push(item);
              }
            }
          }
          if (items && items.length === 0) {
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              this.isRxExistInCart(searchString, patientDetails, items);
            }
          } else {
            this.setState({
              EmailID: patientDetails.EmailAddress,
              phone: patientDetails.MobilePhone,
            });
            let RxItems = this.validateRxFills(items);
            if (
              RxItems &&
              RxItems.validRxItems &&
              RxItems.validRxItems.length > 0
            ) {
              searchedRxItems = RxItems.validRxItems;
            } else {
              searchedRxItems = RxItems.inValidRxItems;
              let errorArray = [];
              if (searchedRxItems && searchedRxItems.length > 0) {
                for (
                  let invalid = 0;
                  invalid < searchedRxItems.length;
                  invalid++
                ) {
                  errorArray.push({ Status: searchedRxItems[invalid].status });
                }
                const statusLabel = errorArray.map((x) => x.Status).join(', ');
                this.setState({
                  loader: false,
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: errorArray.length > 1
                    ? `Statuses ${statusLabel} cannot be assigned. Use Verified, ReadyToDispense, Received, or InTransit.`
                    : `Status ${statusLabel} cannot be assigned. Use Verified, ReadyToDispense, Received, or InTransit.`,
                });
              }
            }
            this.checkADACompatible(
              patientDetails.MedicalRecordNumber,
              patientDetails.EmailAddress
            );
            this.getcustomerLocation(
              patientDetails,
              searchedRxItems,
              'Epic With MTLS'
            );
            this.forceUpdate();
            this.setState({
              rxNumber: '',
              loader: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            loader: false,
            rxNumber: '',
            isEpicHasValidRx: false,
            isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
          });
          return;
        });
    // }
  };
  renderScanRxBasedOnConnectionType = (classes) => {
    const { globalAccountConnection, prescriptionAssign } = this.state;
    const { t } = this.props;
    const connectionTypeId =
      (globalAccountConnection && globalAccountConnection.account_connections_id) ||
      (this.state.accountDetails &&
        this.state.accountDetails.connection &&
        this.state.accountDetails.connection.id);

    if (usesIntegrationAssignLookup(connectionTypeId)) {
      return (
        <TextField
          id='outlined-bare'
          type='text'
          className={classes.scantextField}
          value={this.state.rxNumber}
          margin='normal'
          variant='standard'
          label={t('Assign.ScanRxNow')}
          InputLabelProps={{ shrink: true }}
          autoFocus={true}
          onKeyDown={(e) => handleIntegrationAssignRxKeyDown(this, e)}
          onChange={(e) => handleIntegrationAssignRxOnChange(this, e)}
          inputRef={this.textInput}
          style={{ width: '100%' }}
          inputProps={{
            autoComplete: 'off',
            form: {
              autoComplete: 'off',
            },
          }}
          disabled={!prescriptionAssign}
        />
      );
    }

    switch (connectionTypeId) {
      case CONNECTION_TYPE.EPIC:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'EPIC')}
            onChange={this.handleEpicChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.MEDBANK:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={this.handleMedBankKeyDown}
            onChange={this.handleMedBankChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.MSCRIPTS:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={this.handleMScriptsKeyDown}
            onChange={this.handleMScriptsOnChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.SOLIS:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={(e) => handleIntegrationAssignRxKeyDown(this, e)}
            onChange={(e) => handleIntegrationAssignRxOnChange(this, e)}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.PIONEERRX:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'PIONEERRX')}
            onChange={this.handlePioneerChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.QS1:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'QS1')}
            onChange={this.handleQS1Change}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.MCKESSONERX:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'MCKESSONERX')}
            onChange={this.handleMcKessonRxChange}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.EPIC_WITH_MTLS:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'Epic With MTLS')}
            onChange={this.handleEpicWithmTLSChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.LIBERTY_SOFTWARE:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'LIBERTYSOFTWARE')}
            onChange={this.handleLibertySoftwareChange}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.THIRD_PARTY:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={(e) => this.handleThirdPartyRxCheck(e, 'THIRDPARTY')}
            onChange={this.handleThirdPartyChange}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.HL7:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={this.handleHL7KeyDown}
            onChange={this.handleHL7OnChange}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.DRX_INTEGRATION:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'DRX')}
            onChange={this.handleDRXChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        )
        case CONNECTION_TYPE.PRIMERX:
          return (
            <TextField
              id='outlined-bare'
              type='text'
              className={classes.scantextField}
              value={this.state.rxNumber}
              margin='normal'
              variant='standard'
              label={t('Assign.ScanRxNow')}
              InputLabelProps={{ shrink: true }}
              autoFocus={true}
              onKeyDown={this.handlePrimerxKeyDown}
              onChange={this.handlePrimerxOnChange}
              inputRef={this.textInput}
              style={{ width: '100%' }}
              inputProps={{
                autoComplete: 'off',
                form: {
                  autoComplete: 'off',
                },
              }}
              disabled={!prescriptionAssign}
            />
          );
      default:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            InputLabelProps={{ shrink: true }}
            autoFocus={true}
            onChange={this.onChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
    }
  };

  BindPatientId = () => {
    const { searchedItems, basicDetails } = this.state;
    if (
      searchedItems &&
      searchedItems.PatientID &&
      searchedItems.PatientID !== null &&
      searchedItems.PatientID !== 'null'
    ) {
      return searchedItems.PatientID;
    } else if (
      basicDetails &&
      basicDetails.patient_id &&
      basicDetails.patient_id !== null &&
      basicDetails.patient_id !== 'null'
    ) {
      return basicDetails.patient_id;
    } else {
      return '';
    }
  };

  handleQS1Change = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleQS1KeyDown = () => {
    const { accountDetails, boxDetails, originalScannedScript, scannedRxScript } = this.state;
    let searchedString = originalScannedScript || scannedRxScript;
    if (boxDetails && boxDetails.length === 0) {
      this.setState({
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage:
          'Please select at least one location or check the location is active or not.',
        loader: false,
        rxNumber: '',
      });
      this.handleFocus();
      return;
    }
    this.setState({ loader: true, confirmPMSDialogOpen: false });
    let obj = {
      pharmacyId:
        accountDetails &&
        accountDetails.connection_details &&
        accountDetails.connection_details.pharmacyid,
      rxNumber: searchedString,
      account_id: this.state.accountDetails.id,
    };
    fetch(process.env.REACT_APP_BASEURL + 'qs/rx', {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession
            .idToken.jwtToken,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        this.setState({ loader: false, confirmPMSDialogOpen: false });
        let parsedResponse = JSON.parse(res);
        let patientDetails = parsedResponse.patient;
        let rxDetails = parsedResponse.rx;
        let parsedExpirationDate = '';
        if (
          patientDetails === 404 &&
          (rxDetails[0].Status === 'N' || rxDetails[0].Status === 'n')
        ) {
          toast.error(this.props.t('Toast.Error.RxNotAvailableNumber'));
          this.handleFocus();
          this.setState({
            rxNumber: '',
          });
        } else {
          if (
            rxDetails &&
            rxDetails[0] &&
            rxDetails[0].ExpirationDate
          ) {
            let ExpirationDateyear = rxDetails[0].ExpirationDate.substring(
              0,
              4
            );
            let ExpirationDatemonth = rxDetails[0].ExpirationDate.substring(
              4,
              6
            );
            let ExpirationDateday = rxDetails[0].ExpirationDate.substring(
              6,
              8
            );
            parsedExpirationDate =
              ExpirationDatemonth +
              '/' +
              ExpirationDateday +
              '/' +
              ExpirationDateyear;
          }
          const qs1IsControlled = isQs1DrugScheduleControlled(
            rxDetails && rxDetails[0] && rxDetails[0].DrugSchedule
          );
          this.setState({ is_controlled_substance: qs1IsControlled });
          const qs1PatientAmount = extractQs1PatientAmount(
            parsedResponse.orderStatus,
            rxDetails && rxDetails[0] && rxDetails[0].RxNumber
          );
          let item = {
            ndcCode: '',
            itemId: '',
            binId: '',
            rxNo: rxDetails && rxDetails[0] && rxDetails[0].RxNumber,
            name: rxDetails && rxDetails[0] && rxDetails[0].DrugName,
            description: '',
            image: '',
            potency: '',
            qty: '',
            schedule:
              rxDetails && rxDetails[0] && rxDetails[0].DrugSchedule,
            dea_schedule:
              rxDetails && rxDetails[0] && rxDetails[0].DrugSchedule,
            Amount: '',
            taxPercentage: '',
            insuranceAmount: '',
            qs1PatientAmount,
            CoPayAmount: qs1PatientAmount !== null ? qs1PatientAmount : '',
            PaidAmount: '',
            DueAmount: '',
            paymentDueDate: '',
            stockedOn: '',
            stockedBy: '',
            deStockedOn: '',
            strength: '',
            route: '',
            doseage_form: '',
            non_proprietary_name: '',
            ExpirationDate: parsedExpirationDate,
            isLoadingTrans: true,
            ConsultRequire: false,
            is_controlled_substance: qs1IsControlled,
            datefilled:
              rxDetails && rxDetails[0] && rxDetails[0].LastFillDate,
          };
          obj.datefilled = item.datefilled;
          this.generateCodes();
          this.setState({
            EmailID: patientDetails.EmailAddress,
            phone: patientDetails.CellPhone,
          });
          let parsedDob = '';
          var year = patientDetails.DateOfBirth.substring(0, 4);
          var month = patientDetails.DateOfBirth.substring(4, 6);
          var day = patientDetails.DateOfBirth.substring(6, 8);
          parsedDob = month + '/' + day + '/' + year;
          const existingItem = this.state.searchedItems;
          if (
            existingItem &&
            searchedRxItems &&
            searchedRxItems.length > 0
          ) {
            let _searchedRxNumber = '';
            let _firstCharZero = searchedString.charAt(0);
            if (_firstCharZero === 0 || _firstCharZero === '0') {
              if (searchedString.length === 12) {
                _searchedRxNumber = searchedString.slice(
                  0,
                  searchedString.length - 4
                );
              } else {
                _searchedRxNumber = searchedString;
              }
            } else {
              _searchedRxNumber = '0' + searchedString;
            }
            let isexist = searchedRxItems.findIndex(
              (x) => x.rxNo === _searchedRxNumber
            );
            if (existingItem.PatientID === patientDetails.PatientID) {
              if (isexist < 0) {
                searchedRxItems.push(item);
                this.checkADACompatible(
                  patientDetails.PatientID,
                  this.state.EmailID
                );
                let AddressLine1 = '', 
                AddressLine2 = '', 
                City = '', 
                State = '', 
                Zip = '', 
                Country = '',
                boxId = this.state.box_id;
                let locationDetails = boxDetails.filter((x) => x.id === boxId)[0];
                if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
                  AddressLine1 = locationDetails.address_line_1 || "";
                  AddressLine2 = locationDetails.address_line_2 || "";
                  City = locationDetails.city || "";
                  State = locationDetails.state || "";
                  Zip = locationDetails.zip || "";
                  Country = locationDetails.country || "";
                }
                this.setState({
                  searchedItems: {
                    PatientID: patientDetails.PatientID,
                    customer_id: patientDetails.customer_id || patientDetails.customerId,
                    FirstName: patientDetails.FirstName,
                    LastName: patientDetails.LastName,
                    DateOfBirth: parsedDob,
                    MobileNo: this.state && this.state.phone,
                    EmailID: this.state && this.state.EmailID,
                    orders: [{ items: searchedRxItems }],
                    AddressLine1: AddressLine1,
                    AddressLine2: AddressLine2,
                    City: City,
                    State: State,
                    Zip: Zip,
                    Country: Country,
                  },
                  is_controlled_substance: getOrderControlledSubstanceFromCart(),
                });
              } else {
                toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                this.setState({
                  rxNumber: '',
                });
                this.handleFocus();
              }
            } else {
              toast.error(this.props.t('Toast.Error.WrongPatient'));
              this.setState({
                rxNumber: '',
              });
              this.handleFocus();
            }
          } else {
            searchedRxItems.push(item);
            this.checkADACompatible(
              patientDetails.PatientID,
              this.state && this.state.EmailID
            );
            let AddressLine1 = '', 
            AddressLine2 = '', 
            City = '', 
            State = '', 
            Zip = '', 
            Country = '',
            boxId = this.state.box_id;
            let locationDetails = boxDetails.filter((x) => x.id === boxId)[0];
            if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
              AddressLine1 = locationDetails.address_line_1 || "";
              AddressLine2 = locationDetails.address_line_2 || "";
              City = locationDetails.city || "";
              State = locationDetails.state || "";
              Zip = locationDetails.zip || "";
              Country = locationDetails.country || "";
            }
            this.setState({
              searchedItems: {
                PatientID: patientDetails.PatientID,
                customer_id: patientDetails.customer_id || patientDetails.customerId,
                FirstName: patientDetails.FirstName,
                LastName: patientDetails.LastName,
                MiddleName: null,
                DateOfBirth: parsedDob,
                MobileNo: this.state && this.state.phone,
                EmailID: this.state && this.state.EmailID,
                orders: [{ items: searchedRxItems }],
                AddressLine1: AddressLine1,
                AddressLine2: AddressLine2,
                City: City,
                State: State,
                Zip: Zip,
                Country: Country,
              },
              is_controlled_substance: getOrderControlledSubstanceFromCart(),
            });
          }
          this.fetchTransactions(obj);
        }
      })
      .catch((error) => {
        toast.error(
          `${this.props.t('Toast.Error.RxErrorDetail')} ${searchedString}`
        );
        console.error('Error:', error.message);
        this.setState({ loader: false });
        this.setState({
          rxNumber: '',
        });
        this.handleFocus();
      });
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { selectedObject } = this.state;
    this.setState(
      { searchObj: { ...this.state.searchObj, pageNo: page } },
      () => {
        if (selectedObject && selectedObject.length > 0) {
          this.setState({ innerSearchLoader: true });
          this.FetchSearchResult();
        }
      }
    );
  };

  handleChangeRowsPerPage = (event) => {
    const { selectedObject } = this.state;
    this.setState(
      {
        searchObj: {
          ...this.state.searchObj,
          pageSize: event.target.value,
          pageNo: 0,
        },
      },
      () => {
        if (selectedObject && selectedObject.length > 0) {
          this.setState({ innerSearchLoader: true });
          this.FetchSearchResult();
        }
      }
    );
  };

  handlePrintReceipt = async () => {
    const { box_id, selectedBinId, binid, pmid, printLoading, locationtype_id, boxTypeId } = this.state;
    
    // Race condition protection (Test 1.9) - prevent concurrent calls
    if (printLoading) {
      console.log('Print operation already in progress, ignoring duplicate request');
      return;
    }
    
    // Use binid as fallback if selectedBinId is not set
    const effectiveBinId = selectedBinId || binid;
    
    const isBinOptionalLocation = isBinOptionalAssignLocation(locationtype_id);
    const isFastlaneGoliath = boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    const isSizeBasedPreAssignment =
      this.state.isSizeBasedPreAssignment ||
      resolveSizeBasedAssignUIFromBox(this.findBoxById(box_id));
    const resolvedStockCode = this.resolveStockCodeForRxByBin(
      effectiveBinId,
      pmid
    );
    const hasUsableStockCode = resolvedStockCode.length > 0;
    const isBinOptional =
      isBinOptionalLocation ||
      isFastlaneGoliath ||
      isSizeBasedPreAssignment ||
      hasUsableStockCode;
    const binIdForApi = !effectiveBinId && isBinOptional ? null : effectiveBinId;
    
    // Check if we have the required IDs to fetch fresh data.
    // Counter, Fastlane Goliath, and stock-code lookups can omit bin_id.
    if (!pmid || !box_id || (!binIdForApi && !isBinOptional)) {
      console.error('Missing required IDs for fetching fresh label data:', { pmid, effectiveBinId, box_id, isBinOptional });
      toast.error(this.props.t('Toast.Error.LabelData.MissingIds') || 'Cannot print: missing order information');
      return;
    }
    
    // Fetch fresh data from database
    let labelData = await this.fetchOrderDataForPrint(box_id, binIdForApi, pmid);
    
    if (!labelData) {
      toast.error(this.props.t('Toast.Error.LabelData.FetchFailed') || 'Failed to load label data from database');
      return;
    }

    labelData = this.enrichLabelDataFromAssignContext(labelData, null, null);

    const validation = this.validateLabelData(labelData, locationtype_id, boxTypeId);
    if (!validation.isValid) {
      console.error('Label data validation failed:', validation.missingFields);
      toast.error(
        this.props.t('Toast.Error.LabelData.Incomplete') ||
        `Cannot print: missing ${validation.missingFields.join(', ')}`
      );
      return;
    }

    this.beginLabelPrint(labelData, {
      boxId: box_id,
      delayMs: 500,
      afterPrint: () => {
        this.setState({ printDialogOpen: false, labelDataForPrint: null });
        this.getBoxes();
        searchedRxNumbers = [];
        searchedRxItems = [];
        this.setState({
          selectedBinId: '',
          searchedItems: [],
          rxNumber: '',
          isVisibleForPause: false,
          EmailID: '',
          phone: '',
          BrandingName: '',
          BrandingPhone: '',
          nonRxCartItems: [],
          nonRxPriceEditIndex: null,
          printNonRxItems: [],
        });
        this.handleFocus();
      },
    });
  };

  handleFocus = () => {
    // Keep focus on Marketplace UPC so users can type a code manually.
    if (this._upcScanFocused) {
      return;
    }
    const active = document.activeElement;
    if (
      active &&
      (active.id === 'marketplace-upc-scan-input' ||
        active.id === 'marketplace-upc-scan')
    ) {
      return;
    }
    let event = document.querySelector('#outlined-bare');
    if (![undefined, null, 'undefined', 'null'].includes(event)) event.focus();
  };

  confirmBinOkButton = () => {
    this.setState({
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      selectedBinId: '',
    });
  };
	checkIfCodesExists = async (codes, attempt = 0, generation = this._orderCodeGeneration) => {
    const maxAttempts = 8;
    const useNumeric = !!(codes && codes.useNumeric);
    if (generation !== this._orderCodeGeneration) {
      return codes;
    }
    await fetch(process.env.REACT_APP_BASEURL + 'verify/codes', {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify({
        stockCode: codes.stockCode,
        pickupCode: codes.pickupCode,
      }),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
		.then((res) => {
        if (generation !== this._orderCodeGeneration) {
          return;
        }
        if (res && res.isExist === true) {
          if (attempt >= maxAttempts) {
            // Prefer longer alphanumeric codes when the numeric 4-digit pool is saturated
            const fallback = this.buildRandomOrderCodes(false);
            this.setState({
              stockCode: fallback.stockCode,
              pickupCode: fallback.pickupCode,
            });
            this.checkIfCodesExists(fallback, 0, generation);
            return;
          }
          const nextCodes = this.buildRandomOrderCodes(useNumeric);
          this.checkIfCodesExists(nextCodes, attempt + 1, generation);
          return;
        }
        this.setState({
          stockCode: codes.stockCode,
          pickupCode: codes.pickupCode,
        });
		}).catch(() => {
			if (generation !== this._orderCodeGeneration) {
				return;
			}
			// Bounded retry with simple backoff to avoid infinite re-renders
			if (attempt < 3) {
				setTimeout(() => this.checkIfCodesExists(codes, attempt + 1, generation), (attempt + 1) * 500);
				return;
			}
			// On persistent failure, fall back to using the generated codes without further retries
			this.setState({
				stockCode: codes.stockCode,
				pickupCode: codes.pickupCode,
				loader: false,
			});
		});
    return codes;
  };

  saveCustomerMaster = async (type) => {
    console.log('💾 saveCustomerMaster called with type:', type);
    const {
      EmailID,
      phone,
      selectedBinId,
      isVerifyingBin,
      courier_tracking,
      default_courier_selected,
      isEpicHasValidRx,
      locationtype_id,
      accountDetails,
      servePresRetryCount,
      dateOfBirth,
      boxTypeId,
      deactivatedBins,
      isRetrying,
      fastlaneBinId
    } = this.state;
    const { t } = this.props;
    
    // Prevent concurrent assign attempts (sync flag; setState alone races under React 17).
    if (isRetrying || this._assignInFlight) {
      console.log('💾 Assignment already in progress, skipping duplicate call');
      return;
    }
    this._assignInFlight = true;

    if (deactivatedBins && deactivatedBins.includes(selectedBinId)) {
      toast.error(this.props.t('Toast.Error.BinDeactivated'));
      this.clearAssignInFlight();
      return;
    }
    // Validations before isRetrying:true so early exits cannot leave the sync lock stuck
    // (React 17 batches isRetrying true→false in one commit inside this event handler).
    if (!this.state.box_id) {
      this.clearAssignInFlight();
      this.setState({ hasError: true, loader: false, isRetrying: false });
      return;
    }
    if (!this.hasCartItems()) {
      toast.error(
        this.props.t('Assign.NonRxCart.CartRequired', {
          defaultValue: 'Add at least one Rx or Marketplace item before assigning.',
        })
      );
      this.clearAssignInFlight();
      this.setState({ loader: false, isRetrying: false });
      return;
    }
    const nonRxValidationErrorEarly = this.validateNonRxCartItems();
    if (nonRxValidationErrorEarly) {
      toast.error(nonRxValidationErrorEarly);
      this.clearAssignInFlight();
      this.setState({ loader: false, isRetrying: false });
      return;
    }

    this.setState(prevState => ({ 
      servePresFetchCount: prevState.servePresFetchCount + 1,
      isRetrying: true,
      loader: true,
    }));
    {
      // Cart/non-Rx already validated above; keep block for existing closing braces.
      let allowPrescriptionForcefully = false;
      // Simplified bin validation for Kiosk
      if(locationtype_id === LOCATION_TYPE.Kiosk) {
        if (this.state.isSizeBasedPreAssignment) {
          if (
            [undefined, 'undefined', null, 'null', ''].includes(
              this.state.selectedBinSize
            )
          ) {
            this.clearAssignInFlight();
            this.setState({
              isBinSizeRequired: true,
              loader: false,
              isRetrying: false,
            });
            return;
          }
        } else {
        // For Fastlane: if selectedBinId exists, use it (could be add-on or other selection)
        // If selectedBinId is empty, use fastlaneBinId (YourPosition) for normal Fastlane flow
        // For non-Fastlane: use selectedBinId
        let effectiveBinId;
        if (boxTypeId === BOX_TYPE.FASTLANE) {
          // If user selected a bin (from add-on or anywhere else), use it
          if (selectedBinId && ![undefined, 'undefined', null, 'null', ''].includes(selectedBinId)) {
            effectiveBinId = selectedBinId;
          } else {
            // No bin selected, use fastlaneBinId (YourPosition) for normal Fastlane flow
            // This allows normal Fastlane flow to proceed without dialog interruption
            effectiveBinId = fastlaneBinId;
          }
        } else if (boxTypeId === BOX_TYPE.FASTLANEGOLIATH) {
          // Goliath does not use "next available bin / YourPosition" from matrix.
          // Keep assignment on explicit user-selected bin only.
          effectiveBinId = selectedBinId;
        } else {
          effectiveBinId = selectedBinId;
          // Only show dialog for non-Fastlane boxes if bin is not selected
          if ([undefined, 'undefined', null, 'null', ''].includes(effectiveBinId)) {
            this.clearAssignInFlight();
            this.setState({ openMessage: true, loader: false, isRetrying: false });
            return;
          }
        }
        }
      }
      if (![CONNECTION_TYPE.PIONEERRX, CONNECTION_TYPE.EPIC, CONNECTION_TYPE.EPIC_WITH_MTLS, CONNECTION_TYPE.DRX_INTEGRATION, CONNECTION_TYPE.LIBERTY_SOFTWARE].includes(accountDetails.connection.id)) {
        await this.checkPrescriptionStatus();
      } else {
        allowPrescriptionForcefully = true;
      }
      const hasOnlyNonRx =
        (!searchedRxItems || searchedRxItems.length === 0) &&
        (this.state.nonRxCartItems || []).length > 0;
      if (isEpicHasValidRx || allowPrescriptionForcefully || hasOnlyNonRx) {
        if (!this.shouldShowBasicUI() && !this.isBasicConnection()) {
          if (locationtype_id === LOCATION_TYPE.Counter) {
            // Counter: at least one of phone or email required
            const phoneTrimmed = (phone != null && String(phone).trim() !== '') ? String(phone).trim() : '';
            const emailTrimmed = (EmailID != null && String(EmailID).trim() !== '') ? String(EmailID).trim() : '';
            if (phoneTrimmed === '' && emailTrimmed === '') {
              toast.error(this.props.t('Assign.Counter.PhoneOrEmailRequired', { defaultValue: 'Phone or email is required for counter assignment.' }));
              this.clearAssignInFlight();
              this.setState({ loader: false, isRetrying: false });
              return;
            }
          } else {
            // Non-Counter: both required
            if ([undefined, 'undefined', null, 'null', ''].includes(EmailID)) {
              toast.error(this.props.t('Toast.Error.EnterEmail'));
              this.clearAssignInFlight();
              this.setState({ loader: false, isRetrying: false });
              return;
            }
            if ([undefined, 'undefined', null, 'null', ''].includes(phone)) {
              toast.error(this.props.t('Toast.Error.EnterMobile'));
              this.clearAssignInFlight();
              this.setState({ loader: false, isRetrying: false });
              return;
            }
          }
        }

        if (this.shouldShowBasicUI()) {
          let phoneError = false;
          let basicEmailError = false;
          let dobError = false;
          let rxError = false;
          const notifyByEmail = this.state.notifyChannel === 'email';

          if (notifyByEmail) {
            const emailTrimmed = EmailID != null ? String(EmailID).trim() : '';
            basicEmailError = !emailTrimmed || !this.validateEmail(emailTrimmed);
          } else if (!phone) {
            phoneError = true;
          } else {
            const cleaned = phone.replace(/\D/g, '');
            if (cleaned.length !== 10) {
              phoneError = true;
            }
          }

          if (dateOfBirth) {
            dobError = !moment(dateOfBirth, 'MM/DD/YYYY', true).isValid();
          } else if (!this.isBasicDobOptional()) {
            dobError = true;
          }

          const isAnyRxMissing = this.state.rxEntries.some(
            (entry) => !entry.rxNumber.trim()
          );
          if (isAnyRxMissing) {
            rxError = true;
            toast.error(this.props.t('Toast.Error.RxRequired'))
          }

          if (phoneError || basicEmailError || dobError || rxError) {
            this.clearAssignInFlight();
            this.setState({ phoneError, basicEmailError, dobError, rxError, loader: false, isRetrying: false });
            return;
          }
        }

        if (!isVerifyingBin) {
          await this.ensureUnusedOrderCodes();
          const serverPrescriptionReqPayload =
            this.shouldShowBasicUI()
              ? await this.prepareBasicPayload()
              : await this.prepareServerPrescrptionReqPayload();
          if(locationtype_id === LOCATION_TYPE.Kiosk) {
            const isKioskGoliathAssignment =
              boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
            // Size-based pre-assign (Canada): bin_id is chosen at stock time; only bin_size is required.
            const requiresBinId =
              !isKioskGoliathAssignment && !this.state.isSizeBasedPreAssignment;
            if (
              requiresBinId &&
              [undefined, "undefined", null, "null", ""].includes(
                serverPrescriptionReqPayload.prescription.bin_id
              )
            ) {
              toast.error(this.props.t('Assign.SelectBinToContinueOrRefresh'));
              this.clearAssignInFlight();
              this.setState({ loader: false, isRetrying: false });
              return;
            }
            
            // Additional defense for Fastlane: Ensure bin_id is not NaN or invalid
            // Only validate if Fastlane is actually selected
            const isFastlaneSelection =
              boxTypeId === BOX_TYPE.FASTLANE &&
              (
                this.state.selectedAssignmentLocation === 'fastlane' ||
                !this.state.selectedAssignmentLocation
              );
            if (isFastlaneSelection) {
              const binIdValue = serverPrescriptionReqPayload.prescription.bin_id;
              if ([null, "null", undefined, "undefined", "", 0].includes(binIdValue)) {
                console.error("Invalid Fastlane bin ID detected:", binIdValue);
                this.clearAssignInFlight();
                this.setState({ 
                  loader: false,
                  isRetrying: false,
                  fastlaneBinValidationError: true,
                  pendingSaveMode: type
                });
                return;
              }
            }
          }
          console.log('📍 [ASSIGN PRESCRIPTION] Creating Order with Location Details:', {
            locationTypeId: serverPrescriptionReqPayload.prescription.locationtype_id,
            locationTypeName: (this.state.locationtype && this.state.locationtype.find(l => l.id === serverPrescriptionReqPayload.prescription.locationtype_id)) ? this.state.locationtype.find(l => l.id === serverPrescriptionReqPayload.prescription.locationtype_id).label : 'Unknown',
            boxId: serverPrescriptionReqPayload.prescription.box_id,
            boxName: (this.state.selectedBox && this.state.selectedBox.name) || 'Not Set',
            binId: serverPrescriptionReqPayload.prescription.bin_id,
            isKiosk: serverPrescriptionReqPayload.prescription.locationtype_id === LOCATION_TYPE.Kiosk,
            endpoint: 'serve/prescription'
          });
          fetch(process.env.REACT_APP_BASEURL + "serve/prescription", {
            method: "post",
            withCredentials: true,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession
                  .idToken.jwtToken,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ ...serverPrescriptionReqPayload, audit_writer: 'web-gap-v1' }),
          })
            .then((response) => {
              try {
                return response.json();
              } catch (error) {
                return null;
              }
            })
            .then(async (serverPrescriptionResponse) => {
              const createdOrderLocationTypeId = (serverPrescriptionResponse && serverPrescriptionResponse.patient && serverPrescriptionResponse.patient.locationtype_id) || serverPrescriptionReqPayload.prescription.locationtype_id;
              const assignErrorCode =
                serverPrescriptionResponse &&
                serverPrescriptionResponse.ErrorCode != null &&
                serverPrescriptionResponse.ErrorCode !== ''
                  ? Number(serverPrescriptionResponse.ErrorCode)
                  : null;
              const assignFailed =
                !serverPrescriptionResponse ||
                serverPrescriptionResponse.statusCode === 500 ||
                (assignErrorCode != null &&
                  !Number.isNaN(assignErrorCode) &&
                  assignErrorCode !== 200);
              if (assignFailed) {
                const failedOrderLocationTypeId = serverPrescriptionReqPayload.prescription.locationtype_id;
                console.error('📍 [ASSIGN PRESCRIPTION] Order Creation Failed:', {
                  error:
                    (serverPrescriptionResponse &&
                      serverPrescriptionResponse.statusCode) ||
                    assignErrorCode,
                  errorMessage:
                    serverPrescriptionResponse &&
                    serverPrescriptionResponse.ErrorMessage,
                  locationTypeId: failedOrderLocationTypeId,
                  locationTypeName: (this.state.locationtype && this.state.locationtype.find(l => l.id === failedOrderLocationTypeId)) ? this.state.locationtype.find(l => l.id === failedOrderLocationTypeId).label : 'Unknown',
                  boxId: serverPrescriptionReqPayload.prescription.box_id,
                  boxName: (this.state.selectedBox && this.state.selectedBox.name) || 'Not Set'
                });
                this.clearAssignInFlight();
                const failedMsg =
                  (serverPrescriptionResponse &&
                    serverPrescriptionResponse.ErrorMessage) ||
                  '';
                const isFastlaneBinConflict =
                  boxTypeId === BOX_TYPE.FASTLANE &&
                  /Conflict:|already exists in prescriptions_master|already exists in orders_v2/i.test(
                    failedMsg
                  );
                if (isFastlaneBinConflict) {
                  this.handleFastlaneBinCollision(type, serverPrescriptionResponse);
                  return;
                }
                this.setState({ loader: false, isRetrying: false });
                toast.error(
                  failedMsg ||
                    this.props.t(
                      'Toast.Error.DeliverPrescription.ServePrescription'
                    )
                );
                if (
                  assignErrorCode === 409 ||
                  /duplicate key|prescriptions_master_codes|already in use/i.test(
                    failedMsg
                  )
                ) {
                  this.generateCodes();
                }
                return;
              }
              console.log('📍 [ASSIGN PRESCRIPTION] Order Created Successfully:', {
                locationTypeId: createdOrderLocationTypeId,
                locationTypeName: (this.state.locationtype && this.state.locationtype.find(l => l.id === createdOrderLocationTypeId)) ? this.state.locationtype.find(l => l.id === createdOrderLocationTypeId).label : 'Unknown',
                boxId: serverPrescriptionReqPayload.prescription.box_id,
                boxName: (this.state.selectedBox && this.state.selectedBox.name) || 'Not Set',
                isKiosk: createdOrderLocationTypeId === LOCATION_TYPE.Kiosk,
                patientId: (serverPrescriptionResponse && serverPrescriptionResponse.patient && serverPrescriptionResponse.patient.id) || null
              });
              const { patient } = serverPrescriptionResponse;
              if (patient && patient.id) {
              if (patient.locationtype_id !== LOCATION_TYPE.Kiosk) {
              console.log('📍 [ASSIGN PRESCRIPTION] Sending delivery notification for non-Kiosk:', {
                locationTypeId: patient.locationtype_id,
                locationTypeName: (this.state.locationtype && this.state.locationtype.find(l => l.id === patient.locationtype_id)) ? this.state.locationtype.find(l => l.id === patient.locationtype_id).label : 'Unknown',
                boxId: serverPrescriptionReqPayload.prescription.box_id,
                boxName: (this.state.selectedBox && this.state.selectedBox.name) || 'Not Set',
                patientId: patient.id
              });
                  await this.servePrescriptionForOtherDeliveryTypes(
                    serverPrescriptionResponse,
                    courier_tracking,
                    default_courier_selected
                  );
                }
              }
              
              // Emit updateConsole for Counter/Bedside (existing) and Curbside (additive)
              if (
                (isCounterOrBedside(createdOrderLocationTypeId) ||
                  isCurbsideLocation(createdOrderLocationTypeId)) &&
                this.socket
              ) {
                this.socket.emit('updateConsole');
              }
              
              this.clearAssignInFlight();
              const assignedStockCode =
                serverPrescriptionReqPayload &&
                serverPrescriptionReqPayload.prescription &&
                serverPrescriptionReqPayload.prescription.stock_code;
              if (assignedStockCode) {
                this._lastAssignedStockCode = String(assignedStockCode).trim();
              }
              this._orderCodeGeneration = (this._orderCodeGeneration || 0) + 1;
              this.setState({
                loader: false,
                show_order_notes_dialog: false,
                servePresRetryCount: 3,
                servePresFetchCount: 0,
                isRetrying: false,
                stockCode: '',
                pickupCode: '',
                fastlaneBinId: '',
              });
              this.handleFocus();
              if (type === 1) {
                // Fetch fresh data from database and open print dialog
                // Preserve selectedBinId until after print dialog is opened
                const preservedBinId = this.state.selectedBinId;
                let printOpened = false;
                try {
                  printOpened = await this.handleOpenPrintDialogWithFreshData(serverPrescriptionResponse, preservedBinId);
                } catch (error) {
                  console.error('Error opening print dialog:', error);
                  toast.error(this.props.t('Toast.Error.PrintDialog') || 'Failed to open print dialog: ' + (error.message || error));
                }
                // Curbside-only: confirm assign success if print dialog did not open.
                // Kiosk / Counter / Bedside keep prior SAVE&PRINT toast behavior.
                if (!printOpened && isCurbsideLocation(createdOrderLocationTypeId)) {
                  toast.success(this.props.t('Assign.RxAssignedSuccessfully'));
                  this.refreshCurrentBoxAfterClear();
                }
              } else {
                toast.success(
                  this.props.t("Assign.RxAssignedSuccessfully")
                );
              }
              // Clear fields after print dialog is handled (for type 1) or after success message (for type 0)
              searchedRxItems = [];
              this.setState({
                selectedBinId: "",
                searchedItems: [],
                rxNumber: "",
                EmailID: "",
                phone: "",
                storage_location: "",
                room_number: "",
                locationData: null,
                is_controlled_substance: false,
                makeFastlaneAPICall: true,
                show_order_notes_dialog: false,
              });
              // Only call ClearFields for type 0 to avoid duplicate clearing
              if (type !== 1) {
                this.refreshCurrentBoxAfterClear();
              }
            })
            .catch((error) => {
              if (servePresRetryCount > 0) {
                console.log(`Retrying assignment... Attempts remaining: ${servePresRetryCount - 1}`);
                this.clearAssignInFlight();
                this.setState(
                  (prevState) => ({
                    loader: false,
                    show_order_notes_dialog: false,
                    servePresRetryCount: prevState.servePresRetryCount - 1,
                    isRetrying: false,
                  }),
                  () => {
                    setTimeout(() => {
                      this.checkIfBinIsOccupedFromAnotherLocation(type);
                    }, 1000);
                  }
                );
              } else {
                // After all retries exhausted, show error and reset count
                console.error('Assignment failed after all retry attempts:', error);
                toast.error(
                  t("Toast.Error.DeliverPrescription.ServePrescription") +
                    (error && error.message ? `: ${error.message}` : '')
                );
                // Reset retry count and fetch count for next attempt
                this.clearAssignInFlight();
                this.setState({
                  loader: false,
                  servePresRetryCount: 3,
                  servePresFetchCount: 0,
                  isRetrying: false,
                  show_order_notes_dialog: false,
                });
              }
            });
          
        }
      }
    }
  };

  getPrintLookupConfig = (boxId, binId, pmId, stockCodeOverride = null) => {
    const isFastlaneGoliath = this.state.boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    const hasPmId = ![undefined, 'undefined', null, 'null', ''].includes(pmId);
    const hasUsableBinId = ![undefined, 'undefined', null, 'null', ''].includes(binId);
    const isSizeBasedPreAssignment =
      this.state.isSizeBasedPreAssignment ||
      resolveSizeBasedAssignUIFromBox(this.findBoxById(boxId));
    const useRxByPmId = isSizeBasedPreAssignment && hasPmId && !isFastlaneGoliath;
    const resolvedStockCode = this.resolveStockCodeForRxByBin(
      binId,
      pmId,
      stockCodeOverride
    );
    return {
      endpoint: useRxByPmId ? 'pre-assignment/rxbyPMID' : 'rxbybin',
      requestBody: useRxByPmId
        ? { id: boxId, pm_id: pmId }
        : {
            id: boxId,
            bin_id: hasUsableBinId ? binId : null,
            pm_id: pmId,
            stock_code: resolvedStockCode || null,
          },
    };
  };

  /**
   * Screen values captured before a print fetch. Later scans must not change this label.
   */
  captureLabelScreenFallback = () => {
    const {
      searchedItems,
      stockCode,
      pickupCode,
      dateOfBirth,
      accountDetails,
      rxEntries,
      nonRxCartItems,
      room_number,
      order_notes,
      storage_location,
    } = this.state;
    const hasValue = (value) =>
      ![undefined, null, '', 'undefined', 'null'].includes(value);
    const labelConnectionId =
      accountDetails && accountDetails.connection && accountDetails.connection.id;
    const patient =
      searchedItems && !Array.isArray(searchedItems) ? searchedItems : null;
    const rxNumbers = Array.isArray(searchedRxItems)
      ? searchedRxItems
          .map((item) => getLabelRxNo(item, labelConnectionId))
          .filter(hasValue)
      : [];
    return {
      stockCode: stockCode || '',
      pickupCode: pickupCode || '',
      firstName: patient && (patient.FirstName || patient.first_name),
      lastName: patient && (patient.LastName || patient.last_name),
      dateOfBirth:
        (patient && (patient.DateOfBirth || patient.dateOfBirth)) || dateOfBirth,
      basicFirstName: accountDetails && accountDetails.basic_first_name,
      basicLastName: accountDetails && accountDetails.basic_last_name,
      rxNumbers,
      rxEntries: Array.isArray(rxEntries)
        ? rxEntries.map((entry) => ({ ...entry }))
        : [],
      nonRxItems: Array.isArray(nonRxCartItems)
        ? nonRxCartItems.map((item) => ({
            item_number: item.item_number || '',
            description: item.description || item.drug_name || '',
            price: item.price,
            qty: item.qty,
          }))
        : [],
      roomNumber: room_number || '',
      orderNotes: order_notes || '',
      storageLocation: storage_location || '',
    };
  };

  cloneLabelPrintData = (labelData) => {
    if (!labelData) {
      return null;
    }
    const rxNumbers = Array.isArray(labelData.rxNumbers)
      ? labelData.rxNumbers.filter(Boolean).map((rxNumber) => String(rxNumber))
      : [];
    return {
      orderId: labelData.orderId || '',
      parentAccountId: labelData.parentAccountId || '',
      stockCode: labelData.stockCode || '',
      pickupCode: labelData.pickupCode || '',
      firstName: labelData.firstName || '',
      lastName: labelData.lastName || '',
      dateOfBirth: labelData.dateOfBirth || '',
      isCoolItem: !!labelData.isCoolItem,
      binId: labelData.binId || '',
      rxNumbers,
      rxEntries: Array.isArray(labelData.rxEntries) && labelData.rxEntries.length > 0
        ? labelData.rxEntries.map((entry) => ({
            rxNumber: entry && entry.rxNumber,
            isConsultRequired: !!(entry && entry.isConsultRequired),
          }))
        : rxNumbers.map((rxNumber) => ({ rxNumber, isConsultRequired: false })),
      nonRxItems: Array.isArray(labelData.nonRxItems)
        ? labelData.nonRxItems.map((item) => ({ ...item }))
        : [],
      roomNumber: labelData.roomNumber || '',
      orderNotes: labelData.orderNotes || '',
      brandName: labelData.brandName || '',
      brandPhone: labelData.brandPhone || '',
    };
  };

  resolvePrintBranding = (boxId) => {
    const boxIdStr = boxId != null ? String(boxId) : '';
    const boxDetails = this.state.boxDetails;
    const getBranding = boxDetails && boxDetails.find(
      (ele) => ele && String(ele.id) === boxIdStr
    );
    const selectedBox = this.state.selectedBox;
    const gbName = getBranding && getBranding.brandName;
    const sbName = selectedBox && selectedBox.brandName;
    const gbPhone = getBranding && getBranding.brandPhone;
    const sbPhone = selectedBox && selectedBox.brandPhone;
    return {
      brandName: (gbName != null ? gbName : sbName) || '',
      brandPhone: (gbPhone != null ? gbPhone : sbPhone) || '',
    };
  };

  buildPrintRequestAudit = (labelData, boxId, kind) => {
    const box = this.findBoxById(boxId);
    const parentAccountId = labelData.parentAccountId || (box && box.parent_account_id);
    // Do not file a child-location action under an unrelated selected account.
    if (!boxId || !parentAccountId) return null;
    const refs = [
      `Order: ${labelData.orderId || 'unavailable'}`,
      `stock code: ${labelData.stockCode || 'unavailable'}`,
      `bin: ${labelData.binId || 'not assigned'}`,
    ].join('; ');
    return {
      description: `${kind} print requested. ${refs}. Physical printing or cancellation cannot be confirmed by the browser.`,
      action: kind === 'Label' ? 'Print Label' : 'Print Ticket',
      subject: { boxId, parentAccountId },
    };
  };

  recordPrintRequestAudit = (audit) => {
    if (!audit) {
      console.error('Print audit missing target account or location');
      return;
    }
    // Dispatch immediately before window.print; never claim physical completion.
    // Existing audit transport is best-effort and does not block the print dialog.
    writeAuditLog(audit.description, audit.action, audit.subject, {}, { wait: true, deferMs: 0 })
      .catch((error) => console.error('Failed to record print request:', error));
  };

  beginLabelPrint = (labelData, options = {}) => {
    const branding = this.resolvePrintBranding(options.boxId);
    const snapshot = this.cloneLabelPrintData({
      ...labelData,
      brandName: branding.brandName,
      brandPhone: branding.brandPhone,
    });
    if (!snapshot || !snapshot.stockCode) {
      return false;
    }
    this._labelPrintQueue = this._labelPrintQueue || [];
    this._labelPrintQueue.push({
      snapshot,
      audit: this.buildPrintRequestAudit(snapshot, options.boxId, 'Label'),
      delayMs: options.delayMs != null ? options.delayMs : 1500,
      afterPrint: options.afterPrint || null,
    });
    if (!this._labelPrintRunning) {
      this.runNextLabelPrint();
    }
    return true;
  };

  runNextLabelPrint = () => {
    const job = (this._labelPrintQueue || []).shift();
    if (!job) {
      this._labelPrintRunning = false;
      return;
    }
    this._labelPrintRunning = true;
    this.setState({
      labelDataForPrint: job.snapshot,
      printDialogOpen: true,
      BrandingName: job.snapshot.brandName,
      BrandingPhone: job.snapshot.brandPhone,
    }, () => {
      setTimeout(() => {
        this.recordPrintRequestAudit(job.audit);
        window.print();
        setTimeout(() => {
          if (typeof job.afterPrint === 'function') {
            job.afterPrint();
          } else {
            this.setState({
              printDialogOpen: false,
              labelDataForPrint: null,
              BrandingName: '',
              BrandingPhone: '',
            });
          }
          this.runNextLabelPrint();
        }, 500);
      }, job.delayMs);
    });
  };

  selectCustomerOrderForLabel = (customers, pmId) => {
    const list = Array.isArray(customers) ? customers : [];
    if (pmId) {
      const pmKey = String(pmId);
      for (let i = 0; i < list.length; i += 1) {
        const orders = (list[i] && list[i].orders) || [];
        const matched = orders.find((entry) => entry && String(entry.id) === pmKey);
        if (matched) {
          return { customer: list[i], order: matched };
        }
      }
    }
    const customer = list[0];
    return {
      customer,
      order: customer && customer.orders && customer.orders[0],
    };
  };

  enrichLabelDataFromAssignContext = (labelData, serverPrescriptionResponse = null, screenFallback = null) => {
    if (!labelData) {
      return labelData;
    }
    const screen = screenFallback || {};
    const { accountDetails } = this.state;
    const prescription = serverPrescriptionResponse && serverPrescriptionResponse.prescription;
    const patient = serverPrescriptionResponse && serverPrescriptionResponse.patient;
    const prescriptionItems = serverPrescriptionResponse && serverPrescriptionResponse.prescriptionItems;
    const hasValue = (value) =>
      ![undefined, null, '', 'undefined', 'null'].includes(value);
    const isNonRxItem = isNonRxOrderItem;
    const labelConnectionId =
      accountDetails && accountDetails.connection && accountDetails.connection.id;

    const rxFromServe = Array.isArray(prescriptionItems)
      ? prescriptionItems
          .filter((item) => !isNonRxItem(item))
          .map((item) => getLabelRxNo(item, labelConnectionId))
          .filter(hasValue)
      : [];
    const rxFromScreen = Array.isArray(screen.rxNumbers)
      ? screen.rxNumbers.filter((rx) => hasValue(rx) && String(rx).trim() !== '')
      : [];
    const rxFromEntries = Array.isArray(screen.rxEntries)
      ? screen.rxEntries
          .map((entry) => entry && entry.rxNumber)
          .filter((rx) => hasValue(rx) && String(rx).trim() !== '')
      : [];
    const mergedRxNumbers =
      labelData.rxNumbers && labelData.rxNumbers.length > 0
        ? labelData.rxNumbers.filter(hasValue)
        : rxFromServe.length > 0
          ? rxFromServe
          : rxFromScreen.length > 0
            ? rxFromScreen
            : rxFromEntries;

    const nonRxFromServe = Array.isArray(prescriptionItems)
      ? prescriptionItems
          .filter((item) => isNonRxItem(item))
          .map((item) => ({
            item_number: item.item_number || '',
            description: item.drug_name || item.description || '',
            price: item.price,
            qty: item.qty,
          }))
      : [];
    const nonRxFromScreen = Array.isArray(screen.nonRxItems) ? screen.nonRxItems : [];
    const mergedNonRxItems =
      labelData.nonRxItems && labelData.nonRxItems.length > 0
        ? labelData.nonRxItems
        : nonRxFromServe.length > 0
          ? nonRxFromServe
          : nonRxFromScreen;

    return {
      ...labelData,
      stockCode: hasValue(labelData.stockCode)
        ? labelData.stockCode
        : (prescription && prescription.stock_code) || screen.stockCode,
      pickupCode: hasValue(labelData.pickupCode)
        ? labelData.pickupCode
        : (prescription && prescription.pucode) || screen.pickupCode,
      firstName: hasValue(labelData.firstName)
        ? labelData.firstName
        : (patient && patient.first_name) ||
          screen.firstName ||
          screen.basicFirstName,
      lastName: hasValue(labelData.lastName)
        ? labelData.lastName
        : (patient && patient.last_name) ||
          screen.lastName ||
          screen.basicLastName,
      dateOfBirth: hasValue(labelData.dateOfBirth)
        ? labelData.dateOfBirth
        : (patient && (patient.dob_str || patient.dob)) ||
          screen.dateOfBirth,
      binId: hasValue(labelData.binId)
        ? labelData.binId
        : (prescription && (prescription.bin_id || prescription.storage_location)) ||
          screen.storageLocation ||
          labelData.binId,
      roomNumber: hasValue(labelData.roomNumber)
        ? labelData.roomNumber
        : (prescription && prescription.room_number) || screen.roomNumber,
      orderNotes: hasValue(labelData.orderNotes)
        ? labelData.orderNotes
        : (prescription && prescription.order_notes) || screen.orderNotes,
      rxNumbers: mergedRxNumbers,
      nonRxItems: mergedNonRxItems,
      rxEntries:
        labelData.rxEntries && labelData.rxEntries.length > 0
          ? labelData.rxEntries
          : mergedRxNumbers.map((rxNumber) => ({
              rxNumber,
              isConsultRequired: false,
            })),
    };
  };

  /**
   * Fetches complete order data from database for label printing
   * Uses /rxbybin or pre-assignment/rxbyPMID (size-based) to get fresh data
   * @param {number} boxId - Box ID
   * @param {number} binId - Bin ID  
   * @param {string} pmId - Prescription master ID
   * @returns {object|null} Structured label data or null if error
   */
  fetchOrderDataForPrint = async (boxId, binId, pmId, stockCodeOverride = null) => {
    this.setState({ printLoading: true });
    
    try {
      // Create abort controller for timeout handling (Test 1.7)
      // eslint-disable-next-line no-undef
      const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      const timeoutId = controller ? setTimeout(() => controller.abort(), 30000) : null; // 30 second timeout
      
      const { endpoint, requestBody } = this.getPrintLookupConfig(
        boxId,
        binId,
        pmId,
        stockCodeOverride
      );
      
      const fetchOptions = {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + 
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      };
      
      // Add signal only if AbortController is available
      if (controller && controller.signal) {
        fetchOptions.signal = controller.signal;
      }
      
      const response = await fetch(
        process.env.REACT_APP_BASEURL + endpoint,
        fetchOptions
      );
      
      if (timeoutId) clearTimeout(timeoutId);
      
      // Check HTTP status (Test 1.3, 1.6)
      if (!response.ok) {
        throw new Error(`API returned status ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();

      if (!data || !data.response || !data.response.box) {
        throw new Error(`Invalid response structure from /${endpoint}`);
      }
      
      const details = data.response.box;
      const customers = details.customers;
      
      if (!customers || customers.length === 0) {
        throw new Error('No customer data found');
      }
      
      const { customer, order } = this.selectCustomerOrderForLabel(customers, pmId);
      if (!customer || !order) {
        throw new Error('No order data found');
      }
      const items = order.items || [];
      const contacts = customer.contacts || [];
      const contact = contacts[0] || {};
      
      // For Counter/Bedside/Curbside, if binId was empty in request but exists in order response, use it
      let finalBinId = binId;
      if (!binId && order.bin_id) {
        finalBinId = order.bin_id;
      }
      if (!finalBinId && order.storage_location) {
        finalBinId = order.storage_location;
      }

      const { rxItems: rxOnlyItems, nonRxItems } = splitOrderItemsForCarts(items);
      const labelConnectionId =
        this.state.accountDetails &&
        this.state.accountDetails.connection &&
        this.state.accountDetails.connection.id;
      
      // Extract and structure label data
      const labelData = {
        // Codes
        stockCode: order.stock_code,
        pickupCode: order.pucode,
        
        // Patient Info
        firstName: customer.first_name,
        lastName: customer.last_name,
        dateOfBirth: customer.dob_str,
        patientId: customer.patient_id,
        
        // Prescription Info — storage_location used as label bin text for Counter/Bedside/Curbside
        binId: finalBinId || order.bin_id || order.storage_location,
        isCoolItem: order.is_cool_item || false,
        rxNumbers: rxOnlyItems
          .map((item) => getLabelRxNo(item, labelConnectionId))
          .filter(Boolean),
        rxItems: rxOnlyItems,
        nonRxItems,
        
        // Location
        locationTypeId: order.customerLocations && order.customerLocations.length > 0 
          ? order.customerLocations[0].locationtype_id 
          : null,
        roomNumber: order.room_number || order.roomNumber || '',
        orderNotes: order.order_notes || order.orderNotes || '',
        
        // Contact
        email: contact.email,
        phone: contact.phone,
        
        // Order metadata
        parentAccountId: details.parent_account_id,
        orderId: order.id,
        createdOn: order.created_on,
        
        // For BASIC connection type
        rxEntries: rxOnlyItems
          .map((item) => ({
            rxNumber: getLabelRxNo(item, labelConnectionId),
            isConsultRequired: item.is_consultrequire
          }))
          .filter((entry) => Boolean(entry.rxNumber))
      };
      
      this.setState({ printLoading: false });
      return labelData;
      
    } catch (error) {
      // Handle specific error types (Test 1.7 - timeout)
      if (error.name === 'AbortError') {
        toast.error(this.props.t('Toast.Error.LabelData.Timeout') || 'Request timed out. Please try again.');
      } else if (error.message && error.message.includes('status')) {
        toast.error(this.props.t('Toast.Error.LabelData.ApiError') || `API Error: ${error.message}`);
      } else {
        toast.error(this.props.t('Toast.Error.LabelData.FetchFailed') || `Failed to fetch label data: ${error.message || error}`);
      }
      
      this.setState({ printLoading: false });
      return null;
    }
  };

  /**
   * Validates that all required fields for label printing are present
   * @param {object} labelData - Label data object
   * @param {string} locationtype_id - Location type ID (optional, for Counter binId validation)
   * @returns {object} { isValid: boolean, missingFields: string[] }
   */
  validateLabelData = (labelData, locationtype_id = null, boxTypeId = null) => {
    const isBinOptionalLocation = isBinOptionalAssignLocation(locationtype_id);
    const isFastlaneGoliath = boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    const isSizeBasedPreAssignment =
      this.state.isSizeBasedPreAssignment ||
      resolveSizeBasedAssignUIFromBox(this.findBoxById(this.state.box_id));
    const isBinOptional = isBinOptionalLocation || isFastlaneGoliath || isSizeBasedPreAssignment;
    
    if (!labelData) {
      return { isValid: false, missingFields: ['labelData is null'] };
    }
    
    const requiredFields = {
      stockCode: labelData.stockCode,
      pickupCode: labelData.pickupCode,
      firstName: labelData.firstName,
      lastName: labelData.lastName,
      dateOfBirth: labelData.dateOfBirth,
      // binId is optional for Counter and Fastlane Goliath
      ...(isBinOptional ? {} : { binId: labelData.binId }),
      rxNumbers: labelData.rxNumbers
    };
    
    // For optional-bin flows, still check binId when present but don't fail when missing
    if (isBinOptional && labelData.binId) {
      requiredFields.binId = labelData.binId;
    }
    
    const missingFields = [];
    
    Object.keys(requiredFields).forEach(field => {
      const value = requiredFields[field];
      if ([undefined, null, '', 'undefined', 'null'].includes(value)) {
        missingFields.push(field);
      } else if (field === 'rxNumbers' && (!Array.isArray(value) || value.length === 0)) {
        missingFields.push('rxNumbers (empty array)');
      }
    });
    
    // For optional-bin flows, remove binId from missingFields if present
    if (isBinOptional && missingFields.includes('binId')) {
      const binIdIndex = missingFields.indexOf('binId');
      if (binIdIndex > -1) {
        missingFields.splice(binIdIndex, 1);
      }
    }
    
    const isValid = missingFields.length === 0;
    
    return { isValid, missingFields };
  };

  /**
   * Opens print dialog with fresh data fetched from database
   * @param {object} serverPrescriptionResponse - Response from /serve/prescription
   */
  handleOpenPrintDialogWithFreshData = async (serverPrescriptionResponse, preservedBinId = null) => {
    const screenFallback = this.captureLabelScreenFallback();
    const { box_id, selectedBinId, locationtype_id } = this.state;
    
    // Extract IDs from response - check multiple possible locations for binId
    const prescription = serverPrescriptionResponse && serverPrescriptionResponse.prescription;
    const order = serverPrescriptionResponse && serverPrescriptionResponse.order;
    const patient = serverPrescriptionResponse && serverPrescriptionResponse.patient;
    
    const pmId =
      (prescription && prescription.id) ||
      (prescription && prescription.pm_id) ||
      (order && order.pm_id) ||
      (patient && patient.pm_id) ||
      this.state.pmid;
    const prescriptionBinId = prescription && prescription.bin_id;
    const orderBinId = order && order.bin_id;
    const patientBinId = patient && patient.bin_id;
    
    // Use preserved binId if provided, otherwise try from response (check multiple locations), then fallback to current state
    let binId = preservedBinId || prescriptionBinId || orderBinId || patientBinId || selectedBinId;
    
    const isBinOptionalLocation = isBinOptionalAssignLocation(locationtype_id);
    const isFastlaneGoliath = this.state.boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    const isSizeBasedPreAssignment =
      this.state.isSizeBasedPreAssignment ||
      resolveSizeBasedAssignUIFromBox(this.findBoxById(box_id));
    const isBinOptionalForFetch =
      isBinOptionalLocation || isFastlaneGoliath || isSizeBasedPreAssignment;
    const binIdForApi = isBinOptionalForFetch && !binId ? null : binId;

    if (!pmId || !box_id) {
      toast.error(
        this.props.t('Toast.Error.LabelData.MissingIds') ||
          'Cannot print: missing order information'
      );
      return false;
    }
    
    // Fetch fresh data from database
    let labelData = await this.fetchOrderDataForPrint(box_id, binIdForApi, pmId);
    
    if (!labelData) {
      toast.error(this.props.t('Toast.Error.LabelData.FetchFailed') || 'Failed to load label data from database');
      return false;
    }

    labelData = this.enrichLabelDataFromAssignContext(
      labelData,
      serverPrescriptionResponse,
      screenFallback
    );
    
    // Validate data - pass locationtype_id so Counter/Bedside/Curbside can have optional binId
    const validation = this.validateLabelData(labelData, locationtype_id, this.state.boxTypeId);
    
    if (!validation.isValid) {
      console.error('Label data validation failed:', validation.missingFields);
      toast.error(
        this.props.t('Toast.Error.LabelData.Incomplete') || 
        `Cannot print: missing ${validation.missingFields.join(', ')}`
      );
      return false;
    }

    this.setState({ pmid: pmId });
    const opened = this.beginLabelPrint(labelData, {
      boxId: box_id,
      delayMs: 1500,
      afterPrint: () => this.handleClosePrintDialog(),
    });
    if (!opened) {
      toast.error(this.props.t('Toast.Error.LabelData.Incomplete') || 'Cannot print: missing stock code');
      return false;
    }
    return true;
  };

  /**
   * Closes print dialog and cleans up state
   */
  handleClosePrintDialog = (closeOptions = {}) => {
    const fromAddAndSave =
      (closeOptions && closeOptions.fromAddAndSave === true) ||
      this.state._printCloseFromAddAndSave === true;
    const fromReprint =
      (closeOptions && closeOptions.fromReprint === true) ||
      this.state._printCloseFromReprint === true;
    this.setState({
      printDialogOpen: false,
      labelDataForPrint: null,
      BrandingName: '',
      BrandingPhone: '',
      loader: false,
      makeFastlaneAPICall: true,
      show_order_notes_dialog: false,
      _printCloseFromAddAndSave: false,
      _printCloseFromReprint: false,
      printNonRxItems: [],
    });
    searchedRxNumbers = [];
    if (!fromAddAndSave && !fromReprint) {
      toast.success(this.props.t('Assign.RxAssignedSuccessfully'));
    }
    if (!fromReprint) {
      this.refreshCurrentBoxAfterClear();
    }
  };

  openPrintDialogFromRxByBin = async (boxId, binId, pmId, options = {}) => {
    const fromAddAndSave = options.fromAddAndSave === true;
    const fromReprint = options.fromReprint === true;
    const { locationtype_id } = this.state;
    const labelData = await this.fetchOrderDataForPrint(
      boxId,
      binId || null,
      pmId,
      options.stockCode || null
    );
    if (!labelData) return;
    const validation = this.validateLabelData(
      labelData,
      locationtype_id,
      this.state.boxTypeId
    );
    if (!validation.isValid) {
      toast.error(
        this.props.t('Toast.Error.LabelData.Incomplete') ||
        `Cannot print: missing ${validation.missingFields.join(', ')}`
      );
      return;
    }
    this.beginLabelPrint(labelData, {
      boxId,
      delayMs: 1500,
      afterPrint: () => this.handleClosePrintDialog({ fromAddAndSave, fromReprint }),
    });
  };

  prepareBasicPayload = async () => {
    const {
      selectedAssignmentBoxId,
      selectedAssignmentBinId,
      phone,
      box_id,
      locationtype_id,
      box_position,
      source_location,
      storage_location,
      room_number,
      orderId,
      address,
      dateOfBirth,
      rxEntries,
      accountDetails,
      stockCode,
      pickupCode,
      searchedItems,
      selectedBox,
      boxTypeId
    } = this.state;
    
    // Fallback for address: use searchedItems or selectedBox if address is not set
    const boxAddress = selectedBox && selectedBox.address;
    const resolvedAddress = address || {
      address1: (searchedItems && searchedItems.AddressLine1) || (boxAddress && boxAddress.address_line_1) || (selectedBox && selectedBox.address_line_1) || '',
      address2: (searchedItems && searchedItems.AddressLine2) || (boxAddress && boxAddress.address_line_2) || (selectedBox && selectedBox.address_line_2) || '',
      city: (searchedItems && searchedItems.City) || (boxAddress && boxAddress.city) || (selectedBox && selectedBox.city) || '',
      state: (searchedItems && searchedItems.State) || (boxAddress && boxAddress.state) || (selectedBox && selectedBox.state) || '',
      zip: (searchedItems && searchedItems.Zip) || (boxAddress && boxAddress.zip) || (selectedBox && selectedBox.zip) || '',
      country: (searchedItems && searchedItems.Country) || (boxAddress && boxAddress.country) || (selectedBox && selectedBox.country) || ''
    };
    
    // Use dialog selections if available
    const assignmentBoxId = selectedAssignmentBoxId || box_id;
    const isKioskGoliathAssignment =
      locationtype_id === LOCATION_TYPE.Kiosk &&
      boxTypeId === BOX_TYPE.FASTLANEGOLIATH;
    // Goliath main unit stays unassigned until stocking; add-on locker bins use selectedBinId.
    const assignmentBinId = isKioskGoliathAssignment
      ? await this.getSelectedBinsByType()
      : (selectedAssignmentBinId || await this.getSelectedBinsByType());
    // Use codes from state - no localStorage
    let codes = {
      stockCode: stockCode || '',
      pickupCode: pickupCode || ''
    };

    let rxItems = rxEntries && rxEntries.map((item) => ({
      rx_no: item.rxNumber,
      drug_name: "",
      ndc_code: "",
      price: 0,
      expires_on: null,
      qty: 0,
      strength: "",
      route: "",
      doseage_form: "",
      non_proprietary_name: "",
      fillNumber: 0,
      is_consultrequire: item.isConsultRequired,
      is_returnable: false,
      prescriptionnumber: "",
      order_id: "",
      prescription_txn_id: "",
      pucode: codes.pickupCode,
      SeqNumber: 0,
      dateFilled: 0,
      partialfillseqnum: 0
    }));

    return {
      first_name: accountDetails.basic_first_name || 'iLocal',
      middle_name: '',
      last_name: accountDetails.basic_last_name || 'Box',
      dob: dateOfBirth,
      phone: this.state.notifyChannel === 'email' ? '' : phone,
      email: this.state.notifyChannel === 'email' ? (this.state.EmailID || '') : '',
      notify_channel: this.state.notifyChannel === 'email' ? 'email' : 'sms',
      parent_box_id: assignmentBoxId,
      patient_id: this.state.notifyChannel === 'email'
        ? String(this.state.EmailID || '').trim()
        : (phone && phone.replace(/\D/g, '')),
      locationtype_id: locationtype_id,
      address1: resolvedAddress.address1,
      address2: resolvedAddress.address2,
      city: resolvedAddress.city,
      state: resolvedAddress.state,
      zip: resolvedAddress.zip,
      country: resolvedAddress.country,
      location_notes: '',
      is_future_release: false,
      future_release_date: null,
      notes: '',
      alternateAgents: [],
      prescription: {
        bin_id: assignmentBinId,
        type_id: locationtype_id === LOCATION_TYPE.Kiosk ? assignmentstatus.ASSIGNED : DEVICE_TYPE.Ready,
        stock_code: codes.stockCode,
        pucode: codes.pickupCode,
        box_id: assignmentBoxId,
        box_position: box_position,
        locationtype_id: locationtype_id,
        source_location: source_location,
        storage_location: storage_location,
        room_number: locationtype_id === LOCATION_TYPE.Bedside ? room_number : '',
        order_notes: '',
        location_notes: '',
        order_id: orderId,
        courier_type: '',
        tracking_number: '',
        iscool_item: false,
        items: rxItems,
        is_controlled_substance: false,
        assign_order_notes: ""
      },
    };
  };
  prepareServerPrescrptionReqPayload = async () => {
    const {
      accountDetails,
      EmailID,
      phone,
      searchedItems,
      box_id,
      locationtype_id,
      boxTypeId,
      box_position,
      source_location,
      storage_location,
      room_number,
      locationData,
      order_notes,
      orderId,
      default_courier_selected,
      courier_tracking,
      isSelectedFlag,
      FutureRelease,
      FutureReleaseDate,
      alternateAgents,
      assign_order_notes,
      stockCode,
      pickupCode,
      selectedBinSize,
    } = this.state;

    // Goliath main unit stays unassigned until stocking; add-on locker bins use selectedBinId.
    const assignmentBinId = await this.getSelectedBinsByType();
    const assignmentBoxId = box_id; // Always use main box_id for hardware access
    
    // Determine is_fastlane: false if bin is from add-on (letter+number pattern), true if Fastlane
    let isFastlaneAssignment = true; // Default to true for Fastlane
    const isAddOnBinId = assignmentBinId && this.isAddOnBin(assignmentBinId);
    console.log('🔍 Determining isFastlane flag:', {
      assignmentBinId,
      assignmentBinIdType: typeof assignmentBinId,
      isAddOnBinId,
      boxTypeId,
      locationtype_id
    });
    
    if (isAddOnBinId) {
      isFastlaneAssignment = false; // Add-on/locker assignment
      console.log('✅ Setting isFastlane = false (add-on bin detected)');
    } else if (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) {
      isFastlaneAssignment = true; // Fastlane assignment
      console.log('✅ Setting isFastlane = true (Fastlane assignment)');
    } else if (boxTypeId === BOX_TYPE.FASTLANEGOLIATH && locationtype_id === LOCATION_TYPE.Kiosk) {
      isFastlaneAssignment = !isAddOnBinId;
      console.log(
        isAddOnBinId
          ? '✅ Setting isFastlane = false (Goliath add-on locker bin)'
          : '✅ Setting isFastlane = true (Goliath main unit; bin assigned at stocking)',
      );
    } else {
      isFastlaneAssignment = false; // Non-Fastlane assignment
      console.log('✅ Setting isFastlane = false (non-Fastlane)');
    }
    // Use codes from state - no localStorage
    let codes = {
      stockCode: stockCode || '',
      pickupCode: pickupCode || ''
    };
    
    const payload = {
      first_name: searchedItems.FirstName,
      middle_name: searchedItems.MiddleName,
      last_name: searchedItems.LastName,
      dob: searchedItems.DateOfBirth,
      phone:
        usesOrderStagingAssignFlow(accountDetails.connection.id)
          ? '1234567890'
          : phone,
      email:
        usesOrderStagingAssignFlow(accountDetails.connection.id)
          ? 'na@ilocalbox.com'
          : EmailID,
      parent_box_id: box_id,
      patient_id: searchedItems.PatientID,
      locationtype_id: this.state.locationtype_id,
      address1: searchedItems.AddressLine1,
      address2: searchedItems.AddressLine2,
      city: searchedItems.City,
      state: searchedItems.State,
      zip: searchedItems.Zip,
      country: searchedItems.Country,
      location_notes: searchedItems.location_notes,
      is_future_release: FutureRelease,
      future_release_date: FutureReleaseDate,
      notes: this.state.patientNotes,
      bin_size: selectedBinSize,
      alternateAgents: alternateAgents,
      prescription: {
        bin_id: assignmentBinId,
        type_id:
          locationtype_id === LOCATION_TYPE.Kiosk
            ? assignmentstatus.ASSIGNED
            : DEVICE_TYPE.Ready,
        stock_code: codes.stockCode,
        pucode: codes.pickupCode,
        box_id: assignmentBoxId,
        box_position: box_position,
        locationtype_id: locationtype_id,
        source_location: source_location,
        storage_location: usesCounterAssignShell(locationtype_id) && locationData && locationData.location
          ? locationData.location
          : storage_location,
        room_number: locationtype_id === LOCATION_TYPE.Bedside ? room_number : '',
        order_notes: order_notes,
        location_notes: searchedItems.location_notes,
        order_id: orderId,
        courier_type: default_courier_selected,
        tracking_number: courier_tracking,
        iscool_item: isSelectedFlag,
        items: await this.prepareReqPayloadForPrescriptionItems(),
        is_controlled_substance: getOrderControlledSubstanceFromCart(),
        assign_order_notes,
        is_fastlane: isFastlaneAssignment, // Flag to distinguish Fastlane assignment (true) from locker/add-on assignment (false)
        custom_note_id: this.state.customNote && this.state.customNote.id,
        custom_note_text: this.state.customNote && this.state.customNote.text,
        custom_note_source: this.state.customNote && this.state.customNote.source,
      },
    };
    
    console.log('📤 Final payload is_fastlane value:', {
      is_fastlane: isFastlaneAssignment,
      assignmentBinId,
      isAddOnBin: this.isAddOnBin(assignmentBinId)
    });
    
    return payload;
  };

  prepareReqPayloadForPrescriptionItems = async () => {
    const { accountDetails, pickupCode } = this.state;
    this.getCartRxNumbers();
    let _prescriptionItemsList = [];

    if (searchedRxItems.length > 0) {
      for (let item = 0; item < searchedRxItems.length; item++) {
        let _singleItem = searchedRxItems[item];
        let rxNo = '';
        if (accountDetails.connection.id === CONNECTION_TYPE.QS1) {
          let rx = _singleItem.rxNo.substring(0, 1);
          if ((rx === 0 || rx === '0') && _singleItem.rxNo.length > 8) {
            rxNo = _singleItem.rxNo.substring(1, _singleItem.rxNo.length);
          } else {
            rxNo = _singleItem.rxNo;
          }
        } else if (accountDetails.connection.id === CONNECTION_TYPE.THIRD_PARTY) {
          rxNo = _singleItem.id
        } else {
          rxNo = _singleItem.rxNo;
        }
        _prescriptionItemsList.push({
          rx_no: rxNo,
          drug_name: _singleItem.name || _singleItem.drug_name,
          ndc_code: _singleItem.ndcCode,
          price: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.CoPayAmount || _singleItem.amount_due
          )
            ? 0
            : _singleItem.CoPayAmount || _singleItem.amount_due,
          expires_on: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.ExpirationDate
          )
            ? '01/01/2020'
            : _singleItem.ExpirationDate,
          qty: _singleItem.qty || _singleItem.dispensed_qty,
          strength: _singleItem.strength,
          route: _singleItem.route,
          doseage_form: _singleItem.doseage_form,
          non_proprietary_name: _singleItem.non_proprietary_name,
          fillNumber: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.fillNumber || _singleItem.fillnumber
          )
            ? 0
            : _singleItem.fillNumber || _singleItem.fillnumber,
          is_consultrequire: (() => {
            const resolved = determineConsultRequire(
              [undefined, "undefined", null, "null", ""].includes(
                _singleItem.ConsultRequire
              )
                ? false
                : _singleItem.ConsultRequire,
              isItemControlledSubstance(_singleItem),
              this.state.locationtype_id,
              isBypassConsultEnabled(this.state.accountDetails),
              _singleItem.consultRequireManual === true
            );
            const rxKey = String(_singleItem.rxNo || _singleItem.rx_no || '').toUpperCase();
            if (process.env.NODE_ENV !== 'production' && rxKey.startsWith('A55')) {
              console.log('[A55 Demo] prepareReqPayload consult', {
                rxNo: rxKey,
                ConsultRequire: _singleItem.ConsultRequire,
                consultRequireManual: _singleItem.consultRequireManual,
                is_controlled_substance: _singleItem.is_controlled_substance,
                locationtype_id: this.state.locationtype_id,
                bypass_consult:
                  this.state.accountDetails &&
                  this.state.accountDetails.bypass_consult,
                resolved_is_consultrequire: resolved,
              });
            }
            return resolved;
          })(),
          is_returnable: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.IsReturnable)
            ? false
            : _singleItem.IsReturnable,
          is_controlledsubstances: isItemControlledSubstance(_singleItem),
          dea_schedule: (() => {
            const candidates = [
              _singleItem.dea_schedule,
              _singleItem.DEACodeNumber,
              _singleItem.DrugSchedule,
              _singleItem.drugSchedule,
              _singleItem.schedule,
            ];
            const connectionId =
              accountDetails &&
              accountDetails.connection &&
              accountDetails.connection.id;
            const isQs1 = connectionId === CONNECTION_TYPE.QS1;
            const isLiberty = connectionId === CONNECTION_TYPE.LIBERTY_SOFTWARE;
            for (let c = 0; c < candidates.length; c++) {
              const raw = candidates[c];
              if ([undefined, 'undefined', null, 'null', ''].includes(raw)) {
                continue;
              }
              const normalized = String(raw).trim();
              if (isQs1 || isLiberty) {
                // QS1/Liberty: keep original numeric ("5", "02") or alphanumeric ("3C", "C2N")
                const stored = isLiberty
                  ? sanitizeLibertyDrugScheduleForStorage(normalized)
                  : sanitizeQs1DrugScheduleForStorage(normalized);
                if (stored != null) {
                  return stored;
                }
                continue;
              }
              // Other PMS: only persist bare numeric DEA class values
              if (['2', '3', '4', '5', '1'].includes(normalized)) {
                return normalized;
              }
            }
            return null;
          })(),
          prescriptionnumber: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.prescriptionNumber)
            ? ''
            : _singleItem.prescriptionNumber,
          order_id: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.order_id
          )
            ? ''
            : _singleItem.order_id,
          prescription_txn_id: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.prescription_txn_id)
            ? ''
            : _singleItem.prescription_txn_id,
          pucode: pickupCode,
          SeqNumber: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.SeqNumber
          )
            ? 0
            : _singleItem.SeqNumber,
          dateFilled: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.dateFilled
          )
            ? 0
            : _singleItem.dateFilled,
          partialfillseqnum: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.partialfillseqnum)
            ? 0
            : _singleItem.partialfillseqnum,
          tax_amount: [undefined, 'undefined', null, 'null', '', '0', 0].includes(_singleItem.tax_amount)
            ? 0
            : (typeof _singleItem.tax_amount === 'string' ? parseFloat(_singleItem.tax_amount) : _singleItem.tax_amount),
          store_number: _singleItem.StoreNumber,
          // Epic Flags & Status Information - Single JSON object containing all flag data
          epic_flag_response: (() => {
            // Build epic_flag_response object only if any flag data exists
            const hasFlags = _singleItem.Flags && Array.isArray(_singleItem.Flags) && _singleItem.Flags.length > 0;
            const hasPrescriptionFlags = _singleItem.PrescriptionFlags && Array.isArray(_singleItem.PrescriptionFlags) && _singleItem.PrescriptionFlags.length > 0;
            const hasCannotDispenseReasons = _singleItem.CannotDispenseReasons && Array.isArray(_singleItem.CannotDispenseReasons) && _singleItem.CannotDispenseReasons.length > 0;
            const hasIsDispensable = _singleItem.IsDispensable !== undefined && _singleItem.IsDispensable !== null;
            const hasReasonNotFillable = _singleItem.ReasonNotFillable !== undefined && _singleItem.ReasonNotFillable !== null && _singleItem.ReasonNotFillable !== '' && _singleItem.ReasonNotFillable !== 'null';
            const hasFillStatus = _singleItem.status !== undefined && _singleItem.status !== null && _singleItem.status !== '' && _singleItem.status !== 'null';

            // Only create object if at least one field has data
            if (hasFlags || hasPrescriptionFlags || hasCannotDispenseReasons || hasIsDispensable || hasReasonNotFillable || hasFillStatus) {
              return {
                flags: hasFlags ? _singleItem.Flags : [],
                prescription_flags: hasPrescriptionFlags ? _singleItem.PrescriptionFlags : [],
                cannot_dispense_reasons: hasCannotDispenseReasons ? _singleItem.CannotDispenseReasons : [],
                is_dispensable: hasIsDispensable ? _singleItem.IsDispensable : null,
                reason_not_fillable: hasReasonNotFillable ? _singleItem.ReasonNotFillable : null,
                fill_status: hasFillStatus ? _singleItem.status : null
              };
            }
            return null;
          })(),
        });
      }
    }

    const nonRxItems = this.state.nonRxCartItems || [];
    if (this.isNonRxDeliverEnabled() && nonRxItems.length > 0) {
      for (let i = 0; i < nonRxItems.length; i++) {
        const nonRxItem = nonRxItems[i];
        _prescriptionItemsList.push({
          is_non_rx: true,
          item_number: (nonRxItem.item_number || '').toString().trim(),
          drug_name: (nonRxItem.description || '').toString().trim(),
          price: [undefined, 'undefined', null, 'null', ''].includes(nonRxItem.price)
            ? 0
            : parseFloat(nonRxItem.price),
          qty: parseFloat(nonRxItem.qty) || 1,
          tax_amount: parseFloat(nonRxItem.tax_amount) || 0,
          upc: (nonRxItem.upc || '').toString().trim() || null,
          uom: (nonRxItem.uom || '').toString().trim() || null,
          non_rx_product_id: nonRxItem.non_rx_product_id || null,
          image_url: (nonRxItem.image_url || '').toString().trim() || null,
        });
      }
    }
    return _prescriptionItemsList;
  };

  checkPrescriptionStatus = async () => {
    const {
      accountDetails,
      isEpicHasValidRx,
      selectedBinId,
      box_id,
    } = this.state;
    if (![undefined, 'undefined', null, 'null', ''].includes(selectedBinId)) {
      if (this.hasCartItems()) {
        let obj = {
          bin_id: selectedBinId,
          box_id: box_id,
          account_id: accountDetails && accountDetails.id,
        };
        let codes = {
          stockCode: this.state.stockCode,
          pickupCode: this.state.pickupCode,
        };
        await this.checkIfCodesExists(codes);
        fetch(process.env.REACT_APP_BASEURL + 'prescription/status/check', {
          crossDomain: true,
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
          },
          body: JSON.stringify(obj),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then((res) => {
            if (
              (res && res.statusCode === 200) ||
              (res && res.statusCode === 404)
            ) {
              const hasRxItems = searchedRxItems && searchedRxItems.length > 0;
              if (
                hasRxItems &&
                accountDetails.connection.id === CONNECTION_TYPE.EPIC &&
                isEpicHasValidRx === false
              ) {
                toast.error(this.props.t('Toast.Error.PrescriptionStatusVerified')
                );
                this.setState({ loader: false });
                return;
              }
              if (
                hasRxItems &&
                accountDetails.connection.id === CONNECTION_TYPE.EPIC_WITH_MTLS &&
                isEpicHasValidRx === false
              ) {
                toast.error(this.props.t('Toast.Error.PrescriptionStatusVerified')
                );
                this.setState({ loader: false });
                return;
              }
              if (hasRxItems && usesOrderStagingAssignFlow(accountDetails.connection.id)) {
                let orderIds = [];
                let prescriptionNumbers = [];
                for (let i = 0; i < searchedRxItems.length; i++) {
                  orderIds.push(searchedRxItems[i].order_id);
                  prescriptionNumbers.push(
                    searchedRxItems[i].prescriptionNumber ||
                    searchedRxItems[i].prescriptionnumber ||
                    ''
                  );
                }
                this.setState({
                  orderIds: orderIds,
                  prescriptionIds: prescriptionNumbers,
                });
              }
              if (hasRxItems && accountDetails.connection.id === CONNECTION_TYPE.LIBERTY_SOFTWARE &&
                isEpicHasValidRx === false) {
                toast.error(this.props.t('Toast.Error.LibertyStatus'));
                this.setState({ loader: false });
                return;
              }
            } else {
              this.setState({
                isVerifyingBin: true,
                loader: false,
                isVerifyingBinMessage:
                  'This bin is currently unavailable, please select another bin.',
              });
            }
          }).catch(() => {
            this.setState({ loader: false });
          });
      }
    }
  };

  handleRxCheck = async (event, pmsType) => {
    if (event.keyCode === 13) {
      const { globalAccountConnection, rxNumber } = this.state;
      let searchedString = event.target.value;
      let originalRxNumber = '';
      let RxTobeValid;
      let is_drx_lookup = false
      if (pmsType === 'PIONEERRX') {
        RxTobeValid = this.normalizePioneerRxNumber(searchedString);
        searchedString = RxTobeValid;
        originalRxNumber = RxTobeValid || rxNumber;
      }
      if (pmsType === 'MCKESSONERX') {
        const rxToValidate = this.parseMcKessonRxNumber(searchedString, globalAccountConnection);
        searchedString = rxToValidate.rxNumber
        originalRxNumber = rxNumber;
      }
      if (pmsType === 'LIBERTYSOFTWARE') {
        searchedString = this.parseLibertyRxNumber(searchedString, globalAccountConnection.liberty_rx_regrx)._scriptNumber;
        originalRxNumber = rxNumber;
      }
      if(pmsType === 'EPIC' || pmsType === 'Epic With MTLS') {
        // Store the original scanned value BEFORE parsing
        originalRxNumber = event.target.value;

        const parsedResponse = await this.parseEpicLabel(searchedString);
        if (parsedResponse && parsedResponse.regexMiss) {
          toast.error(this.props.t('Toast.Error.EpicRegexMiss'));
          this.setState({ rxNumber: '', loader: false });
          return;
        }
        const rxValue = parsedResponse && parsedResponse.prescriptionNumber;
        searchedString = Array.isArray(rxValue) ? rxValue[0] : rxValue;
      }
      if(pmsType === 'DRX') {
        is_drx_lookup = true;
        originalRxNumber = rxNumber;
      }
      this.setState({ scannedRxScript: searchedString, originalScannedScript: originalRxNumber})
      if (![undefined, 'undefined', null, 'null', ''].includes(searchedString)) {
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + 'checkrxexistornot/' + searchedString + '/' + is_drx_lookup, {
          method: 'GET',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
        }).then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        }).then((res) => {
          this.setState({ selectedPMSType: pmsType, loader: false });
          if ([true, "true"].includes(res && res.Rx_Is_Exist)) {
            this.setState({ confirmPMSDialogOpen: true });
          } else {
            this.handlePMSDialogYesEvent();
          }
          return res && res.Rx_Is_Exist;
        }).catch(() => {
          this.setState({ loader: false });
        })
      }
    }
  }

  handlePMSDialogYesEvent = () => {
    const { selectedPMSType } = this.state;
    this.setState({ confirmPMSDialogOpen: false });
    switch (selectedPMSType) {
      case 'QS1':
        this.handleQS1KeyDown();
        break;
      case 'PIONEERRX':
        this.handlePioneerKeyDown();
        break;
      case 'LIBERTYSOFTWARE':
        this.handleLibertySoftwareKeyDown()
        break;
      case 'MCKESSONERX':
        this.handleMcKessonRxKeyDown()
        break;
      case 'EPIC':
        this.handleEpicKeyDown()
        break;
      case 'Epic With MTLS': 
        this.handleEpicWithmTLSKeyDown()
        break;
      case 'DRX':
        this.handleDRXKeyDown()
        break;
      default:
        break;
    }
  }

  handlePMSDialogNoEvent = () => {
    this.setState({
      rxNumber: '',
      loader: false,
      confirmPMSDialogOpen: false
    });
    this.handleFocus();
  }

  handleLibertySoftwareKeyDown = () => {
    const { originalScannedScript } = this.state;
    let searchedString = originalScannedScript;
    this.setState({ loader: true, isEdit: false, confirmPMSDialogOpen: false });
    fetch(`${process.env.REACT_APP_BASEURL}liberty-software/GetPrescriptionByScriptNumber/${searchedString}`, {
      crossDomain: true,
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession
            .idToken.jwtToken,
      }
    }).then((response) => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then((res) => {
      console.log(res);
      this.setState({ loader: false, isEdit: false });
      if (res && res !== '') {
        let patientDetails = res.patient;
        let rxDetails = res.prescription;
        this.setState({ loader: false });
        if (
          rxDetails !== undefined &&
          rxDetails !== 'undefined' &&
          rxDetails !== null &&
          rxDetails !== 'null' &&
          rxDetails !== ''
        ) {
          if (['PickedUp', 'Shipped'].includes(rxDetails.StatusCode)) {
            this.setState({
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: `The status of Rx: ${searchedString} is ${rxDetails.StatusCode}.`,
              rxNumber: '',
            });
          }
        }
        if (rxDetails === undefined || rxDetails === 'undefined') {
          toast.error(res.errorMessage);
          this.setState({
            rxNumber: '',
          });
          return;
        }
        // Liberty: derive controlled + dea_schedule from schedule ("5", "05", etc.)
        const libertySchedule =
          rxDetails.schedule ||
          rxDetails.dea_schedule ||
          rxDetails.drugSchedule;
        const libertyControlled = isLibertyDrugScheduleControlled(libertySchedule);
        rxDetails.dea_schedule =
          sanitizeLibertyDrugScheduleForStorage(libertySchedule) ||
          rxDetails.dea_schedule ||
          null;
        rxDetails.is_controlled_substance =
          libertyControlled ||
          isAssignFlagTrue(rxDetails.is_controlled_substance);
        rxDetails = normalizeCartItemControlledSubstance(rxDetails);
        const existingItem = this.state.searchedItems;
        if (
          existingItem &&
          searchedRxItems &&
          searchedRxItems.length > 0
        ) {
          let isexist = searchedRxItems.findIndex(
            (x) => x.rxNo === searchedString
          );
          if (existingItem.PatientID === patientDetails.patientID) {
            if (isexist < 0) {
              // Respect account-level bypass_consult flag for Liberty prescriptions
              console.log("accountDetails", this.state.accountDetails);
              if (
                this.state.accountDetails &&
                [true, "true"].includes(this.state.accountDetails.bypass_consult)
              ) {
                rxDetails.ConsultRequire = false;
              }
              searchedRxItems.push(rxDetails);
              if (
                patientDetails.email !== '' &&
                patientDetails.email !== undefined &&
                patientDetails.email !== 'undefined' &&
                patientDetails.email !== 'null' &&
                patientDetails.email !== 'null'
              ) {
                this.checkADACompatible(
                  patientDetails.patientID,
                  patientDetails.email
                );
              }
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'LIBERTYSOFTWARE'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
                is_controlled_substance: getOrderControlledSubstanceFromCart(),
              });
            } else {
              toast.error(this.props.t('Toast.Error.RxAddedToCart'));
              this.setState({
                rxNumber: '',
              });
            }
          } else {
            toast.error(this.props.t('Toast.Error.WrongPatient'));
            this.setState({
              rxNumber: '',
            });
          }
        } else {
          // First Liberty script for this patient in the cart.
          // Respect account-level bypass_consult flag here as well.
          if (
            this.state.accountDetails &&
            [true, "true"].includes(this.state.accountDetails.bypass_consult)
          ) {
            rxDetails.ConsultRequire = false;
          }
          searchedRxItems.push(rxDetails);
          if (
            patientDetails.email !== null &&
            patientDetails.email !== 'null' &&
            patientDetails.email !== undefined &&
            patientDetails.email !== 'undefined' &&
            patientDetails.email !== ''
          ) {
            this.checkADACompatible(
              patientDetails.patientID,
              patientDetails.email
            );
          }
          this.getcustomerLocation(
            patientDetails,
            searchedRxItems,
            'LIBERTYSOFTWARE'
          );
          this.forceUpdate();
          this.setState({
            EmailID: patientDetails.emailAddress || patientDetails.email,
            phone: patientDetails.primaryPhone || patientDetails.phone,
            rxNumber: '',
            is_controlled_substance: getOrderControlledSubstanceFromCart(),
          });
        }
      }
    }).catch((error) => {
      this.setState({
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: error && error.message + '. Looks like server is unable to featch requested data. Please try again or contact to administrator!',
        rxNumber: '',
        loader: false,
        confirmPMSDialogOpen: false
      });
    });
  }

  handleLibertySoftwareChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  }

  handleThirdPartyRxCheck = async (event, pmsType) => {
    if (event.keyCode === 13) {
      let searchedString = event.target.value;
      this.setState({ scannedRxScript: searchedString, originalScannedScript: event.target.value, loader: true })
      if (![undefined, 'undefined', null, 'null', ''].includes(searchedString)) {
        this.setState({ loader: true });
        const obj = {
          prescription_number: searchedString,
          parent_account_id: this.state.globalAccountConnection.id
        }
        fetch(process.env.REACT_APP_BASEURL + `api/v1/subscriptions/prescriptionManagement/getPrescriptionByRx`, {
          method: 'POST',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
          body: JSON.stringify(obj)
        }).then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        }).then((res) => {
          const data = res.data;
          this.setState({ selectedPMSType: pmsType, loader: false });
          if ([true, "true"].includes(res && res.Rx_Is_Exist)) {
            const existingItem = this.state.searchedItems;
            const existingPatientID = existingItem && !Array.isArray(existingItem) ? existingItem.PatientID : null;
            const newPatientID = data[0] && data[0].patient_id ? String(data[0].patient_id).trim() : null;
            
            // Check if this is the first scan (no existing patient) or same patient
            const isFirstScan = !existingPatientID || 
                                Array.isArray(existingItem) || 
                                (existingItem && Object.keys(existingItem).length === 0);
            const isSamePatient = existingPatientID && newPatientID && 
                                 String(existingPatientID).trim() === newPatientID;
            
            if (isFirstScan || isSamePatient) {
              // First scan or same patient - check if prescription already exists
              let sameRx = searchedRxItems.findIndex((x) => 
                (x.prescriptionNumber && data[0].prescriptionNumber && 
                 String(x.prescriptionNumber).trim() === String(data[0].prescriptionNumber).trim()) ||
                (x.id && data[0].id && 
                 String(x.id).trim() === String(data[0].id).trim())
              );
              
              if (sameRx < 0) {
                // Add new prescription to the array
                if (isFirstScan) {
                  searchedRxItems = data;
                } else {
                  searchedRxItems.push(data[0]);
                }
                
                this.setState({
                  EmailID: data[0].email,
                  phone: data[0].sms_phone,
                  searchedItems: {
                    FirstName: data[0].first_name,
                    LastName: data[0].last_name,
                    notes: '',
                    AddressLine1: data[0].address_line_1,
                    AddressLine2: data[0].address_line_2,
                    DateOfBirth: data[0].dob,
                    City: data[0].city,
                    State: data[0].state,
                    Zip: data[0].zip,
                    Country: '',
                    PatientID: data[0].patient_id,
                    customer_id: data[0].customer_id || data[0].customerId,
                  },
                  rxNumber: ''
                })
              } else {
                toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                this.setState({ rxNumber: '' });
              }
            } else {
              // Different patient - show error
              toast.error(this.props.t('Toast.Error.WrongPatient'));
              this.setState({ rxNumber: '' });
            }
          } else {
            toast.error(res.message);
            this.setState({ rxNumber: '' });
          }
        }).catch(() => {
          this.setState({ rxNumber: '', loader: false });
        })
      }
    }
  }

  handleThirdPartyChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      }
    );
  }

  parseLibertyRxNumber = (scriptNumber, customRegexp) => {
    console.log(customRegexp);
    let _scriptNumber = null, _refillNumber = null;
    if (!customRegexp || typeof scriptNumber !== 'string') {
        return { _scriptNumber: null, _refillNumber: null };
    }
    const cleanScriptNumber = scriptNumber.trim();
    try {
        const customPattern = new RegExp(customRegexp, 'i');
        const customMatch = cleanScriptNumber.match(customPattern);
        if (customMatch && customMatch.length >= 3) {
            _scriptNumber = customMatch[1];
            _refillNumber = customMatch[2];
        }
    } catch (error) {
        console.warn('Invalid custom regex pattern from database:', customRegexp, error && error.message);
    }
    return { _scriptNumber, _refillNumber };
  }

  fetchFastlaneBinWithRetry = async (retryCount = 0, saveMode = null) => {
    const { box_id, fastlaneBinMaxRetries } = this.state;
    const { t } = this.props;
    
    try {
      const response = await fetch(
        process.env.REACT_APP_BASEURL + `fastlane/matrix?boxId=${box_id}&status=All&tableName=&sortColumn=created_on&sortOrder=desc`,
        {
          method: 'get',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      );
      
      const data = await response.json();
      const binId = data && data.data && data.data.YourPosition;
      
      if (![undefined, "undefined", null, "null", "", 0].includes(binId) && !isNaN(binId)) {
        // Store in state instead of localStorage
        console.log('✅ Fastlane - Bin position from retry function:', binId);
        this.setState({ 
          fastlaneBinId: binId,
          isFastlaneRetrying: false, 
          fastlaneBinRetryCount: 0,
          fastlaneRetryMessage: '',
          fastlaneBinFetchError: false
        });
        return parseInt(binId, 10);
      } else {
        console.error('Invalid bin ID received from API:', binId);
        return null;
      }
    } catch (error) {
      console.error(`Fastlane bin fetch attempt ${retryCount + 1} failed:`, error);
      
      if (retryCount < fastlaneBinMaxRetries - 1) {
        this.setState({
          fastlaneBinRetryCount: retryCount + 1,
          fastlaneRetryMessage: t('Assign.Fastlane.RetryingAttempt', { 
            attempt: retryCount + 2, 
            total: fastlaneBinMaxRetries 
          })
        });
        
        await new Promise(resolve => setTimeout(resolve, 1000));
        return await this.fetchFastlaneBinWithRetry(retryCount + 1, saveMode);
      } else {
        this.setState({ 
          isFastlaneRetrying: false, 
          fastlaneBinRetryCount: 0,
          fastlaneRetryMessage: '',
          fastlaneBinFetchError: true,
          pendingSaveMode: saveMode,
          loader: false
        });
        return null;
      }
    }
  };

  handleFastlaneBinPositionUpdate = (position) => {
    if ([undefined, 'undefined', null, 'null', '', 0].includes(position)) {
      return;
    }

    this.setState((prevState) => {
      if (prevState.fastlaneBinId === position) {
        return null;
      }

      return { fastlaneBinId: position };
    });
  };
  getSelectedBinsByType = async (saveMode = null) => {
    const { boxTypeId, locationtype_id, selectedBinId, fastlaneBinId, storage_location } = this.state;
    let binIds = "";
    
    if (
      boxTypeId === BOX_TYPE.FASTLANE &&
      locationtype_id === LOCATION_TYPE.Kiosk
    ) {
      // For Fastlane: 
      // If user selected a bin (from add-on or anywhere), use it
      // Otherwise, use fastlaneBinId (Your position) for normal Fastlane flow
      if (selectedBinId && ![undefined, 'undefined', null, 'null', ''].includes(selectedBinId)) {
        binIds = selectedBinId;
        console.log('📦 Fastlane - Using selected bin:', binIds, this.isAddOnBin(selectedBinId) ? '(add-on)' : '(fastlane)');
      } else if (fastlaneBinId && ![undefined, "undefined", null, "null", "", 0].includes(fastlaneBinId)) {
        binIds = fastlaneBinId;
        console.log('📦 Fastlane - Using fastlaneBinId (Your position):', binIds);
      }
      
      if ([undefined, "undefined", null, "null", "", 0].includes(binIds)) {
        console.warn("Fastlane bin ID not available. Attempting to fetch with retry...");
        this.setState({ 
          isFastlaneRetrying: true,
          fastlaneRetryMessage: this.props.t('Assign.Fastlane.FetchingAttempt', { 
            attempt: 1, 
            total: this.state.fastlaneBinMaxRetries 
          })
        });
        
        binIds = await this.fetchFastlaneBinWithRetry(0, saveMode);
        
        if ([undefined, "undefined", null, "null", "", 0].includes(binIds)) {
          console.error("Fastlane bin ID is invalid or empty after retries. Cannot proceed with assignment.");
          return null;
        }
      }
    } else if (
      boxTypeId === BOX_TYPE.FASTLANEGOLIATH &&
      locationtype_id === LOCATION_TYPE.Kiosk
    ) {
      // For Goliath, do not fetch next/available bin at assignment time.
      // Keep it null (or explicit selected add-on bin when provided).
      binIds =
        selectedBinId && ![undefined, 'undefined', null, 'null', ''].includes(selectedBinId)
          ? selectedBinId
          : null;
    } else {
      // For non-Fastlane Kiosk: use selectedBinId
      // For Counter: use storage_location as bin_id to preserve existing single-use behavior.
      // For Bedside: keep the mapped location in storage_location only, so reusable locations
      // do not collide with the physical bin uniqueness constraint.
      // For other location types: return null
      if (locationtype_id === LOCATION_TYPE.Kiosk) {
        binIds = this.state.isSizeBasedPreAssignment
          ? selectedBinId || null
          : selectedBinId;
      } else if (locationtype_id === LOCATION_TYPE.Counter) {
        binIds = storage_location && storage_location !== "" ? storage_location : null;
      } else if (isReusableStorageLocationType(locationtype_id)) {
        binIds = null;
      } else {
        binIds = null;
      }
    }
    return binIds;
  };

  getAccountAndPatientIdByPhiType = (typeOfPhi, patient) => {
    let obj;
    if (typeOfPhi === 'Epic') {
      obj = {
        patientID: patient.MedicalRecordNumber,
        accountID: this.state.accountDetails.id,
      }
    } else if (typeOfPhi === 'Epic With MTLS') {
      obj = {
        patientID: patient.MedicalRecordNumber,
        accountID: this.state.accountDetails.id,
      }
    } else if (typeOfPhi === 'MScripts') {
      obj = {
        patientID: patient.PatientID || patient.patient_id || patient.patientID,
        accountID: patient.parent_account_id,
      }
    } else if (typeOfPhi === 'McKesson') {
      obj = {
        patientID: patient && patient.ExternalPatientID,
        accountID: this.state && this.state.globalAccountConnection.id,
      };
    }  else if (typeOfPhi === PARTNER_INTEGRATION_ASSIGN_PHI_TYPE) {
      obj = {
        patientID: patient.PatientID || patient.patient_id || patient.patientID,
        accountID: patient.parent_account_id,
      }
    } else {
      obj = {
        patientID: patient.PatientID || patient.patient_id || patient.patientID,
        accountID: this.state.globalAccountConnection.id,
      };
    }
    return obj;
  }

  handleFastlaneBinErrorRetry = () => {
    const { pendingSaveMode, fastlaneBinMaxRetries } = this.state;
    this.setState({ 
      fastlaneBinFetchError: false,
      isFastlaneRetrying: true,
      fastlaneRetryMessage: this.props.t('Assign.Fastlane.FetchingAttempt', { 
        attempt: 1, 
        total: fastlaneBinMaxRetries 
      }),
      fastlaneBinRetryCount: 0
    });
    
    if (pendingSaveMode !== null) {
      this.checkIfFastlaneBinIdIsExistOrNot(pendingSaveMode);
    }
  };

  fetchFastlaneBinForValidationWithRetry = async (retryCount = 0, options = {}) => {
    const { keepLoader = false, shouldTriggerAutoAssign = true } = options;
    const { box_id, fastlaneBinMaxRetries, pendingSaveMode, boxTypeId } = this.state;
    const { t } = this.props;

    if (boxTypeId === BOX_TYPE.FASTLANEGOLIATH) {
      // Goliath: do not fetch/use next available bin from matrix.
      this.setState({
        isFastlaneRetrying: false,
        fastlaneBinRetryCount: 0,
        fastlaneRetryMessage: '',
        ...(keepLoader ? {} : { loader: false }),
      });
      return null;
    }
    
    try {
      let URL = process.env.REACT_APP_BASEURL + `fastlane/matrix?boxId=${box_id}&status=All&tableName=&sortColumn=created_on&sortOrder=desc`;
      const response = await fetch(
        URL,
        {
          method: 'get',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      );
      
      const data = await response.json();
      const binId = data && data.data && data.data.YourPosition;
      
      if (![undefined, "undefined", null, "null", "", 0].includes(binId) && !isNaN(binId)) {
        // Store in state instead of localStorage
        console.log('✅ Fastlane - Fetched bin position after validation:', binId);
        
        this.setState({ 
          fastlaneBinId: binId,
          isFastlaneRetrying: false,
          fastlaneBinRetryCount: 0,
          fastlaneRetryMessage: '',
          ...(keepLoader ? {} : { loader: false })
        });
        
        if (shouldTriggerAutoAssign && pendingSaveMode !== null) {
          setTimeout(() => {
            this.checkIfBinIsOccupedFromAnotherLocation(pendingSaveMode);
          }, 100);
        }
        
        return binId;
      } else {
        console.error('Invalid bin ID received from matrix API:', binId);
        return null;
      }
    } catch (error) {
      console.error(`Fastlane validation bin fetch attempt ${retryCount + 1} failed:`, error);
      
      if (retryCount < fastlaneBinMaxRetries - 1) {
        this.setState({
          fastlaneBinRetryCount: retryCount + 1,
          fastlaneRetryMessage: t('Assign.Fastlane.RetryingAttempt', { 
            attempt: retryCount + 2, 
            total: fastlaneBinMaxRetries 
          })
        });
        
        await new Promise(resolve => setTimeout(resolve, 1000));
        return await this.fetchFastlaneBinForValidationWithRetry(retryCount + 1);
      } else {
        this.setState({ 
          isFastlaneRetrying: false,
          fastlaneBinRetryCount: 0,
          fastlaneRetryMessage: '',
          ...(keepLoader ? {} : { loader: false })
        });
        
        toast.error(t('Assign.Fastlane.FinalErrorMessage'));
        this.ClearFields();
        return null;
      }
    }
  };

  handleFastlaneBinValidationErrorRetry = async () => {
    const { fastlaneBinMaxRetries } = this.state;
    
    this.setState({ 
      fastlaneBinValidationError: false,
      isFastlaneRetrying: true,
      fastlaneRetryMessage: this.props.t('Assign.Fastlane.FetchingAttempt', { 
        attempt: 1, 
        total: fastlaneBinMaxRetries 
      }),
      fastlaneBinRetryCount: 0
    });
    
    console.log('🔄 Fastlane - Fetching latest matrix after validation error with retry...');
    
    await this.fetchFastlaneBinForValidationWithRetry(0);
  };

  handleFastlaneBinCollision = (saveMode, serverResponse = null) => {
    // Extract next available bin from API response if provided
    const nextAvailableBinId =
      serverResponse &&
      serverResponse.data &&
      serverResponse.data.nextAvailableBinId
        ? serverResponse.data.nextAvailableBinId
        : null;

    this.setState({
      isFastlaneCollisionResolving: true,
      isRetrying: false,
      selectedBinId: '',
      fastlaneBinId: '',
      loader: true,
      pendingSaveMode: saveMode,
      fastlaneCollisionDialogOpen: true,
      fastlaneCollisionNextBinId: nextAvailableBinId || '',
    });
  };

  handleFastlaneCollisionConfirm = async () => {
    const { fastlaneCollisionNextBinId, pendingSaveMode } = this.state;
    let refreshedBinId = fastlaneCollisionNextBinId;

    // If API did not provide next available bin, fall back to matrix API
    if (
      refreshedBinId === null ||
      refreshedBinId === undefined ||
      refreshedBinId === '' ||
      refreshedBinId === 0
    ) {
      refreshedBinId = await this.fetchFastlaneBinForValidationWithRetry(0, {
        keepLoader: true,
        shouldTriggerAutoAssign: false,
      });
    }

    if (
      ![undefined, 'undefined', null, 'null', '', 0].includes(refreshedBinId)
    ) {
      this.setState(
        {
          isFastlaneCollisionResolving: false,
          fastlaneCollisionDialogOpen: false,
          fastlaneBinId: refreshedBinId,
        },
        () => {
          if (pendingSaveMode !== null) {
            this.checkIfFastlaneBinIdIsExistOrNot(pendingSaveMode);
          }
        }
      );
    } else {
      this.setState({
        isFastlaneCollisionResolving: false,
        fastlaneCollisionDialogOpen: false,
        loader: false,
      });
    }
  };

  handleFastlaneCollisionCancel = () => {
    this.setState({
      isFastlaneCollisionResolving: false,
      fastlaneCollisionDialogOpen: false,
      loader: false,
      pendingSaveMode: null,
      fastlaneCollisionNextBinId: '',
    });
  };

  checkIfFastlaneBinIdIsExistOrNot = async (saveMode) => {
    const { box_id, selectedAssignmentBoxId, boxTypeId, locationtype_id } = this.state;
    // Goliath assignments do not use next-available-bin checks at assignment time.
    if (
      boxTypeId === BOX_TYPE.FASTLANEGOLIATH &&
      locationtype_id === LOCATION_TYPE.Kiosk
    ) {
      this.checkIfBinIsOccupedFromAnotherLocation(saveMode);
      return;
    }
    // Use selectedAssignmentBoxId from dialog if available, otherwise use box_id
    const effectiveBoxId = selectedAssignmentBoxId || box_id;
    this.setState({ loader: true, pendingSaveMode: saveMode });

    try {
      const binIds = await this.getSelectedBinsByType(saveMode);

      // Validate bin ID: check if empty/null, and for numeric bins check if valid number
      // Add-on bins (letter+number format like "CC7") are strings, so skip isNaN check for them
      const isEmpty = [undefined, 'undefined', null, 'null', ''].includes(binIds);
      const isInvalidNumeric = binIds && !this.isAddOnBin(binIds) && (isNaN(binIds) || binIds === 0);
      
      if (isEmpty || isInvalidNumeric) {
        console.error("Fastlane bin validation failed. Bin ID:", binIds);
        this.setState({ 
          loader: false,
          fastlaneBinValidationError: true
        });
        return;
      }

      // Skip bin existence check for add-on bins (they use different validation)
      // Only check for fastlane numeric bins
      if (this.isAddOnBin(binIds)) {
        console.log('📦 Skipping fastlane bin check for add-on bin:', binIds);
        // For add-on bins, proceed directly to save
        this.saveCustomerMaster(saveMode);
        return;
      }

      let URL = `${process.env.REACT_APP_BASEURL}fastlane/bin/is-exist?bin_id=${binIds}&boxId=${effectiveBoxId}`;
      if(this.state.boxTypeId === BOX_TYPE.FASTLANEGOLIATH) {
        URL = `${process.env.REACT_APP_BASEURL}fastlane-goliath/bin/is-exist?bin_id=${binIds}&boxId=${effectiveBoxId}`;
      }
      const response = await fetch(
        URL,
        {
          method: 'get',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
            'Content-Type': 'application/json',
          },
        }
      );

      let checkIfFastlaneBinIdIsExistOrNotResponse = null;
      try {
        checkIfFastlaneBinIdIsExistOrNotResponse = await response.json();
      } catch (error) {
        console.error('Unable to parse Fastlane bin validation response:', error);
      }

      if (checkIfFastlaneBinIdIsExistOrNotResponse && checkIfFastlaneBinIdIsExistOrNotResponse.statusCode === 200) {
        const isBinInUse =
          checkIfFastlaneBinIdIsExistOrNotResponse &&
          checkIfFastlaneBinIdIsExistOrNotResponse.data &&
          checkIfFastlaneBinIdIsExistOrNotResponse.data.isExist === true;

        if (isBinInUse) {
          await this.handleFastlaneBinCollision(
            saveMode,
            checkIfFastlaneBinIdIsExistOrNotResponse
          );
          return;
        }

        this.setState({ loader: false, isFastlaneCollisionResolving: false });
        this.checkIfBinIsOccupedFromAnotherLocation(saveMode);
      } else {
        this.setState({ loader: false, isFastlaneCollisionResolving: false });
        toast.error(this.props.t('Assign.Fastlane.BinCheckError'));
      }
    } catch (error) {
      console.error('Error in checkIfFastlaneBinIdIsExistOrNot:', error);
      this.setState({ 
        loader: false,
        fastlaneBinValidationError: true,
        isFastlaneCollisionResolving: false
      });
    }
  }

  handleBinActivationChange = async () => {
    const {
      selectedBinId,
      deactivatedBins,
      box_id,
      isSizeBasedPreAssignment,
      loader,
    } = this.state;
    if (!selectedBinId || !box_id || loader) {
      return;
    }

    const { t } = this.props;
    const isActivating = deactivatedBins.includes(selectedBinId);
    const nextDeactivatedBins = isActivating
      ? deactivatedBins.filter((item) => item !== selectedBinId && item !== '')
      : [...deactivatedBins.filter((item) => item !== ''), selectedBinId];
    const failureMessage = t('Assign.BinActivationFailed', { binId: selectedBinId });

    // Confirm the save before changing the layout. An optimistic list would
    // hide a concurrent update and leave the wrong bins if the request fails.
    this.setState({ loader: true });

    try {
      const response = await fetch(process.env.REACT_APP_BASEURL + 'boxs', {
        method: 'put',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken
        },
        body: JSON.stringify({
          // Keep the full list for API-first rolling deployment compatibility.
          disabled_bins: nextDeactivatedBins.join(','),
          id: box_id,
          bin_id: selectedBinId,
          deactivated: !isActivating,
        })
      });
      let data = null;
      try {
        data = await response.json();
      } catch (parseError) {
        data = null;
      }
      const savedCount = data && typeof data.box === 'number' ? data.box : 0;
      const failed = !response.ok || !data || Boolean(data.message) || Boolean(data.error) || savedCount !== 1;
      if (failed) {
        const serverMessage = data && (data.message || (typeof data.error === 'string' ? data.error : ''));
        toast.error(serverMessage || failureMessage);
        this.setState({ loader: false });
        return;
      }
      const savedBins = typeof data.disabled_bins === 'string'
        ? data.disabled_bins.split(',').filter(Boolean)
        : nextDeactivatedBins;
      const orderStatePatch = this.binHasActiveOrder(selectedBinId)
        ? {}
        : this.clearHoldResumeOrderState();
      toast.success(
        isActivating
          ? t('Assign.BinActivated', { binId: selectedBinId })
          : t('Assign.BinDeactivated', { binId: selectedBinId })
      );
      this.setState((prevState) => ({
        ...orderStatePatch,
        loader: false,
        deactivatedBins: savedBins,
        selectedBox: prevState.selectedBox
          ? { ...prevState.selectedBox, disabled_bins: savedBins.join(',') }
          : prevState.selectedBox,
        selectedBinId: '',
        isBinDeactivated: false,
        doesBinClicked: false,
        stockCode: '',
        pickupCode: '',
        binLayoutRefreshKey: prevState.binLayoutRefreshKey + 1,
      }), () => {
        if (isSizeBasedPreAssignment) {
          this.triggerPreAssignmentRefresh();
        } else {
          this.getAssignedBins(box_id);
        }
      });
    } catch (error) {
      console.error('Failed to update bin activation state:', error);
      toast.error(failureMessage);
      this.setState({ loader: false });
    }
  }

  createRowAlterAgent = () => {
    const { classes, t } = this.props;
    let alternateAgents = this.state && this.state.alternateAgents;
    let row =
      alternateAgents &&
      alternateAgents.map((val, idx) => (
        <div className={classes.styleBottom} key={`alternate-agent-${idx}`}>
          <React.Fragment>
            <div>
              <Grid container spacing={1} alignItems='flex-start'>
                <Grid item xs={2} sm={1}>
                  <Box sx={{ pt: '20px', display: 'flex', alignItems: 'center' }}>
                    <Tooltip title={t('Patient.Preference.AlternateContactRemoveButton')}>
                      <span>
                        <IconButton
                          aria-label={t('Patient.Preference.AlternateContactRemoveButton')}
                          onClick={() => this.removeAlternetAgentRow(idx)}
                          color='error'
                          size='small'
                          disabled={this.state.readOnly}
                          sx={{ p: 0.5 }}
                        >
                          <DeleteIcon fontSize='small' />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Box>
                </Grid>
                <Grid item xs={3} sm={1}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 56 }}>
                    <Typography component='span' sx={{ color: '#000', fontSize: '0.83rem', fontWeight: 500, lineHeight: 1.25 }}>
                      {t('Patient.Preference.AlternateContactActiveCheckbox')}
                    </Typography>
                    <Checkbox
                      checked={val.isdefault}
                      onChange={this.onChangeAgentActive(idx)}
                      value='default'
                      color='primary'
                      disabled={this.state.readOnly}
                      size='small'
                      sx={{ mt: 0.25, alignSelf: 'flex-start' }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='normal'
                    value={val.agent_firstname}
                    id='agent_firstname'
                    label={t('Patient.Preference.AlternateContactFirstName')}
                    InputLabelProps={{ shrink: true }}
                    onChange={this.onChangeAgentFirstName(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: this.state.readOnly,
                      maxLength: 50,
                      autoComplete: 'new-password',
                      form: {
                        autoComplete: 'off',
                      },
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='normal'
                    value={val.agent_lastname}
                    id='Last_Name'
                    label={t('Patient.Preference.AlternateContactLastName')}
                    InputLabelProps={{ shrink: true }}
                    onChange={this.onChangeAgentLastName(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: this.state.readOnly,
                      maxLength: 50,
                      autoComplete: 'new-password',
                      form: {
                        autoComplete: 'off',
                      },
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='normal'
                    value={val.agent_email}
                    id='Email'
                    label={t('Patient.Preference.AlternateContactEmail')}
                    InputLabelProps={{ shrink: true }}
                    onChange={this.onChangeAgentEmail(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: this.state.readOnly,
                      maxLength: 50,
                      autoComplete: 'new-password',
                      form: {
                        autoComplete: 'off',
                      },
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <PhoneInput
                    labelStyle={{ left: 0, top: '-17px' }}
                    className={classes.halfTextFieldAgents}
                    id='smsphone'
                    name='phone'
                    onBlur={this.onChangeAgentsmsphone(idx)}
                    defaultValue={val.agent_sms}
                    readOnly={this.state.readOnly}
                    style={{ width: '100%' }}
                  />
                </Grid>
              </Grid>
            </div>
          </React.Fragment>
        </div>
      ));
    return row;
  };

  addAlterAgentRow = () => {
    this.setState({
      alternateAgents:
        this.state &&
        this.state.alternateAgents &&
        this.state.alternateAgents.concat([
          {
            agent_firstname: '',
            agent_lastname: '',
            agent_email: '',
            agent_sms: '',
            isdefault: false,
          },
        ]),
    });
  };

  onChangeAgentFirstName = (idx) => (evt) => {
    const agent_firstname =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: evt.target.value,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agent_firstname });
  };

  onChangeAgentLastName = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: evt.target.value,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  onChangeAgentEmail = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: evt.target.value,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  onChangeAgentsmsphone = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: evt.target.value,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  onChangeAgentActive = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: evt.target.checked,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  removeAlternetAgentRow = (i) => {
    this.setState({
      alternateAgents: this.state.alternateAgents.filter((s, sidx) => i !== sidx),
    });
  };

  servePrescriptionForOtherDeliveryTypes = async (serverPrescriptionResponse, courier_tracking, default_courier_selected) => {
    const { t } = this.props;
    const { patient, prescription } = serverPrescriptionResponse;
    if (!(prescription && prescription.id)) {
      return null;
    }
    const data = {
      order_id: prescription.id,
      account_id: patient.parent_account_id,
      location_type_id: patient.locationtype_id,
      courier_tracking: courier_tracking,
      default_courier_selected: default_courier_selected,
    };
    const requestUrl = `${[LOCATION_TYPE.Bedside].includes(data.location_type_id)
      ? 'delivery/bedsidenotification'
      : 'delivery/notifications'
      }`;
    try {
      const response = await fetch(process.env.REACT_APP_BASEURL + requestUrl, {
        method: 'POST',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user'))
              .signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      let servePrescriptionForOtherDeliveryTypesResponse = null;
      try {
        servePrescriptionForOtherDeliveryTypesResponse = await response.json();
      } catch (_error) {
        servePrescriptionForOtherDeliveryTypesResponse = null;
      }
      console.log('📍 [ASSIGN PRESCRIPTION] Delivery notification sent successfully:', {
        response: servePrescriptionForOtherDeliveryTypesResponse,
        locationTypeId: data.location_type_id
      });
      this.setState({ loader: false });
      return servePrescriptionForOtherDeliveryTypesResponse;
    } catch (error) {
      console.error('📍 [ASSIGN PRESCRIPTION] Delivery notification failed:', {
        error: error && error.message,
        locationTypeId: data.location_type_id
      });
      toast.error(t("Toast.Error.DeliverPrescription.ServePrescription") + " " + error && error.message);
      this.setState({ loader: false });
      return null;
    }
  }

  removePhantomBin = (e) => {
    const { t } = this.props;
    e && e.preventDefault();
    const { pmid, stockCode, isPhantomStockCodePrompt } = this.state;
    const normalizedStockCode = (stockCode || '').trim();
    if (isPhantomStockCodePrompt && !normalizedStockCode) {
      toast.error('Please enter stock code');
      return;
    }
    if (!pmid) {
      toast.error('Unable to remove phantom bin. Prescription id is missing.');
      return;
    }
    console.log(`Order to be removed ${pmid}`);
    this.setState({ loader: true });
    fetch(`${process.env.REACT_APP_BASEURL}release/phantom`, {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user'))
            .signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prescriptionId: pmid, stockCode: normalizedStockCode }),
    }).then((response) => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then((pbrr) => {
      console.log(JSON.stringify(pbrr, null, 2));
      if(pbrr && pbrr.data) {
        toast.success(t("Assign.PhantomBin.SuccessMessage"));
        this.ClearFields();
      }
      this.setState({
        loader: false,
        confirmPhantomRemoval: false,
        doesBinClicked: false,
        isPhantomStockCodePrompt: false,
      });
    }).catch((error) => {
      toast.error(t("Toast.Error.DeliverPrescription.ServePrescription") + " " + error && error.message);
      this.setState({
        loader: false,
        confirmPhantomRemoval: false,
        doesBinClicked: false,
        isPhantomStockCodePrompt: false,
      });
    });
  }

  setPermission = () => {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("permissionUser"));
    if(_checkUserRole === userroles.SUPERADMIN) {
      this.setState({ 
        isManualOverridePermissionEnabled: true, 
        prescriptionUnAssign: true, 
        prescriptionAssign: true, 
        prescriptionView: true,
        prescriptionDirectPickup: true,
        prescriptionRemind: true,
        prescriptionConsult: true,
        prescriptionHoldResume: true,
        prescriptionAcDc: true,
        printTicketPermissionAllowed: true 
      });
    } else {
      if (permissions && permissions.length > 0) {
        const manualOverride = permissions.filter((item) => {
          return item.permission_entity_type === "Manual Override"
        });
        const assignPrescriptions = permissions.filter((item) => {
          return item.permission_entity_type === "Assign Prescription"
        });

        if (manualOverride.length > 0) {
          this.setState({ isManualOverridePermissionEnabled: manualOverride.some((x) => x.name.trim() === 'Open Bin' && x.is_allowed === 1) })
        } else {
          this.setState({ isManualOverridePermissionEnabled: false });
        }

        if (assignPrescriptions.length > 0) {
          this.setState({
            prescriptionUnAssign: assignPrescriptions.some((x) => x.name.trim() === 'UnAssign' && x.is_allowed === 1),  // UnAssign
            prescriptionAssign: assignPrescriptions.some((x) => x.name.trim() === 'Assign' && x.is_allowed === 1),  // Assign
            prescriptionView: assignPrescriptions.some((x) => x.name.trim() === 'View' && x.is_allowed === 1), //View
            prescriptionRemind: assignPrescriptions.some((x) => x.name.trim() === 'Remind' && x.is_allowed === 1), //Remind
            prescriptionDirectPickup: assignPrescriptions.some((x) => x.name.trim() === 'Direct Pickup' && x.is_allowed === 1),  // Direct Pickup
            prescriptionConsult: assignPrescriptions.some((x) => x.name.trim() === 'Consult' && x.is_allowed === 1), //Consult
            prescriptionAcDc: assignPrescriptions.some((x) => x.name.trim() === 'Activate/DeActivate' && x.is_allowed === 1), // Activate/DeActivate
            prescriptionHoldResume: assignPrescriptions.some((x) => x.name.trim() === 'Hold/Resume' && x.is_allowed === 1), // Activate/DeActivate
            printTicketPermissionAllowed: assignPrescriptions.some((x) => x.name.trim() === 'Print Ticket' && x.is_allowed === 1), // Print Ticket
          })
        } else {
          this.setState({
            prescriptionUnAssign: false,
            prescriptionAssign: false,
            prescriptionView: false,
            prescriptionDirectPickup: false,
            prescriptionRemind: false,
            prescriptionConsult: false,
            prescriptionHoldResume: false,
            prescriptionAcDc: false,
            printTicketPermissionAllowed: false
          });
        }
      } else {
        this.setState({
          isManualOverridePermissionEnabled: false,
          prescriptionUnAssign: false,
          prescriptionAssign: false,
          prescriptionView: false,
          prescriptionDirectPickup: false,
          prescriptionRemind: false,
          prescriptionConsult: false,
          prescriptionHoldResume: false,
          prescriptionAcDc: false,
          printTicketPermissionAllowed: false
        });
      } 
    }
  }
  handleHL7KeyDown = (event) => {
    const { globalAccountConnection } = this.state;
    if (event.keyCode === 13) {
      this.setState({ loader: true, isEdit: false });
      let searchedString = event.target.value;
      let obj = {
        lookupValue: searchedString,
        account_id: globalAccountConnection.id,
      };
      fetch(process.env.REACT_APP_BASEURL + 'hl/orders/lookup', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          let parsedJson = JSON.parse(res);
          if (
            parsedJson &&
            parsedJson.status &&
            parsedJson.status.toLowerCase() === 'failed'
          ) {
            toast.error(parsedJson.error_message);
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.order_details;
          if (!prescriptionDetails) {
            toast.error(this.props.t('Toast.Error.RxFound'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          } else {
            let item = {
              ndcCode: prescriptionDetails.ndc,
              itemId: '',
              binId: '',
              rxNo: prescriptionDetails.rx_num,
              name: prescriptionDetails.name,
              description: '',
              image: '',
              potency: '',
              qty: prescriptionDetails.dispensed_qty,
              schedule: '',
              Amount: prescriptionDetails.amount_due,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: prescriptionDetails.amount_due,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: prescriptionDetails.expiry_date,
              isLoadingTrans: false,
              fillNumber: null,
              prescriptionNumber: null,
              ConsultRequire: false,
              IsReturnable: false,
              status: '',
              order_id: null,
              prescription_txn_id: null,
              is_controlled_substance: false
            };
            const existingItem = this.state.searchedItems;
            this.setState({ EmailID: patientDetails.EmailAddress, phone: patientDetails.phone });
            if (
              existingItem &&
              searchedRxItems &&
              searchedRxItems.length > 0
            ) {
              let isexist = searchedRxItems.findIndex(
                (x) => x.rxNo === searchedString
              );
              if (existingItem.PatientID === patientDetails.patient_id) {
                if (isexist < 0) {
                  searchedRxItems.push(item);
                  if (
                    patientDetails &&
                    patientDetails.patient_id &&
                    patientDetails.EmailAddress
                  ) {
                    this.checkADACompatible(
                      patientDetails.patient_id,
                      patientDetails.EmailAddress
                    );
                  }
                  this.getcustomerLocation(
                    patientDetails,
                    searchedRxItems,
                    'HL7'
                  );
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                  this.forceUpdate();
                } else {
                  toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                }
              } else {
                toast.error(this.props.t('Toast.Error.WrongPatient'));
                this.setState({
                  rxNumber: '',
                  loader: false,
                });
              }
            } else {
              searchedRxItems.push(item);
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'HL7'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
                loader: false,
              });
            }
          }
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  }

  handleHL7OnChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  }

  validateRxFillsForDRX = (items) => {
    let _validRxItemArray = [];
    let _inValidRxItemArray = [];
    let validatedRxFills = {};
    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        if (['Waiting Bin', 'Verify', 'Scan', 'Pre-Check'].includes(items[i].status)) {
          _validRxItemArray.push(items[i]);
        } else {
          _inValidRxItemArray.push(items[i]);
        }
      }
    }
    validatedRxFills.validRxItems = _validRxItemArray;
    validatedRxFills.inValidRxItems = _inValidRxItemArray;
    return validatedRxFills;
  };

  isRxExistInCartForDRX = async (searchedString, patientDetails, items) => {
    let _existingPrescriptionNumbers = [];
    let existingRxNo = searchedString;
    for (let si = 0; si < searchedRxItems.length; si++) {
      if (
        existingRxNo === searchedRxItems[si].rxNo.toString()
      ) {
        _existingPrescriptionNumbers.push(searchedRxItems[si].rxNo.toString());
      }
    }
    if (_existingPrescriptionNumbers.length > 0) {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The prescription ${_existingPrescriptionNumbers.join(
          ','
        )} is already exist in the cart!`,
      });
      return true;
    } else {
      let itemsdetail;
      let validRxScripts = this.validateRxFillsForDRX(items);
      if (
        validRxScripts &&
        validRxScripts.validRxItems &&
        validRxScripts.validRxItems.length > 0
      ) {
        itemsdetail = validRxScripts.validRxItems;
      } else {
        itemsdetail = validRxScripts.inValidRxItems;
      }
      for (let i = 0; i < itemsdetail.length; i++) {
        searchedRxItems.push(itemsdetail[i]);
      }
      this.checkADACompatible(
        patientDetails.patient_id,
        patientDetails.email
      );
      this.getcustomerLocation(patientDetails, itemsdetail, 'DRX');
      this.forceUpdate();
      this.setState({
        rxNumber: '',
        loader: false,
      });
    }
  };

  isSamePatientForDRX = (patientDetails) => {
    const { searchedItems } = this.state;
    if (searchedItems.PatientID === patientDetails.patient_id) {
      this.setState({
        EmailID: patientDetails.email,
        phone: patientDetails.phone,
      });
      return true;
    } else {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The scanned or entered prescription has different patient details. Please assign this prescription to any bin first then scan or enter another prescription!`,
      });
      return false;
    }
  };

  checkIfRxExistOrNotForDRX = async (rxTransactionNumber) => {
    let response = {};
    return fetch(
      process.env.REACT_APP_BASEURL +
      'drx/prescription/check/rxno-fillid/' +
      rxTransactionNumber,
      {
        method: 'get',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((checkResponse) => {
        if (checkResponse) {
          let parsedJsonResponse = JSON.parse(checkResponse);
          if (
            parsedJsonResponse &&
            parsedJsonResponse.res &&
            parsedJsonResponse.res.status === 200
          ) {
            response.error = parsedJsonResponse.res.message;
            response.result = true;
            return response;
          } else {
            response.error = '';
            response.result = false;
            return response;
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleDRXChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleDRXKeyDown = (event) => {
    this.setState({
      loader: true,
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: "",
      isEdit: false,
    });
    const { originalScannedScript } = this.state;
    let searchedString = originalScannedScript;
    let validItems = [];
    let items = [];
    let obj = {
      lookupValue: searchedString,
      accountId: this.state.accountDetails.id,
    };
    fetch(process.env.REACT_APP_BASEURL + "drx/prescription/lookup", {
      crossDomain: true,
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(async (res) => {
        let parsedJsonResponse = res;
        let parsedJson;
        if (parsedJsonResponse && parsedJsonResponse.status !== 200) {
          this.setState({
            loader: false,
            rxNumber: "",
            isEpicHasValidRx: false,
            isEpicHasValidRxMessage: `${parsedJsonResponse.message}`,
          });
          return;
        }
        parsedJson = parsedJsonResponse.data;
        let patientDetails = parsedJson.prescription.patient;
        let prescriptionDetails = parsedJson.prescription;
        if (prescriptionDetails.length <= 0) {
          toast.error(this.props.t("Toast.Error.Prescription"));
          this.setState({
            rxNumber: "",
            loader: false,
          });
          return;
        }
        if (searchedRxItems && searchedRxItems.length > 0) {
          const _isSamePatient = this.isSamePatientForDRX(patientDetails);
          if (_isSamePatient === true) {
            let _existingPrescriptionNumbers = [];
            let preacriptionNumber =
              prescriptionDetails.prescription_id;
            for (let si = 0; si < searchedRxItems.length; si++) {
              if (
                preacriptionNumber === searchedRxItems[si].prescription_id
              ) {
                _existingPrescriptionNumbers.push(preacriptionNumber);
              }
            }
            if (
              _existingPrescriptionNumbers &&
              _existingPrescriptionNumbers.length &&
              _existingPrescriptionNumbers.length > 0
            ) {
              this.setState({
                loader: false,
                rxNumber: "",
                isEpicHasValidRx: false,
                isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers} are already exist in the cart!`,
              });
              return true;
            }
          }
        }
        let isconsultrequired = false;
        let isreturnable = false;
        let isControlledSubstance = false;
        if (
          prescriptionDetails.prescribed_item &&
          ![undefined, "undefined", null, "null", ""].includes(
            prescriptionDetails &&
            prescriptionDetails.prescribed_item &&
            prescriptionDetails.prescribed_item.dea_schedule
          )
        ) {
          const deaClass = prescriptionDetails.prescribed_item.dea_schedule;
          if (["2", "3", "4", "5", 2, 3, 4, 5].includes(deaClass)) {
            isControlledSubstance = true;
          }
        }
        this.setState({ is_controlled_substance: isControlledSubstance });
        for (let i = 0; i < prescriptionDetails.fills.length; i++) {
          let item = {
            ndcCode: prescriptionDetails.ndc,
            itemId: "",
            binId: "",
            rxNo: prescriptionDetails.prescription_id,
            name: prescriptionDetails.drug_name,
            description: prescriptionDetails.sig,
            image: "",
            potency: "",
            qty: prescriptionDetails.fills[i].dispensed_quantity,
            schedule: "",
            dea_schedule:
              prescriptionDetails.prescribed_item &&
              prescriptionDetails.prescribed_item.dea_schedule != null
                ? prescriptionDetails.prescribed_item.dea_schedule
                : "",
            Amount: prescriptionDetails.fills[i].copay,
            taxPercentage: "",
            insuranceAmount: "",
            CoPayAmount: prescriptionDetails.fills[i].copay,
            PaidAmount: "",
            DueAmount: "",
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            strength: "",
            route: "",
            doseage_form: "",
            non_proprietary_name: "",
            ExpirationDate: prescriptionDetails.expiration_date,
            isLoadingTrans: false,
            fillNumber: prescriptionDetails.fills[i].id,
            prescriptionNumber: "",
            ConsultRequire: isconsultrequired,
            IsReturnable: isreturnable,
            status: prescriptionDetails.fills[i].status,
            is_controlled_substance: isControlledSubstance,
          };
          let rxTransactionNumber = `${prescriptionDetails.prescription_id}-${prescriptionDetails.fills[i].id}`;
          if (['Waiting Bin', 'Verify', 'Scan', 'Pre-Check'].includes(prescriptionDetails.fills[i].status)
          ) {
            let isRxTrasactionNumberExist = false
            isRxTrasactionNumberExist = await this.checkIfRxExistOrNotForDRX(
              rxTransactionNumber
            );
            if (
              isRxTrasactionNumberExist &&
              isRxTrasactionNumberExist.result === true
            ) {
              items.push(item);
              this.setState({
                loader: false,
                isEpicHasValidRx: false,
                isEpicHasValidRxMessage: "The Rx transaction has already been processed!",
              });
            } else {
              items.push(item);
              if (['Waiting Bin', 'Verify', 'Scan', 'Pre-Check'].includes(prescriptionDetails.fills[i].status)) {
                validItems.push(prescriptionDetails.fills[i]);
              }
              if (validItems.length > 0) {
                prescriptionDetails.fills[i] = validItems;
              }
            }
          } else {
            items.push(item);
          }
        }
        if (items && items.length === 0) {
          return;
        }
        if (searchedRxItems && searchedRxItems.length > 0) {
          const _isSamePatient = this.isSamePatientForDRX(patientDetails);
          if (_isSamePatient === true) {
            this.isRxExistInCartForDRX(searchedString, patientDetails, items);
          }
        } else {
          this.setState({
            EmailID: patientDetails.email,
            phone: patientDetails.phone,
          });
          let RxItems = this.validateRxFillsForDRX(items);
          if (
            RxItems &&
            RxItems.validRxItems &&
            RxItems.validRxItems.length > 0
          ) {
            searchedRxItems = RxItems.validRxItems;
          } else {
            searchedRxItems = RxItems.inValidRxItems;
            let errorArray = [];
            if (searchedRxItems && searchedRxItems.length > 0) {
              for (let invalid = 0; invalid < searchedRxItems.length; invalid++) {
                errorArray.push({ Status: searchedRxItems[invalid].status });
              }
              this.setState({
                loader: false,
                isEpicHasValidRx: false,
                isEpicHasValidRxMessage: `The status of the prescription
                  should be Waiting Bin, Verify, Scan, Pre-Check but the ${
                    errorArray && errorArray.length > 1
                      ? "statuses are"
                      : "status is"
                  } ${errorArray && errorArray.map((x) => x.Status).join(", ")}`,
              });
            }
          }
          this.checkADACompatible(
            patientDetails.patient_id,
            patientDetails.email
          );
          this.getcustomerLocation(patientDetails, searchedRxItems, "DRX");
          this.forceUpdate();
          this.setState({
            rxNumber: "",
            loader: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loader: false,
          rxNumber: "",
          isEpicHasValidRx: false,
          isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
        });
        return;
      });
  };

  parseEpicLabel = async (scannedQR) => {
    const { globalAccountConnection } = this.state;
    const isEpic =
      globalAccountConnection &&
      globalAccountConnection.account_connections_id === CONNECTION_TYPE.EPIC;
    if (isEpic) {
      if (String(scannedQR || '').startsWith('ilb')) {
        return this.parseScannedQrCode(scannedQR);
      }
      const appliedRegexp = resolveEpicScanRegexp(
        globalAccountConnection.regexp
      );
      const parsed = parseEpicScanRegex(scannedQR, appliedRegexp);
      if (!parsed) {
        writeAuditLog(
          `Epic label did not match the account regular expression. Scanned text: ${scannedQR}. Regex: ${appliedRegexp}`,
          'Epic Regex Miss'
        );
        return {
          regexMiss: true,
          prescriptionNumber: '',
          fillId: '',
          pharmacyNCPDPId: '',
          is_coreFlex: false,
        };
      }
      return parsed;
    }
    if (
      globalAccountConnection &&
      globalAccountConnection.vial_label_scan &&
      globalAccountConnection.vial_label_scan === true
    ) {
      return this.parseScannedQrCodeForVialLabelScan(scannedQR);
    }
    return this.parseScannedQrCode(scannedQR);
  };

  parseScannedQrCodeForVialLabelScan = async (scannedQR) => {
    const { t } = this.props;
    let _parsedResponse = {};
    if (scannedQR.startsWith('\\')) {
      const splittedRx = scannedQR.split('^');
      if(splittedRx.length > 0) {
        const actualRxNumber = splittedRx[0].substring(4, splittedRx[0].length);
        _parsedResponse.prescriptionNumber = actualRxNumber;
        _parsedResponse.pharmacyNCPDPId = null;
        _parsedResponse.fillId = splittedRx[1];
        _parsedResponse.is_coreFlex = false;  
      } else {
        toast.error(t('Toast.Error.RxNotValid'))
      }
    } else {
      const splittedRx = scannedQR.split('^');
      if(splittedRx.length > 0) {
        const actualRxNumber = splittedRx[0].substring(3, splittedRx[0].length);
        _parsedResponse.prescriptionNumber = actualRxNumber;
        _parsedResponse.pharmacyNCPDPId = null;
        _parsedResponse.fillId = splittedRx[1];
        _parsedResponse.is_coreFlex = false;  
      } else {
        toast.error(t('Toast.Error.RxNotValid'))
      }
    }
    console.log(
      `Parsed Response for EPIC script : ${JSON.stringify(
        _parsedResponse,
        null,
        2
      )}`
    );
    return _parsedResponse;
  };

  checkIfBinIsOccupedFromAnotherLocation = async (type) => {
    const { 
      box_id, 
      boxTypeId,
      locationtype_id,
      isSizeBasedPreAssignment,
    } = this.state;

    if (isSizeBasedPreAssignment) {
      this.saveCustomerMaster(type);
      return;
    }
    
    // Get effective bin ID - if selectedBinId is add-on pattern, use it; otherwise use fastlaneBinId for Fastlane
    let effectiveBinId = await this.getSelectedBinsByType(type);
    const effectiveBoxId = box_id;
    
    // Skip collision check if bin is from add-on (letter+number pattern)
    if (effectiveBinId && this.isAddOnBin(effectiveBinId)) {
      console.log("🔶 Skipping collision check for add-on bin:", effectiveBinId);
      this.saveCustomerMaster(type);
      return;
    }
    
    // For Fastlane and FastlaneGoliath, skip collision check for non-Kiosk locations
    if(boxTypeId === BOX_TYPE.FASTLANE || boxTypeId === BOX_TYPE.FASTLANEGOLIATH) {
      if(locationtype_id !== LOCATION_TYPE.Kiosk) {
        console.log("No action required for other types of locations.");
        this.saveCustomerMaster(type);
        return;
      }
    }
    
    if(locationtype_id !== LOCATION_TYPE.Kiosk) {
      if([undefined, 'undefined', null, 'null', ""].includes(effectiveBinId)) {
        this.saveCustomerMaster(type);
        return;
      }
    }
    
    // For Fastlane and FastlaneGoliath, skip collision check (original Fastlane behavior)
    if((boxTypeId === BOX_TYPE.FASTLANE || boxTypeId === BOX_TYPE.FASTLANEGOLIATH) && locationtype_id === LOCATION_TYPE.Kiosk) {
      this.saveCustomerMaster(type);
      return;
    }
    
    console.log("🔶 Checking bin collision status for box_id:", effectiveBoxId, "bin_id:", effectiveBinId);
    fetch(process.env.REACT_APP_BASEURL + "api/v2/orders/bin/status", {
      crossDomain: true,
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify({
        box_id: effectiveBoxId,
        bin_id: effectiveBinId,
      }),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          console.log(
            `Preflight error while processing request ${error && error.message}`
          );
          return null;
        }
      })
      .then(async (res) => {
        console.log("🔶 Bin collision check response:", res);
        if (res && res.isOccupied === true) {
          console.log("🔶 Bin is occupied - showing error");
          toast.error(res.message);
          this.setState({ loader: false, isRetrying: false });
        } else {
          console.log("🔶 Bin is not occupied - proceeding to saveCustomerMaster");
          this.saveCustomerMaster(type);
        }
      })
      .catch((error) => {
        // Don't show error toast here - let saveCustomerMaster retry mechanism handle it
        // This prevents duplicate error dialogs when retrying
        console.error(`🔶 Bin status check failed: ${error && error.message}`);
        // Still proceed with save to let the retry mechanism work
        console.log("🔶 Proceeding to saveCustomerMaster despite error");
        this.saveCustomerMaster(type);
      });
  };

  handleChangeOrderNotes = (e) => {
    e.preventDefault();
    this.setState({
      assign_order_notes: e.target.value,
    })
  }


  // Helper function to check if a bin ID is from an add-on (letter+number format like "CC5", "DD12")
  isAddOnBin = (binId) => {
    if (!binId) return false;
    // Convert to string to handle both string and number inputs
    const binIdStr = String(binId).trim();
    // Add-on bins have letter+number format (e.g., "CC5", "DD12", "AA1", "BB4")
    // Fastlane bins are numeric (e.g., "76", "77", "1")
    const isAddOn = /^[A-Z]+\d+$/i.test(binIdStr); // Added 'i' flag for case-insensitive matching
    console.log('🔍 isAddOnBin check:', { binId, binIdStr, isAddOn });
    return isAddOn;
  }

  // Check if box has add-on expansions
  hasAddOnExpansions = () => {
    const { expansionUnits } = this.state;
    if (!expansionUnits || expansionUnits.length === 0) return false;
    // Check if there are any actual add-on units (not just Fastlane main unit)
    return expansionUnits.some(unit => unit.id && unit.id !== -1 && unit.pos !== 'FASTLANE');
  }


  handlePhoneChange = (e) => {
    this.setState({ phoneError: false })
    const { name, value } = e.target;

    let cleaned = value.replace(/\D/g, '');
    if (cleaned.length > 10) {
      cleaned = cleaned.slice(0, 10);
    }

    let formatted = cleaned;
    if (cleaned.length > 6) {
      formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length > 3) {
      formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else if (cleaned.length > 0) {
      formatted = `(${cleaned}`;
    }

    this.setState({ [name]: formatted });
  }

  handlePhoneBlur = () => {
    if (!this.state.isRxView) {
      this.generateCodes()
    }
  }
  
  handleDOBChange = (e) => {
    this.setState({ dobError: false });
    const { value } = e.target;
    let cleaned = value.replace(/\D/g, '');
    if (cleaned.length > 8) {
      cleaned = cleaned.slice(0, 8);
    }

    let formatted = cleaned;
    if (cleaned.length > 4) {
      formatted = `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4)}`;
    } else if (cleaned.length > 2) {
      formatted = `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
    }

    this.setState({ dateOfBirth: formatted });
  };

  handleRxChange = (index, event) => {
    const newEntries = [...this.state.rxEntries];
    newEntries[index].rxNumber = event.target.value;
    this.setState({ rxEntries: newEntries });
  };

  handleConsultChange = (index, event) => {
    const newEntries = [...this.state.rxEntries];
    newEntries[index].isConsultRequired = event.target.checked;
    this.setState({ rxEntries: newEntries });
  };

  handleAddRx = () => {
    this.setState((prevState) => ({
      rxEntries: [...prevState.rxEntries, { rxNumber: '', isConsultRequired: false }]
    }));
  };

  handleRemoveRx = (index) => {
    const newEntries = [...this.state.rxEntries];
    newEntries.splice(index, 1);
    this.setState({ rxEntries: newEntries });
  };

  handlePrintTicket = async () => {
    const data = this.state.reminderData;
    const box = data && data.data && data.data.response && data.data.response.box;
    const order = box && box.customers && box.customers[0] && box.customers[0].orders && box.customers[0].orders[0];
    if (!order || !order.pucode) return;
    const audit = this.buildPrintRequestAudit({
      orderId: order.id,
      stockCode: order.stock_code,
      binId: order.bin_id,
      parentAccountId: box.parent_account_id,
    }, box.id || this.state.box_id, 'Ticket');
    await this.getHtmlForPrint(order.pucode, audit);
  }

  openPrintDialog = () => {
    this.setState({ openPrintDialog: true });
  }

  closePrintDialog = () => {
    this.setState({ openPrintDialog: false });
  }

  getHtmlForPrint = async (pucode, audit) => {
    this.setState({ loader: true });
    return fetch(
      process.env.REACT_APP_BASEURL + "printStockedItemEmailTemplate/" + pucode,
      {
        method: "GET",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load print ticket');
        return response.text();
      })
      .then(async (res) => {
        this.setState({ htmlBodyToPrint: res, loader: false });
        await this.handlePrint(audit);
      })
      .catch((err) => {
        this.setState({ loader: false });
        console.error(err)
      });
  }
    
  
  handlePrint = async (audit) => {
    this.openPrintDialog();
    setTimeout(() => {
      this.recordPrintRequestAudit(audit);
      window.print();
      this.closePrintDialog();
    }, 1500);
  };  
  handlePrimerxOnChange = (e) => {
    const scannedValue = e.target.value;
    const cleanedValue = String(scannedValue).replace(/^0+/, ""); 
    
    this.setState(
      {
        rxNumber: cleanedValue,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handlePrimerxKeyDown = (event) => {
    const { globalAccountConnection } = this.state;
    if (event.keyCode === 13) {
      this.setState({ loader: true, isEdit: false });
      let searchedString = event.target.value;
      let obj = {
        lookupValue: searchedString,
        account_id: globalAccountConnection.account_id,
      };
      fetch(process.env.REACT_APP_BASEURL + "api/primerx/order/lookup", {
        crossDomain: true,
        method: "post",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          let parsedJson = JSON.parse(res);
          if (
            parsedJson &&
            parsedJson.status &&
            parsedJson.status.toLowerCase() === "failed"
          ) {
            toast.error(parsedJson.error_message);
            this.setState({
              rxNumber: "",
              loader: false,
            });
            return;
          }
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.order_details;
          if (
            [false, "false"].includes(
              patientDetails && patientDetails._isOrderFound
            )
          ) {
            toast.error("This order may not be deliverable.", {
              autoClose: 5000,
              progress: undefined,
              hideProgressBar: false,
            });
          }
          if (!prescriptionDetails) {
            toast.error(this.props.t("Toast.Error.RxFound"));
            this.setState({
              rxNumber: "",
              loader: false,
            });
            return;
          }
          let _localIsControlledSubstance = false;
          if(![undefined, 'undefined', null, 'null', ''].includes(prescriptionDetails.drug_class)) {
            if(["2", "3", "4", "5", 2, 3, 4, 5].includes(prescriptionDetails.drug_class)) {
              this.setState({ is_controlled_substance: true });
              _localIsControlledSubstance = true;
            } else {
              this.setState({ is_controlled_substance: false });
              _localIsControlledSubstance = false;
            }
          } else {
            this.setState({ is_controlled_substance: false });
            _localIsControlledSubstance = false;
          }
          let item = {
            ndcCode: prescriptionDetails.ndc,
            itemId: "",
            binId: "",
            rxNo: prescriptionDetails.rx_num,
            name: prescriptionDetails.name,
            description: "",
            image: "",
            potency: "",
            qty: prescriptionDetails.dispensed_qty,
            schedule: "",
            Amount: prescriptionDetails.amount_due,
            taxPercentage: "",
            insuranceAmount: "",
            CoPayAmount: prescriptionDetails.amount_due,
            PaidAmount: "",
            DueAmount: "",
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            strength: "",
            route: "",
            doseage_form: "",
            non_proprietary_name: "",
            ExpirationDate: prescriptionDetails.expiry_date,
            isLoadingTrans: false,
            fillNumber: prescriptionDetails.fill_number,
            prescriptionNumber: "",
            ConsultRequire:
              [true, "true"].includes(this.state.accountDetails.bypass_consult)
                ? false
                : ((prescriptionDetails && prescriptionDetails.fill_number === 0) ||
                   (prescriptionDetails && prescriptionDetails.fill_number === "0")),
            IsReturnable: false,
            status: "",
            order_id: parsedJson.order_id,
            prescription_txn_id: "",
            is_controlled_substance: _localIsControlledSubstance ? true : false,
          };
          const existingItem = this.state.searchedItems;
          this.setState({
            EmailID: patientDetails.EmailAddress,
            phone: patientDetails.phone,
          });
          if (existingItem && searchedRxItems && searchedRxItems.length > 0) {
            let isexist = searchedRxItems.findIndex(
              (x) => x.rxNo === searchedString
            );
            if (existingItem.PatientID === patientDetails.patient_id) {
              if (isexist < 0) {
                searchedRxItems.push(item);
                if (
                  patientDetails &&
                  patientDetails.patient_id &&
                  patientDetails.EmailAddress
                ) {
                  this.checkADACompatible(
                    patientDetails.patient_id,
                    patientDetails.EmailAddress
                  );
                }
                this.getcustomerLocation(
                  patientDetails,
                  searchedRxItems,
                  "PrimeRx"
                );
                this.setState({
                  rxNumber: "",
                  loader: false,
                });
                this.forceUpdate();
              } else {
                toast.error(this.props.t("Toast.Error.RxAddedToCart"));
                this.setState({
                  rxNumber: "",
                  loader: false,
                });
              }
            } else {
              toast.error(this.props.t("Toast.Error.WrongPatient"));
              this.setState({
                rxNumber: "",
                loader: false,
              });
            }
          } else {
            searchedRxItems.push(item);
            this.getcustomerLocation(patientDetails, searchedRxItems, "PrimeRx");
            this.forceUpdate();
            this.setState({
              rxNumber: "",
              loader: false,
            });
          }
        })
        .catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  handleLockToggle = async () => {
    const nextLockState = !this.state.isBinLocked;
  
    this.setState({ isBinLocked: nextLockState });
  
    try {
      const response = await fetch(`${process.env.REACT_APP_BASEURL}bin-lock`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        },
        body: JSON.stringify({
          id: this.state.orderId,
          lockState: nextLockState,
        }),
      });
  
      const result = await response.json();
  
      if (!response.ok || !result.success) {
        throw new Error(result.message || "Failed to update lock state");
      }

      // Audit log: bin lock/unlock at root cause (after successful API response)
      // Description shows only P/U code and bin for professional display; order id is in metadata (User Details modal)
      const actionLabel = nextLockState ? "locked" : "unlocked";
      const pucode = this.state.pickupCode ? this.state.pickupCode : "—";
      const binId = this.state.selectedBinId ? this.state.selectedBinId : "—";
      const description = `Bin ${actionLabel} for P/U: ${pucode}, bin ${binId}.`;
      await writeAuditLog(
        description,
        "Bin Lock",
        {
          boxId: this.state.box_id,
          ...(this.state.orderId && { prescriptionMasterId: this.state.orderId })
        },
        {
          eventType: "BIN_LOCK",
          source: "PORTAL",
          severity: "INFO",
          metadata: {
            orderId: this.state.orderId,
            lockState: nextLockState,
            binId: this.state.selectedBinId || null,
            pucode: this.state.pickupCode || null
          }
        },
        { wait: false }
      );

      this.getAssignedBins(this.state.box_id);
      console.log("Lock state updated:", nextLockState);
    } catch (error) {
      console.error("Failed to update lock state", error);
  
      // Rollback UI on failure
      this.setState(prev => ({
        isBinLocked: !prev.isBinLocked,
      }));
    }
  };

  renderAssignActionButton = (label, onClick, options = {}) => {
    const {
      disabled,
      variant = 'neutral',
      children,
      tooltip,
      placement = 'top',
      iconOnly,
      ...rest
    } = options;
    const isIconOnly =
      iconOnly === true || (Boolean(children) && (label == null || label === ''));
    const tooltipTitle = formatAssignActionTooltip(
      tooltip !== undefined && tooltip !== null && tooltip !== ''
        ? tooltip
        : label
    );
    const button = (
      <Button
        type="button"
        variant="contained"
        disableElevation
        disabled={disabled}
        onClick={onClick}
        sx={{
          ...getAssignActionButtonSx(variant),
          ...(isIconOnly
            ? {
                minWidth: assignActionIconButtonSize,
                width: assignActionIconButtonSize,
                height: assignActionIconButtonSize,
                p: 0,
                borderRadius: '12px',
              }
            : {}),
        }}
        {...rest}
      >
        {children || label}
      </Button>
    );

    if (!tooltipTitle) {
      return button;
    }

    return (
      <Tooltip title={tooltipTitle} arrow placement={placement}>
        <span style={{ display: 'inline-flex' }}>{button}</span>
      </Tooltip>
    );
  };

  renderAssignActionFooter = () => {
    const { t } = this.props;
    let itemCount = 0;
    if (this.shouldShowBasicUI()) {
      const firstRxEntry =
        this.state.rxEntries && this.state.rxEntries[0];
      const rxNumber = firstRxEntry && firstRxEntry.rxNumber;
      itemCount = rxNumber && typeof rxNumber.length === 'number' ? rxNumber.length : 0;
    } else {
      itemCount = searchedRxItems && searchedRxItems.length ? searchedRxItems.length : 0;
    }
    const {
      selectedBinId,
      isAlreadyOnHold,
      isAlreadyAssigned,
      is_stocked,
      prescriptionUnAssign,
      prescriptionAssign,
      prescriptionDirectPickup,
      prescriptionRemind,
      prescriptionConsult,
      prescriptionHoldResume,
      prescriptionAcDc,
      printTicketPermissionAllowed,
      isBinDeactivated,
      doesBinClicked,
    } = this.state;
    const canShowLockButton = isAlreadyOnHold || is_stocked;
    const isIlocalUser = localStorage.getItem('isIlocalUser');
    const zeroItems = itemCount === 0;
    const loading = this.state && this.state.isLoadingTrans === true;
    const itemDisabled = zeroItems || loading;

    return (
      <AssignPrescriptionActionFooter>
        {printTicketPermissionAllowed
          ? this.renderAssignActionButton(
              t('API.Roles.Permission.Assign.PrintTicket'),
              this.handlePrintTicket,
              {
                variant: 'print',
                disabled:
                  !Boolean(selectedBinId) ||
                  !(
                    this.state.reminderData &&
                    this.state.reminderData.data &&
                    this.state.reminderData.data.response &&
                    this.state.reminderData.data.response.box &&
                    this.state.reminderData.data.response.box.customers &&
                    this.state.reminderData.data.response.box.customers[0] &&
                    this.state.reminderData.data.response.box.customers[0].orders &&
                    this.state.reminderData.data.response.box.customers[0].orders[0] &&
                    this.state.reminderData.data.response.box.customers[0].orders[0].type_id ===
                      assignmentstatus.STOCKED
                  ),
              }
            )
          : null}
        {prescriptionAcDc
          ? this.renderAssignActionButton(
              isBinDeactivated ? t('Assign.Activate') : t('Assign.Deactivate'),
              this.handleBinActivationChange,
              {
                variant: isBinDeactivated ? 'success' : 'danger',
                disabled: !Boolean(selectedBinId),
              }
            )
          : null}
        {(is_stocked || isAlreadyAssigned || isAlreadyOnHold) && itemCount !== 0 ? (
          <React.Fragment>
            {prescriptionRemind
              ? this.renderAssignActionButton(t('Assign.RemindButton'), () => this.reminderHandler(), {
                  variant: 'remind',
                })
              : null}
            {prescriptionConsult
              ? this.renderAssignActionButton(t('Assign.ConsultButton'), () => this.handleConsultClick(), {
                  variant: 'consult',
                })
              : null}
          </React.Fragment>
        ) : null}
        {this.renderAssignActionButton(t('Assign.ClearButton'), () => this.ClearFields(), {
          variant: 'neutral',
          disabled: itemDisabled,
        })}
        {[true, 'true'].includes(isIlocalUser)
          ? this.renderAssignActionButton(t('Assign.PhantomBin.Button'), () =>
              this.setState({ confirmPhantomRemoval: true }), {
              variant: 'utility',
              disabled: !doesBinClicked,
            })
          : null}
        {!this.state.isVisibleForPause ? (
          <React.Fragment>
            {prescriptionDirectPickup
              ? this.renderAssignActionButton(
                  t('Assign.DirectPickupButton'),
                  () => this.ManualPickupNotification(0),
                  { variant: 'pickup', disabled: itemDisabled }
                )
              : null}
            {prescriptionAssign === true ? (
              <React.Fragment>
                {this.renderAssignActionButton(
                  t('Assign.SaveButton'),
                  () => {
                    const type = 0;
                    const { boxTypeId, locationtype_id } = this.state;
                    if (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) {
                      this.checkIfFastlaneBinIdIsExistOrNot(type);
                    } else {
                      this.checkIfBinIsOccupedFromAnotherLocation(type);
                    }
                  },
                  { variant: 'primary', disabled: itemDisabled }
                )}
                {this.renderAssignActionButton(
                  t('Assign.SavePrintButton'),
                  () => {
                    const type = 1;
                    const { boxTypeId, locationtype_id } = this.state;
                    if (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) {
                      this.checkIfFastlaneBinIdIsExistOrNot(type);
                    } else {
                      this.checkIfBinIsOccupedFromAnotherLocation(type);
                    }
                  },
                  { variant: 'savePrint', disabled: itemDisabled }
                )}
              </React.Fragment>
            ) : null}
          </React.Fragment>
        ) : !isAlreadyOnHold ? (
          <React.Fragment>
            {isAlreadyAssigned && (
              <React.Fragment>
                {prescriptionDirectPickup
                  ? this.renderAssignActionButton(
                      t('Assign.DirectPickupButton'),
                      () => this.ManualPickupNotification(1),
                      { variant: 'pickup', disabled: itemDisabled }
                    )
                  : null}
                {prescriptionUnAssign === true
                  ? this.renderAssignActionButton('Remove', () => this.changeOrderStatus('remove'), {
                      variant: 'remove',
                      disabled: isAlreadyOnHold,
                      tooltip: t('Assign.RemovePrescription'),
                    })
                  : null}
              </React.Fragment>
            )}
            {prescriptionHoldResume
              ? this.renderAssignActionButton(null, () => this.changeOrderStatus('pause'), {
                  variant: 'hold',
                  disabled: isAlreadyOnHold || isAlreadyAssigned,
                  tooltip: t('API.Roles.Permission.Assign.Hold', { defaultValue: 'Pause order' }),
                  children: <Pause fontSize="small" />,
                  iconOnly: true,
                })
              : null}
            {this.renderAssignActionButton(t('Assign.PrintLabel'), () => this.handlePrintReceipt(), {
              variant: 'printLabel',
              disabled: this.state.printLoading,
            })}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {prescriptionHoldResume
              ? this.renderAssignActionButton(null, () => this.changeOrderStatus('play'), {
                  variant: 'resume',
                  disabled: !isAlreadyOnHold,
                  tooltip: t('Assign.ResumeButton', { defaultValue: 'Resume order' }),
                  children: <PlayArrow fontSize="small" />,
                  iconOnly: true,
                })
              : null}
            {this.renderAssignActionButton(t('Assign.PrintLabel'), () => this.handlePrintReceipt(), {
              variant: 'printLabel',
              disabled: this.state.printLoading,
            })}
          </React.Fragment>
        )}
        {canShowLockButton
          ? this.renderAssignActionButton(null, this.handleLockToggle, {
              variant: 'icon',
              tooltip: this.state.isBinLocked ? t('Assign.Unlock') : t('Assign.Lock'),
              children: this.state.isBinLocked ? (
                <LockIcon sx={{ fontSize: 25 }} />
              ) : (
                <LockOpenIcon sx={{ fontSize: 25 }} />
              ),
            })
          : null}
      </AssignPrescriptionActionFooter>
    );
  };
  
  render() {
    const Dateoptions = { year: 'numeric', month: 'numeric', day: 'numeric' }; // Define options for formatting the date
    const {
      searchedItems,
      selectedBinId,
      stockCode,
      pickupCode,
      selected,
      hasError,
      locationtype,
      order,
      orderBy,
      isManualOverrideOpen,
      selectedBox,
      boxTypeId,
      accountDetails,
      confirmPhantomRemoval,
      isPhantomStockCodePrompt,
      prescriptionAssign,
      prescriptionView,
      prescriptionHoldResume,
      assign_order_notes,
      consultCheckBoxFlagForRxByBin,
      htmlBodyToPrint,
      assignCartItems,
    } = this.state;
    const { classes, t } = this.props;
    const labelPrint = this.state.labelDataForPrint || {};
    const locationtype_id = this.getActiveLocationTypeId();
    const cartRxList = resolveAssignCartRxList(assignCartItems, searchedRxItems);
    const localizer = momentLocalizer(moment);
    const assignPrescriptionCurrentTabIndex = this.state.expansionUnits.findIndex(
      (x) => x.pos === 'M' || x.pos === 'M22' || x.pos === 'FASTLANE' || x.pos === 'M24' || x.pos === 'FASTLANEGOLIATH' || x.pos === 'M41'
    );
    const disabledDatesStyle = (date, currentDate) => {
      if (date < currentDate) {
        return {
          className: 'disabled-date',
          style: {
            backgroundColor: '#e6e6e6',
            color: '#99999',
            pointerEvents: 'none',
          },
        };
      }
    };
    
    // Early return for Counter/Bedside/Curbside — shared assignment UI
    if (usesCounterAssignShell(locationtype_id)) {
      const fallbackPatientEmail =
        (searchedItems &&
          (searchedItems.email ||
            searchedItems.EmailAddress ||
            searchedItems.EmailID ||
            searchedItems.emailAddress)) ||
        "";
      const fallbackPatientPhone =
        (searchedItems &&
          (searchedItems.phone ||
            searchedItems.sms_phone ||
            searchedItems.MobilePhone ||
            searchedItems.mobilePhone ||
            searchedItems.CellPhone ||
            searchedItems.cell_phone)) ||
        "";

      const patientEmailValue =
        this.state.EmailID !== undefined && this.state.EmailID !== null
          ? this.state.EmailID
          : fallbackPatientEmail;

      const rawPhoneValue =
        this.state.phone !== undefined && this.state.phone !== null
          ? this.state.phone
          : fallbackPatientPhone;
      const patientPhoneValue = this.formatUSPhoneNumber(rawPhoneValue);

      const patientEmailError = this.getEmailError(patientEmailValue);
      const patientPhoneError = this.getPhoneError(patientPhoneValue);

      return (
        <Box component='div'>
          <Paper
            id='react-no-print'
            className={`${classes.paperRoot} assign-prescription-dense`}
          >
            {this.renderEpicStatusBanner()}
            {this.renderLoaderCover()}
            
            {/* Shared dialogs that Counter UI might need */}
            <div id='react-no-print'>
              {/* Delete Confirmation Dialog */}
              <Dialog
                open={this.state.deleteDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
              >
                <DialogTitle id='alert-dialog-title'>
                  {'Are you sure you want to delete?'}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    {t('Assign.AreYouSureToDelete')}
                    <ul>
                      {this.state.forDeletion &&
                        this.state.forDeletion.map(function (a) {
                          return <li>{a.name}</li>;
                        })}
                    </ul>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.deleteConfirmClose}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.CancelButton')}
                  </Button>
                  <Button
                    onClick={this.deleteConfirmed}
                    color='primary'
                    autoFocus
                    className={classes.primaryButton}
                  >
                    {t('Assign.DeleteButton')}
                  </Button>
                </DialogActions>
              </Dialog>
              
              {/* Manual Override Dialog */}
              {isManualOverrideOpen && (
                <PatientManulOverride
                  detailDialogOpen={isManualOverrideOpen}
                  selectedObject={{
                    binid: selectedBinId,
                    kiosk_box_id: selectedBox && selectedBox.kiosk_box_id,
                    pmid: this.state.pmid,
                    boxid: this.state.box_id,
                    pucode: this.state.pickupCode,
                  }}
                  onPopupClose={() =>
                    this.setState({ isManualOverrideOpen: false })
                  }
                  isPatientDetailsVisible={false}
                  isBoxDetailsVisible={false}
                  isManualOverrideVisible={true}
                  isManualConsultVisible={true}
                />
              )}
              
              {/* Verifying Bin Dialog */}
              <Dialog
                open={this.state.isVerifyingBin || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
              >
                <DialogTitle id='alert-dialog-title'>
                  {t('Assign.BinStatus')}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    {this.state && this.state.isVerifyingBinMessage}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.confirmBinOkButton}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.OkayButton')}
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Consult cancel reason dialog - when user unchecks required consultation */}
              <Dialog
                open={this.state.consultWaiveDialogOpen}
                onClose={this.handleConsultWaiveCancel}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                  sx: {
                    borderRadius: 3,
                    boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
                    overflow: "hidden",
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    m: 0,
                    px: 3,
                    py: 2.5,
                    background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "1.15rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <InfoIcon sx={{ color: "#ffffff", fontSize: "1.5rem" }} />
                    <span>{t('Assign.ConsultWaive.Title')}</span>
                  </Box>
                  <IconButton
                    aria-label={t('Global.Close') || 'Close'}
                    onClick={this.handleConsultWaiveCancel}
                    sx={{
                      color: "#ffffff",
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.18)",
                      },
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </DialogTitle>
                <DialogContent
                  sx={{
                    px: 3,
                    pt: 3,
                    pb: 2,
                    backgroundColor: "#f8fafc",
                  }}
                >
                  <DialogContentText
                    sx={{
                      color: "#475569",
                      fontSize: "0.95rem",
                      lineHeight: 1.6,
                      mb: 2,
                    }}
                  >
                    {t('Assign.ConsultWaive.ReasonPlaceholder')}
                  </DialogContentText>
                  <TextField
                    autoFocus
                    fullWidth
                    placeholder={t('Assign.ConsultWaive.ReasonPlaceholder')}
                    value={this.state.consultWaiveReason}
                    onChange={(e) => this.setState({ consultWaiveReason: e.target.value })}
                    multiline
                    minRows={2}
                    variant="outlined"
                    margin="dense"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#ffffff",
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#7c3aed",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#7c3aed",
                          borderWidth: 2,
                        },
                      },
                    }}
                  />
                </DialogContent>
                <DialogActions
                  sx={{
                    px: 3,
                    py: 2,
                    backgroundColor: "#ffffff",
                    borderTop: "1px solid #e2e8f0",
                  }}
                >
                  <Button
                    onClick={this.handleConsultWaiveCancel}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      color: "#64748b",
                      px: 3,
                      "&:hover": {
                        backgroundColor: "#e2e8f0",
                      },
                    }}
                  >
                    {t('Assign.ConsultWaive.Cancel')}
                  </Button>
                  <Button
                    onClick={this.handleConsultWaiveConfirm}
                    variant="contained"
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
                      boxShadow: "0 4px 14px 0 rgba(124, 58, 237, 0.3)",
                      px: 3,
                      py: 1,
                      borderRadius: 2,
                      "&:hover": {
                        background: "linear-gradient(135deg, #6d28d9 0%, #5b21b6 100%)",
                        boxShadow: "0 6px 20px 0 rgba(124, 58, 237, 0.4)",
                      },
                    }}
                  >
                    {t('Assign.ConsultWaive.Confirm')}
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
            
            {this.renderLocationTypeLicenseCallout()}
            {/* Counter-specific UI */}
            <CounterAssignUI
              searchedRxItems={searchedRxItems}
              searchedItems={searchedItems}
              stockCode={stockCode}
              pickupCode={pickupCode}
              prescriptionAssign={prescriptionAssign}
              customerId={searchedItems && (searchedItems.customer_id || searchedItems.customerId || searchedItems.patient_id || searchedItems.PatientID)}
              prescriptionView={prescriptionView}
              prescriptionHoldResume={prescriptionHoldResume}
              isEpicHasValidRx={this.state.isEpicHasValidRx}
              isEpicHasValidRxMessage={this.state.isEpicHasValidRxMessage}
              rxNumber={this.state.rxNumber}
              patientFirstName={(searchedItems && searchedItems.first_name) || (searchedItems && searchedItems.FirstName) || ''}
              patientLastName={(searchedItems && searchedItems.last_name) || (searchedItems && searchedItems.LastName) || ''}
              patientEmail={patientEmailValue}
              patientEmailError={patientEmailError}
              patientPhone={patientPhoneValue}
              patientPhoneError={patientPhoneError}
              patientDOB={this.state.dateOfBirth || (searchedItems && (searchedItems.dateOfBirth || searchedItems.DateOfBirth || searchedItems.dob_str || searchedItems.DOB)) || ''}
              patientRecord={this.state.patientRecord || (searchedItems && (searchedItems.PatientRecordNumber || searchedItems.patientRecordNumber || searchedItems.patient_record_number || searchedItems.PatientID || searchedItems.patientID)) || ''}
              locationName={(selectedBox && selectedBox.name) || ''}
              locationTypeDisplay={getLocationTypeName(locationtype_id) || ''}
              addressLine1={(this.state.searchedItems && this.state.searchedItems.AddressLine1) || (this.state.address && this.state.address.address1) || (selectedBox && selectedBox.address && selectedBox.address.address_line_1) || (selectedBox && selectedBox.address_line_1) || ''}
              addressLine2={(this.state.searchedItems && this.state.searchedItems.AddressLine2) || (this.state.address && this.state.address.address2) || (selectedBox && selectedBox.address && selectedBox.address.address_line_2) || (selectedBox && selectedBox.address_line_2) || ''}
              city={(this.state.searchedItems && this.state.searchedItems.City) || (this.state.address && this.state.address.city) || (selectedBox && selectedBox.address && selectedBox.address.city) || (selectedBox && selectedBox.city) || ''}
              state={(this.state.searchedItems && this.state.searchedItems.State) || (this.state.address && this.state.address.state) || (selectedBox && selectedBox.address && selectedBox.address.state) || (selectedBox && selectedBox.state) || ''}
              zip={(this.state.searchedItems && this.state.searchedItems.Zip) || (this.state.address && this.state.address.zip) || (selectedBox && selectedBox.address && selectedBox.address.zip) || (selectedBox && selectedBox.zip) || ''}
              binAssignments={this.getBinAssignments()}
              orderTotal={this.getDueAmount()}
              binId={usesCounterAssignShell(locationtype_id) ? (this.state.storage_location || '') : (this.state.selectedBinId || '')}
              defaultValidatedLocation={isReusableStorageLocationType(locationtype_id) ? this.state.defaultCheckInLocation : null}
              locationOptions={isReusableStorageLocationType(locationtype_id) ? (this.state.bedsideLocationOptions || []) : []}
              isLoadingLocationOptions={isReusableStorageLocationType(locationtype_id) && this.state.isLoadingCheckInDefault}
              onLocationOptionsOpen={
                isReusableStorageLocationType(locationtype_id)
                  ? () => this.loadDefaultCheckInLocation(this.state.box_id)
                  : undefined
              }
              roomNumber={this.state.room_number || ''}
              orderNotes={isReusableStorageLocationType(this.state.locationtype_id) ? (this.state.order_notes || '') : ''}
              isNonRxDeliverEnabled={this.isNonRxDeliverEnabled()}
              otcDeliveryEntitlementLoading={this.isOtcDeliveryEntitlementLoading()}
              showNonRxScan={false}
              otcDeliveryEntitlement={this.state.otcDeliveryEntitlement}
              boxId={this.state.box_id}
              nonRxCartItems={this.state.nonRxCartItems}
              upcScan={this.state.upcScan}
              upcScanBusy={this.state.upcScanBusy}
              onUpcScanChange={this.handleUpcScanChange}
              onUpcScanKeyDown={this.handleUpcScanKeyDown}
              onUpcScanSubmit={this.handleUpcScanSubmit}
              onUpcScanFocus={this.handleUpcScanFocus}
              onUpcScanBlur={this.handleUpcScanBlur}
              onAddNonRxItem={this.handleAddNonRxItem}
              onAddCustomNonRxItem={this.handleAddCustomNonRxItem}
              onChangeNonRxItem={this.handleChangeNonRxItem}
              onRemoveNonRxItem={this.handleRemoveNonRxItem}
              onSearchNonRxCatalog={this.searchNonRxCatalog}
              onSelectNonRxCatalogProduct={this.handleSelectNonRxCatalogProduct}
              onSaveNonRxProductImage={this.handleSaveNonRxProductImage}
              onRxScan={(value) => this.onChange({ target: { value } })}
              onBinScan={(value) => this.getSelectedBin(value)}
              onBinIdChange={(value) => {
                // For Counter/Bedside/Curbside, update storage_location instead of selectedBinId
                if (usesCounterAssignShell(locationtype_id)) {
                  this.setState({ storage_location: value });
                } else {
                  this.setState({ selectedBinId: value });
                }
              }}
              onRoomNumberChange={(value) => {
                this.setState({ room_number: value });
              }}
              onOrderNotesChange={(value) => {
                this.setState({ order_notes: value });
              }}
              onLocationChange={(locationData, options = {}) => {
                this.setState({ locationData: locationData });
                if (locationData && locationData.location) {
                  this.setState({ storage_location: locationData.location });
                } else if (!locationData && !options.preserveInput) {
                  this.setState({ storage_location: '' });
                }
              }}
              onRxChange={(index, field, value) => {
                if (searchedRxItems && searchedRxItems[index]) {
                  searchedRxItems[index][field] = value;
                  this.forceUpdate();
                }
              }}
              onQtyChange={(index, value) => {
                if (searchedRxItems && searchedRxItems[index]) {
                  searchedRxItems[index].qty = value;
                  this.forceUpdate();
                }
              }}
              onPatientEmailChange={this.handlePatientEmailChange}
              onPatientPhoneChange={this.handlePatientPhoneChange}
              onAmountDueChange={(index, value) => {
                if (searchedRxItems && searchedRxItems[index]) {
                  searchedRxItems[index].CoPayAmount = value;
                  this.forceUpdate();
                }
              }}
              onControlledSubstanceChange={(index, checked) => {
                this.handleControlledSubstanceChange(index, checked);
              }}
              onConsultChange={(index, checked) => {
                if (searchedRxItems && searchedRxItems[index]) {
                  const item = searchedRxItems[index];
                  const isCurrentlyRequired = item.ConsultRequire || item.is_consultrequire;
                  if (checked === false && isCurrentlyRequired) {
                    this.setState({
                      consultWaiveDialogOpen: true,
                      consultWaiveIndex: index,
                      consultWaiveReason: '',
                    });
                    return;
                  }
                  searchedRxItems[index].ConsultRequire = checked;
                  this.forceUpdate();
                }
              }}
              onRemoveItem={(index) => {
                if (searchedRxItems && searchedRxItems[index]) {
                  searchedRxItems.splice(index, 1);
                  if (searchedRxItems.length === 0) {
                    this.ClearFields();
                  } else {
                    this.forceUpdate();
                  }
                }
              }}
              onAssign={() => {
                const type = 0;
                const { boxTypeId, locationtype_id } = this.state;
                // Simplified: proceed directly with assignment flow
                if (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) {
                  this.checkIfFastlaneBinIdIsExistOrNot(type);
                } else {
                  this.checkIfBinIsOccupedFromAnotherLocation(type);
                }
              }}
              onAssignAndPrint={() => {
                const type = 1;
                const { boxTypeId, locationtype_id } = this.state;
                // Simplified: proceed directly with assignment flow
                if (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) {
                  this.checkIfFastlaneBinIdIsExistOrNot(type);
                } else {
                  this.checkIfBinIsOccupedFromAnotherLocation(type);
                }
              }}
              onClear={() => this.ClearFields()}
              onToggleLoader={(loading) => this.setState({ loader: loading })}
              onOpenPrintDialogWithRxByBin={this.openPrintDialogFromRxByBin}
              currentBoxData={this.state.currentBoxData}
              accountDetails={this.state.accountDetails}
              courier_tracking={this.state.courier_tracking}
              default_courier_selected={this.state.default_courier_selected}
              locationtype_id={locationtype_id}
              locationtype={this.getLicensedLocationTypes()}
              onLocationTypeChange={this.handleLocationTypeChange}
              boxes={this.state.allBoxes}
              onCounterLocationChange={this.handleCounterLocationChange}
              onGetAccountConnection={this.GetAcccountConnectionId}
              boxDetails={this.state.boxDetails}
              paymentDeviceSelector={this.renderPaymentDeviceSelector({ paymentCard: true })}
            />
          </Paper>

          
          {/* Print Label Functionality for Counter */}
          <Box component='div' id='Print_AssingPrescription_Label'>
            <PrintTemplate>
              <Dialog
                open={this.state.printDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                PaperProps={{
                  sx: { borderRadius: '0px', width: '255px', height: '500px' },
                }}
              >
                <DialogContent sx={{ p: '10px' }}>
                  <LabelTemplate
                    style={{ display: 'none' }}
                    stockCode={labelPrint.stockCode || ''}
                    pickupCode={labelPrint.pickupCode || ''}
                    rxNumbers={labelPrint.rxNumbers || []}
                    boxId={this.state.box_id || ''}
                    ref={(el) => (this.componentRef = el)}
                    accountDetails={this.state.accountDetails || ''}
                    pharmacyDetails={this.state.pharmacyDetails || ''}
                    firstName={labelPrint.firstName || ''}
                    lastName={labelPrint.lastName || ''}
                    dateOfBirth={labelPrint.dateOfBirth || ''}
                    isCoolItem={labelPrint.isCoolItem || false}
                    locationTypeID={this.state.locationtype_id || ''}
                    brandingName={labelPrint.brandName || ''}
                    brandingPhone={labelPrint.brandPhone || ''}
                    boxDetails={this.state.boxDetails}
                    connectionType={0}
                    t={t}
                    bin_id={labelPrint.binId || ''}
                    rxEntries={labelPrint.rxEntries || []}
                    accountConnectionsId={this.state.accountConnectionsLoginId}
                    compactStockLabelLayout={true}
                    nonRxItems={labelPrint.nonRxItems || []}
                    roomNumber={labelPrint.roomNumber || ''}
                    orderNotes={labelPrint.orderNotes || ''}
                    showRoomNumber={this.state.locationtype_id === LOCATION_TYPE.Bedside}
                  />
                </DialogContent>
              </Dialog>
            </PrintTemplate>
          </Box>
        </Box>
      );
    }
    // Default UI for all other location types
    return (
      <Box component='div' className={classes.assignPageRoot}>
        <Paper className={`${classes.paperRoot} assign-prescription-dense`}>
          {this.renderEpicStatusBanner()}
          {/* Tabs and Search Bar Row - At top of Paper, tabs left, search right */}
          {locationtype && locationtype.length > 1 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 0,
                gap: 2,
                width: '100%',
px: 1,
                pt: 0.25,
              }}
            >
              <Box sx={{ flexShrink: 0 }}>
                <DeliveryTypeTabs
                  selectedLocationTypeId={locationtype_id}
                  onLocationTypeChange={this.handleLocationTypeChange}
                  locationtype={this.getLicensedLocationTypes()}
                  position="inline"
                />
              </Box>
              {this.renderColumnMappingNotice()}
              <Box sx={{ flexShrink: 0 }}>
                <TextField
                  id='idsearchtxt'
                  type='text'
                  margin='normal'
                  variant='standard'
                  value={this.state.searchObj.searchTxt}
                  label={t('Assign.Search')}
                  InputProps={{
                    inputProps: { autoComplete: 'off' },
                    form: {
                      autoComplete: 'off',
                    },
                    startAdornment: (
                      <InputAdornment position='start'>
                        <MagnifyIcon />
                      </InputAdornment>
                    ),
                  }}
                  onChange={this.onSearchChange}
                  sx={{ width: '6cm' }}
                />
              </Box>
            </Box>
          )}
          {this.renderLocationTypeLicenseCallout()}
          
          {(!locationtype || locationtype.length === 0 || locationtype.length === 1) && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 0,
                gap: 2,
                width: '100%',
                px: 1,
                pt: 0.25,
              }}
            >
              {this.renderColumnMappingNotice()}
              <Box sx={{ flexShrink: 0, ml: 'auto' }}>
              <TextField
                id='idsearchtxt'
                type='text'
                margin='normal'
                variant='standard'
                value={this.state.searchObj.searchTxt}
                label={t('Assign.Search')}
                InputProps={{
                  inputProps: { autoComplete: 'off' },
                  form: {
                    autoComplete: 'off',
                  },
                  startAdornment: (
                    <InputAdornment position='start'>
                      <MagnifyIcon />
                    </InputAdornment>
                  ),
                }}
                onChange={this.onSearchChange}
                sx={{ width: '6cm' }}
              />
              </Box>
            </Box>
          )}
          {this.renderLoaderCover()}
          <Box id='react-no-print' className={classes.assignPageBody}>
            <div id='react-no-print' className={classes.root}>
              <Dialog
                open={this.state.deleteDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
              >
                <DialogTitle id='alert-dialog-title'>
                  {'Are you sure you want to delete?'}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    {t('Assign.AreYouSureToDelete')}
                    <ul>
                      {this.state.forDeletion &&
                        this.state.forDeletion.map(function (a) {
                          return <li>{a.name}</li>;
                        })}
                    </ul>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.deleteConfirmClose}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.CancelButton')}
                  </Button>
                  <Button
                    onClick={this.deleteConfirmed}
                    color='primary'
                    autoFocus
                    className={classes.primaryButton}
                  >
                    {t('Assign.DeleteButton')}
                  </Button>
                </DialogActions>
              </Dialog>
              {/* Consult cancel reason dialog (non-counter theme) - when user unchecks required consultation */}
              <Dialog
                open={this.state.consultWaiveDialogOpen || false}
                onClose={this.handleConsultWaiveCancel}
                aria-labelledby='consult-waive-dialog-title'
                aria-describedby='consult-waive-dialog-description'
                maxWidth='sm'
                fullWidth
              >
                <DialogTitle id='consult-waive-dialog-title' className={classes.dialogTitleColor}>
                  {t('Assign.ConsultWaive.Title')}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id='consult-waive-dialog-description'>
                    {t('Assign.ConsultWaive.ReasonPlaceholder')}
                  </DialogContentText>
                  <TextField
                    autoFocus
                    fullWidth
                    margin='normal'
                    placeholder={t('Assign.ConsultWaive.ReasonPlaceholder')}
                    value={this.state.consultWaiveReason}
                    onChange={(e) => this.setState({ consultWaiveReason: e.target.value })}
                    multiline
                    minRows={2}
                    variant='outlined'
                    className={classes.textField}
                    inputProps={{
                      'aria-label': t('Assign.ConsultWaive.ReasonLabel') || 'Reason for waiving consultation',
                    }}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.handleConsultWaiveCancel}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.ConsultWaive.Cancel')}
                  </Button>
                  <Button
                    onClick={this.handleConsultWaiveConfirm}
                    color='primary'
                    className={classes.primaryButton}
                    autoFocus
                  >
                    {t('Assign.ConsultWaive.Confirm')}
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.SearchResultDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                fullWidth={true}
                PaperProps={{
                  style: { maxWidth: '1315px' },
                }}
              >
                <DialogContent>
                  {this.state.innerSearchLoader && (
                    <Box component='div' className={classes.spinner}>
                      <Box
                        component='img'
                        className={classes.spinnerImage}
                        src={spinner}
                        alt='loading'
                      />
                    </Box>
                  )}
                  <Table aria-labelledby='tableTitle'>
                    <TableHead>
                      <TableRow sx={{ height: '56px' }}>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.FirstName')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.LastName')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Email')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Phone')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Bin')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Status')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.StockCode')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.PUCode')}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Array.isArray(this.state.selectedObject) &&
                        this.state.selectedObject.length > 0 ? (
                        this.state &&
                        this.state.selectedObject.map((n) => {
                          return (
                            <TableRow>
                              <TableCell className={classes.tablebody}>
                                {n.first_name}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.last_name}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.email}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.phone}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.bin_id}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.status}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                <a
                                  href=''
                                  title='View'
                                  style={{
                                    color: '#385cad',
                                    fontWeight: 500,
                                    textDecoration: 'none ',
                                    fontSize: '1rem',
                                  }}
                                  onClick={(event) =>
                                    this.handlePUcodeClick(
                                      event,
                                      n.bin_id,
                                      n.pm_id,
                                      n.box_id,
                                      n.stock_code
                                    )
                                  }
                                >
                                  {n.stock_code}
                                </a>
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                <a
                                  href=''
                                  title='View'
                                  style={{
                                    color: '#385cad',
                                    fontWeight: 500,
                                    textDecoration: 'none ',
                                    fontSize: '1rem',
                                  }}
                                  onClick={(event) =>
                                    this.handlePUcodeClick(
                                      event,
                                      n.bin_id,
                                      n.pm_id,
                                      n.box_id,
                                      n.stock_code
                                    )
                                  }
                                >
                                  {n.pucode}
                                </a>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={5}>
                            {t('Assign.NoDataFound')}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <ThemeProvider theme={localeTheme}>
                    <TablePagination
                      component='div'
                      count={this.state.totalSearchRecords || 0}
                      rowsPerPage={this.state.searchObj.pageSize}
                      page={this.state.searchObj.pageNo}
                      backIconButtonProps={{
                        'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                        'aria-label': 'Next Page',
                      }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                  </ThemeProvider>
                </DialogContent>
                <DialogActions style={{ marginTop: '-20px' }}>
                  <Button
                    onClick={(e) => {
                      this.handleSearchClose(e);
                    }}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.Search.Close')}
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.showDatePopup || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                PaperProps={{
                  style: { maxWidth: '1315px' },
                }}
              >
                <DialogTitle id='alert-dialog-title'>
                  {'Set Future Release Date'}
                  <IconButton
                    onClick={() => { this.setState({ showDatePopup: false, FutureRelease: false }) }}
                    aria-label="Close"
                    style={{ position: 'absolute', padding: '0px', right: '20px', top: '20px' }}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <Calendar
                    dayPropGetter={(date) => disabledDatesStyle(date, new Date())}
                    localizer={localizer}
                    selectable={true}
                    toolbar={true}
                    events={[]}
                    views={['month']}
                    startAccessor="start"
                    endAccessor="end"
                    onSelectSlot={this.handleFutureDateChange}
                    style={{ height: 500, width: 600 }}
                  />
                </DialogContent>
              </Dialog>
              <div className="assign-page-columns">
              <div id='react-no-print' className={classNames(classes.assignForm, 'assign-form-panel')}>
                <div className={classNames(classes.main, 'assign-form-header')}>
                  {!this.shouldShowBasicUI() || this.shouldShowScanRowNotices() ? (
                    <div className="assign-scan-notice-row">
                      {!this.shouldShowBasicUI() && (
                        <div className="assign-scan-rx-row assign-scan-rx-row--rx-only">
                          {this.renderScanRxBasedOnConnectionType(classes)}
                        </div>
                      )}
                      {this.renderScanRowNotices()}
                    </div>
                  ) : null}
                </div>
                {this.shouldShowBasicUI() ?
                  <Grid container spacing={0} sx={{ width: '100%', m: 0, minWidth: 0 }}>
                    <Grid item xs={this.state.locationtype_id === LOCATION_TYPE.Kiosk ? 12 : 6} sx={{ minWidth: 0, maxWidth: '100%' }}>
                      <Grid container spacing={0} sx={{ width: '100%', m: 0 }}>
                        <Grid item xs={12}>
                          <div className={classes.basicNotifyBar}>
                            <span className={classes.basicNotifyLabel}>{t('Assign.NotifyBy')}</span>
                            <RadioGroup
                              row
                              name='notifyChannel'
                              value={this.state.notifyChannel === 'email' ? 'email' : 'sms'}
                              onChange={(event) => this.setState({
                                notifyChannel: event.target.value,
                                phoneError: false,
                                basicEmailError: false,
                              })}
                            >
                              <FormControlLabel
                                value='sms'
                                control={<Radio size='small' color='primary' />}
                                label={t('Assign.SMSPhone')}
                                disabled={!prescriptionAssign || this.state.isRxView}
                              />
                              <FormControlLabel
                                value='email'
                                control={<Radio size='small' color='primary' />}
                                label={t('Assign.Email')}
                                disabled={!prescriptionAssign || this.state.isRxView}
                              />
                            </RadioGroup>
                            <span className={classes.basicNotifyHelp}>{t('Assign.NotifyByHelp')}</span>
                          </div>
                        </Grid>
                        <Grid item xs={6} sx={{ pr: 1.5, minWidth: 0, minHeight: 56 }}>
                          {this.state.notifyChannel === 'email' ? (
                            <TextField
                              id='basicEmail'
                              type='email'
                              className={classes.textField}
                              fullWidth
                              name='EmailID'
                              margin='normal'
                              variant='standard'
                              label={`${t('Assign.Email')} *`}
                              onChange={(event) => this.setState({
                                EmailID: event.target.value,
                                basicEmailError: false,
                              })}
                              onBlur={this.handlePhoneBlur}
                              InputLabelProps={{ shrink: true }}
                              value={this.state.EmailID}
                              inputProps={{ autoComplete: 'off' }}
                              disabled={!prescriptionAssign}
                              readOnly={this.state.isRxView}
                              error={this.state.basicEmailError}
                              helperText={this.state.basicEmailError ? t('Toast.Error.EnterEmail') : ''}
                            />
                          ) : (
                            <TextField
                              id='phoneNo'
                              type='text'
                              className={classes.textField}
                              fullWidth
                              inputRef={this.phoneInputRef}
                              name='phone'
                              margin='normal'
                              variant='standard'
                              label={`${t('Assign.SMSPhone')} *`}
                              onChange={this.handlePhoneChange}
                              onBlur={this.handlePhoneBlur}
                              InputLabelProps={{ shrink: true }}
                              value={this.state.phone}
                              inputProps={{
                                autoComplete: 'off',
                                maxLength: 14
                              }}
                              disabled={!prescriptionAssign}
                              readOnly={this.state.isRxView}
                              error={this.state.phoneError}
                              helperText={this.state.phoneError ? t('Validation.Phone') : ''}
                            />
                          )}
                        </Grid>
                        <Grid item xs={6} sx={{ pl: 1.5, minWidth: 0, minHeight: 56 }}>
                          <TextField
                            id="dateOfBirth"
                            type="text"
                            className={classes.textField}
                            margin="normal"
                            variant="standard"
                            label={
                              this.isBasicDobOptional()
                                ? (
                                  <span>
                                    {t('Assign.DOB')}
                                    <span style={{ marginLeft: 8, color: '#64748b', fontWeight: 500 }}>
                                      {t('Assign.DobOptional')}
                                    </span>
                                  </span>
                                )
                                : `${t('Assign.DOB')} *`
                            }
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              maxLength: 10,
                            }}
                            disabled={!prescriptionAssign}
                            readOnly={this.state.isRxView}
                            value={this.state.dateOfBirth}
                            onChange={this.handleDOBChange}
                            error={this.state.dobError}
                            helperText={this.state.dobError ? t('Validation.DOB') : ''}
                          />

                        </Grid>
                        <Grid item xs={12}>
                          <div className={classes.basicRxCard}>
                            <div className={classes.basicRxHeader}>
                              <div style={{ width: '40%' }}>{t('Home.StartConsultPopup.RxHash')}</div>
                              <div>{t('Navbar.Consult')}</div>
                              <IconButton
                                disabled={this.state.isRxView}
                                onClick={this.handleAddRx}
                                color="primary"
                                style={{ marginLeft: 'auto' }}
                              >
                                <AddCircleOutlineRounded />
                              </IconButton>
                            </div>
                            <div
                              style={{
                                maxHeight: '220px',
                                overflowY: this.state.rxEntries.length > 3 ? 'auto' : 'visible',
                                paddingTop: '8px',
                              }}
                            >
                            {this.state.rxEntries.map((entry, index) => (
                              <div key={index} className={classes.basicRxRow}>
                                <TextField
                                  id={`rx-${index}`}
                                  type='text'
                                  className={classes.scantextField}
                                  value={entry.rxNumber}
                                  margin='normal'
                                  variant='standard'
                                  placeholder="Enter Rx"
                                  onChange={(e) => this.handleRxChange(index, e)}
                                  inputProps={{
                                    autoComplete: 'off',
                                    form: { autoComplete: 'off' },
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !this.state.isRxView) {
                                      this.handleAddRx();
                                    }
                                  }}
                                  style={{ width: '40%' }}
                                  disabled={!prescriptionAssign}
                                  readOnly={this.state.isRxView}
                                />
                                <Checkbox
                                  checked={entry.isConsultRequired}
                                  onChange={(e) => this.handleConsultChange(index, e)}
                                  color="primary"
                                  disabled={!prescriptionAssign}
                                  readOnly={this.state.isRxView}
                                />

                                {this.state.rxEntries && this.state.rxEntries.length > 1 && (
                                  <IconButton
                                    onClick={() => this.handleRemoveRx(index)}
                                    color="primary"
                                    style={{ marginLeft: 'auto' }}
                                    disabled={this.state.isRxView}
                                  >
                                    <RemoveCircleOutlineRounded />
                                  </IconButton>
                                )}
                              </div>
                            ))}
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{ display: this.state.locationtype_id === LOCATION_TYPE.Kiosk ? 'none' : 'block' }}
                    >
                      <Grid container spacing={1}>
                        {this.state.locationtype_id !== LOCATION_TYPE.Kiosk && (
                          <Grid item xs={6}>
                            {this.renderLocationSelect('select-location')}
                          </Grid>
                        )}
                        {this.state.locationtype_id !== LOCATION_TYPE.Kiosk && (
                          <React.Fragment>
                            <Grid item xs={6}>
                              <TextField
                                id='address1'
                                type='text'
                                className={classes.textField}
                                margin='normal'
                                variant='standard'
                                label={t('Assign.Address1')}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                  autoComplete: 'off',
                                  form: {
                                    autoComplete: 'off',
                                  },
                                }}
                                value={this.state.address && this.state.address.address1}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                id='address2'
                                type='text'
                                className={classes.textField}
                                margin='normal'
                                variant='standard'
                                label={t('Assign.Address2')}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                  autoComplete: 'off',
                                  form: {
                                    autoComplete: 'off',
                                  },
                                }}
                                value={this.state.address && this.state.address.address2}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                id='city'
                                type='text'
                                className={classes.textField}
                                margin='normal'
                                variant='standard'
                                label={t('Assign.City')}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                  autoComplete: 'off',
                                  form: {
                                    autoComplete: 'off',
                                  },
                                }}
                                value={this.state.address && this.state.address.city}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                id='state'
                                type='text'
                                className={classes.textField}
                                margin='normal'
                                variant='standard'
                                label={t('Assign.State')}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                  autoComplete: 'off',
                                  form: {
                                    autoComplete: 'off',
                                  },
                                }}
                                value={this.state.address && this.state.address.state}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                id='zip'
                                type='text'
                                className={classes.textField}
                                margin='normal'
                                variant='standard'
                                label={t('Assign.Zip')}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                  autoComplete: 'off',
                                  form: {
                                    autoComplete: 'off',
                                  },
                                }}
                                value={this.state.address && this.state.address.zip}
                              />
                            </Grid>
                          </React.Fragment>
                        )}
                        {(this.state.locationtype_id !== LOCATION_TYPE.Kiosk) &&
                          this.renderKioskBinOrBinSizeField(classes, t, selectedBinId)}
                      </Grid>
                    </Grid>
                  </Grid> 
                  :
                  <Grid container spacing={0.5} className="assign-form-3col">
                    {this.state.locationtype_id !== LOCATION_TYPE.Kiosk && (
                    <Grid item xs={6}>
                      {this.renderLocationSelect('select-location-table')}
                    </Grid>
                    )}
                    <Grid item xs={4}>
                      <TextField
                        id='firstName'
                        type='text'
                        className={classes.textField}
                        margin='normal'
                        variant='standard'
                        label={t('Assign.FirstName')}
                        fullWidth
                        inputProps={{
                          autoComplete: 'off',
                          form: {
                            autoComplete: 'off',
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          searchedItems &&
                            searchedItems.FirstName &&
                            searchedItems.FirstName !== null &&
                            searchedItems.FirstName !== 'null'
                            ? searchedItems.FirstName
                            : ''
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id='lastName'
                        type='text'
                        className={classes.textField}
                        margin='normal'
                        variant='standard'
                        label={t('Assign.LastName')}
                        fullWidth
                        inputProps={{
                          autoComplete: 'off',
                          form: {
                            autoComplete: 'off',
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          searchedItems &&
                            searchedItems.LastName &&
                            searchedItems.LastName !== null &&
                            searchedItems.LastName !== 'null'
                            ? searchedItems.LastName
                            : ''
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id='patient record number'
                        type='text'
                        className={classes.textField}
                        margin='normal'
                        variant='standard'
                        label={t('Assign.PatientRecordNumber')}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          autoComplete: 'off',
                          form: {
                            autoComplete: 'off',
                          },
                        }}
                        value={this.BindPatientId()}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id='dateOfBirth'
                        type='text'
                        className={classes.textField}
                        margin='normal'
                        variant='standard'
                        label={t('Assign.DOB')}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          autoComplete: 'off',
                          form: {
                            autoComplete: 'off',
                          },
                        }}
                        value={
                          searchedItems &&
                            searchedItems.DateOfBirth &&
                            searchedItems.DateOfBirth !== null &&
                            searchedItems.DateOfBirth !== 'null'
                            ? searchedItems.DateOfBirth
                            : ''
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id='phoneNo'
                        type='text'
                        className={classes.textField}
                        fullWidth
                        margin='normal'
                        variant='standard'
                        label={t('Assign.SMSPhone')}
                        name='phone'
                        onChange={this.onInputChange}
                        InputLabelProps={{ shrink: true, maxLength: 10 }}
                        value={this.state.phone}
                        inputProps={{
                          autoComplete: 'off',
                          form: {
                            autoComplete: 'off',
                          },
                        }}
                        disabled={!prescriptionAssign}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id='email'
                        type='text'
                        className={classes.textField}
                        fullWidth
                        margin='normal'
                        variant='standard'
                        label={t('Assign.Email')}
                        name='EmailID'
                        onChange={this.onInputChange}
                        InputLabelProps={{ shrink: true }}
                        value={this.state.EmailID}
                        inputProps={{
                          autoComplete: 'off',
                          form: {
                            autoComplete: 'off',
                          },
                        }}
                        disabled={!prescriptionAssign}
                      />
                    </Grid>
                    {this.state.locationtype_id !== LOCATION_TYPE.Kiosk &&
                      this.renderKioskBinOrBinSizeField(classes, t, selectedBinId, { gridXs: 4 })}
                    {this.state.accountDetails && this.state.accountDetails.is_future_release ? (
                      <Grid item xs={4}>
                        <InputLabel
                          htmlFor='FutureRelease'
                          style={{ fontSize: '0.83rem' }}
                        >
                          {t('Assign.FutureRelease')}
                          {
                            this.state.FutureReleaseDate &&
                            this.state.FutureRelease &&
                            <span style={{
                              marginLeft: "3px",
                              color: "white",
                              padding: "3px",
                              fontSize: "10px",
                              borderRadius: "5px",
                              backgroundColor: "#00a7e1"
                            }}>
                              {
                                this.state.FutureReleaseDate.toLocaleDateString('en-US', Dateoptions)
                              }
                            </span>
                          }
                        </InputLabel>
                        <Select
                          disabled={this.state.disableFeild}
                          fullWidth={true}
                          value={this.state.FutureRelease}
                          onChange={this.handleFutureChange}
                          inputProps={{
                            name: 'FutureRelease',
                            id: 'FutureRelease',
                            disabled: !prescriptionAssign
                          }}
                          variant='standard'
                        >
                          {
                            [{ label: "Yes", value: true }, { label: "No", value: false }].map((type, index) => (
                              <MenuItem
                                key={index}
                                value={type.value}
                                selected
                                className={classes.locationType}
                              >
                                {type.label}
                              </MenuItem>
                            ))}
                        </Select>
                        {hasError && (
                          <FormHelperText className={classes.selectLable}>
                            Please select any option
                          </FormHelperText>
                        )}
                      </Grid>
                    ) : null}
                    {this.state.locationtype_id !== LOCATION_TYPE.Kiosk && (
                      <React.Fragment>
                        <Grid item xs={4}>
                          <TextField
                            id='address1'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Address1')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.AddressLine1 &&
                                searchedItems.AddressLine1 !== null &&
                                searchedItems.AddressLine1 !== 'null'
                                ? searchedItems.AddressLine1
                                : ''
                            }
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            id='address2'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Address2')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.AddressLine2 &&
                                searchedItems.AddressLine2 !== null &&
                                searchedItems.AddressLine2 !== 'null'
                                ? searchedItems.AddressLine2
                                : ''
                            }
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            id='city'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.City')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.City &&
                                searchedItems.City !== null &&
                                searchedItems.City !== 'null'
                                ? searchedItems.City
                                : ''
                            }
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            id='state'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.State')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.State &&
                                searchedItems.State !== null &&
                                searchedItems.State !== 'null'
                                ? searchedItems.State
                                : ''
                            }
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            id='zip'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Zip')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.Zip &&
                                searchedItems.Zip !== null &&
                                searchedItems.Zip !== 'null'
                                ? searchedItems.Zip
                                : ''
                            }
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            id='country'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Country')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autoComplete: 'off',
                              form: {
                                autoComplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.Country &&
                                searchedItems.Country !== null &&
                                searchedItems.Country !== 'null'
                                ? searchedItems.Country
                                : ''
                            }
                          />
                        </Grid>
                      </React.Fragment>
                    )}
                    <Grid item xs={12}>
                      <TextField
                        id='PatientNotes'
                        type='text'
                        className={classes.textField}
                        margin='normal'
                        variant='standard'
                        label={t('Assign.PatientNotes')}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          autoComplete: 'off',
                          form: {
                            autoComplete: 'off',
                          },
                        }}
                        value={this.state.patientNotes || ''}
                        onChange={(e) =>
                          !this.state.readOnly && this.setState({ patientNotes: e.target.value })
                        }
                        readOnly={this.state.readOnly}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id='orderNotes'
                        type='text'
                        className={classes.textField}
                        fullWidth
                        margin='normal'
                        variant='standard'
                        label={t('Unplugged.Courier.OrderNotes')}
                        name='orderNotes'
                        onChange={this.handleChangeOrderNotes}
                        InputLabelProps={{ shrink: true }}
                        value={assign_order_notes}
                        inputProps={{
                          autoComplete: 'off',
                          form: {
                            autoComplete: 'off',
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomNotePicker
                        t={t}
                        boxId={this.state.box_id || localStorage.getItem('selectedLocation')}
                        locationTypeId={this.state.locationtype_id}
                        value={this.state.customNote}
                        onChange={(customNote) => this.setState({ customNote })}
                        disabled={this.state.readOnly}
                      />
                    </Grid>
                  </Grid>}
                {!this.shouldShowBasicUI() && (
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography>{t('Assign.AlternateContacts')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid item xs={12}>
                        <Tooltip title={t('Patient.Preference.AddAlternateContactButton')}>
                          <span>
                            <IconButton
                              aria-label={t('Patient.Preference.AddAlternateContactButton')}
                              onClick={this.addAlterAgentRow}
                              color='primary'
                              disabled={this.state.readOnly}
                              size='small'
                            >
                              <AddCircleOutlineRounded />
                            </IconButton>
                          </span>
                        </Tooltip>
                        {this.createRowAlterAgent()}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
                {!this.shouldShowBasicUI() && (
                  <div className={classNames(classes.adjustDrugGrid, 'assign-rx-cart')}>
                    {selected.length > 0 ? (
                      <EnhancedTableToolbar
                        numSelected={selected.length}
                        deleteItems={this.deleteItems}
                        confirmDelete={this.confirmDelete}
                      />
                    ) : null}
                    <div
                      className={classNames(classes.handleOverflow, 'assign-rx-cart-scroll', {
                        'is-empty': !cartRxList.length,
                      })}
                    >
                      <Table
                        className={classes.table}
                        aria-labelledby='tableTitle'
                      >
                        <EnhancedTableHead
                          numSelected={selected.length}
                          onSelectAllClick={this.handleSelectAllClick}
                          rowCount={cartRxList ? cartRxList.length : 0}
                          isVisibleForPause={this.state.isVisibleForPause}
                          order={order}
                          orderBy={orderBy}
                          onRequestSort={this.handleRequestSort}
                          className={classes.tableCellLabel}
                        />
                        <TableBody>
                          {cartRxList.length === 0 ? (
                            <TableRow>
                              <TableCell
                                className={classes.emptyRowCell}
                                style={{ padding: '6px 0px' }}
                                colSpan='12'
                              >
                                {t('Assign.NoDataFound')}
                              </TableCell>
                            </TableRow>
                          ) : (
                            stableSort(
                              cartRxList,
                              getSorting(order, orderBy)
                            ).map((n, index) => {
                              let amount;
                              if (
                                n.price !== undefined &&
                                n.price !== null &&
                                n.price !== 'undefined' &&
                                n.price !== 'null' &&
                                n.price !== ''
                              ) {
                                amount = n.price;
                              } else if (
                                n.CoPayAmount !== undefined &&
                                n.CoPayAmount !== null &&
                                n.CoPayAmount !== 'undefined' &&
                                n.CoPayAmount !== 'null' &&
                                n.CoPayAmount !== ''
                              ) {
                                amount = n.CoPayAmount;
                              } else if (
                                n.amount_due !== undefined &&
                                n.amount_due !== null &&
                                n.amount_due !== 'undefined' &&
                                n.amount_due !== 'null' &&
                                n.amount_due !== ''
                              ) {
                                amount = n.amount_due;
                              } else {
                                amount = 0;
                              }
                              const isSelected = this.isSelected(getDisplayRxNo(n));
                              const _seqNumber = n.SeqNumber || n.seqnumber;
                              return (
                                <TableRow
                                  hover
                                  role='checkbox'
                                  aria-checked={isSelected}
                                  tabIndex={-1}
                                  key={`${getDisplayRxNo(n) || `rx-row-${index}`}-${index}`}
                                  selected={isSelected}
                                >
                                  {!this.state.isVisibleForPause && (
                                    <TableCell
                                      style={{ fontSize: '0.6rem' }}
                                      padding={'none'}
                                      onClick={(event) =>
                                        this.handleClick(event, getDisplayRxNo(n))
                                      }
                                    >
                                      <Checkbox checked={isSelected} />
                                    </TableCell>
                                  )}
                                  <TableCell
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, getDisplayRxNo(n))
                                    }
                                    style={{ fontSize: '0.6rem' }}
                                  >
                                    {getDisplayRxNo(n)}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, getDisplayRxNo(n))
                                    }
                                    sx={{ fontSize: '0.6rem' }}
                                  >
                                    {n.fillNumber || n.fillnumber}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: '140px' }}
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, getDisplayRxNo(n))
                                    }
                                    sx={{ fontSize: '0.6rem' }}
                                  >
                                    {n.prescriptionNumber ||
                                      n.prescriptionnumber ||
                                      ''}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: '140px' }}
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, getDisplayRxNo(n))
                                    }
                                    sx={{ fontSize: '0.6rem' }}
                                  >
                                    {n.order_id || ''}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: '140px' }}
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, getDisplayRxNo(n))
                                    }
                                  >
                                    {accountDetails &&
                                    accountDetails.connection &&
                                    accountDetails.connection.id === CONNECTION_TYPE.QS1 ?
                                      n.isLoadingTrans === true ? (
                                        <img src={cl} alt='loader' width='36' />
                                      ) :
                                        <TextField
                                          sx={{
                                            width: '60px',
                                            mt: '7px',
                                            '.MuiInput-root': {
                                              fontSize: '0.80rem',
                                            },
                                          }}
                                          value={_seqNumber}
                                          variant='standard'
                                          onChange={(e) =>
                                            this.onHandleChangeInputValue(
                                              ![undefined, 'undefined', null, 'null', ''].includes(n.id) ? n.id : n.itemId,
                                              'seqNumber',
                                              e.target.value,
                                              n.rxNo || n.rx_no
                                            )
                                          }
                                          id='seqNumber'
                                        />
                                      : (n.prescription_txn_id || '')}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: '160px' }}
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, getDisplayRxNo(n))
                                    }
                                    sx={{ fontSize: '0.6rem' }}
                                  >
                                    {n.name || n.drug_name}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, getDisplayRxNo(n))
                                    }
                                    sx={{ fontSize: '0.6rem' }}
                                  >
                                    {n.isLoadingTrans === true ? (
                                      <img src={cl} alt='loader' width='36' />
                                    ) : (
                                      n.ndcCode || n.ndc_code
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className={classes.tableCell}
                                    onClick={(event) =>
                                      this.handleClick(event, getDisplayRxNo(n))
                                    }
                                    sx={{ fontSize: '0.6rem' }}
                                  >
                                    {n.isLoadingTrans === true ? (
                                      <img src={cl} alt='loader' width='36' />
                                    ) : (
                                      n.qty
                                    )}
                                  </TableCell>
                                  <TableCell className={classes.tableCell} sx={{ fontSize: '0.6rem' }}>
                                    {n && n.is_order_released && n.is_order_released === true ? (
                                      <div>
                                        <img
                                          src={checked}
                                          alt={n.rx_no || n.rxNo}
                                          height={24}
                                          width={24}
                                        />
                                      </div>
                                    ) : (
                                      <div>
                                        {n.isLoadingTrans === true ? (
                                          <img src={cl} alt="loader" width="36" />
                                        ) : (
                                          <Checkbox
                                            key={`controlled-${n.rx_no || n.rxNo}`}
                                            checked={isItemControlledSubstance(n)}
                                            onChange={(event) =>
                                              this.handleControlledSubstanceChange(
                                                searchedRxItems.indexOf(n),
                                                event.target.checked
                                              )
                                            }
                                            value={isItemControlledSubstance(n)}
                                            color="primary"
                                          />
                                        )}
                                      </div>
                                    )}
                                  </TableCell>
                                  {this.state.accountDetails.bypass_consult ? (
                                    <TableCell className={classes.TableCell}>
                                      <Checkbox
                                        key={`consult-${n.rx_no || n.rxNo}-${this.state.consultWaiveDialogOpen}`}
                                        checked={!(n.ConsultRequire !== true && n.is_consultrequire !== true)}
                                        disabled={consultCheckBoxFlagForRxByBin}
                                        onChange={() =>
                                          this.handleConsultrequire(searchedRxItems.indexOf(n))
                                        }
                                        value={
                                          n.ConsultRequire || n.is_consultrequire
                                        }
                                        color="primary"
                                      />
                                    </TableCell>
                                  ) : (
                                    <TableCell
                                      className={classes.tableCell}
                                      sx={{ fontSize: '0.6rem' }}
                                    >
                                      {' '}
                                      {n &&
                                        n.is_order_released &&
                                        n.is_order_released === true ? (
                                        <div>
                                          <img
                                            src={checked}
                                            alt={n.rx_no}
                                            height={24}
                                            width={24}
                                          />
                                        </div>
                                      ) : (
                                        <div>
                                          {n.isLoadingTrans === true ? (
                                            <img
                                              src={cl}
                                              alt='loader'
                                              width='36'
                                            />
                                          ) : (
                                            <Checkbox
                                              key={`consult-${n.rx_no || n.rxNo}-${this.state.consultWaiveDialogOpen}`}
                                              checked={!(n.ConsultRequire !== true && n.is_consultrequire !== true)}
                                              onChange={() =>
                                                this.handleConsultrequire(searchedRxItems.indexOf(n))
                                              }
                                              value={
                                                n.ConsultRequire ||
                                                n.is_consultrequire
                                              }
                                              color='primary'
                                            />
                                          )}
                                        </div>
                                      )}
                                    </TableCell>
                                  )}
                                  <TableCell className={classes.tableCell} sx={{ fontSize: "0.6rem" }}>
                                    {" "}
                                    {n && n.is_order_released && n.is_order_released === true ? (
                                      <div>
                                        <img src={checked} alt={n.rx_no} height={24} width={24} />
                                      </div>
                                    ) : (
                                      <div>
                                        {n.isLoadingTrans === true ? (
                                          <img src={cl} alt="loader" width="36" />
                                        ) : (
                                          <Checkbox
                                            onChange={() => this.handleIsReturnable(index)}
                                            value={n.is_returnable || n.IsReturnable}
                                            checked={
                                              n.IsReturnable ||
                                              n.is_returnable
                                            }
                                            color="primary"
                                          />
                                        )}
                                      </div>
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className={`${classes.tableCell} assign-rx-cart-price-cell-wrap`}
                                    sx={{ fontSize: '0.6rem', verticalAlign: 'middle' }}
                                  >
                                    {n.isLoadingTrans === true ? (
                                      <img src={cl} alt='loader' width='36' />
                                    ) : (
                                      <div className='assign-rx-cart-price-cell'>
                                        {this.state.isEdit === true &&
                                        this.state.isAmountPaid === false &&
                                        this.state.isPartiallyPaid === false ? (
                                          this.state.indexNo === index ? (
                                            <React.Fragment>
                                              <TextField
                                                sx={{
                                                  width: '64px',
                                                  m: 0,
                                                  '.MuiInput-root': {
                                                    fontSize: '0.75rem',
                                                  },
                                                }}
                                                value={parseFloat(amount)}
                                                variant='standard'
                                                onChange={(e) =>
                                                  this.onHandleChangeInputValue(
                                                    ![undefined, 'undefined', null, 'null', ''].includes(n.id) ? n.id : n.itemId,
                                                    'price',
                                                    e.target.value,
                                                    n.rxNo || n.rx_no
                                                  )
                                                }
                                                id='price'
                                                InputProps={{
                                                  inputComponent: NumberFormatCustom,
                                                  autoComplete: 'new-password',
                                                  form: {
                                                    autoComplete: 'off',
                                                  },
                                                }}
                                              />
                                              <Tooltip title={t('Assign.SaveTooltip')}>
                                                <IconButton
                                                  size='small'
                                                  onClick={() =>
                                                    this.handleCloseDueAmountEditInput(
                                                      index,
                                                      n.id
                                                    )
                                                  }
                                                  className={
                                                    classes.onAmoutDueEditPrimaryButton
                                                  }
                                                >
                                                  <SaveIcon style={{ fontSize: '1rem' }} />
                                                </IconButton>
                                              </Tooltip>
                                            </React.Fragment>
                                          ) : (
                                            <React.Fragment>
                                              <span className='assign-rx-cart-price-value'>
                                                {'$' + parseFloat(amount).toFixed(2)}
                                              </span>
                                              <Tooltip title={t('Assign.EditTooltip')}>
                                                <IconButton
                                                  size='small'
                                                  className={
                                                    classes.onAmoutDueEditPrimaryButton
                                                  }
                                                  onClick={() =>
                                                    this.handleOpenDueAmountEditInput(
                                                      index
                                                    )
                                                  }
                                                >
                                                  <EditIcon style={{ fontSize: '1rem' }} />
                                                </IconButton>
                                              </Tooltip>
                                            </React.Fragment>
                                          )
                                        ) : (
                                          <TextField
                                            sx={{
                                              width: '64px',
                                              m: 0,
                                              '.MuiInput-root': {
                                                fontSize: '0.75rem',
                                              },
                                            }}
                                            value={parseFloat(amount)}
                                            variant='standard'
                                            onChange={(e) =>
                                              this.onHandleChangeInputValue(
                                                ![undefined, 'undefined', null, 'null', ''].includes(n.id) ? n.id : n.itemId,
                                                'price',
                                                e.target.value,
                                                n.rxNo || n.rx_no
                                              )
                                            }
                                            id='price'
                                            InputProps={{
                                              inputComponent: NumberFormatCustom,
                                              autoComplete: 'new-password',
                                              form: {
                                                autoComplete: 'off',
                                              },
                                            }}
                                          />
                                        )}
                                      </div>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          )}
                        </TableBody>
                      </Table>
                    </div>
                    {this.state.isVisibleForPause ? (
                      <div
                        className={
                          'assign-rx-payment-summary' +
                          (this.state.isAmountPaid
                            ? ' is-paid'
                            : this.state.isPartiallyPaid
                              ? ' is-partial'
                              : ' is-due')
                        }
                      >
                        <div className="assign-rx-payment-metric">
                          <span className="assign-rx-payment-metric-label">
                            {this.state.isPartiallyPaid ? (
                              <span style={{ color: '#b45309' }}>
                                {t('Assign.PartiallyPaid', {
                                  defaultValue: 'Partially Paid',
                                })}
                              </span>
                            ) : (
                              t('Assign.Paid')
                            )}
                          </span>
                          <span
                            className={
                              'assign-rx-payment-metric-value' +
                              (this.state.isPartiallyPaid
                                ? ' is-partial'
                                : this.state.isAmountPaid
                                  ? ' is-paid'
                                  : '')
                            }
                          >
                            {this.getPaidAmountDisplay()}
                          </span>
                        </div>
                        <div className="assign-rx-payment-metric is-emphasis">
                          <span className="assign-rx-payment-metric-label">
                            {t('Assign.AmountDue')}
                          </span>
                          <span
                            className={
                              'assign-rx-payment-metric-value' +
                              (this.state.isPartiallyPaid
                                ? ' is-partial'
                                : this.state.isAmountPaid
                                  ? ' is-settled'
                                  : ' is-due')
                            }
                          >
                            {this.getDueAmountDisplay()}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                )}
                {!this.shouldShowBasicUI() ? this.renderMarketplaceSection(classes, t) : null}
              </div>
              <div id='react-no-print' key='BoxLayout' className={classNames(classes.boxHolder, 'assign-bin-panel')}>
                {this.state.locationtype_id === LOCATION_TYPE.Kiosk ? (
                  <React.Fragment>
                    {this.state.isSizeBasedPreAssignment ? (
                      <SizeBasedBinAvailabilitySummary
                        t={t}
                        binCountsBySize={this.state.binCountsBySize}
                      />
                    ) : null}
                    <Grid container sx={{ m: '0px', mt: 0 }}>
                      {/* Informational message when add-ons are connected */}
                      {this.hasAddOnExpansions() && (boxTypeId === BOX_TYPE.FASTLANE || boxTypeId === BOX_TYPE.FASTLANEGOLIATH) && (
                        <Grid item xs={12} sx={{ mb: 1 }}>
                          <Box
                            sx={{
                              backgroundColor: '#e3f2fd',
                              border: '1px solid #1976d2',
                              borderRadius: '6px',
                              padding: '6px 10px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              width: '98%'
                            }}
                          >
                            <InfoIcon sx={{ color: '#1976d2', fontSize: '18px', flexShrink: 0 }} />
                            <Typography sx={{ color: '#1976d2', fontWeight: 500, fontSize: '0.75rem', lineHeight: 1.35 }}>
                              {t('Assign.AddOnInfoMessage') || 'You can also assign this prescription to an add-on locker. Use pagination to switch between units and select a bin.'}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <Boxlayout
                          key={`bin-layout-${this.state.binLayoutRefreshKey}`}
                          BinStatus={this.state.BinStatus}
                          deactivatedBins={this.state.deactivatedBins}
                          selectedBinId={this.state.selectedBinId}
                          expansionUnits={this.state.expansionUnits}
                          getPrescriptionDetails={this.getPrescriptionDetails}
                          getSelectedBin={this.getSelectedBin}
                          getSelectedUnitName={this.getSelectedUnitName}
                          currentTabIndex={assignPrescriptionCurrentTabIndex}
                          isADACompatible={this.state.isADACompatible}
                          ADAData={this.state.ADAData}
                          PatientID={
                            this.state &&
                            this.state.searchedItems &&
                            this.state.searchedItems.PatientID
                          }
                          boxTypeId={this.state.boxTypeId}
                          t={t}
                          allowMultiBinsPickup={this.state.allow_multi_bins_pickup}
                          BoxID={this.state && this.state.box_id}
                          makeFastlaneAPICall={this.state.makeFastlaneAPICall}
                          selectedBox={selectedBox}
                          isViewPermissionAllowed={prescriptionView}
                          onBinPositionUpdate={this.handleFastlaneBinPositionUpdate}
                          columnMappings={this.state.currentBoxData && this.state.currentBoxData.column_mappings ? this.state.currentBoxData.column_mappings : []}
                          userGroupType={(() => {
                            const groupType = sessionStorage.getItem('groupType');
                            const result = groupType && groupType !== 'null' && groupType !== 'undefined' && groupType !== '' ? groupType : null;
                            return result;
                          })()}
                          is_pre_assignment={this.is_pre_assignment}
                          is_size_based_pre_assignment={this.state.isSizeBasedPreAssignment}
                          getAvailableBinsCount={this.getAvailableBinsCount}
                          makeAPICall={this.state.makePreAssignmentAPICall}
                        />
                      </Grid>
                    </Grid>
                    <div className="box-sidebar-footer">
                      {!(boxTypeId === BOX_TYPE.FASTLANE || boxTypeId === BOX_TYPE.FASTLANEGOLIATH) && !this.state.isSizeBasedPreAssignment && (
                        <BinStatusLegend items={BIN_STATUS_LEGEND_WITH_LOCKED} />
                      )}
                      <KioskDeliveryInfoPanel
                        t={t}
                        stockCode={stockCode}
                        pickupCode={pickupCode}
                        selectedBinId={this.state.selectedBinId || ''}
                        locationControl={this.renderLocationSelect('select-location-kiosk', { menuPlacement: 'top' })}
                        binSizeControl={
                          this.state.isSizeBasedPreAssignment
                            ? this.renderBinSizeSelect('bin_sizes_kiosk', { menuPlacement: 'top' })
                            : null
                        }
                        addressLine1={
                          (this.state.address && this.state.address.address1) ||
                          (searchedItems && searchedItems.AddressLine1) ||
                          ''
                        }
                        addressLine2={
                          (this.state.address && this.state.address.address2) ||
                          (searchedItems && searchedItems.AddressLine2) ||
                          ''
                        }
                        city={
                          (this.state.address && this.state.address.city) ||
                          (searchedItems && searchedItems.City) ||
                          ''
                        }
                        state={
                          (this.state.address && this.state.address.state) ||
                          (searchedItems && searchedItems.State) ||
                          ''
                        }
                        zip={
                          (this.state.address && this.state.address.zip) ||
                          (searchedItems && searchedItems.Zip) ||
                          ''
                        }
                        country={
                          (this.state.address && this.state.address.country) ||
                          (searchedItems && searchedItems.Country) ||
                          ''
                        }
                        assignedDate={
                          (searchedItems && searchedItems.assignedDate) ||
                          (searchedItems && searchedItems.assigned_date) ||
                          (this.state.assignedPrescription &&
                            this.state.assignedPrescription.customers &&
                            this.state.assignedPrescription.customers[0] &&
                            this.state.assignedPrescription.customers[0].orders &&
                            this.state.assignedPrescription.customers[0].orders[0] &&
                            (this.state.assignedPrescription.customers[0].orders[0].created_on ||
                              this.state.assignedPrescription.customers[0].orders[0].createdOn)) ||
                          null
                        }
                        stockedDate={
                          (searchedItems && searchedItems.stockedDate) ||
                          (searchedItems && searchedItems.stocked_date) ||
                          (this.state.assignedPrescription &&
                            this.state.assignedPrescription.customers &&
                            this.state.assignedPrescription.customers[0] &&
                            this.state.assignedPrescription.customers[0].orders &&
                            this.state.assignedPrescription.customers[0].orders[0] &&
                            (this.state.assignedPrescription.customers[0].orders[0].stocked_date ||
                              this.state.assignedPrescription.customers[0].orders[0].stockedDate)) ||
                          null
                        }
                        expiresDate={
                          (searchedItems && searchedItems.expiresDate) ||
                          (searchedItems && searchedItems.rx_expiration_date) ||
                          (this.state.assignedPrescription &&
                            this.state.assignedPrescription.customers &&
                            this.state.assignedPrescription.customers[0] &&
                            this.state.assignedPrescription.customers[0].orders &&
                            this.state.assignedPrescription.customers[0].orders[0] &&
                            (this.state.assignedPrescription.customers[0].orders[0].rx_expiration_date ||
                              this.state.assignedPrescription.customers[0].orders[0].rxExpirationDate)) ||
                          null
                        }
                        expirationDays={
                          this.state.accountDetails &&
                          this.state.accountDetails.expiration_days
                        }
                      />
                    </div>
                  </React.Fragment>
                ) : this.state.locationtype_id === LOCATION_TYPE.Home ? (
                  <Box
                    component='div'
                    sx={{ height: '100%', width: '100%', textAlign: 'center' }}
                  >
                    <HomeIcon
                      style={{ height: '100%', width: '50%', color: '#0369a1' }}
                    />
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Work ? (
                  <Box
                    component='div'
                    sx={{ height: '100%', width: '100%', textAlign: 'center' }}
                  >
                    <WorkIcon
                      style={{ height: '100%', width: '50%', color: '#0369a1' }}
                    />
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Courier ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: 0.5,
                    }}
                  >
                    <img
                      src={courierIcon}
                      style={{ height: '30%', width: '50%', color: '#0369a1' }}
                      alt='no-icon'
                    />
                    <Grid
                      container
                      spacing={1}
                      sx={{ pl: '0.5rem', pr: '0.5rem' }}
                    >
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={1}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '1%' }}
                    >
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={1}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '1%' }}
                    >
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.Courier')}
                        </label>
                        {this.state.courier_type &&
                          this.state.courier_type.length > 0
                          ? this.state.courier_type.map((val) => {
                            return (
                              <div>
                                <FormControlLabel
                                  label={
                                    <span style={{ color: '#000' }}>
                                      {val}
                                    </span>
                                  }
                                  control={
                                    <Checkbox
                                      value={val}
                                      color='primary'
                                      checked={
                                        this.state
                                          .default_courier_selected === val
                                      }
                                      onClick={() =>
                                        this.checkBoxHandler(val)
                                      }
                                    />
                                  }
                                />
                              </div>
                            );
                          })
                          : ''}
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.TrackingNumber')}
                        </label>
                        <br />
                        <input
                          type='text'
                          style={{
                            width: '100%',
                            borderRadius: '5px',
                            padding: '5px',
                            height: '45px',
                            fontSize: '15px',
                          }}
                          value={this.state.courier_tracking}
                          onChange={(evt) => this.courierTrackingHandler(evt)}
                          placeholder='Scan or Enter Tracking Number'
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ mt: '5%', mb: '2%', textAlign: 'start' }}
                        >
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Other ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: 0.5,
                    }}
                  >
                    <OtherIcon
                      style={{ height: '100%', width: '50%', color: '#0369a1' }}
                    />
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Curbside ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: 0.5,
                    }}
                  >
                    <img
                      src={curbsideIcon}
                      style={{
                        height: '35%',
                        width: '50%',
                        color: '#0369a1',
                        marginBottom: '-10%',
                      }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '0.5rem', pr: '0.5rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ mt: '5%', textAlign: 'start' }}
                        >
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Bedside ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: 0.5,
                    }}
                  >
                    <img
                      src={inpatientIcon}
                      style={{ height: '30%', width: '50%', color: '#0369a1' }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '0.5rem', pr: '0.5rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}
                        >
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : (
                  ''
                )}
              </div>
              </div>
            </div>
          </Box>
        </Paper>
        {this.renderAssignActionFooter()}
        <div>
                <Dialog
                  maxWidth='xs'
                  fullWidth
                  open={this.state.openMessage}
                  onClose={this.handleClose}
                  aria-labelledby='assign-bin-message-title'
                  sx={{ zIndex: 22000 }}
                  PaperProps={{
                    sx: {
                      borderRadius: '12px',
                      overflow: 'hidden',
                    },
                  }}
                >
                  <DialogTitle
                    id='assign-bin-message-title'
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      m: 0,
                      px: 2.5,
                      py: 1.75,
                      background: '#00a7e1',
                      color: '#fff',
                      fontSize: '1.05rem',
                      fontWeight: 700,
                    }}
                  >
                    <InfoIcon sx={{ fontSize: 22 }} />
                    {t('Assign.MessageText')}
                  </DialogTitle>
                  <DialogContent sx={{ px: 2.5, pt: '20px !important', pb: 2 }}>
                    <Typography sx={{ color: 'text.primary', fontSize: '0.95rem', lineHeight: 1.5 }}>
                      {t('Assign.SelectBinToContinue')}
                    </Typography>
                  </DialogContent>
                  <DialogActions
                    sx={{
                      px: 2.5,
                      py: 1.5,
                      background: '#f4fbfe',
                      borderTop: '1px solid #d3eef8',
                    }}
                  >
                    <Button
                      onClick={this.handleClose}
                      variant='contained'
                      disableElevation
                      autoFocus
                      sx={{
                        textTransform: 'none',
                        fontWeight: 700,
                        borderRadius: '8px',
                        backgroundColor: '#00a7e1',
                        '&:hover': { backgroundColor: '#0096cc' },
                      }}
                    >
                      {t('Assign.OkButton')}
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
              {this.state.detailDialogOpen ? (
                <Manualconsultation
                  detailDialogOpen={this.state.detailDialogOpen}
                  selectedObject={this.state.searchedItems}
                  stockCode={stockCode}
                  pickupCode={pickupCode}
                  boxId={this.state.box_id}
                  accountDetails={this.state.accountDetails}
                  pharmacyDetails={this.state.pharmacyDetails}
                  onPopupClose={this.handleConsultClose}
                  searchedRxItems={searchedRxItems}
                />
              ) : null}
              {isManualOverrideOpen && (
                <PatientManulOverride
                  detailDialogOpen={isManualOverrideOpen}
                  selectedObject={{
                    binid: selectedBinId,
                    kiosk_box_id: selectedBox.kiosk_box_id,
                    pmid: this.state.pmid,
                    boxid: this.state.box_id,
                    pucode: this.state.pickupCode,
                  }}
                  onPopupClose={() =>
                    this.setState({ isManualOverrideOpen: false })
                  }
                  isPatientDetailsVisible={false}
                  isBoxDetailsVisible={false}
                  isManualOverrideVisible={true}
                  isManualConsultVisible={true}
                />
              )}

        {/* Print Label Functionality  */}
        <Box component='div' id='Print_AssingPrescription_Label'>
          <PrintTemplate>
            <Dialog
              open={this.state.printDialogOpen || false}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
              PaperProps={{
                sx: { borderRadius: '0px', width: '255px', height: '500px' },
              }}
            >
              <DialogContent sx={{ p: '10px' }}>
                <LabelTemplate
                  style={{ display: 'none' }}
                  stockCode={labelPrint.stockCode || ''}
                  pickupCode={labelPrint.pickupCode || ''}
                  rxNumbers={labelPrint.rxNumbers || []}
                  boxId={this.state.box_id || ''}
                  ref={(el) => (this.componentRef = el)}
                  accountDetails={this.state.accountDetails || ''}
                  pharmacyDetails={this.state.pharmacyDetails || ''}
                  firstName={labelPrint.firstName || ''}
                  lastName={labelPrint.lastName || ''}
                  dateOfBirth={labelPrint.dateOfBirth || ''}
                  isCoolItem={labelPrint.isCoolItem || false}
                  locationTypeID={this.state.locationtype_id || ''}
                  brandingName={labelPrint.brandName || ''}
                  brandingPhone={labelPrint.brandPhone || ''}
                  boxDetails={this.state.boxDetails}
                  connectionType={0}
                  t={t}
                  bin_id={labelPrint.binId || ''}
                  rxEntries={labelPrint.rxEntries || []}
                  accountConnectionsId={this.state.accountConnectionsLoginId}
                  compactStockLabelLayout={true}
                  nonRxItems={labelPrint.nonRxItems || []}
                  roomNumber={labelPrint.roomNumber || ''}
                  orderNotes={labelPrint.orderNotes || ''}
                  showRoomNumber={this.state.locationtype_id === LOCATION_TYPE.Bedside}
                />
              </DialogContent>
            </Dialog>
          </PrintTemplate>
        </Box>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={this.state.isVerifyingBin || false}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {t('Assign.BinStatus')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                {this.state && this.state.isVerifyingBinMessage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.confirmBinOkButton}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.OkayButton')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={this.state.nonReadyRxBlockDialogOpen || false}
            aria-labelledby='non-ready-rx-block-title'
            aria-describedby='non-ready-rx-block-description'
            disableEscapeKeyDown
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return;
              }
            }}
          >
            <DialogTitle id='non-ready-rx-block-title'>
              {t('Assign.NonReadyBlock.Title')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='non-ready-rx-block-description'>
                {this.state.nonReadyRxBlockMessage}
              </DialogContentText>
              <DialogContentText style={{ marginTop: '12px' }}>
                {t('Assign.NonReadyBlock.NotAdded')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.closeNonReadyPrescriptionBlock}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Common.Confirm')}
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.confirmPMSDialogOpen || false}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {t('Assign.DoYouWantToContinue')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                {t('Assign.DoYouWantToContinueText')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => this.handlePMSDialogYesEvent(e)}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.ManualConsult.Yes')}
              </Button>
              <Button
                onClick={this.handlePMSDialogNoEvent}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.ManualConsult.No')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={(boxTypeId === BOX_TYPE.FASTLANE) && (this.state.isFastlaneRetrying || false)}
            aria-labelledby='fastlane-retry-dialog-title'
            aria-describedby='fastlane-retry-dialog-description'
            disableEscapeKeyDown
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return false;
              }
            }}
            PaperProps={{
              style: { 
                minWidth: '400px'
              }
            }}
            BackdropProps={{
              style: {
                backgroundColor: 'rgba(0, 0, 0, 0.7)'
              }
            }}
          >
            <DialogTitle id='fastlane-retry-dialog-title' sx={{ textAlign: 'center', color: '#1976d2' }}>
              {t('Assign.Fastlane.RetryDialogTitle')}
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', pb: 3, pt: 2 }}>
              <Box component='div' sx={{ mb: 2 }}>
                <img
                  className={classes.spinnerImage}
                  src={spinner}
                  alt='loading'
                  style={{ width: '50px', height: '50px' }}
                />
              </Box>
              <DialogContentText id='fastlane-retry-dialog-description' sx={{ fontSize: '1rem', fontWeight: 600, color: '#000' }}>
                {this.state.fastlaneRetryMessage}
              </DialogContentText>
              <DialogContentText sx={{ mt: 1, fontSize: '0.875rem', color: '#666' }}>
                {t('Assign.Fastlane.RetryMessage')}
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={(boxTypeId === BOX_TYPE.FASTLANE) && (this.state.fastlaneBinFetchError || false)}
            aria-labelledby='fastlane-error-dialog-title'
            aria-describedby='fastlane-error-dialog-description'
            disableEscapeKeyDown
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return false;
              }
            }}
          >
            <DialogTitle id='fastlane-error-dialog-title' sx={{ color: '#d32f2f' }}>
              {t('Assign.Fastlane.ErrorDialogTitle')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='fastlane-error-dialog-description'>
                {t('Assign.Fastlane.ErrorMessage')}
              </DialogContentText>
              <DialogContentText sx={{ mt: 2, fontWeight: 500 }}>
                {t('Assign.Fastlane.ErrorQuestion')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleFastlaneBinErrorRetry}
                color='primary'
                className={classes.primaryButton}
                autoFocus
              >
                {t('Assign.Fastlane.TryAgainButton')}
              </Button>
              <Button
                onClick={() => this.setState({ fastlaneBinFetchError: false, pendingSaveMode: null })}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.CancelButton')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={(boxTypeId === BOX_TYPE.FASTLANE) && (this.state.fastlaneBinValidationError || false)}
            aria-labelledby='fastlane-validation-error-dialog-title'
            aria-describedby='fastlane-validation-error-dialog-description'
            disableEscapeKeyDown
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return false;
              }
            }}
          >
            <DialogTitle id='fastlane-validation-error-dialog-title' sx={{ color: '#d32f2f' }}>
              {t('Assign.Fastlane.ErrorDialogTitle')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='fastlane-validation-error-dialog-description'>
                {t('Assign.Fastlane.InvalidBinError')}
              </DialogContentText>
              <DialogContentText sx={{ mt: 2, fontWeight: 500 }}>
                {t('Assign.Fastlane.ValidationErrorMessage')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleFastlaneBinValidationErrorRetry}
                color='primary'
                className={classes.primaryButton}
                autoFocus
              >
                {t('Assign.OkayButton')}
              </Button>
              <Button
                onClick={() => this.setState({ fastlaneBinValidationError: false, pendingSaveMode: null })}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.CancelButton')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={(boxTypeId === BOX_TYPE.FASTLANE) && (this.state.fastlaneCollisionDialogOpen || false)}
            aria-labelledby='fastlane-collision-dialog-title'
            aria-describedby='fastlane-collision-dialog-description'
            disableEscapeKeyDown
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return false;
              }
            }}
          >
            <DialogTitle id='fastlane-collision-dialog-title' sx={{ color: '#d32f2f' }}>
              {t('Assign.Fastlane.CollisionTitle')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='fastlane-collision-dialog-description'>
                {t('Assign.Fastlane.CollisionMessage')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleFastlaneCollisionConfirm}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.YesButton') || 'Yes'}
              </Button>
              <Button
                onClick={this.handleFastlaneCollisionCancel}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.NoButton') || 'No'}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={confirmPhantomRemoval || false}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {t('Assign.DoYouWantToContinue')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                {t('Assign.PhantomBin.Confirmation')}
              </DialogContentText>
              {isPhantomStockCodePrompt ? (
                <TextField
                  fullWidth
                  margin='dense'
                  label={t('Assign.StockCode')}
                  value={stockCode || ''}
                  onChange={(event) =>
                    this.setState({ stockCode: event.target.value })
                  }
                />
              ) : null}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => this.removePhantomBin(e)}
                color='primary'
                className={classes.primaryButton}
                disabled={this.state.loader}
              >
                {t('Assign.ManualConsult.Yes')}
              </Button>
              <Button
                onClick={(e) =>
                  this.setState({
                    confirmPhantomRemoval: false,
                    isPhantomStockCodePrompt: false,
                  })
                }
                color='primary'
                className={classes.primaryButton}
                disabled={this.state.loader}
              >
                {t('Assign.ManualConsult.No')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='print-mount'>
           <PrintTemplate>
             <Dialog
               open={this.state.openPrintDialog}
               PaperProps={{
                 sx: { borderRadius: '0px', minWidth: '700px', minHeight: '500px' },
               }}
             >
               <DialogContent sx={{ p: '10px' }}>
                 <div
                   dangerouslySetInnerHTML={{ __html: htmlBodyToPrint }}
                 ></div>
               </DialogContent>
             </Dialog>
           </PrintTemplate>
        </div>
      </Box>
    );
  }
}

export default withStyles(styles)(withTranslation()(AssignPrescriptions));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/index.js